var Lc = Object.defineProperty;
var Ac = (t, e, o) => e in t ? Lc(t, e, { enumerable: !0, configurable: !0, writable: !0, value: o }) : t[e] = o;
var C = (t, e, o) => (Ac(t, typeof e != "symbol" ? e + "" : e, o), o);
var mo, S, kr, ft, Nn, zr, Ps, Er, Zo = {}, $r = [], Oc = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, is = Array.isArray;
function Ue(t, e) {
  for (var o in e)
    t[o] = e[o];
  return t;
}
function Sr(t) {
  var e = t.parentNode;
  e && e.removeChild(t);
}
function re(t, e, o) {
  var s, n, i, r = {};
  for (i in e)
    i == "key" ? s = e[i] : i == "ref" ? n = e[i] : r[i] = e[i];
  if (arguments.length > 2 && (r.children = arguments.length > 3 ? mo.call(arguments, 2) : o), typeof t == "function" && t.defaultProps != null)
    for (i in t.defaultProps)
      r[i] === void 0 && (r[i] = t.defaultProps[i]);
  return eo(t, r, s, n, null);
}
function eo(t, e, o, s, n) {
  var i = { type: t, props: e, key: o, ref: s, __k: null, __: null, __b: 0, __e: null, __d: void 0, __c: null, __h: null, constructor: void 0, __v: n ?? ++kr };
  return n == null && S.vnode != null && S.vnode(i), i;
}
function Pr() {
  return { current: null };
}
function et(t) {
  return t.children;
}
function Ie(t, e) {
  this.props = t, this.context = e;
}
function no(t, e) {
  if (e == null)
    return t.__ ? no(t.__, t.__.__k.indexOf(t) + 1) : null;
  for (var o; e < t.__k.length; e++)
    if ((o = t.__k[e]) != null && o.__e != null)
      return o.__e;
  return typeof t.type == "function" ? no(t) : null;
}
function Cr(t) {
  var e, o;
  if ((t = t.__) != null && t.__c != null) {
    for (t.__e = t.__c.base = null, e = 0; e < t.__k.length; e++)
      if ((o = t.__k[e]) != null && o.__e != null) {
        t.__e = t.__c.base = o.__e;
        break;
      }
    return Cr(t);
  }
}
function Cs(t) {
  (!t.__d && (t.__d = !0) && ft.push(t) && !Yo.__r++ || Nn !== S.debounceRendering) && ((Nn = S.debounceRendering) || zr)(Yo);
}
function Yo() {
  var t, e, o, s, n, i, r, a;
  for (ft.sort(Ps); t = ft.shift(); )
    t.__d && (e = ft.length, s = void 0, n = void 0, r = (i = (o = t).__v).__e, (a = o.__P) && (s = [], (n = Ue({}, i)).__v = i.__v + 1, en(a, i, n, o.__n, a.ownerSVGElement !== void 0, i.__h != null ? [r] : null, s, r ?? no(i), i.__h), Or(s, i), i.__e != r && Cr(i)), ft.length > e && ft.sort(Ps));
  Yo.__r = 0;
}
function Tr(t, e, o, s, n, i, r, a, c, d) {
  var l, h, u, p, v, g, y, b = s && s.__k || $r, _ = b.length;
  for (o.__k = [], l = 0; l < e.length; l++)
    if ((p = o.__k[l] = (p = e[l]) == null || typeof p == "boolean" || typeof p == "function" ? null : typeof p == "string" || typeof p == "number" || typeof p == "bigint" ? eo(null, p, null, null, p) : is(p) ? eo(et, { children: p }, null, null, null) : p.__b > 0 ? eo(p.type, p.props, p.key, p.ref ? p.ref : null, p.__v) : p) != null) {
      if (p.__ = o, p.__b = o.__b + 1, (u = b[l]) === null || u && p.key == u.key && p.type === u.type)
        b[l] = void 0;
      else
        for (h = 0; h < _; h++) {
          if ((u = b[h]) && p.key == u.key && p.type === u.type) {
            b[h] = void 0;
            break;
          }
          u = null;
        }
      en(t, p, u = u || Zo, n, i, r, a, c, d), v = p.__e, (h = p.ref) && u.ref != h && (y || (y = []), u.ref && y.push(u.ref, null, p), y.push(h, p.__c || v, p)), v != null ? (g == null && (g = v), typeof p.type == "function" && p.__k === u.__k ? p.__d = c = Ir(p, c, t) : c = Lr(t, p, u, b, v, c), typeof o.type == "function" && (o.__d = c)) : c && u.__e == c && c.parentNode != t && (c = no(u));
    }
  for (o.__e = g, l = _; l--; )
    b[l] != null && (typeof o.type == "function" && b[l].__e != null && b[l].__e == o.__d && (o.__d = Ar(s).nextSibling), Dr(b[l], b[l]));
  if (y)
    for (l = 0; l < y.length; l++)
      Rr(y[l], y[++l], y[++l]);
}
function Ir(t, e, o) {
  for (var s, n = t.__k, i = 0; n && i < n.length; i++)
    (s = n[i]) && (s.__ = t, e = typeof s.type == "function" ? Ir(s, e, o) : Lr(o, s, s, n, s.__e, e));
  return e;
}
function He(t, e) {
  return e = e || [], t == null || typeof t == "boolean" || (is(t) ? t.some(function(o) {
    He(o, e);
  }) : e.push(t)), e;
}
function Lr(t, e, o, s, n, i) {
  var r, a, c;
  if (e.__d !== void 0)
    r = e.__d, e.__d = void 0;
  else if (o == null || n != i || n.parentNode == null)
    e:
      if (i == null || i.parentNode !== t)
        t.appendChild(n), r = null;
      else {
        for (a = i, c = 0; (a = a.nextSibling) && c < s.length; c += 1)
          if (a == n)
            break e;
        t.insertBefore(n, i), r = i;
      }
  return r !== void 0 ? r : n.nextSibling;
}
function Ar(t) {
  var e, o, s;
  if (t.type == null || typeof t.type == "string")
    return t.__e;
  if (t.__k) {
    for (e = t.__k.length - 1; e >= 0; e--)
      if ((o = t.__k[e]) && (s = Ar(o)))
        return s;
  }
  return null;
}
function Rc(t, e, o, s, n) {
  var i;
  for (i in o)
    i === "children" || i === "key" || i in e || Ko(t, i, null, o[i], s);
  for (i in e)
    n && typeof e[i] != "function" || i === "children" || i === "key" || i === "value" || i === "checked" || o[i] === e[i] || Ko(t, i, e[i], o[i], s);
}
function Fn(t, e, o) {
  e[0] === "-" ? t.setProperty(e, o ?? "") : t[e] = o == null ? "" : typeof o != "number" || Oc.test(e) ? o : o + "px";
}
function Ko(t, e, o, s, n) {
  var i;
  e:
    if (e === "style")
      if (typeof o == "string")
        t.style.cssText = o;
      else {
        if (typeof s == "string" && (t.style.cssText = s = ""), s)
          for (e in s)
            o && e in o || Fn(t.style, e, "");
        if (o)
          for (e in o)
            s && o[e] === s[e] || Fn(t.style, e, o[e]);
      }
    else if (e[0] === "o" && e[1] === "n")
      i = e !== (e = e.replace(/Capture$/, "")), e = e.toLowerCase() in t ? e.toLowerCase().slice(2) : e.slice(2), t.l || (t.l = {}), t.l[e + i] = o, o ? s || t.addEventListener(e, i ? Un : Bn, i) : t.removeEventListener(e, i ? Un : Bn, i);
    else if (e !== "dangerouslySetInnerHTML") {
      if (n)
        e = e.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
      else if (e !== "width" && e !== "height" && e !== "href" && e !== "list" && e !== "form" && e !== "tabIndex" && e !== "download" && e !== "rowSpan" && e !== "colSpan" && e in t)
        try {
          t[e] = o ?? "";
          break e;
        } catch {
        }
      typeof o == "function" || (o == null || o === !1 && e[4] !== "-" ? t.removeAttribute(e) : t.setAttribute(e, o));
    }
}
function Bn(t) {
  return this.l[t.type + !1](S.event ? S.event(t) : t);
}
function Un(t) {
  return this.l[t.type + !0](S.event ? S.event(t) : t);
}
function en(t, e, o, s, n, i, r, a, c) {
  var d, l, h, u, p, v, g, y, b, _, E, m, P, k, A, T = e.type;
  if (e.constructor !== void 0)
    return null;
  o.__h != null && (c = o.__h, a = e.__e = o.__e, e.__h = null, i = [a]), (d = S.__b) && d(e);
  try {
    e:
      if (typeof T == "function") {
        if (y = e.props, b = (d = T.contextType) && s[d.__c], _ = d ? b ? b.props.value : d.__ : s, o.__c ? g = (l = e.__c = o.__c).__ = l.__E : ("prototype" in T && T.prototype.render ? e.__c = l = new T(y, _) : (e.__c = l = new Ie(y, _), l.constructor = T, l.render = Mc), b && b.sub(l), l.props = y, l.state || (l.state = {}), l.context = _, l.__n = s, h = l.__d = !0, l.__h = [], l._sb = []), l.__s == null && (l.__s = l.state), T.getDerivedStateFromProps != null && (l.__s == l.state && (l.__s = Ue({}, l.__s)), Ue(l.__s, T.getDerivedStateFromProps(y, l.__s))), u = l.props, p = l.state, l.__v = e, h)
          T.getDerivedStateFromProps == null && l.componentWillMount != null && l.componentWillMount(), l.componentDidMount != null && l.__h.push(l.componentDidMount);
        else {
          if (T.getDerivedStateFromProps == null && y !== u && l.componentWillReceiveProps != null && l.componentWillReceiveProps(y, _), !l.__e && l.shouldComponentUpdate != null && l.shouldComponentUpdate(y, l.__s, _) === !1 || e.__v === o.__v) {
            for (e.__v !== o.__v && (l.props = y, l.state = l.__s, l.__d = !1), l.__e = !1, e.__e = o.__e, e.__k = o.__k, e.__k.forEach(function(z) {
              z && (z.__ = e);
            }), E = 0; E < l._sb.length; E++)
              l.__h.push(l._sb[E]);
            l._sb = [], l.__h.length && r.push(l);
            break e;
          }
          l.componentWillUpdate != null && l.componentWillUpdate(y, l.__s, _), l.componentDidUpdate != null && l.__h.push(function() {
            l.componentDidUpdate(u, p, v);
          });
        }
        if (l.context = _, l.props = y, l.__P = t, m = S.__r, P = 0, "prototype" in T && T.prototype.render) {
          for (l.state = l.__s, l.__d = !1, m && m(e), d = l.render(l.props, l.state, l.context), k = 0; k < l._sb.length; k++)
            l.__h.push(l._sb[k]);
          l._sb = [];
        } else
          do
            l.__d = !1, m && m(e), d = l.render(l.props, l.state, l.context), l.state = l.__s;
          while (l.__d && ++P < 25);
        l.state = l.__s, l.getChildContext != null && (s = Ue(Ue({}, s), l.getChildContext())), h || l.getSnapshotBeforeUpdate == null || (v = l.getSnapshotBeforeUpdate(u, p)), Tr(t, is(A = d != null && d.type === et && d.key == null ? d.props.children : d) ? A : [A], e, o, s, n, i, r, a, c), l.base = e.__e, e.__h = null, l.__h.length && r.push(l), g && (l.__E = l.__ = null), l.__e = !1;
      } else
        i == null && e.__v === o.__v ? (e.__k = o.__k, e.__e = o.__e) : e.__e = Dc(o.__e, e, o, s, n, i, r, c);
    (d = S.diffed) && d(e);
  } catch (z) {
    e.__v = null, (c || i != null) && (e.__e = a, e.__h = !!c, i[i.indexOf(a)] = null), S.__e(z, e, o);
  }
}
function Or(t, e) {
  S.__c && S.__c(e, t), t.some(function(o) {
    try {
      t = o.__h, o.__h = [], t.some(function(s) {
        s.call(o);
      });
    } catch (s) {
      S.__e(s, o.__v);
    }
  });
}
function Dc(t, e, o, s, n, i, r, a) {
  var c, d, l, h = o.props, u = e.props, p = e.type, v = 0;
  if (p === "svg" && (n = !0), i != null) {
    for (; v < i.length; v++)
      if ((c = i[v]) && "setAttribute" in c == !!p && (p ? c.localName === p : c.nodeType === 3)) {
        t = c, i[v] = null;
        break;
      }
  }
  if (t == null) {
    if (p === null)
      return document.createTextNode(u);
    t = n ? document.createElementNS("http://www.w3.org/2000/svg", p) : document.createElement(p, u.is && u), i = null, a = !1;
  }
  if (p === null)
    h === u || a && t.data === u || (t.data = u);
  else {
    if (i = i && mo.call(t.childNodes), d = (h = o.props || Zo).dangerouslySetInnerHTML, l = u.dangerouslySetInnerHTML, !a) {
      if (i != null)
        for (h = {}, v = 0; v < t.attributes.length; v++)
          h[t.attributes[v].name] = t.attributes[v].value;
      (l || d) && (l && (d && l.__html == d.__html || l.__html === t.innerHTML) || (t.innerHTML = l && l.__html || ""));
    }
    if (Rc(t, u, h, n, a), l)
      e.__k = [];
    else if (Tr(t, is(v = e.props.children) ? v : [v], e, o, s, n && p !== "foreignObject", i, r, i ? i[0] : o.__k && no(o, 0), a), i != null)
      for (v = i.length; v--; )
        i[v] != null && Sr(i[v]);
    a || ("value" in u && (v = u.value) !== void 0 && (v !== t.value || p === "progress" && !v || p === "option" && v !== h.value) && Ko(t, "value", v, h.value, !1), "checked" in u && (v = u.checked) !== void 0 && v !== t.checked && Ko(t, "checked", v, h.checked, !1));
  }
  return t;
}
function Rr(t, e, o) {
  try {
    typeof t == "function" ? t(e) : t.current = e;
  } catch (s) {
    S.__e(s, o);
  }
}
function Dr(t, e, o) {
  var s, n;
  if (S.unmount && S.unmount(t), (s = t.ref) && (s.current && s.current !== t.__e || Rr(s, null, e)), (s = t.__c) != null) {
    if (s.componentWillUnmount)
      try {
        s.componentWillUnmount();
      } catch (i) {
        S.__e(i, e);
      }
    s.base = s.__P = null, t.__c = void 0;
  }
  if (s = t.__k)
    for (n = 0; n < s.length; n++)
      s[n] && Dr(s[n], e, o || typeof t.type != "function");
  o || t.__e == null || Sr(t.__e), t.__ = t.__e = t.__d = void 0;
}
function Mc(t, e, o) {
  return this.constructor(t, o);
}
function tt(t, e, o) {
  var s, n, i;
  S.__ && S.__(t, e), n = (s = typeof o == "function") ? null : o && o.__k || e.__k, i = [], en(e, t = (!s && o || e).__k = re(et, null, [t]), n || Zo, Zo, e.ownerSVGElement !== void 0, !s && o ? [o] : n ? null : e.firstChild ? mo.call(e.childNodes) : null, i, !s && o ? o : n ? n.__e : e.firstChild, s), Or(i, t);
}
function tn(t, e) {
  tt(t, e, tn);
}
function on(t, e, o) {
  var s, n, i, r, a = Ue({}, t.props);
  for (i in t.type && t.type.defaultProps && (r = t.type.defaultProps), e)
    i == "key" ? s = e[i] : i == "ref" ? n = e[i] : a[i] = e[i] === void 0 && r !== void 0 ? r[i] : e[i];
  return arguments.length > 2 && (a.children = arguments.length > 3 ? mo.call(arguments, 2) : o), eo(t.type, a, s || t.key, n || t.ref, null);
}
function sn(t, e) {
  var o = { __c: e = "__cC" + Er++, __: t, Consumer: function(s, n) {
    return s.children(n);
  }, Provider: function(s) {
    var n, i;
    return this.getChildContext || (n = [], (i = {})[e] = this, this.getChildContext = function() {
      return i;
    }, this.shouldComponentUpdate = function(r) {
      this.props.value !== r.value && n.some(function(a) {
        a.__e = !0, Cs(a);
      });
    }, this.sub = function(r) {
      n.push(r);
      var a = r.componentWillUnmount;
      r.componentWillUnmount = function() {
        n.splice(n.indexOf(r), 1), a && a.call(r);
      };
    }), s.children;
  } };
  return o.Provider.__ = o.Consumer.contextType = o;
}
mo = $r.slice, S = { __e: function(t, e, o, s) {
  for (var n, i, r; e = e.__; )
    if ((n = e.__c) && !n.__)
      try {
        if ((i = n.constructor) && i.getDerivedStateFromError != null && (n.setState(i.getDerivedStateFromError(t)), r = n.__d), n.componentDidCatch != null && (n.componentDidCatch(t, s || {}), r = n.__d), r)
          return n.__E = n;
      } catch (a) {
        t = a;
      }
  throw t;
} }, kr = 0, Ie.prototype.setState = function(t, e) {
  var o;
  o = this.__s != null && this.__s !== this.state ? this.__s : this.__s = Ue({}, this.state), typeof t == "function" && (t = t(Ue({}, o), this.props)), t && Ue(o, t), t != null && this.__v && (e && this._sb.push(e), Cs(this));
}, Ie.prototype.forceUpdate = function(t) {
  this.__v && (this.__e = !0, t && this.__h.push(t), Cs(this));
}, Ie.prototype.render = et, ft = [], zr = typeof Promise == "function" ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, Ps = function(t, e) {
  return t.__v.__b - e.__v.__b;
}, Yo.__r = 0, Er = 0;
function nn() {
  return (nn = Object.assign || function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var o = arguments[e];
      for (var s in o)
        Object.prototype.hasOwnProperty.call(o, s) && (t[s] = o[s]);
    }
    return t;
  }).apply(this, arguments);
}
function Nc(t) {
  this.getChildContext = function() {
    return t.context;
  };
  var e = t.children, o = function(s, n) {
    if (s == null)
      return {};
    var i, r, a = {}, c = Object.keys(s);
    for (r = 0; r < c.length; r++)
      n.indexOf(i = c[r]) >= 0 || (a[i] = s[i]);
    return a;
  }(t, ["context", "children"]);
  return on(e, o);
}
function Fc() {
  var t = new CustomEvent("_preact", { detail: {}, bubbles: !0, cancelable: !0 });
  this.dispatchEvent(t), this._vdom = re(Nc, nn({}, this._props, { context: t.detail.context }), function e(o, s) {
    if (o.nodeType === 3)
      return o.data;
    if (o.nodeType !== 1)
      return null;
    var n = [], i = {}, r = 0, a = o.attributes, c = o.childNodes;
    for (r = a.length; r--; )
      a[r].name !== "slot" && (i[a[r].name] = a[r].value, i[Mr(a[r].name)] = a[r].value);
    for (r = c.length; r--; ) {
      var d = e(c[r], null), l = c[r].slot;
      l ? i[l] = re(Hn, { name: l }, d) : n[r] = d;
    }
    var h = s ? re(Hn, null, n) : n;
    return re(s || o.nodeName.toLowerCase(), i, h);
  }(this, this._vdomComponent)), (this.hasAttribute("hydrate") ? tn : tt)(this._vdom, this._root);
}
function Mr(t) {
  return t.replace(/-(\w)/g, function(e, o) {
    return o ? o.toUpperCase() : "";
  });
}
function Bc(t, e, o) {
  if (this._vdom) {
    var s = {};
    s[t] = o = o ?? void 0, s[Mr(t)] = o, this._vdom = on(this._vdom, s), tt(this._vdom, this._root);
  }
}
function Uc() {
  tt(this._vdom = null, this._root);
}
function Hn(t, e) {
  var o = this;
  return re("slot", nn({}, t, { ref: function(s) {
    s ? (o.ref = s, o._listener || (o._listener = function(n) {
      n.stopPropagation(), n.detail.context = e;
    }, s.addEventListener("_preact", o._listener))) : o.ref.removeEventListener("_preact", o._listener);
  } }));
}
function Hc(t, e, o, s) {
  function n() {
    var i = Reflect.construct(HTMLElement, [], n);
    return i._vdomComponent = t, i._root = s && s.shadow ? i.attachShadow({ mode: "open" }) : i, i;
  }
  return (n.prototype = Object.create(HTMLElement.prototype)).constructor = n, n.prototype.connectedCallback = Fc, n.prototype.attributeChangedCallback = Bc, n.prototype.disconnectedCallback = Uc, o = o || t.observedAttributes || Object.keys(t.propTypes || {}), n.observedAttributes = o, o.forEach(function(i) {
    Object.defineProperty(n.prototype, i, { get: function() {
      return this._vdom.props[i];
    }, set: function(r) {
      this._vdom ? this.attributeChangedCallback(i, null, r) : (this._props || (this._props = {}), this._props[i] = r, this.connectedCallback());
      var a = typeof r;
      r != null && a !== "string" && a !== "boolean" && a !== "number" || this.setAttribute(i, r);
    } });
  }), customElements.define(e || t.tagName || t.displayName || t.name, n);
}
var Vc = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, Nr = { exports: {} };
(function(t) {
  (function(e, o) {
    t.exports ? t.exports = o() : e.log = o();
  })(Vc, function() {
    var e = function() {
    }, o = "undefined", s = typeof window !== o && typeof window.navigator !== o && /Trident\/|MSIE /.test(window.navigator.userAgent), n = [
      "trace",
      "debug",
      "info",
      "warn",
      "error"
    ];
    function i(g, y) {
      var b = g[y];
      if (typeof b.bind == "function")
        return b.bind(g);
      try {
        return Function.prototype.bind.call(b, g);
      } catch {
        return function() {
          return Function.prototype.apply.apply(b, [g, arguments]);
        };
      }
    }
    function r() {
      console.log && (console.log.apply ? console.log.apply(console, arguments) : Function.prototype.apply.apply(console.log, [console, arguments])), console.trace && console.trace();
    }
    function a(g) {
      return g === "debug" && (g = "log"), typeof console === o ? !1 : g === "trace" && s ? r : console[g] !== void 0 ? i(console, g) : console.log !== void 0 ? i(console, "log") : e;
    }
    function c(g, y) {
      for (var b = 0; b < n.length; b++) {
        var _ = n[b];
        this[_] = b < g ? e : this.methodFactory(_, g, y);
      }
      this.log = this.debug;
    }
    function d(g, y, b) {
      return function() {
        typeof console !== o && (c.call(this, y, b), this[g].apply(this, arguments));
      };
    }
    function l(g, y, b) {
      return a(g) || d.apply(this, arguments);
    }
    function h(g, y, b) {
      var _ = this, E;
      y = y ?? "WARN";
      var m = "loglevel";
      typeof g == "string" ? m += ":" + g : typeof g == "symbol" && (m = void 0);
      function P(z) {
        var L = (n[z] || "silent").toUpperCase();
        if (!(typeof window === o || !m)) {
          try {
            window.localStorage[m] = L;
            return;
          } catch {
          }
          try {
            window.document.cookie = encodeURIComponent(m) + "=" + L + ";";
          } catch {
          }
        }
      }
      function k() {
        var z;
        if (!(typeof window === o || !m)) {
          try {
            z = window.localStorage[m];
          } catch {
          }
          if (typeof z === o)
            try {
              var L = window.document.cookie, D = L.indexOf(
                encodeURIComponent(m) + "="
              );
              D !== -1 && (z = /^([^;]+)/.exec(L.slice(D))[1]);
            } catch {
            }
          return _.levels[z] === void 0 && (z = void 0), z;
        }
      }
      function A() {
        if (!(typeof window === o || !m)) {
          try {
            window.localStorage.removeItem(m);
            return;
          } catch {
          }
          try {
            window.document.cookie = encodeURIComponent(m) + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC";
          } catch {
          }
        }
      }
      _.name = g, _.levels = {
        TRACE: 0,
        DEBUG: 1,
        INFO: 2,
        WARN: 3,
        ERROR: 4,
        SILENT: 5
      }, _.methodFactory = b || l, _.getLevel = function() {
        return E;
      }, _.setLevel = function(z, L) {
        if (typeof z == "string" && _.levels[z.toUpperCase()] !== void 0 && (z = _.levels[z.toUpperCase()]), typeof z == "number" && z >= 0 && z <= _.levels.SILENT) {
          if (E = z, L !== !1 && P(z), c.call(_, z, g), typeof console === o && z < _.levels.SILENT)
            return "No console available for logging";
        } else
          throw "log.setLevel() called with invalid level: " + z;
      }, _.setDefaultLevel = function(z) {
        y = z, k() || _.setLevel(z, !1);
      }, _.resetLevel = function() {
        _.setLevel(y, !1), A();
      }, _.enableAll = function(z) {
        _.setLevel(_.levels.TRACE, z);
      }, _.disableAll = function(z) {
        _.setLevel(_.levels.SILENT, z);
      };
      var T = k();
      T == null && (T = y), _.setLevel(T, !1);
    }
    var u = new h(), p = {};
    u.getLogger = function(y) {
      if (typeof y != "symbol" && typeof y != "string" || y === "")
        throw new TypeError("You must supply a name when creating a logger.");
      var b = p[y];
      return b || (b = p[y] = new h(
        y,
        u.getLevel(),
        u.methodFactory
      )), b;
    };
    var v = typeof window !== o ? window.log : void 0;
    return u.noConflict = function() {
      return typeof window !== o && window.log === u && (window.log = v), u;
    }, u.getLoggers = function() {
      return p;
    }, u.default = u, u;
  });
})(Nr);
var de = Nr.exports;
const Vn = de.getLogger("EventEmitter");
let jc = class {
  constructor() {
    C(this, "listeners", []);
  }
  addEventListener(e) {
    if (!this.listeners.includes(e))
      this.listeners.push(e);
    else
      throw new Error(`Listener ${e} already registered`);
  }
  removeEventListener(e) {
    const o = this.listeners;
    o.includes(e) ? this.listeners = o.filter((s) => s !== e) : Vn.warn(`Listener ${e} was not registered`);
  }
  fireEvent(e) {
    this.listeners.forEach((o) => {
      try {
        o(e);
      } catch (s) {
        Vn.error("Error invoking listener", o, "for event", e, "error", s);
      }
    });
  }
};
const Wc = "https://api-player.redbull.com", qc = "https://api-player-staging.redbull.com";
function rn(t, e) {
  if (e && !isNaN(e))
    return `https://rbup-datamanager-pr-${e}.herokuapp.com`;
  switch (t) {
    case "PRODUCTION":
      return Wc;
    case "STAGING":
      return qc;
    default:
      throw new Error("unknown server environment");
  }
}
de.getLogger("fetchUserLocation");
class Gc {
  async loadData(e) {
    if (!e.mediaSrc)
      throw new Error("invalid configuration, player configuration requires mediaSrc");
    return {
      coverArt: e.coverArt,
      duration: e.duration,
      episodeNumber: e.episodeNumber,
      episodePageUrl: e.episodePageUrl,
      mediaSrc: e.mediaSrc,
      podcastTitle: e.podcastTitle,
      podcastShowPageUrl: e.podcastShowPageUrl,
      publishedAt: e.publishedAt,
      seasonNumber: e.seasonNumber,
      space: e.space,
      title: e.title,
      waveformPoints: e.waveformPoints,
      distributions: e.distributions
    };
  }
}
function Ke(t) {
  return t < 0 ? `${t}` : t < 10 ? `0${t}` : `${t}`;
}
const jn = 10, Ts = "rbup-video-core", Bo = "rbup-audio-core", Zc = [
  "adFinished",
  "adSkipped",
  "beforePlay",
  "loaded",
  "muted",
  "paused",
  "play",
  "playbackFinished",
  "seeking",
  "timeChanged",
  "timeshifting",
  "unmuted",
  "nextUpCancelled",
  "nextUpDisplayed",
  "nextUpTimeout",
  "nextUpTriggered",
  "podcastTitleClick"
], Yc = "Enter";
de.getLogger("AspectRatioUtils");
const Gt = {
  small: 540,
  medium: 650,
  large: 1e3,
  xLarge: 1200,
  xxLarge: 1350
}, Kc = [
  Gt.small,
  Gt.medium,
  Gt.large,
  Gt.xLarge,
  Gt.xxLarge
], Xc = [
  { placeholder: "/im/", transformation: (t) => `/im:i:${t}/` },
  { placeholder: "/{op}/", transformation: (t) => `/${t}/` }
], Jc = [512, 384, 256, 192, 128, 96];
function Qc(t) {
  if (t !== void 0)
    return Jc.map((e) => {
      const o = e;
      return {
        src: el(t, e, 1),
        sizes: `${e}x${o}`
      };
    });
}
function el(t, e, o) {
  return Xc.reduce((s, { placeholder: n, transformation: i }) => s.replace(n, i(`c_fill,w_${e},ar_${o},q_auto,g_auto,f_auto`)), t);
}
function Wn(t) {
  return t.changedTouches.length >= 1 ? t.changedTouches[0] : void 0;
}
function tl(t) {
  var e, o;
  return nl(t) ? {
    clientX: ((e = Wn(t)) == null ? void 0 : e.clientX) ?? 0,
    clientY: ((o = Wn(t)) == null ? void 0 : o.clientY) ?? 0
  } : {
    clientX: t.clientX,
    clientY: t.clientY
  };
}
function ol(t, e) {
  const o = e.current;
  if (!o)
    return;
  const s = o.getBoundingClientRect(), n = tl(t), i = n.clientX - (s.x + document.body.scrollLeft), r = n.clientY - (s.y + document.body.scrollTop);
  return { x: i, y: r, elementBoundingRect: s };
}
function sl(t, e) {
  const o = ol(t, e);
  if (o) {
    const s = o.elementBoundingRect.width, n = o.x >= 0, i = o.x <= s, r = n ? o.x : 0, a = i ? s : o.x;
    return an(r / a);
  }
}
function nl(t) {
  return t.type.includes("touch");
}
function qn() {
  return window.navigator.language ? window.navigator.language.split("-")[0] : "";
}
function Is(t) {
  const e = Math.floor(t / 3600), o = Math.floor(t / 60) - e * 60, s = Math.floor(t) % 60;
  return e < 1 ? `${Ke(o)}:${Ke(s)}` : `${Ke(e)}:${Ke(o)}:${Ke(s)}`;
}
function Fr(t) {
  let e = {};
  return t != null && t.fontFamily && (e = {
    ...e,
    "--rbup-font-family": t.fontFamily
  }), t != null && t.componentFontFamily && (e = {
    ...e,
    "--rbup-component-font-family": t.componentFontFamily
  }), t != null && t.primaryColor && (e = {
    ...e,
    "--rbup-primary-color": t.primaryColor,
    "--rbup-play-button-background-color": t.primaryColor,
    "--rbup-play-button-background-hover-color": t.primaryColorHover ?? t.primaryColor
  }), t != null && t.lineHeight && (e = {
    ...e,
    "--rbup-text-line-height": t.lineHeight
  }), t != null && t.containerBackgroundColor && (e = {
    ...e,
    "--rbup-container16x9-background-color": t.containerBackgroundColor
  }), e;
}
function il(t, e) {
  switch (t) {
    case "ENDED":
    case "BUFFERING":
      return;
    case "PLAYING":
      e == null || e.pause();
      break;
    case "PAUSED":
    case "IDLE":
      e == null || e.play();
      break;
  }
}
function Br() {
  return /(?:iPhone|iPad|iPod|Android)/.test(window.navigator.userAgent) ? !0 : window.navigator.maxTouchPoints >= 3;
}
const rl = {
  primary: 0,
  secondary: 1,
  auxiliary: 2,
  back: 3
}, Ur = {
  mouse: "mouse",
  touch: "touch"
};
function al(t) {
  return cl(t) && t.button === rl.primary;
}
function cl(t) {
  return t.pointerType === Ur.mouse;
}
function ll(t) {
  return t.pointerType === Ur.touch;
}
function an(t) {
  return Hr(t, 5);
}
function dl(t) {
  return Hr(t, 2);
}
function Hr(t, e) {
  const o = Math.pow(10, e);
  return Math.round(t * o) / o;
}
function ul(t, e) {
  if (t.size !== e.size)
    return !1;
  for (const o of t)
    if (!e.has(o))
      return !1;
  return !0;
}
function fs(t) {
  return typeof t == "boolean" ? t : typeof t == "string" ? t === "true" : !1;
}
function ml() {
  let t, e;
  const o = new Promise((s, n) => {
    t = s, e = n;
  });
  return Object.assign(o, {
    resolve: (s) => t(s),
    reject: (s) => e(s)
  });
}
function cn(t) {
  return fl(t) && t.hasOwnProperty("message") ? t.message : `Unknown error ${t == null ? void 0 : t.toString()}`;
}
function fl(t) {
  return !!t && typeof t == "object";
}
const Vr = "rbup-video-cosmos-font-injection";
function pl(t) {
  if (!hl()) {
    const e = document.createElement("style");
    e.id = Vr, e.innerHTML = t, document.getElementsByTagName("head")[0].appendChild(e);
  }
}
function hl() {
  return document.getElementById(Vr) !== null;
}
function jr(t, e) {
  const { playerId: o } = e, s = vl(t), n = {
    type: "nextEpisodeTriggered",
    playerId: o,
    issuer: s
  };
  e.dispatchPlayerEvent(n);
}
const vl = (t) => t === "NEXT_EPISODE_TRIGGERED_AUTOMATICALLY" ? "AUTOMATICALLY" : "USER";
function gl(t, e, o) {
  const s = t.getAttributeNames(), n = Object.keys(e);
  for (const i of s)
    i !== "id" && !n.includes(i) && (o.debug("removing excess attribute from web component", i), t.removeAttribute(i));
}
function bl(t) {
  for (const e in t)
    t[e] === void 0 && delete t[e];
}
const yl = (t) => t.toLowerCase().split("-").map((e) => e.charAt(0).toUpperCase() + e.slice(1)).join(""), xl = (t) => t.indexOf("on") === 0 && t[2] === t[2].toUpperCase(), _l = (t) => `on${t[2].toLowerCase()}${t.substring(3)}`;
function H({ tagName: t, defaultProps: e, defineCustomElement: o }) {
  o !== void 0 && o();
  const s = (n) => {
    const i = Object.entries(n).reduce((r, [a, c]) => xl(a) ? Object.assign(Object.assign({}, r), { [`${_l(a)}`]: c }) : Object.assign(Object.assign({}, r), { [a]: c }), {});
    return re(t, Object.assign(Object.assign({}, e), i));
  };
  return s.displayName = `${yl(t)}`, s;
}
const wl = "cosmos-web", ln = (
  /* cosmos-web */
  { allRenderFn: !0, appendChildSlotFix: !1, asyncLoading: !0, asyncQueue: !1, attachStyles: !0, cloneNodeFix: !1, cmpDidLoad: !0, cmpDidRender: !0, cmpDidUnload: !1, cmpDidUpdate: !1, cmpShouldUpdate: !1, cmpWillLoad: !0, cmpWillRender: !0, cmpWillUpdate: !1, connectedCallback: !0, constructableCSS: !0, cssAnnotations: !0, devTools: !1, disconnectedCallback: !0, element: !1, event: !0, experimentalScopedSlotChanges: !1, experimentalSlotFixes: !1, formAssociated: !1, hasRenderFn: !0, hostListener: !0, hostListenerTarget: !1, hostListenerTargetBody: !1, hostListenerTargetDocument: !1, hostListenerTargetParent: !1, hostListenerTargetWindow: !1, hotModuleReplacement: !1, hydrateClientSide: !0, hydrateServerSide: !1, hydratedAttribute: !1, hydratedClass: !0, hydratedSelectorName: "hydrated", invisiblePrehydration: !0, isDebug: !1, isDev: !1, isTesting: !1, lazyLoad: !1, lifecycle: !0, lifecycleDOMEvents: !1, member: !0, method: !0, mode: !1, observeAttribute: !0, profile: !1, prop: !0, propBoolean: !0, propMutable: !0, propNumber: !0, propString: !0, reflect: !0, scoped: !1, scopedSlotTextContentFix: !1, scriptDataOpts: !1, shadowDelegatesFocus: !1, shadowDom: !0, slot: !0, slotChildNodesFix: !1, slotRelocation: !0, state: !0, style: !0, svg: !0, taskQueue: !0, updatable: !0, vdomAttribute: !0, vdomClass: !0, vdomFunctional: !0, vdomKey: !0, vdomListener: !0, vdomPropOrAttr: !0, vdomRef: !0, vdomRender: !0, vdomStyle: !0, vdomText: !0, vdomXlink: !1, watchCallback: !0 }
);
var kl = Object.defineProperty, zl = (t, e) => {
  for (var o in e)
    kl(t, o, { get: e[o], enumerable: !0 });
}, Gn = {}, El = "http://www.w3.org/2000/svg", $l = "http://www.w3.org/1999/xhtml", Sl = (t) => t != null, dn = (t) => (t = typeof t, t === "object" || t === "function");
function Pl(t) {
  var e, o, s;
  return (s = (o = (e = t.head) == null ? void 0 : e.querySelector('meta[name="csp-nonce"]')) == null ? void 0 : o.getAttribute("content")) != null ? s : void 0;
}
var Cl = {};
zl(Cl, {
  err: () => Wr,
  map: () => Tl,
  ok: () => Ls,
  unwrap: () => Il,
  unwrapErr: () => Ll
});
var Ls = (t) => ({
  isOk: !0,
  isErr: !1,
  value: t
}), Wr = (t) => ({
  isOk: !1,
  isErr: !0,
  value: t
});
function Tl(t, e) {
  if (t.isOk) {
    const o = e(t.value);
    return o instanceof Promise ? o.then((s) => Ls(s)) : Ls(o);
  }
  if (t.isErr) {
    const o = t.value;
    return Wr(o);
  }
  throw "should never get here";
}
var Il = (t) => {
  if (t.isOk)
    return t.value;
  throw t.value;
}, Ll = (t) => {
  if (t.isErr)
    return t.value;
  throw t.value;
}, Ve = (t, e = "") => () => {
}, Al = (t, e) => () => {
}, Ol = "r", Rl = "o", Dl = "s", Ml = "t", As = "s-id", Nl = "sty-id", Zn = "c-id", Fl = "slot-fb{display:contents}slot-fb[hidden]{display:none}", w = (t, e, ...o) => {
  let s = null, n = null, i = null, r = !1, a = !1;
  const c = [], d = (h) => {
    for (let u = 0; u < h.length; u++)
      s = h[u], Array.isArray(s) ? d(s) : s != null && typeof s != "boolean" && ((r = typeof t != "function" && !dn(s)) && (s = String(s)), r && a ? c[c.length - 1].$text$ += s : c.push(r ? Lt(null, s) : s), a = r);
  };
  if (d(o), e) {
    e.key && (n = e.key), e.name && (i = e.name);
    {
      const h = e.className || e.class;
      h && (e.class = typeof h != "object" ? h : Object.keys(h).filter((u) => h[u]).join(" "));
    }
  }
  if (typeof t == "function")
    return t(
      e === null ? {} : e,
      c,
      Ul
    );
  const l = Lt(t, null);
  return l.$attrs$ = e, c.length > 0 && (l.$children$ = c), l.$key$ = n, l.$name$ = i, l;
}, Lt = (t, e) => {
  const o = {
    $flags$: 0,
    $tag$: t,
    $text$: e,
    $elm$: null,
    $children$: null
  };
  return o.$attrs$ = null, o.$key$ = null, o.$name$ = null, o;
}, ee = {}, Bl = (t) => t && t.$tag$ === ee, Ul = {
  forEach: (t, e) => t.map(Yn).forEach(e),
  map: (t, e) => t.map(Yn).map(e).map(Hl)
}, Yn = (t) => ({
  vattrs: t.$attrs$,
  vchildren: t.$children$,
  vkey: t.$key$,
  vname: t.$name$,
  vtag: t.$tag$,
  vtext: t.$text$
}), Hl = (t) => {
  if (typeof t.vtag == "function") {
    const o = { ...t.vattrs };
    return t.vkey && (o.key = t.vkey), t.vname && (o.name = t.vname), w(t.vtag, o, ...t.vchildren || []);
  }
  const e = Lt(t.vtag, t.vtext);
  return e.$attrs$ = t.vattrs, e.$children$ = t.vchildren, e.$key$ = t.vkey, e.$name$ = t.vname, e;
}, Vl = (t, e, o, s) => {
  const n = Ve("hydrateClient", e), i = t.shadowRoot, r = [], a = [], c = i ? [] : null, d = s.$vnode$ = Lt(e, null);
  G.$orgLocNodes$ || Rs(ge.body, G.$orgLocNodes$ = /* @__PURE__ */ new Map()), t[As] = o, t.removeAttribute(As), Os(d, r, a, c, t, t, o), r.map((l) => {
    const h = l.$hostId$ + "." + l.$nodeId$, u = G.$orgLocNodes$.get(h), p = l.$elm$;
    u && hd && u["s-en"] === "" && u.parentNode.insertBefore(p, u.nextSibling), i || (p["s-hn"] = e, u && (p["s-ol"] = u, p["s-ol"]["s-nr"] = p)), G.$orgLocNodes$.delete(h);
  }), i && c.map((l) => {
    l && i.appendChild(l);
  }), n();
}, Os = (t, e, o, s, n, i, r) => {
  let a, c, d, l;
  if (i.nodeType === 1) {
    for (a = i.getAttribute(Zn), a && (c = a.split("."), (c[0] === r || c[0] === "0") && (d = {
      $flags$: 0,
      $hostId$: c[0],
      $nodeId$: c[1],
      $depth$: c[2],
      $index$: c[3],
      $tag$: i.tagName.toLowerCase(),
      $elm$: i,
      $attrs$: null,
      $children$: null,
      $key$: null,
      $name$: null,
      $text$: null
    }, e.push(d), i.removeAttribute(Zn), t.$children$ || (t.$children$ = []), t.$children$[d.$index$] = d, t = d, s && d.$depth$ === "0" && (s[d.$index$] = d.$elm$))), l = i.childNodes.length - 1; l >= 0; l--)
      Os(
        t,
        e,
        o,
        s,
        n,
        i.childNodes[l],
        r
      );
    if (i.shadowRoot)
      for (l = i.shadowRoot.childNodes.length - 1; l >= 0; l--)
        Os(
          t,
          e,
          o,
          s,
          n,
          i.shadowRoot.childNodes[l],
          r
        );
  } else if (i.nodeType === 8)
    c = i.nodeValue.split("."), (c[1] === r || c[1] === "0") && (a = c[0], d = {
      $flags$: 0,
      $hostId$: c[1],
      $nodeId$: c[2],
      $depth$: c[3],
      $index$: c[4],
      $elm$: i,
      $attrs$: null,
      $children$: null,
      $key$: null,
      $name$: null,
      $tag$: null,
      $text$: null
    }, a === Ml ? (d.$elm$ = i.nextSibling, d.$elm$ && d.$elm$.nodeType === 3 && (d.$text$ = d.$elm$.textContent, e.push(d), i.remove(), t.$children$ || (t.$children$ = []), t.$children$[d.$index$] = d, s && d.$depth$ === "0" && (s[d.$index$] = d.$elm$))) : d.$hostId$ === r && (a === Dl ? (d.$tag$ = "slot", c[5] ? i["s-sn"] = d.$name$ = c[5] : i["s-sn"] = "", i["s-sr"] = !0, s && (d.$elm$ = ge.createElement(d.$tag$), d.$name$ && d.$elm$.setAttribute("name", d.$name$), i.parentNode.insertBefore(d.$elm$, i), i.remove(), d.$depth$ === "0" && (s[d.$index$] = d.$elm$)), o.push(d), t.$children$ || (t.$children$ = []), t.$children$[d.$index$] = d) : a === Ol && (s ? i.remove() : (n["s-cr"] = i, i["s-cn"] = !0))));
  else if (t && t.$tag$ === "style") {
    const h = Lt(null, i.textContent);
    h.$elm$ = i, h.$index$ = "0", t.$children$ = [h];
  }
}, Rs = (t, e) => {
  if (t.nodeType === 1) {
    let o = 0;
    for (; o < t.childNodes.length; o++)
      Rs(t.childNodes[o], e);
    if (t.shadowRoot)
      for (o = 0; o < t.shadowRoot.childNodes.length; o++)
        Rs(t.shadowRoot.childNodes[o], e);
  } else if (t.nodeType === 8) {
    const o = t.nodeValue.split(".");
    o[0] === Rl && (e.set(o[1] + "." + o[2], t), t.nodeValue = "", t["s-en"] = o[3]);
  }
}, jl = (t, e) => t != null && !dn(t) ? e & 4 ? t === "false" ? !1 : t === "" || !!t : e & 2 ? parseFloat(t) : e & 1 ? String(t) : t : t, Wl = (t) => t, Ds = (t, e, o) => {
  const s = Wl(t);
  return {
    emit: (n) => qr(s, e, {
      bubbles: !!(o & 4),
      composed: !!(o & 2),
      cancelable: !!(o & 1),
      detail: n
    })
  };
}, qr = (t, e, o) => {
  const s = G.ce(e, o);
  return t.dispatchEvent(s), s;
}, Kn = /* @__PURE__ */ new WeakMap(), ql = (t, e, o) => {
  let s = es.get(t);
  bd && o ? (s = s || new CSSStyleSheet(), typeof s == "string" ? s = e : s.replaceSync(e)) : s = e, es.set(t, s);
}, Gr = (t, e, o) => {
  var s;
  const n = Zr(e), i = es.get(n);
  if (t = t.nodeType === 11 ? t : ge, i)
    if (typeof i == "string") {
      t = t.head || t;
      let r = Kn.get(t), a;
      if (r || Kn.set(t, r = /* @__PURE__ */ new Set()), !r.has(n)) {
        if (t.host && (a = t.querySelector(`[${Nl}="${n}"]`)))
          a.innerHTML = i;
        else {
          a = ge.createElement("style"), a.innerHTML = i;
          const c = (s = G.$nonce$) != null ? s : Pl(ge);
          c != null && a.setAttribute("nonce", c), t.insertBefore(a, t.querySelector("link"));
        }
        e.$flags$ & 4 && (a.innerHTML += Fl), r && r.add(n);
      }
    } else
      t.adoptedStyleSheets.includes(i) || (t.adoptedStyleSheets = [...t.adoptedStyleSheets, i]);
  return n;
}, Gl = (t) => {
  const e = t.$cmpMeta$, o = t.$hostElement$, s = e.$flags$, n = Ve("attachStyles", e.$tagName$), i = Gr(
    o.shadowRoot ? o.shadowRoot : o.getRootNode(),
    e
  );
  s & 10 && (o["s-sc"] = i, o.classList.add(i + "-h")), n();
}, Zr = (t, e) => "sc-" + t.$tagName$, Xn = (t, e, o, s, n, i) => {
  if (o !== s) {
    let r = oi(t, e), a = e.toLowerCase();
    if (e === "class") {
      const c = t.classList, d = Jn(o), l = Jn(s);
      c.remove(...d.filter((h) => h && !l.includes(h))), c.add(...l.filter((h) => h && !d.includes(h)));
    } else if (e === "style") {
      for (const c in o)
        (!s || s[c] == null) && (c.includes("-") ? t.style.removeProperty(c) : t.style[c] = "");
      for (const c in s)
        (!o || s[c] !== o[c]) && (c.includes("-") ? t.style.setProperty(c, s[c]) : t.style[c] = s[c]);
    } else if (e !== "key")
      if (e === "ref")
        s && s(t);
      else if (!t.__lookupSetter__(e) && e[0] === "o" && e[1] === "n") {
        if (e[2] === "-" ? e = e.slice(3) : oi(rs, a) ? e = a.slice(2) : e = a[2] + e.slice(3), o || s) {
          const c = e.endsWith(Yr);
          e = e.replace(Yl, ""), o && G.rel(t, e, o, c), s && G.ael(t, e, s, c);
        }
      } else {
        const c = dn(s);
        if ((r || c && s !== null) && !n)
          try {
            if (t.tagName.includes("-"))
              t[e] = s;
            else {
              const d = s ?? "";
              e === "list" ? r = !1 : (o == null || t[e] != d) && (t[e] = d);
            }
          } catch {
          }
        s == null || s === !1 ? (s !== !1 || t.getAttribute(e) === "") && t.removeAttribute(e) : (!r || i & 4 || n) && !c && (s = s === !0 ? "" : s, t.setAttribute(e, s));
      }
  }
}, Zl = /\s/, Jn = (t) => t ? t.split(Zl) : [], Yr = "Capture", Yl = new RegExp(Yr + "$"), Kr = (t, e, o) => {
  const s = e.$elm$.nodeType === 11 && e.$elm$.host ? e.$elm$.host : e.$elm$, n = t && t.$attrs$ || Gn, i = e.$attrs$ || Gn;
  for (const r of Qn(Object.keys(n)))
    r in i || Xn(s, r, n[r], void 0, o, e.$flags$);
  for (const r of Qn(Object.keys(i)))
    Xn(s, r, n[r], i[r], o, e.$flags$);
};
function Qn(t) {
  return t.includes("ref") ? (
    // we need to sort these to ensure that `'ref'` is the last attr
    [...t.filter((e) => e !== "ref"), "ref"]
  ) : (
    // no need to sort, return the original array
    t
  );
}
var $t, Ms, io, un = !1, Xo = !1, mn = !1, fe = !1, Jo = (t, e, o, s) => {
  var n;
  const i = e.$children$[o];
  let r = 0, a, c, d;
  if (un || (mn = !0, i.$tag$ === "slot" && ($t && s.classList.add($t + "-s"), i.$flags$ |= i.$children$ ? (
    // slot element has fallback content
    // still create an element that "mocks" the slot element
    2
  ) : (
    // slot element does not have fallback content
    // create an html comment we'll use to always reference
    // where actual slot content should sit next to
    1
  ))), i.$text$ !== null)
    a = i.$elm$ = ge.createTextNode(i.$text$);
  else if (i.$flags$ & 1)
    a = i.$elm$ = ge.createTextNode("");
  else {
    if (fe || (fe = i.$tag$ === "svg"), a = i.$elm$ = ge.createElementNS(
      fe ? El : $l,
      i.$flags$ & 2 ? "slot-fb" : i.$tag$
    ), fe && i.$tag$ === "foreignObject" && (fe = !1), Kr(null, i, fe), Sl($t) && a["s-si"] !== $t && a.classList.add(a["s-si"] = $t), i.$children$)
      for (r = 0; r < i.$children$.length; ++r)
        c = Jo(t, i, r, a), c && a.appendChild(c);
    i.$tag$ === "svg" ? fe = !1 : a.tagName === "foreignObject" && (fe = !0);
  }
  return a["s-hn"] = io, i.$flags$ & 3 && (a["s-sr"] = !0, a["s-cr"] = Ms, a["s-sn"] = i.$name$ || "", a["s-rf"] = (n = i.$attrs$) == null ? void 0 : n.ref, d = t && t.$children$ && t.$children$[o], d && d.$tag$ === i.$tag$ && t.$elm$ && ro(t.$elm$, !1)), a;
}, ro = (t, e) => {
  G.$flags$ |= 1;
  const o = Array.from(t.childNodes);
  if (t["s-sr"] && ln.experimentalSlotFixes) {
    let s = t;
    for (; s = s.nextSibling; )
      s && s["s-sn"] === t["s-sn"] && s["s-sh"] === io && o.push(s);
  }
  for (let s = o.length - 1; s >= 0; s--) {
    const n = o[s];
    n["s-hn"] !== io && n["s-ol"] && (Qe(Qr(n), n, fn(n)), n["s-ol"].remove(), n["s-ol"] = void 0, n["s-sh"] = void 0, mn = !0), e && ro(n, e);
  }
  G.$flags$ &= -2;
}, Xr = (t, e, o, s, n, i) => {
  let r = t["s-cr"] && t["s-cr"].parentNode || t, a;
  for (r.shadowRoot && r.tagName === io && (r = r.shadowRoot); n <= i; ++n)
    s[n] && (a = Jo(null, o, n, t), a && (s[n].$elm$ = a, Qe(r, a, fn(e))));
}, Jr = (t, e, o) => {
  for (let s = e; s <= o; ++s) {
    const n = t[s];
    if (n) {
      const i = n.$elm$;
      oa(n), i && (Xo = !0, i["s-ol"] ? i["s-ol"].remove() : ro(i, !0), i.remove());
    }
  }
}, Kl = (t, e, o, s, n = !1) => {
  let i = 0, r = 0, a = 0, c = 0, d = e.length - 1, l = e[0], h = e[d], u = s.length - 1, p = s[0], v = s[u], g, y;
  for (; i <= d && r <= u; )
    if (l == null)
      l = e[++i];
    else if (h == null)
      h = e[--d];
    else if (p == null)
      p = s[++r];
    else if (v == null)
      v = s[--u];
    else if (To(l, p, n))
      St(l, p, n), l = e[++i], p = s[++r];
    else if (To(h, v, n))
      St(h, v, n), h = e[--d], v = s[--u];
    else if (To(l, v, n))
      (l.$tag$ === "slot" || v.$tag$ === "slot") && ro(l.$elm$.parentNode, !1), St(l, v, n), Qe(t, l.$elm$, h.$elm$.nextSibling), l = e[++i], v = s[--u];
    else if (To(h, p, n))
      (l.$tag$ === "slot" || v.$tag$ === "slot") && ro(h.$elm$.parentNode, !1), St(h, p, n), Qe(t, h.$elm$, l.$elm$), h = e[--d], p = s[++r];
    else {
      for (a = -1, c = i; c <= d; ++c)
        if (e[c] && e[c].$key$ !== null && e[c].$key$ === p.$key$) {
          a = c;
          break;
        }
      a >= 0 ? (y = e[a], y.$tag$ !== p.$tag$ ? g = Jo(e && e[r], o, a, t) : (St(y, p, n), e[a] = void 0, g = y.$elm$), p = s[++r]) : (g = Jo(e && e[r], o, r, t), p = s[++r]), g && Qe(Qr(l.$elm$), g, fn(l.$elm$));
    }
  i > d ? Xr(
    t,
    s[u + 1] == null ? null : s[u + 1].$elm$,
    o,
    s,
    r,
    u
  ) : r > u && Jr(e, i, d);
}, To = (t, e, o = !1) => t.$tag$ === e.$tag$ ? t.$tag$ === "slot" ? t.$name$ === e.$name$ : o ? !0 : t.$key$ === e.$key$ : !1, fn = (t) => t && t["s-ol"] || t, Qr = (t) => (t["s-ol"] ? t["s-ol"] : t).parentNode, St = (t, e, o = !1) => {
  const s = e.$elm$ = t.$elm$, n = t.$children$, i = e.$children$, r = e.$tag$, a = e.$text$;
  let c;
  a === null ? (fe = r === "svg" ? !0 : r === "foreignObject" ? !1 : fe, r === "slot" && !un || Kr(t, e, fe), n !== null && i !== null ? Kl(s, n, e, i, o) : i !== null ? (t.$text$ !== null && (s.textContent = ""), Xr(s, null, e, i, 0, i.length - 1)) : n !== null && Jr(n, 0, n.length - 1), fe && r === "svg" && (fe = !1)) : (c = s["s-cr"]) ? c.parentNode.textContent = a : t.$text$ !== a && (s.data = a);
}, ea = (t) => {
  const e = t.childNodes;
  for (const o of e)
    if (o.nodeType === 1) {
      if (o["s-sr"]) {
        const s = o["s-sn"];
        o.hidden = !1;
        for (const n of e)
          if (n !== o) {
            if (n["s-hn"] !== o["s-hn"] || s !== "") {
              if (n.nodeType === 1 && (s === n.getAttribute("slot") || s === n["s-sn"]) || n.nodeType === 3 && s === n["s-sn"]) {
                o.hidden = !0;
                break;
              }
            } else if (n.nodeType === 1 || n.nodeType === 3 && n.textContent.trim() !== "") {
              o.hidden = !0;
              break;
            }
          }
      }
      ea(o);
    }
}, Fe = [], ta = (t) => {
  let e, o, s;
  for (const n of t.childNodes) {
    if (n["s-sr"] && (e = n["s-cr"]) && e.parentNode) {
      o = e.parentNode.childNodes;
      const i = n["s-sn"];
      for (s = o.length - 1; s >= 0; s--)
        if (e = o[s], !e["s-cn"] && !e["s-nr"] && e["s-hn"] !== n["s-hn"] && !ln.experimentalSlotFixes)
          if (ei(e, i)) {
            let r = Fe.find((a) => a.$nodeToRelocate$ === e);
            Xo = !0, e["s-sn"] = e["s-sn"] || i, r ? (r.$nodeToRelocate$["s-sh"] = n["s-hn"], r.$slotRefNode$ = n) : (e["s-sh"] = n["s-hn"], Fe.push({
              $slotRefNode$: n,
              $nodeToRelocate$: e
            })), e["s-sr"] && Fe.map((a) => {
              ei(a.$nodeToRelocate$, e["s-sn"]) && (r = Fe.find((c) => c.$nodeToRelocate$ === e), r && !a.$slotRefNode$ && (a.$slotRefNode$ = r.$slotRefNode$));
            });
          } else
            Fe.some((r) => r.$nodeToRelocate$ === e) || Fe.push({
              $nodeToRelocate$: e
            });
    }
    n.nodeType === 1 && ta(n);
  }
}, ei = (t, e) => t.nodeType === 1 ? t.getAttribute("slot") === null && e === "" || t.getAttribute("slot") === e : t["s-sn"] === e ? !0 : e === "", oa = (t) => {
  t.$attrs$ && t.$attrs$.ref && t.$attrs$.ref(null), t.$children$ && t.$children$.map(oa);
}, Qe = (t, e, o) => t == null ? void 0 : t.insertBefore(e, o), Xl = (t, e, o = !1) => {
  var s, n, i, r;
  const a = t.$hostElement$, c = t.$cmpMeta$, d = t.$vnode$ || Lt(null, null), l = Bl(e) ? e : w(null, null, e);
  if (io = a.tagName, c.$attrsToReflect$ && (l.$attrs$ = l.$attrs$ || {}, c.$attrsToReflect$.map(
    ([h, u]) => l.$attrs$[u] = a[h]
  )), o && l.$attrs$)
    for (const h of Object.keys(l.$attrs$))
      a.hasAttribute(h) && !["key", "ref", "style", "class"].includes(h) && (l.$attrs$[h] = a[h]);
  l.$tag$ = null, l.$flags$ |= 4, t.$vnode$ = l, l.$elm$ = d.$elm$ = a.shadowRoot || a, $t = a["s-sc"], un = (c.$flags$ & 1) !== 0, Ms = a["s-cr"], Xo = !1, St(d, l, o);
  {
    if (G.$flags$ |= 1, mn) {
      ta(l.$elm$);
      for (const h of Fe) {
        const u = h.$nodeToRelocate$;
        if (!u["s-ol"]) {
          const p = ge.createTextNode("");
          p["s-nr"] = u, Qe(u.parentNode, u["s-ol"] = p, u);
        }
      }
      for (const h of Fe) {
        const u = h.$nodeToRelocate$, p = h.$slotRefNode$;
        if (p) {
          const v = p.parentNode;
          let g = p.nextSibling;
          {
            let y = (s = u["s-ol"]) == null ? void 0 : s.previousSibling;
            for (; y; ) {
              let b = (n = y["s-nr"]) != null ? n : null;
              if (b && b["s-sn"] === u["s-sn"] && v === b.parentNode) {
                for (b = b.nextSibling; b === u || b != null && b["s-sr"]; )
                  b = b == null ? void 0 : b.nextSibling;
                if (!b || !b["s-nr"]) {
                  g = b;
                  break;
                }
              }
              y = y.previousSibling;
            }
          }
          (!g && v !== u.parentNode || u.nextSibling !== g) && u !== g && (!u["s-hn"] && u["s-ol"] && (u["s-hn"] = u["s-ol"].parentNode.nodeName), Qe(v, u, g), u.nodeType === 1 && (u.hidden = (i = u["s-ih"]) != null ? i : !1)), u && typeof p["s-rf"] == "function" && p["s-rf"](u);
        } else
          u.nodeType === 1 && (o && (u["s-ih"] = (r = u.hidden) != null ? r : !1), u.hidden = !0);
      }
    }
    Xo && ea(l.$elm$), G.$flags$ &= -2, Fe.length = 0;
  }
  Ms = void 0;
}, sa = (t, e) => {
  e && !t.$onRenderResolve$ && e["s-p"] && e["s-p"].push(new Promise((o) => t.$onRenderResolve$ = o));
}, pn = (t, e) => {
  if (t.$flags$ |= 16, t.$flags$ & 4) {
    t.$flags$ |= 512;
    return;
  }
  return sa(t, t.$ancestorComponent$), xd(() => Jl(t, e));
}, Jl = (t, e) => {
  const o = t.$hostElement$, s = Ve("scheduleUpdate", t.$cmpMeta$.$tagName$), n = o;
  if (!n)
    throw new Error(
      `Can't render component <${o.tagName.toLowerCase()} /> with invalid Stencil runtime! Make sure this imported component is compiled with a \`externalRuntime: true\` flag. For more information, please refer to https://stenciljs.com/docs/custom-elements#externalruntime`
    );
  let i;
  return e && (i = Qo(n, "componentWillLoad")), i = ti(i, () => Qo(n, "componentWillRender")), s(), ti(i, () => ed(t, n, e));
}, ti = (t, e) => Ql(t) ? t.then(e) : e(), Ql = (t) => t instanceof Promise || t && t.then && typeof t.then == "function", ed = async (t, e, o) => {
  var s;
  const n = t.$hostElement$, i = Ve("update", t.$cmpMeta$.$tagName$), r = n["s-rc"];
  o && Gl(t);
  const a = Ve("render", t.$cmpMeta$.$tagName$);
  td(t, e, n, o), r && (r.map((c) => c()), n["s-rc"] = void 0), a(), i();
  {
    const c = (s = n["s-p"]) != null ? s : [], d = () => od(t);
    c.length === 0 ? d() : (Promise.all(c).then(d), t.$flags$ |= 4, c.length = 0);
  }
}, td = (t, e, o, s) => {
  try {
    e = e.render(), t.$flags$ &= -17, t.$flags$ |= 2, Xl(t, e, s);
  } catch (n) {
    bt(n, t.$hostElement$);
  }
  return null;
}, od = (t) => {
  const e = t.$cmpMeta$.$tagName$, o = t.$hostElement$, s = Ve("postUpdate", e), n = o, i = t.$ancestorComponent$;
  Qo(n, "componentDidRender"), t.$flags$ & 64 ? s() : (t.$flags$ |= 64, na(o), Qo(n, "componentDidLoad"), s(), t.$onReadyResolve$(o), i || sd()), t.$onRenderResolve$ && (t.$onRenderResolve$(), t.$onRenderResolve$ = void 0), t.$flags$ & 512 && hn(() => pn(t, !1)), t.$flags$ &= -517;
}, sd = (t) => {
  na(ge.documentElement), hn(() => qr(rs, "appload", { detail: { namespace: wl } }));
}, Qo = (t, e, o) => {
  if (t && t[e])
    try {
      return t[e](o);
    } catch (s) {
      bt(s);
    }
}, na = (t) => {
  var e;
  return t.classList.add((e = ln.hydratedSelectorName) != null ? e : "hydrated");
}, nd = (t, e) => fo(t).$instanceValues$.get(e), id = (t, e, o, s) => {
  const n = fo(t), i = t, r = n.$instanceValues$.get(e), a = n.$flags$, c = i;
  o = jl(o, s.$members$[e][0]);
  const d = Number.isNaN(r) && Number.isNaN(o);
  if (o !== r && !d) {
    n.$instanceValues$.set(e, o);
    {
      if (s.$watchers$ && a & 128) {
        const h = s.$watchers$[e];
        h && h.map((u) => {
          try {
            c[u](o, r, e);
          } catch (p) {
            bt(p, i);
          }
        });
      }
      (a & 18) === 2 && pn(n, !1);
    }
  }
}, ia = (t, e, o) => {
  var s;
  const n = t.prototype;
  if (e.$members$) {
    t.watchers && (e.$watchers$ = t.watchers);
    const i = Object.entries(e.$members$);
    i.map(([r, [a]]) => {
      (a & 31 || a & 32) && Object.defineProperty(n, r, {
        get() {
          return nd(this, r);
        },
        set(c) {
          id(this, r, c, e);
        },
        configurable: !0,
        enumerable: !0
      });
    });
    {
      const r = /* @__PURE__ */ new Map();
      n.attributeChangedCallback = function(a, c, d) {
        G.jmp(() => {
          var l;
          const h = r.get(a);
          if (this.hasOwnProperty(h))
            d = this[h], delete this[h];
          else {
            if (n.hasOwnProperty(h) && typeof this[h] == "number" && this[h] == d)
              return;
            if (h == null) {
              const u = fo(this), p = u == null ? void 0 : u.$flags$;
              if (p && !(p & 8) && p & 128 && d !== c) {
                const g = this, y = (l = e.$watchers$) == null ? void 0 : l[a];
                y == null || y.forEach((b) => {
                  g[b] != null && g[b].call(g, d, c, a);
                });
              }
              return;
            }
          }
          this[h] = d === null && typeof this[h] == "boolean" ? !1 : d;
        });
      }, t.observedAttributes = Array.from(
        /* @__PURE__ */ new Set([
          ...Object.keys((s = e.$watchers$) != null ? s : {}),
          ...i.filter(
            ([a, c]) => c[0] & 15
            /* HasAttribute */
          ).map(([a, c]) => {
            var d;
            const l = c[1] || a;
            return r.set(l, a), c[0] & 512 && ((d = e.$attrsToReflect$) == null || d.push([a, l])), l;
          })
        ])
      );
    }
  }
  return t;
}, rd = async (t, e, o, s) => {
  let n;
  if (!(e.$flags$ & 32)) {
    if (e.$flags$ |= 32, o.$lazyBundleId$) {
      const c = pd(o);
      if (c && "then" in c) {
        const l = Al();
        n = await c, l();
      } else
        n = c;
      if (!n)
        throw new Error(`Constructor for "${o.$tagName$}#${e.$modeName$}" was not found`);
      n.isProxied || (o.$watchers$ = n.watchers, ia(n, o), n.isProxied = !0);
      const d = Ve("createInstance", o.$tagName$);
      e.$flags$ |= 8;
      try {
        new n(e);
      } catch (l) {
        bt(l);
      }
      e.$flags$ &= -9, e.$flags$ |= 128, d();
    } else {
      n = t.constructor;
      const c = t.localName;
      customElements.whenDefined(c).then(
        () => e.$flags$ |= 128
        /* isWatchReady */
      );
    }
    if (n && n.style) {
      let c = n.style;
      const d = Zr(o);
      if (!es.has(d)) {
        const l = Ve("registerStyles", o.$tagName$);
        ql(d, c, !!(o.$flags$ & 1)), l();
      }
    }
  }
  const i = e.$ancestorComponent$, r = () => pn(e, !0);
  i && i["s-rc"] ? i["s-rc"].push(r) : r();
}, ad = (t) => {
}, cd = (t) => {
  if (!(G.$flags$ & 1)) {
    const e = fo(t), o = e.$cmpMeta$, s = Ve("connectedCallback", o.$tagName$);
    if (e.$flags$ & 1)
      ra(t, e, o.$listeners$), e != null && e.$lazyInstance$ || e != null && e.$onReadyPromise$ && e.$onReadyPromise$.then(() => ad());
    else {
      e.$flags$ |= 1;
      let n;
      if (n = t.getAttribute(As), n) {
        if (o.$flags$ & 1) {
          const i = Gr(t.shadowRoot, o);
          t.classList.remove(i + "-h", i + "-s");
        }
        Vl(t, o.$tagName$, n, e);
      }
      n || // TODO(STENCIL-854): Remove code related to legacy shadowDomShim field
      o.$flags$ & 12 && ld(t);
      {
        let i = t;
        for (; i = i.parentNode || i.host; )
          if (i.nodeType === 1 && i.hasAttribute("s-id") && i["s-p"] || i["s-p"]) {
            sa(e, e.$ancestorComponent$ = i);
            break;
          }
      }
      o.$members$ && Object.entries(o.$members$).map(([i, [r]]) => {
        if (r & 31 && t.hasOwnProperty(i)) {
          const a = t[i];
          delete t[i], t[i] = a;
        }
      }), rd(t, e, o);
    }
    s();
  }
}, ld = (t) => {
  const e = t["s-cr"] = ge.createComment(
    ""
  );
  e["s-cn"] = !0, Qe(t, e, t.firstChild);
}, dd = async (t) => {
  if (!(G.$flags$ & 1)) {
    const e = fo(t);
    e.$rmListeners$ && (e.$rmListeners$.map((o) => o()), e.$rmListeners$ = void 0);
  }
}, V = (t, e) => {
  const o = {
    $flags$: e[0],
    $tagName$: e[1]
  };
  o.$members$ = e[2], o.$listeners$ = e[3], o.$watchers$ = t.$watchers$, o.$attrsToReflect$ = [];
  const s = t.prototype.connectedCallback, n = t.prototype.disconnectedCallback;
  return Object.assign(t.prototype, {
    __registerHost() {
      fd(this, o);
    },
    connectedCallback() {
      cd(this), s && s.call(this);
    },
    disconnectedCallback() {
      dd(this), n && n.call(this);
    },
    __attachShadow() {
      this.attachShadow({ mode: "open" });
    }
  }), t.is = o.$tagName$, ia(t, o);
}, ra = (t, e, o, s) => {
  o && o.map(([n, i, r]) => {
    const a = t, c = ud(e, r), d = md(n);
    G.ael(a, i, c, d), (e.$rmListeners$ = e.$rmListeners$ || []).push(() => G.rel(a, i, c, d));
  });
}, ud = (t, e) => (o) => {
  try {
    t.$hostElement$[e](o);
  } catch (s) {
    bt(s);
  }
}, md = (t) => vd ? {
  passive: (t & 1) !== 0,
  capture: (t & 2) !== 0
} : (t & 2) !== 0, aa = /* @__PURE__ */ new WeakMap(), fo = (t) => aa.get(t), fd = (t, e) => {
  const o = {
    $flags$: 0,
    $hostElement$: t,
    $cmpMeta$: e,
    $instanceValues$: /* @__PURE__ */ new Map()
  };
  return o.$onReadyPromise$ = new Promise((s) => o.$onReadyResolve$ = s), t["s-p"] = [], t["s-rc"] = [], ra(t, o, e.$listeners$), aa.set(t, o);
}, oi = (t, e) => e in t, bt = (t, e) => (0, console.error)(t, e), si = /* @__PURE__ */ new Map(), pd = (t, e, o) => {
  const s = t.$tagName$.replace(/-/g, "_"), n = t.$lazyBundleId$;
  if (!n)
    return;
  const i = si.get(n);
  if (i)
    return i[s];
  /*!__STENCIL_STATIC_IMPORT_SWITCH__*/
  return import(
    /* @vite-ignore */
    /* webpackInclude: /\.entry\.js$/ */
    /* webpackExclude: /\.system\.entry\.js$/ */
    /* webpackMode: "lazy" */
    `./${n}.entry.js`
  ).then((r) => (si.set(n, r), r[s]), bt);
}, es = /* @__PURE__ */ new Map(), rs = typeof window < "u" ? window : {}, ge = rs.document || { head: {} }, j = rs.HTMLElement || class {
}, G = {
  $flags$: 0,
  $resourcesUrl$: "",
  jmp: (t) => t(),
  raf: (t) => requestAnimationFrame(t),
  ael: (t, e, o, s) => t.addEventListener(e, o, s),
  rel: (t, e, o, s) => t.removeEventListener(e, o, s),
  ce: (t, e) => new CustomEvent(t, e)
}, hd = (
  // TODO(STENCIL-854): Remove code related to legacy shadowDomShim field
  !0
), vd = /* @__PURE__ */ (() => {
  let t = !1;
  try {
    ge.addEventListener(
      "e",
      null,
      Object.defineProperty({}, "passive", {
        get() {
          t = !0;
        }
      })
    );
  } catch {
  }
  return t;
})(), gd = (t) => Promise.resolve(t), bd = /* @__PURE__ */ (() => {
  try {
    return new CSSStyleSheet(), typeof new CSSStyleSheet().replaceSync == "function";
  } catch {
  }
  return !1;
})(), Ns = !1, ni = [], ca = [], yd = (t, e) => (o) => {
  t.push(o), Ns || (Ns = !0, e && G.$flags$ & 4 ? hn(Fs) : G.raf(Fs));
}, ii = (t) => {
  for (let e = 0; e < t.length; e++)
    try {
      t[e](performance.now());
    } catch (o) {
      bt(o);
    }
  t.length = 0;
}, Fs = () => {
  ii(ni), ii(ca), (Ns = ni.length > 0) && G.raf(Fs);
}, hn = (t) => gd().then(t), xd = /* @__PURE__ */ yd(ca, !0), _d = Object.defineProperty, wd = (t, e) => {
  for (var o in e)
    _d(t, o, { get: e[o], enumerable: !0 });
}, kd = {};
wd(kd, {
  err: () => la,
  map: () => zd,
  ok: () => Bs,
  unwrap: () => Ed,
  unwrapErr: () => $d
});
var Bs = (t) => ({
  isOk: !0,
  isErr: !1,
  value: t
}), la = (t) => ({
  isOk: !1,
  isErr: !0,
  value: t
});
function zd(t, e) {
  if (t.isOk) {
    const o = e(t.value);
    return o instanceof Promise ? o.then((s) => Bs(s)) : Bs(o);
  }
  if (t.isErr) {
    const o = t.value;
    return la(o);
  }
  throw "should never get here";
}
var Ed = (t) => {
  if (t.isOk)
    return t.value;
  throw t.value;
}, $d = (t) => {
  if (t.isErr)
    return t.value;
  throw t.value;
};
const Pt = {
  elementDelimiter: "__",
  modifierDelimiter: "--",
  namespace: "",
  namespaceDelimiter: "-",
  strict: !0
};
function Sd({ elementDelimiter: t, modifierDelimiter: e, namespace: o, namespaceDelimiter: s, strict: n }) {
  typeof t == "string" && (Pt.elementDelimiter = t), typeof e == "string" && (Pt.modifierDelimiter = e), (typeof o == "string" || Array.isArray(o)) && (Pt.namespace = o), typeof s == "string" && (Pt.namespaceDelimiter = s), typeof n == "boolean" && (Pt.strict = n);
}
const Pd = (t) => t.join("").split("").filter((e, o, s) => s.indexOf(e) === o), ri = (t, e) => e.some((o) => t.includes(o)), ai = (t, e, o) => {
  const s = `"${o.join('", "')}"`;
  return `The ${t} ("${e}") must not use the characters contained within the delimiters (${s}).`;
};
function Cd(t, e = {}) {
  const { elementDelimiter: o, modifierDelimiter: s, namespace: n, namespaceDelimiter: i, strict: r } = {
    ...Pt,
    ...e
  }, c = `${[].concat(n).filter(Boolean).reduce((h, u) => `${h}${u}${i}`, "")}${t}`, d = r ? [i, o, s] : [], l = r ? Pd(d) : [];
  return function(u, p) {
    if (u == null)
      return c;
    const v = typeof u == "string" ? u : null;
    if (r && v != null && ri(v, l))
      throw new Error(ai("element", v, d));
    const g = v == null ? c : `${c}${o}${v}`, y = typeof u == "string" ? p : u;
    if (y == null)
      return g;
    const b = (_, E) => {
      if (E != null && E !== "") {
        if (r && ri(E, l))
          throw new Error(ai("modifier", E, d));
        return `${_} ${g}${s}${E}`;
      }
      return _;
    };
    return Array.isArray(y) ? y.reduce(b, g) : Object.keys(y).filter((_) => y[_]).reduce(b, g);
  };
}
Sd({
  strict: !1
});
const ci = (t) => typeof t != "object" ? t : Object.keys(t).reduce((e, o) => {
  const s = t[o];
  if (!s)
    return e;
  if (s === !0)
    return [...e, o];
  if (typeof s == "object") {
    const n = Object.keys(s).map((i) => `${o}-${s[i]}@${i}`);
    return [...e, ...n];
  }
  return [...e, `${o}-${s}`];
}, []), yt = (t) => (e, o) => {
  const s = typeof e == "string" ? e : ci(e);
  return Cd(t)(s, ci(o));
}, At = typeof window > "u" ? {} : window;
var _r, wr;
let li = !!((_r = At.cosmosConfig) != null && _r.disableWarnings) || !!((wr = At.gravityConfig) != null && wr.disableWarnings);
const da = {
  get disableWarnings() {
    return li;
  },
  set disableWarnings(t) {
    li = t;
  }
};
At.cosmosConfig = da;
At.gravityConfig = da;
const ua = () => new Promise((t) => {
  requestAnimationFrame(() => requestAnimationFrame(() => {
    t();
  }));
});
class Td {
  constructor() {
    this.classNames = {
      enter: "enter",
      leave: "leave"
    }, this.timeouts = {
      enter: void 0,
      leave: void 0
    };
  }
  async enter(e, o) {
    if (!e)
      return Promise.reject();
    const s = this.getClassNames();
    return this.clearTimeouts(), this.clearClassNames(e), this.addClassName(e, s.enter), await this.addClassNameOnNextTick(e, s.enterActive), new Promise((n) => {
      this.timeouts.enter = setTimeout(() => {
        this.clearClassNames(e), n();
      }, o);
    });
  }
  async leave(e, o) {
    if (!e)
      return Promise.reject();
    const s = this.getClassNames();
    return this.clearTimeouts(), this.clearClassNames(e), this.addClassName(e, s.leave), await this.addClassNameOnNextTick(e, s.leaveActive), new Promise((n) => {
      this.timeouts.leave = setTimeout(() => {
        this.clearClassNames(e), n();
      }, o);
    });
  }
  getClassNames() {
    return {
      enter: this.classNames.enter,
      enterActive: `${this.classNames.enter}-active`,
      leave: this.classNames.leave,
      leaveActive: `${this.classNames.leave}-active`
    };
  }
  addClassName(e, o) {
    e.classList.add(o);
  }
  clearTimeouts() {
    Object.values(this.timeouts).forEach((e) => {
      e && clearTimeout(e);
    });
  }
  clearClassNames(e) {
    const o = this.getClassNames();
    Object.values(o).forEach((s) => {
      this.removeClassName(e, s);
    });
  }
  removeClassName(e, o) {
    e.classList.remove(o);
  }
  async addClassNameOnNextTick(e, o) {
    await ua(), this.addClassName(e, o);
  }
}
var Je = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, Id = typeof Je == "object" && Je && Je.Object === Object && Je, Ld = typeof self == "object" && self && self.Object === Object && self, Ad = Id || Ld || Function("return this")(), di = Ad.Symbol, ui = di ? di.prototype : void 0;
ui && ui.toString;
var Od = typeof Je == "object" && Je && Je.Object === Object && Je, Rd = typeof self == "object" && self && self.Object === Object && self, Dd = Od || Rd || Function("return this")(), mi = Dd.Symbol, fi = mi ? mi.prototype : void 0;
fi && fi.toString;
const po = () => typeof process < "u" && process.versions != null && process.versions.node != null;
class Md {
  constructor() {
    po() || (this.eventTarget = document.createDocumentFragment());
  }
  on(e, o) {
    var s;
    (s = this.eventTarget) == null || s.addEventListener(e, o);
  }
  off(e, o) {
    var s;
    (s = this.eventTarget) == null || s.removeEventListener(e, o);
  }
  emit(e, o) {
    var n;
    const s = new CustomEvent(e, o);
    (n = this.eventTarget) == null || n.dispatchEvent(s);
  }
}
const Nd = (t) => {
  if (t) {
    if (typeof HTMLFormElement.prototype.requestSubmit == "function")
      return t.requestSubmit();
    if (!po()) {
      const e = At.document.createElement("button");
      e.type = "submit", e.style.display = "none", t.appendChild(e), e.click(), e.remove();
    }
  }
}, Us = /([a-zA-Z0-9-]+)@([a-zA-Z0-9-]+)/, vn = (t) => typeof t == "string" && Us.test(t), gn = (t) => (t.match(new RegExp(Us, "g")) || []).reduce((o, s) => {
  const n = s.match(Us);
  if (n) {
    const [, i, r] = n;
    o[r] = i;
  }
  return o;
}, {});
function Hs(t, e) {
  if (!t || typeof t.querySelector != "function")
    return !1;
  try {
    return t.querySelector(`:scope > [slot="${e}"]`) !== null;
  } catch {
    return t.querySelector(`[slot="${e}"]`) !== null;
  }
}
class Be {
  constructor() {
    this.observers = /* @__PURE__ */ new Map(), this.isNodeEnv = po(), this.observer = this.isNodeEnv ? null : this.createObserver();
  }
  /**
   * Gets the singleton instance of SlotMutationService.
   *
   * @returns {SlotMutationService} The singleton instance of SlotMutationService.
   * @static
   */
  static getInstance() {
    return Be.instance || (Be.instance = new Be()), Be.instance;
  }
  /**
   * Starts observing the given element for mutations.
   *
   * @remarks
   * It is recommended to call this method in the `componentWillLoad` lifecycle method
   * of a Stencil component to ensure that the element is observed as soon as it is loaded.
   *
   * @param {HTMLElement} element - The element to observe.
   * @param {() => void} handleSlotChange - The callback to execute when a mutation is observed.
   * @returns {void}
   */
  observe(e, o) {
    var s;
    this.isNodeEnv || this.observers.has(e) || (this.observers.set(e, o), (s = this.observer) == null || s.observe(e, Be.OBSERVER_OPTIONS), o.call(e));
  }
  /**
   * Stops observing the given element for mutations.
   *
   * @remarks
   * It is recommended to call this method in the `disconnectedCallback` lifecycle method
   * of a Stencil component to ensure that the element is no longer observed when it is removed from the DOM.
   *
   * @param {HTMLElement} element - The element to stop observing.
   * @returns {void}
   */
  unobserve(e) {
    var o;
    this.isNodeEnv || !this.observers.has(e) || (this.observers.delete(e), this.observers.size === 0 && ((o = this.observer) == null || o.disconnect()));
  }
  /**
   * Creates a MutationObserver instance.
   *
   * @returns {MutationObserver} The created MutationObserver instance.
   * @private
   */
  createObserver() {
    return new MutationObserver(this.handleMutations.bind(this));
  }
  /**
   * Handles observed mutations.
   *
   * @param {MutationRecord[]} mutations - The array of observed mutations.
   * @returns {void}
   * @private
   */
  handleMutations(e) {
    e.forEach((o) => {
      this.observers.forEach((s, n) => {
        n.contains(o.target) && s.call(n);
      });
    });
  }
}
Be.instance = null;
Be.OBSERVER_OPTIONS = {
  childList: !0,
  subtree: !0,
  characterData: !0
};
Be.getInstance();
var ce = "top", ye = "bottom", xe = "right", le = "left", bn = "auto", ho = [ce, ye, xe, le], Ot = "start", ao = "end", Fd = "clippingParents", ma = "viewport", Zt = "popper", Bd = "reference", pi = /* @__PURE__ */ ho.reduce(function(t, e) {
  return t.concat([e + "-" + Ot, e + "-" + ao]);
}, []), fa = /* @__PURE__ */ [].concat(ho, [bn]).reduce(function(t, e) {
  return t.concat([e, e + "-" + Ot, e + "-" + ao]);
}, []), Ud = "beforeRead", Hd = "read", Vd = "afterRead", jd = "beforeMain", Wd = "main", qd = "afterMain", Gd = "beforeWrite", Zd = "write", Yd = "afterWrite", Kd = [Ud, Hd, Vd, jd, Wd, qd, Gd, Zd, Yd];
function Ae(t) {
  return t ? (t.nodeName || "").toLowerCase() : null;
}
function pe(t) {
  if (t == null)
    return window;
  if (t.toString() !== "[object Window]") {
    var e = t.ownerDocument;
    return e && e.defaultView || window;
  }
  return t;
}
function gt(t) {
  var e = pe(t).Element;
  return t instanceof e || t instanceof Element;
}
function be(t) {
  var e = pe(t).HTMLElement;
  return t instanceof e || t instanceof HTMLElement;
}
function yn(t) {
  if (typeof ShadowRoot > "u")
    return !1;
  var e = pe(t).ShadowRoot;
  return t instanceof e || t instanceof ShadowRoot;
}
function Xd(t) {
  var e = t.state;
  Object.keys(e.elements).forEach(function(o) {
    var s = e.styles[o] || {}, n = e.attributes[o] || {}, i = e.elements[o];
    !be(i) || !Ae(i) || (Object.assign(i.style, s), Object.keys(n).forEach(function(r) {
      var a = n[r];
      a === !1 ? i.removeAttribute(r) : i.setAttribute(r, a === !0 ? "" : a);
    }));
  });
}
function Jd(t) {
  var e = t.state, o = {
    popper: {
      position: e.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(e.elements.popper.style, o.popper), e.styles = o, e.elements.arrow && Object.assign(e.elements.arrow.style, o.arrow), function() {
    Object.keys(e.elements).forEach(function(s) {
      var n = e.elements[s], i = e.attributes[s] || {}, r = Object.keys(e.styles.hasOwnProperty(s) ? e.styles[s] : o[s]), a = r.reduce(function(c, d) {
        return c[d] = "", c;
      }, {});
      !be(n) || !Ae(n) || (Object.assign(n.style, a), Object.keys(i).forEach(function(c) {
        n.removeAttribute(c);
      }));
    });
  };
}
const pa = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: Xd,
  effect: Jd,
  requires: ["computeStyles"]
};
function Le(t) {
  return t.split("-")[0];
}
var pt = Math.max, ts = Math.min, Rt = Math.round;
function Vs() {
  var t = navigator.userAgentData;
  return t != null && t.brands && Array.isArray(t.brands) ? t.brands.map(function(e) {
    return e.brand + "/" + e.version;
  }).join(" ") : navigator.userAgent;
}
function ha() {
  return !/^((?!chrome|android).)*safari/i.test(Vs());
}
function Dt(t, e, o) {
  e === void 0 && (e = !1), o === void 0 && (o = !1);
  var s = t.getBoundingClientRect(), n = 1, i = 1;
  e && be(t) && (n = t.offsetWidth > 0 && Rt(s.width) / t.offsetWidth || 1, i = t.offsetHeight > 0 && Rt(s.height) / t.offsetHeight || 1);
  var r = gt(t) ? pe(t) : window, a = r.visualViewport, c = !ha() && o, d = (s.left + (c && a ? a.offsetLeft : 0)) / n, l = (s.top + (c && a ? a.offsetTop : 0)) / i, h = s.width / n, u = s.height / i;
  return {
    width: h,
    height: u,
    top: l,
    right: d + h,
    bottom: l + u,
    left: d,
    x: d,
    y: l
  };
}
function xn(t) {
  var e = Dt(t), o = t.offsetWidth, s = t.offsetHeight;
  return Math.abs(e.width - o) <= 1 && (o = e.width), Math.abs(e.height - s) <= 1 && (s = e.height), {
    x: t.offsetLeft,
    y: t.offsetTop,
    width: o,
    height: s
  };
}
function va(t, e) {
  var o = e.getRootNode && e.getRootNode();
  if (t.contains(e))
    return !0;
  if (o && yn(o)) {
    var s = e;
    do {
      if (s && t.isSameNode(s))
        return !0;
      s = s.parentNode || s.host;
    } while (s);
  }
  return !1;
}
function je(t) {
  return pe(t).getComputedStyle(t);
}
function Qd(t) {
  return ["table", "td", "th"].indexOf(Ae(t)) >= 0;
}
function st(t) {
  return ((gt(t) ? t.ownerDocument : (
    // $FlowFixMe[prop-missing]
    t.document
  )) || window.document).documentElement;
}
function as(t) {
  return Ae(t) === "html" ? t : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    t.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    t.parentNode || // DOM Element detected
    (yn(t) ? t.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    st(t)
  );
}
function hi(t) {
  return !be(t) || // https://github.com/popperjs/popper-core/issues/837
  je(t).position === "fixed" ? null : t.offsetParent;
}
function eu(t) {
  var e = /firefox/i.test(Vs()), o = /Trident/i.test(Vs());
  if (o && be(t)) {
    var s = je(t);
    if (s.position === "fixed")
      return null;
  }
  var n = as(t);
  for (yn(n) && (n = n.host); be(n) && ["html", "body"].indexOf(Ae(n)) < 0; ) {
    var i = je(n);
    if (i.transform !== "none" || i.perspective !== "none" || i.contain === "paint" || ["transform", "perspective"].indexOf(i.willChange) !== -1 || e && i.willChange === "filter" || e && i.filter && i.filter !== "none")
      return n;
    n = n.parentNode;
  }
  return null;
}
function vo(t) {
  for (var e = pe(t), o = hi(t); o && Qd(o) && je(o).position === "static"; )
    o = hi(o);
  return o && (Ae(o) === "html" || Ae(o) === "body" && je(o).position === "static") ? e : o || eu(t) || e;
}
function _n(t) {
  return ["top", "bottom"].indexOf(t) >= 0 ? "x" : "y";
}
function to(t, e, o) {
  return pt(t, ts(e, o));
}
function tu(t, e, o) {
  var s = to(t, e, o);
  return s > o ? o : s;
}
function ga() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function ba(t) {
  return Object.assign({}, ga(), t);
}
function ya(t, e) {
  return e.reduce(function(o, s) {
    return o[s] = t, o;
  }, {});
}
var ou = function(e, o) {
  return e = typeof e == "function" ? e(Object.assign({}, o.rects, {
    placement: o.placement
  })) : e, ba(typeof e != "number" ? e : ya(e, ho));
};
function su(t) {
  var e, o = t.state, s = t.name, n = t.options, i = o.elements.arrow, r = o.modifiersData.popperOffsets, a = Le(o.placement), c = _n(a), d = [le, xe].indexOf(a) >= 0, l = d ? "height" : "width";
  if (!(!i || !r)) {
    var h = ou(n.padding, o), u = xn(i), p = c === "y" ? ce : le, v = c === "y" ? ye : xe, g = o.rects.reference[l] + o.rects.reference[c] - r[c] - o.rects.popper[l], y = r[c] - o.rects.reference[c], b = vo(i), _ = b ? c === "y" ? b.clientHeight || 0 : b.clientWidth || 0 : 0, E = g / 2 - y / 2, m = h[p], P = _ - u[l] - h[v], k = _ / 2 - u[l] / 2 + E, A = to(m, k, P), T = c;
    o.modifiersData[s] = (e = {}, e[T] = A, e.centerOffset = A - k, e);
  }
}
function nu(t) {
  var e = t.state, o = t.options, s = o.element, n = s === void 0 ? "[data-popper-arrow]" : s;
  n != null && (typeof n == "string" && (n = e.elements.popper.querySelector(n), !n) || va(e.elements.popper, n) && (e.elements.arrow = n));
}
const iu = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: su,
  effect: nu,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function Mt(t) {
  return t.split("-")[1];
}
var ru = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function au(t, e) {
  var o = t.x, s = t.y, n = e.devicePixelRatio || 1;
  return {
    x: Rt(o * n) / n || 0,
    y: Rt(s * n) / n || 0
  };
}
function vi(t) {
  var e, o = t.popper, s = t.popperRect, n = t.placement, i = t.variation, r = t.offsets, a = t.position, c = t.gpuAcceleration, d = t.adaptive, l = t.roundOffsets, h = t.isFixed, u = r.x, p = u === void 0 ? 0 : u, v = r.y, g = v === void 0 ? 0 : v, y = typeof l == "function" ? l({
    x: p,
    y: g
  }) : {
    x: p,
    y: g
  };
  p = y.x, g = y.y;
  var b = r.hasOwnProperty("x"), _ = r.hasOwnProperty("y"), E = le, m = ce, P = window;
  if (d) {
    var k = vo(o), A = "clientHeight", T = "clientWidth";
    if (k === pe(o) && (k = st(o), je(k).position !== "static" && a === "absolute" && (A = "scrollHeight", T = "scrollWidth")), k = k, n === ce || (n === le || n === xe) && i === ao) {
      m = ye;
      var z = h && k === P && P.visualViewport ? P.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        k[A]
      );
      g -= z - s.height, g *= c ? 1 : -1;
    }
    if (n === le || (n === ce || n === ye) && i === ao) {
      E = xe;
      var L = h && k === P && P.visualViewport ? P.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        k[T]
      );
      p -= L - s.width, p *= c ? 1 : -1;
    }
  }
  var D = Object.assign({
    position: a
  }, d && ru), R = l === !0 ? au({
    x: p,
    y: g
  }, pe(o)) : {
    x: p,
    y: g
  };
  if (p = R.x, g = R.y, c) {
    var M;
    return Object.assign({}, D, (M = {}, M[m] = _ ? "0" : "", M[E] = b ? "0" : "", M.transform = (P.devicePixelRatio || 1) <= 1 ? "translate(" + p + "px, " + g + "px)" : "translate3d(" + p + "px, " + g + "px, 0)", M));
  }
  return Object.assign({}, D, (e = {}, e[m] = _ ? g + "px" : "", e[E] = b ? p + "px" : "", e.transform = "", e));
}
function cu(t) {
  var e = t.state, o = t.options, s = o.gpuAcceleration, n = s === void 0 ? !0 : s, i = o.adaptive, r = i === void 0 ? !0 : i, a = o.roundOffsets, c = a === void 0 ? !0 : a, d = {
    placement: Le(e.placement),
    variation: Mt(e.placement),
    popper: e.elements.popper,
    popperRect: e.rects.popper,
    gpuAcceleration: n,
    isFixed: e.options.strategy === "fixed"
  };
  e.modifiersData.popperOffsets != null && (e.styles.popper = Object.assign({}, e.styles.popper, vi(Object.assign({}, d, {
    offsets: e.modifiersData.popperOffsets,
    position: e.options.strategy,
    adaptive: r,
    roundOffsets: c
  })))), e.modifiersData.arrow != null && (e.styles.arrow = Object.assign({}, e.styles.arrow, vi(Object.assign({}, d, {
    offsets: e.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: c
  })))), e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-placement": e.placement
  });
}
const lu = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: cu,
  data: {}
};
var Io = {
  passive: !0
};
function du(t) {
  var e = t.state, o = t.instance, s = t.options, n = s.scroll, i = n === void 0 ? !0 : n, r = s.resize, a = r === void 0 ? !0 : r, c = pe(e.elements.popper), d = [].concat(e.scrollParents.reference, e.scrollParents.popper);
  return i && d.forEach(function(l) {
    l.addEventListener("scroll", o.update, Io);
  }), a && c.addEventListener("resize", o.update, Io), function() {
    i && d.forEach(function(l) {
      l.removeEventListener("scroll", o.update, Io);
    }), a && c.removeEventListener("resize", o.update, Io);
  };
}
const uu = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: du,
  data: {}
};
var mu = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Uo(t) {
  return t.replace(/left|right|bottom|top/g, function(e) {
    return mu[e];
  });
}
var fu = {
  start: "end",
  end: "start"
};
function gi(t) {
  return t.replace(/start|end/g, function(e) {
    return fu[e];
  });
}
function wn(t) {
  var e = pe(t), o = e.pageXOffset, s = e.pageYOffset;
  return {
    scrollLeft: o,
    scrollTop: s
  };
}
function kn(t) {
  return Dt(st(t)).left + wn(t).scrollLeft;
}
function pu(t, e) {
  var o = pe(t), s = st(t), n = o.visualViewport, i = s.clientWidth, r = s.clientHeight, a = 0, c = 0;
  if (n) {
    i = n.width, r = n.height;
    var d = ha();
    (d || !d && e === "fixed") && (a = n.offsetLeft, c = n.offsetTop);
  }
  return {
    width: i,
    height: r,
    x: a + kn(t),
    y: c
  };
}
function hu(t) {
  var e, o = st(t), s = wn(t), n = (e = t.ownerDocument) == null ? void 0 : e.body, i = pt(o.scrollWidth, o.clientWidth, n ? n.scrollWidth : 0, n ? n.clientWidth : 0), r = pt(o.scrollHeight, o.clientHeight, n ? n.scrollHeight : 0, n ? n.clientHeight : 0), a = -s.scrollLeft + kn(t), c = -s.scrollTop;
  return je(n || o).direction === "rtl" && (a += pt(o.clientWidth, n ? n.clientWidth : 0) - i), {
    width: i,
    height: r,
    x: a,
    y: c
  };
}
function zn(t) {
  var e = je(t), o = e.overflow, s = e.overflowX, n = e.overflowY;
  return /auto|scroll|overlay|hidden/.test(o + n + s);
}
function xa(t) {
  return ["html", "body", "#document"].indexOf(Ae(t)) >= 0 ? t.ownerDocument.body : be(t) && zn(t) ? t : xa(as(t));
}
function oo(t, e) {
  var o;
  e === void 0 && (e = []);
  var s = xa(t), n = s === ((o = t.ownerDocument) == null ? void 0 : o.body), i = pe(s), r = n ? [i].concat(i.visualViewport || [], zn(s) ? s : []) : s, a = e.concat(r);
  return n ? a : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    a.concat(oo(as(r)))
  );
}
function js(t) {
  return Object.assign({}, t, {
    left: t.x,
    top: t.y,
    right: t.x + t.width,
    bottom: t.y + t.height
  });
}
function vu(t, e) {
  var o = Dt(t, !1, e === "fixed");
  return o.top = o.top + t.clientTop, o.left = o.left + t.clientLeft, o.bottom = o.top + t.clientHeight, o.right = o.left + t.clientWidth, o.width = t.clientWidth, o.height = t.clientHeight, o.x = o.left, o.y = o.top, o;
}
function bi(t, e, o) {
  return e === ma ? js(pu(t, o)) : gt(e) ? vu(e, o) : js(hu(st(t)));
}
function gu(t) {
  var e = oo(as(t)), o = ["absolute", "fixed"].indexOf(je(t).position) >= 0, s = o && be(t) ? vo(t) : t;
  return gt(s) ? e.filter(function(n) {
    return gt(n) && va(n, s) && Ae(n) !== "body";
  }) : [];
}
function bu(t, e, o, s) {
  var n = e === "clippingParents" ? gu(t) : [].concat(e), i = [].concat(n, [o]), r = i[0], a = i.reduce(function(c, d) {
    var l = bi(t, d, s);
    return c.top = pt(l.top, c.top), c.right = ts(l.right, c.right), c.bottom = ts(l.bottom, c.bottom), c.left = pt(l.left, c.left), c;
  }, bi(t, r, s));
  return a.width = a.right - a.left, a.height = a.bottom - a.top, a.x = a.left, a.y = a.top, a;
}
function _a(t) {
  var e = t.reference, o = t.element, s = t.placement, n = s ? Le(s) : null, i = s ? Mt(s) : null, r = e.x + e.width / 2 - o.width / 2, a = e.y + e.height / 2 - o.height / 2, c;
  switch (n) {
    case ce:
      c = {
        x: r,
        y: e.y - o.height
      };
      break;
    case ye:
      c = {
        x: r,
        y: e.y + e.height
      };
      break;
    case xe:
      c = {
        x: e.x + e.width,
        y: a
      };
      break;
    case le:
      c = {
        x: e.x - o.width,
        y: a
      };
      break;
    default:
      c = {
        x: e.x,
        y: e.y
      };
  }
  var d = n ? _n(n) : null;
  if (d != null) {
    var l = d === "y" ? "height" : "width";
    switch (i) {
      case Ot:
        c[d] = c[d] - (e[l] / 2 - o[l] / 2);
        break;
      case ao:
        c[d] = c[d] + (e[l] / 2 - o[l] / 2);
        break;
    }
  }
  return c;
}
function co(t, e) {
  e === void 0 && (e = {});
  var o = e, s = o.placement, n = s === void 0 ? t.placement : s, i = o.strategy, r = i === void 0 ? t.strategy : i, a = o.boundary, c = a === void 0 ? Fd : a, d = o.rootBoundary, l = d === void 0 ? ma : d, h = o.elementContext, u = h === void 0 ? Zt : h, p = o.altBoundary, v = p === void 0 ? !1 : p, g = o.padding, y = g === void 0 ? 0 : g, b = ba(typeof y != "number" ? y : ya(y, ho)), _ = u === Zt ? Bd : Zt, E = t.rects.popper, m = t.elements[v ? _ : u], P = bu(gt(m) ? m : m.contextElement || st(t.elements.popper), c, l, r), k = Dt(t.elements.reference), A = _a({
    reference: k,
    element: E,
    strategy: "absolute",
    placement: n
  }), T = js(Object.assign({}, E, A)), z = u === Zt ? T : k, L = {
    top: P.top - z.top + b.top,
    bottom: z.bottom - P.bottom + b.bottom,
    left: P.left - z.left + b.left,
    right: z.right - P.right + b.right
  }, D = t.modifiersData.offset;
  if (u === Zt && D) {
    var R = D[n];
    Object.keys(L).forEach(function(M) {
      var W = [xe, ye].indexOf(M) >= 0 ? 1 : -1, oe = [ce, ye].indexOf(M) >= 0 ? "y" : "x";
      L[M] += R[oe] * W;
    });
  }
  return L;
}
function yu(t, e) {
  e === void 0 && (e = {});
  var o = e, s = o.placement, n = o.boundary, i = o.rootBoundary, r = o.padding, a = o.flipVariations, c = o.allowedAutoPlacements, d = c === void 0 ? fa : c, l = Mt(s), h = l ? a ? pi : pi.filter(function(v) {
    return Mt(v) === l;
  }) : ho, u = h.filter(function(v) {
    return d.indexOf(v) >= 0;
  });
  u.length === 0 && (u = h);
  var p = u.reduce(function(v, g) {
    return v[g] = co(t, {
      placement: g,
      boundary: n,
      rootBoundary: i,
      padding: r
    })[Le(g)], v;
  }, {});
  return Object.keys(p).sort(function(v, g) {
    return p[v] - p[g];
  });
}
function xu(t) {
  if (Le(t) === bn)
    return [];
  var e = Uo(t);
  return [gi(t), e, gi(e)];
}
function _u(t) {
  var e = t.state, o = t.options, s = t.name;
  if (!e.modifiersData[s]._skip) {
    for (var n = o.mainAxis, i = n === void 0 ? !0 : n, r = o.altAxis, a = r === void 0 ? !0 : r, c = o.fallbackPlacements, d = o.padding, l = o.boundary, h = o.rootBoundary, u = o.altBoundary, p = o.flipVariations, v = p === void 0 ? !0 : p, g = o.allowedAutoPlacements, y = e.options.placement, b = Le(y), _ = b === y, E = c || (_ || !v ? [Uo(y)] : xu(y)), m = [y].concat(E).reduce(function(Oe, we) {
      return Oe.concat(Le(we) === bn ? yu(e, {
        placement: we,
        boundary: l,
        rootBoundary: h,
        padding: d,
        flipVariations: v,
        allowedAutoPlacements: g
      }) : we);
    }, []), P = e.rects.reference, k = e.rects.popper, A = /* @__PURE__ */ new Map(), T = !0, z = m[0], L = 0; L < m.length; L++) {
      var D = m[L], R = Le(D), M = Mt(D) === Ot, W = [ce, ye].indexOf(R) >= 0, oe = W ? "width" : "height", K = co(e, {
        placement: D,
        boundary: l,
        rootBoundary: h,
        altBoundary: u,
        padding: d
      }), X = W ? M ? xe : le : M ? ye : ce;
      P[oe] > k[oe] && (X = Uo(X));
      var q = Uo(X), ue = [];
      if (i && ue.push(K[R] <= 0), a && ue.push(K[X] <= 0, K[q] <= 0), ue.every(function(Oe) {
        return Oe;
      })) {
        z = D, T = !1;
        break;
      }
      A.set(D, ue);
    }
    if (T)
      for (var N = v ? 3 : 1, se = function(we) {
        var Re = m.find(function(xt) {
          var De = A.get(xt);
          if (De)
            return De.slice(0, we).every(function(_t) {
              return _t;
            });
        });
        if (Re)
          return z = Re, "break";
      }, ne = N; ne > 0; ne--) {
        var ct = se(ne);
        if (ct === "break")
          break;
      }
    e.placement !== z && (e.modifiersData[s]._skip = !0, e.placement = z, e.reset = !0);
  }
}
const wu = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: _u,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function yi(t, e, o) {
  return o === void 0 && (o = {
    x: 0,
    y: 0
  }), {
    top: t.top - e.height - o.y,
    right: t.right - e.width + o.x,
    bottom: t.bottom - e.height + o.y,
    left: t.left - e.width - o.x
  };
}
function xi(t) {
  return [ce, xe, ye, le].some(function(e) {
    return t[e] >= 0;
  });
}
function ku(t) {
  var e = t.state, o = t.name, s = e.rects.reference, n = e.rects.popper, i = e.modifiersData.preventOverflow, r = co(e, {
    elementContext: "reference"
  }), a = co(e, {
    altBoundary: !0
  }), c = yi(r, s), d = yi(a, n, i), l = xi(c), h = xi(d);
  e.modifiersData[o] = {
    referenceClippingOffsets: c,
    popperEscapeOffsets: d,
    isReferenceHidden: l,
    hasPopperEscaped: h
  }, e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-reference-hidden": l,
    "data-popper-escaped": h
  });
}
const zu = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: ku
};
function Eu(t, e, o) {
  var s = Le(t), n = [le, ce].indexOf(s) >= 0 ? -1 : 1, i = typeof o == "function" ? o(Object.assign({}, e, {
    placement: t
  })) : o, r = i[0], a = i[1];
  return r = r || 0, a = (a || 0) * n, [le, xe].indexOf(s) >= 0 ? {
    x: a,
    y: r
  } : {
    x: r,
    y: a
  };
}
function $u(t) {
  var e = t.state, o = t.options, s = t.name, n = o.offset, i = n === void 0 ? [0, 0] : n, r = fa.reduce(function(l, h) {
    return l[h] = Eu(h, e.rects, i), l;
  }, {}), a = r[e.placement], c = a.x, d = a.y;
  e.modifiersData.popperOffsets != null && (e.modifiersData.popperOffsets.x += c, e.modifiersData.popperOffsets.y += d), e.modifiersData[s] = r;
}
const Su = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: $u
};
function Pu(t) {
  var e = t.state, o = t.name;
  e.modifiersData[o] = _a({
    reference: e.rects.reference,
    element: e.rects.popper,
    strategy: "absolute",
    placement: e.placement
  });
}
const Cu = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: Pu,
  data: {}
};
function Tu(t) {
  return t === "x" ? "y" : "x";
}
function Iu(t) {
  var e = t.state, o = t.options, s = t.name, n = o.mainAxis, i = n === void 0 ? !0 : n, r = o.altAxis, a = r === void 0 ? !1 : r, c = o.boundary, d = o.rootBoundary, l = o.altBoundary, h = o.padding, u = o.tether, p = u === void 0 ? !0 : u, v = o.tetherOffset, g = v === void 0 ? 0 : v, y = co(e, {
    boundary: c,
    rootBoundary: d,
    padding: h,
    altBoundary: l
  }), b = Le(e.placement), _ = Mt(e.placement), E = !_, m = _n(b), P = Tu(m), k = e.modifiersData.popperOffsets, A = e.rects.reference, T = e.rects.popper, z = typeof g == "function" ? g(Object.assign({}, e.rects, {
    placement: e.placement
  })) : g, L = typeof z == "number" ? {
    mainAxis: z,
    altAxis: z
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, z), D = e.modifiersData.offset ? e.modifiersData.offset[e.placement] : null, R = {
    x: 0,
    y: 0
  };
  if (k) {
    if (i) {
      var M, W = m === "y" ? ce : le, oe = m === "y" ? ye : xe, K = m === "y" ? "height" : "width", X = k[m], q = X + y[W], ue = X - y[oe], N = p ? -T[K] / 2 : 0, se = _ === Ot ? A[K] : T[K], ne = _ === Ot ? -T[K] : -A[K], ct = e.elements.arrow, Oe = p && ct ? xn(ct) : {
        width: 0,
        height: 0
      }, we = e.modifiersData["arrow#persistent"] ? e.modifiersData["arrow#persistent"].padding : ga(), Re = we[W], xt = we[oe], De = to(0, A[K], Oe[K]), _t = E ? A[K] / 2 - N - De - Re - L.mainAxis : se - De - Re - L.mainAxis, Ze = E ? -A[K] / 2 + N + De + xt + L.mainAxis : ne + De + xt + L.mainAxis, wt = e.elements.arrow && vo(e.elements.arrow), yo = wt ? m === "y" ? wt.clientTop || 0 : wt.clientLeft || 0 : 0, Ht = (M = D == null ? void 0 : D[m]) != null ? M : 0, xo = X + _t - Ht - yo, _o = X + Ze - Ht, Vt = to(p ? ts(q, xo) : q, X, p ? pt(ue, _o) : ue);
      k[m] = Vt, R[m] = Vt - X;
    }
    if (a) {
      var jt, wo = m === "x" ? ce : le, ko = m === "x" ? ye : xe, Me = k[P], Ye = P === "y" ? "height" : "width", Wt = Me + y[wo], lt = Me - y[ko], qt = [ce, le].indexOf(b) !== -1, zo = (jt = D == null ? void 0 : D[P]) != null ? jt : 0, Eo = qt ? Wt : Me - A[Ye] - T[Ye] - zo + L.altAxis, $o = qt ? Me + A[Ye] + T[Ye] - zo - L.altAxis : lt, So = p && qt ? tu(Eo, Me, $o) : to(p ? Eo : Wt, Me, p ? $o : lt);
      k[P] = So, R[P] = So - Me;
    }
    e.modifiersData[s] = R;
  }
}
const Lu = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: Iu,
  requiresIfExists: ["offset"]
};
function Au(t) {
  return {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  };
}
function Ou(t) {
  return t === pe(t) || !be(t) ? wn(t) : Au(t);
}
function Ru(t) {
  var e = t.getBoundingClientRect(), o = Rt(e.width) / t.offsetWidth || 1, s = Rt(e.height) / t.offsetHeight || 1;
  return o !== 1 || s !== 1;
}
function Du(t, e, o) {
  o === void 0 && (o = !1);
  var s = be(e), n = be(e) && Ru(e), i = st(e), r = Dt(t, n, o), a = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = {
    x: 0,
    y: 0
  };
  return (s || !s && !o) && ((Ae(e) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  zn(i)) && (a = Ou(e)), be(e) ? (c = Dt(e, !0), c.x += e.clientLeft, c.y += e.clientTop) : i && (c.x = kn(i))), {
    x: r.left + a.scrollLeft - c.x,
    y: r.top + a.scrollTop - c.y,
    width: r.width,
    height: r.height
  };
}
function Mu(t) {
  var e = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Set(), s = [];
  t.forEach(function(i) {
    e.set(i.name, i);
  });
  function n(i) {
    o.add(i.name);
    var r = [].concat(i.requires || [], i.requiresIfExists || []);
    r.forEach(function(a) {
      if (!o.has(a)) {
        var c = e.get(a);
        c && n(c);
      }
    }), s.push(i);
  }
  return t.forEach(function(i) {
    o.has(i.name) || n(i);
  }), s;
}
function Nu(t) {
  var e = Mu(t);
  return Kd.reduce(function(o, s) {
    return o.concat(e.filter(function(n) {
      return n.phase === s;
    }));
  }, []);
}
function Fu(t) {
  var e;
  return function() {
    return e || (e = new Promise(function(o) {
      Promise.resolve().then(function() {
        e = void 0, o(t());
      });
    })), e;
  };
}
function Bu(t) {
  var e = t.reduce(function(o, s) {
    var n = o[s.name];
    return o[s.name] = n ? Object.assign({}, n, s, {
      options: Object.assign({}, n.options, s.options),
      data: Object.assign({}, n.data, s.data)
    }) : s, o;
  }, {});
  return Object.keys(e).map(function(o) {
    return e[o];
  });
}
var _i = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function wi() {
  for (var t = arguments.length, e = new Array(t), o = 0; o < t; o++)
    e[o] = arguments[o];
  return !e.some(function(s) {
    return !(s && typeof s.getBoundingClientRect == "function");
  });
}
function Uu(t) {
  t === void 0 && (t = {});
  var e = t, o = e.defaultModifiers, s = o === void 0 ? [] : o, n = e.defaultOptions, i = n === void 0 ? _i : n;
  return function(a, c, d) {
    d === void 0 && (d = i);
    var l = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, _i, i),
      modifiersData: {},
      elements: {
        reference: a,
        popper: c
      },
      attributes: {},
      styles: {}
    }, h = [], u = !1, p = {
      state: l,
      setOptions: function(b) {
        var _ = typeof b == "function" ? b(l.options) : b;
        g(), l.options = Object.assign({}, i, l.options, _), l.scrollParents = {
          reference: gt(a) ? oo(a) : a.contextElement ? oo(a.contextElement) : [],
          popper: oo(c)
        };
        var E = Nu(Bu([].concat(s, l.options.modifiers)));
        return l.orderedModifiers = E.filter(function(m) {
          return m.enabled;
        }), v(), p.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!u) {
          var b = l.elements, _ = b.reference, E = b.popper;
          if (wi(_, E)) {
            l.rects = {
              reference: Du(_, vo(E), l.options.strategy === "fixed"),
              popper: xn(E)
            }, l.reset = !1, l.placement = l.options.placement, l.orderedModifiers.forEach(function(L) {
              return l.modifiersData[L.name] = Object.assign({}, L.data);
            });
            for (var m = 0; m < l.orderedModifiers.length; m++) {
              if (l.reset === !0) {
                l.reset = !1, m = -1;
                continue;
              }
              var P = l.orderedModifiers[m], k = P.fn, A = P.options, T = A === void 0 ? {} : A, z = P.name;
              typeof k == "function" && (l = k({
                state: l,
                options: T,
                name: z,
                instance: p
              }) || l);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: Fu(function() {
        return new Promise(function(y) {
          p.forceUpdate(), y(l);
        });
      }),
      destroy: function() {
        g(), u = !0;
      }
    };
    if (!wi(a, c))
      return p;
    p.setOptions(d).then(function(y) {
      !u && d.onFirstUpdate && d.onFirstUpdate(y);
    });
    function v() {
      l.orderedModifiers.forEach(function(y) {
        var b = y.name, _ = y.options, E = _ === void 0 ? {} : _, m = y.effect;
        if (typeof m == "function") {
          var P = m({
            state: l,
            name: b,
            instance: p,
            options: E
          }), k = function() {
          };
          h.push(P || k);
        }
      });
    }
    function g() {
      h.forEach(function(y) {
        return y();
      }), h = [];
    }
    return p;
  };
}
var Hu = [uu, Cu, lu, pa, Su, wu, Lu, iu, zu], Vu = /* @__PURE__ */ Uu({
  defaultModifiers: Hu
}), ju = "tippy-content", Wu = "tippy-backdrop", qu = "tippy-arrow", Gu = "tippy-svg-arrow", mt = {
  passive: !0,
  capture: !0
}, wa = function() {
  return document.body;
};
function ps(t, e, o) {
  if (Array.isArray(t)) {
    var s = t[e];
    return s ?? (Array.isArray(o) ? o[e] : o);
  }
  return t;
}
function En(t, e) {
  var o = {}.toString.call(t);
  return o.indexOf("[object") === 0 && o.indexOf(e + "]") > -1;
}
function ka(t, e) {
  return typeof t == "function" ? t.apply(void 0, e) : t;
}
function ki(t, e) {
  if (e === 0)
    return t;
  var o;
  return function(s) {
    clearTimeout(o), o = setTimeout(function() {
      t(s);
    }, e);
  };
}
function Zu(t) {
  return t.split(/\s+/).filter(Boolean);
}
function Ct(t) {
  return [].concat(t);
}
function zi(t, e) {
  t.indexOf(e) === -1 && t.push(e);
}
function Yu(t) {
  return t.filter(function(e, o) {
    return t.indexOf(e) === o;
  });
}
function Ku(t) {
  return t.split("-")[0];
}
function os(t) {
  return [].slice.call(t);
}
function Ei(t) {
  return Object.keys(t).reduce(function(e, o) {
    return t[o] !== void 0 && (e[o] = t[o]), e;
  }, {});
}
function Xu() {
  return document.createElement("div");
}
function za(t) {
  return ["Element", "Fragment"].some(function(e) {
    return En(t, e);
  });
}
function Ju(t) {
  return En(t, "NodeList");
}
function Ea(t) {
  return En(t, "MouseEvent");
}
function Qu(t) {
  return !!(t && t._tippy && t._tippy.reference === t);
}
function em(t) {
  return za(t) ? [t] : Ju(t) ? os(t) : Array.isArray(t) ? t : os(document.querySelectorAll(t));
}
function hs(t, e) {
  t.forEach(function(o) {
    o && (o.style.transitionDuration = e + "ms");
  });
}
function $i(t, e) {
  t.forEach(function(o) {
    o && o.setAttribute("data-state", e);
  });
}
function $a(t) {
  var e, o = Ct(t), s = o[0];
  return s != null && (e = s.ownerDocument) != null && e.body ? s.ownerDocument : document;
}
function tm(t, e) {
  var o = e.clientX, s = e.clientY;
  return t.every(function(n) {
    var i = n.popperRect, r = n.popperState, a = n.props, c = a.interactiveBorder, d = Ku(r.placement), l = r.modifiersData.offset;
    if (!l)
      return !0;
    var h = d === "bottom" ? l.top.y : 0, u = d === "top" ? l.bottom.y : 0, p = d === "right" ? l.left.x : 0, v = d === "left" ? l.right.x : 0, g = i.top - s + h > c, y = s - i.bottom - u > c, b = i.left - o + p > c, _ = o - i.right - v > c;
    return g || y || b || _;
  });
}
function vs(t, e, o) {
  var s = e + "EventListener";
  ["transitionend", "webkitTransitionEnd"].forEach(function(n) {
    t[s](n, o);
  });
}
function Si(t, e) {
  for (var o = e; o; ) {
    var s;
    if (t.contains(o))
      return !0;
    o = o.getRootNode == null || (s = o.getRootNode()) == null ? void 0 : s.host;
  }
  return !1;
}
var Te = {
  isTouch: !1
}, Pi = 0;
function om() {
  Te.isTouch || (Te.isTouch = !0, window.performance && document.addEventListener("mousemove", Sa));
}
function Sa() {
  var t = performance.now();
  t - Pi < 20 && (Te.isTouch = !1, document.removeEventListener("mousemove", Sa)), Pi = t;
}
function sm() {
  var t = document.activeElement;
  if (Qu(t)) {
    var e = t._tippy;
    t.blur && !e.state.isVisible && t.blur();
  }
}
function nm() {
  document.addEventListener("touchstart", om, mt), window.addEventListener("blur", sm);
}
var im = typeof window < "u" && typeof document < "u", rm = im ? (
  // @ts-ignore
  !!window.msCrypto
) : !1, am = {
  animateFill: !1,
  followCursor: !1,
  inlinePositioning: !1,
  sticky: !1
}, cm = {
  allowHTML: !1,
  animation: "fade",
  arrow: !0,
  content: "",
  inertia: !1,
  maxWidth: 350,
  role: "tooltip",
  theme: "",
  zIndex: 9999
}, ke = Object.assign({
  appendTo: wa,
  aria: {
    content: "auto",
    expanded: "auto"
  },
  delay: 0,
  duration: [300, 250],
  getReferenceClientRect: null,
  hideOnClick: !0,
  ignoreAttributes: !1,
  interactive: !1,
  interactiveBorder: 2,
  interactiveDebounce: 0,
  moveTransition: "",
  offset: [0, 10],
  onAfterUpdate: function() {
  },
  onBeforeUpdate: function() {
  },
  onCreate: function() {
  },
  onDestroy: function() {
  },
  onHidden: function() {
  },
  onHide: function() {
  },
  onMount: function() {
  },
  onShow: function() {
  },
  onShown: function() {
  },
  onTrigger: function() {
  },
  onUntrigger: function() {
  },
  onClickOutside: function() {
  },
  placement: "top",
  plugins: [],
  popperOptions: {},
  render: null,
  showOnCreate: !1,
  touch: !0,
  trigger: "mouseenter focus",
  triggerTarget: null
}, am, cm), lm = Object.keys(ke), dm = function(e) {
  var o = Object.keys(e);
  o.forEach(function(s) {
    ke[s] = e[s];
  });
};
function Pa(t) {
  var e = t.plugins || [], o = e.reduce(function(s, n) {
    var i = n.name, r = n.defaultValue;
    if (i) {
      var a;
      s[i] = t[i] !== void 0 ? t[i] : (a = ke[i]) != null ? a : r;
    }
    return s;
  }, {});
  return Object.assign({}, t, o);
}
function um(t, e) {
  var o = e ? Object.keys(Pa(Object.assign({}, ke, {
    plugins: e
  }))) : lm, s = o.reduce(function(n, i) {
    var r = (t.getAttribute("data-tippy-" + i) || "").trim();
    if (!r)
      return n;
    if (i === "content")
      n[i] = r;
    else
      try {
        n[i] = JSON.parse(r);
      } catch {
        n[i] = r;
      }
    return n;
  }, {});
  return s;
}
function Ci(t, e) {
  var o = Object.assign({}, e, {
    content: ka(e.content, [t])
  }, e.ignoreAttributes ? {} : um(t, e.plugins));
  return o.aria = Object.assign({}, ke.aria, o.aria), o.aria = {
    expanded: o.aria.expanded === "auto" ? e.interactive : o.aria.expanded,
    content: o.aria.content === "auto" ? e.interactive ? null : "describedby" : o.aria.content
  }, o;
}
function Ti(t) {
  var e = t.firstElementChild, o = os(e.children);
  return {
    box: e,
    content: o.find(function(s) {
      return s.classList.contains(ju);
    }),
    arrow: o.find(function(s) {
      return s.classList.contains(qu) || s.classList.contains(Gu);
    }),
    backdrop: o.find(function(s) {
      return s.classList.contains(Wu);
    })
  };
}
var mm = 1, Lo = [], gs = [];
function fm(t, e) {
  var o = Ci(t, Object.assign({}, ke, Pa(Ei(e)))), s, n, i, r = !1, a = !1, c = !1, d = !1, l, h, u, p = [], v = ki(xo, o.interactiveDebounce), g, y = mm++, b = null, _ = Yu(o.plugins), E = {
    // Is the instance currently enabled?
    isEnabled: !0,
    // Is the tippy currently showing and not transitioning out?
    isVisible: !1,
    // Has the instance been destroyed?
    isDestroyed: !1,
    // Is the tippy currently mounted to the DOM?
    isMounted: !1,
    // Has the tippy finished transitioning in?
    isShown: !1
  }, m = {
    // properties
    id: y,
    reference: t,
    popper: Xu(),
    popperInstance: b,
    props: o,
    state: E,
    plugins: _,
    // methods
    clearDelayTimeouts: Eo,
    setProps: $o,
    setContent: So,
    show: $c,
    hide: Sc,
    hideWithInteractivity: Pc,
    enable: qt,
    disable: zo,
    unmount: Cc,
    destroy: Tc
  };
  if (!o.render)
    return m;
  var P = o.render(m), k = P.popper, A = P.onUpdate;
  k.setAttribute("data-tippy-root", ""), k.id = "tippy-" + m.id, m.popper = k, t._tippy = m, k._tippy = m;
  var T = _.map(function(x) {
    return x.fn(m);
  }), z = t.hasAttribute("aria-expanded");
  return wt(), N(), X(), q("onCreate", [m]), o.showOnCreate && Wt(), k.addEventListener("mouseenter", function() {
    m.props.interactive && m.state.isVisible && m.clearDelayTimeouts();
  }), k.addEventListener("mouseleave", function() {
    m.props.interactive && m.props.trigger.indexOf("mouseenter") >= 0 && W().addEventListener("mousemove", v);
  }), m;
  function L() {
    var x = m.props.touch;
    return Array.isArray(x) ? x : [x, 0];
  }
  function D() {
    return L()[0] === "hold";
  }
  function R() {
    var x;
    return !!((x = m.props.render) != null && x.$$tippy);
  }
  function M() {
    return g || t;
  }
  function W() {
    var x = M().parentNode;
    return x ? $a(x) : document;
  }
  function oe() {
    return Ti(k);
  }
  function K(x) {
    return m.state.isMounted && !m.state.isVisible || Te.isTouch || l && l.type === "focus" ? 0 : ps(m.props.delay, x ? 0 : 1, ke.delay);
  }
  function X(x) {
    x === void 0 && (x = !1), k.style.pointerEvents = m.props.interactive && !x ? "" : "none", k.style.zIndex = "" + m.props.zIndex;
  }
  function q(x, $, I) {
    if (I === void 0 && (I = !0), T.forEach(function(O) {
      O[x] && O[x].apply(O, $);
    }), I) {
      var F;
      (F = m.props)[x].apply(F, $);
    }
  }
  function ue() {
    var x = m.props.aria;
    if (x.content) {
      var $ = "aria-" + x.content, I = k.id, F = Ct(m.props.triggerTarget || t);
      F.forEach(function(O) {
        var ie = O.getAttribute($);
        if (m.state.isVisible)
          O.setAttribute($, ie ? ie + " " + I : I);
        else {
          var he = ie && ie.replace(I, "").trim();
          he ? O.setAttribute($, he) : O.removeAttribute($);
        }
      });
    }
  }
  function N() {
    if (!(z || !m.props.aria.expanded)) {
      var x = Ct(m.props.triggerTarget || t);
      x.forEach(function($) {
        m.props.interactive ? $.setAttribute("aria-expanded", m.state.isVisible && $ === M() ? "true" : "false") : $.removeAttribute("aria-expanded");
      });
    }
  }
  function se() {
    W().removeEventListener("mousemove", v), Lo = Lo.filter(function(x) {
      return x !== v;
    });
  }
  function ne(x) {
    if (!(Te.isTouch && (c || x.type === "mousedown"))) {
      var $ = x.composedPath && x.composedPath()[0] || x.target;
      if (!(m.props.interactive && Si(k, $))) {
        if (Ct(m.props.triggerTarget || t).some(function(I) {
          return Si(I, $);
        })) {
          if (Te.isTouch || m.state.isVisible && m.props.trigger.indexOf("click") >= 0)
            return;
        } else
          q("onClickOutside", [m, x]);
        m.props.hideOnClick === !0 && (m.clearDelayTimeouts(), m.hide(), a = !0, setTimeout(function() {
          a = !1;
        }), m.state.isMounted || Re());
      }
    }
  }
  function ct() {
    c = !0;
  }
  function Oe() {
    c = !1;
  }
  function we() {
    var x = W();
    x.addEventListener("mousedown", ne, !0), x.addEventListener("touchend", ne, mt), x.addEventListener("touchstart", Oe, mt), x.addEventListener("touchmove", ct, mt);
  }
  function Re() {
    var x = W();
    x.removeEventListener("mousedown", ne, !0), x.removeEventListener("touchend", ne, mt), x.removeEventListener("touchstart", Oe, mt), x.removeEventListener("touchmove", ct, mt);
  }
  function xt(x, $) {
    _t(x, function() {
      !m.state.isVisible && k.parentNode && k.parentNode.contains(k) && $();
    });
  }
  function De(x, $) {
    _t(x, $);
  }
  function _t(x, $) {
    var I = oe().box;
    function F(O) {
      O.target === I && (vs(I, "remove", F), $());
    }
    if (x === 0)
      return $();
    vs(I, "remove", h), vs(I, "add", F), h = F;
  }
  function Ze(x, $, I) {
    I === void 0 && (I = !1);
    var F = Ct(m.props.triggerTarget || t);
    F.forEach(function(O) {
      O.addEventListener(x, $, I), p.push({
        node: O,
        eventType: x,
        handler: $,
        options: I
      });
    });
  }
  function wt() {
    D() && (Ze("touchstart", Ht, {
      passive: !0
    }), Ze("touchend", _o, {
      passive: !0
    })), Zu(m.props.trigger).forEach(function(x) {
      if (x !== "manual")
        switch (Ze(x, Ht), x) {
          case "mouseenter":
            Ze("mouseleave", _o);
            break;
          case "focus":
            Ze(rm ? "focusout" : "blur", Vt);
            break;
          case "focusin":
            Ze("focusout", Vt);
            break;
        }
    });
  }
  function yo() {
    p.forEach(function(x) {
      var $ = x.node, I = x.eventType, F = x.handler, O = x.options;
      $.removeEventListener(I, F, O);
    }), p = [];
  }
  function Ht(x) {
    var $, I = !1;
    if (!(!m.state.isEnabled || jt(x) || a)) {
      var F = (($ = l) == null ? void 0 : $.type) === "focus";
      l = x, g = x.currentTarget, N(), !m.state.isVisible && Ea(x) && Lo.forEach(function(O) {
        return O(x);
      }), x.type === "click" && (m.props.trigger.indexOf("mouseenter") < 0 || r) && m.props.hideOnClick !== !1 && m.state.isVisible ? I = !0 : Wt(x), x.type === "click" && (r = !I), I && !F && lt(x);
    }
  }
  function xo(x) {
    var $ = x.target, I = M().contains($) || k.contains($);
    if (!(x.type === "mousemove" && I)) {
      var F = Ye().concat(k).map(function(O) {
        var ie, he = O._tippy, kt = (ie = he.popperInstance) == null ? void 0 : ie.state;
        return kt ? {
          popperRect: O.getBoundingClientRect(),
          popperState: kt,
          props: o
        } : null;
      }).filter(Boolean);
      tm(F, x) && (se(), lt(x));
    }
  }
  function _o(x) {
    var $ = jt(x) || m.props.trigger.indexOf("click") >= 0 && r;
    if (!$) {
      if (m.props.interactive) {
        m.hideWithInteractivity(x);
        return;
      }
      lt(x);
    }
  }
  function Vt(x) {
    m.props.trigger.indexOf("focusin") < 0 && x.target !== M() || m.props.interactive && x.relatedTarget && k.contains(x.relatedTarget) || lt(x);
  }
  function jt(x) {
    return Te.isTouch ? D() !== x.type.indexOf("touch") >= 0 : !1;
  }
  function wo() {
    ko();
    var x = m.props, $ = x.popperOptions, I = x.placement, F = x.offset, O = x.getReferenceClientRect, ie = x.moveTransition, he = R() ? Ti(k).arrow : null, kt = O ? {
      getBoundingClientRect: O,
      contextElement: O.contextElement || M()
    } : t, Mn = {
      name: "$$tippy",
      enabled: !0,
      phase: "beforeWrite",
      requires: ["computeStyles"],
      fn: function(Po) {
        var zt = Po.state;
        if (R()) {
          var Ic = oe(), ms = Ic.box;
          ["placement", "reference-hidden", "escaped"].forEach(function(Co) {
            Co === "placement" ? ms.setAttribute("data-placement", zt.placement) : zt.attributes.popper["data-popper-" + Co] ? ms.setAttribute("data-" + Co, "") : ms.removeAttribute("data-" + Co);
          }), zt.attributes.popper = {};
        }
      }
    }, dt = [{
      name: "offset",
      options: {
        offset: F
      }
    }, {
      name: "preventOverflow",
      options: {
        padding: {
          top: 2,
          bottom: 2,
          left: 5,
          right: 5
        }
      }
    }, {
      name: "flip",
      options: {
        padding: 5
      }
    }, {
      name: "computeStyles",
      options: {
        adaptive: !ie
      }
    }, Mn];
    R() && he && dt.push({
      name: "arrow",
      options: {
        element: he,
        padding: 3
      }
    }), dt.push.apply(dt, ($ == null ? void 0 : $.modifiers) || []), m.popperInstance = Vu(kt, k, Object.assign({}, $, {
      placement: I,
      onFirstUpdate: u,
      modifiers: dt
    }));
  }
  function ko() {
    m.popperInstance && (m.popperInstance.destroy(), m.popperInstance = null);
  }
  function Me() {
    var x = m.props.appendTo, $, I = M();
    m.props.interactive && x === wa || x === "parent" ? $ = I.parentNode : $ = ka(x, [I]), $.contains(k) || $.appendChild(k), m.state.isMounted = !0, wo();
  }
  function Ye() {
    return os(k.querySelectorAll("[data-tippy-root]"));
  }
  function Wt(x) {
    m.clearDelayTimeouts(), x && q("onTrigger", [m, x]), we();
    var $ = K(!0), I = L(), F = I[0], O = I[1];
    Te.isTouch && F === "hold" && O && ($ = O), $ ? s = setTimeout(function() {
      m.show();
    }, $) : m.show();
  }
  function lt(x) {
    if (m.clearDelayTimeouts(), q("onUntrigger", [m, x]), !m.state.isVisible) {
      Re();
      return;
    }
    if (!(m.props.trigger.indexOf("mouseenter") >= 0 && m.props.trigger.indexOf("click") >= 0 && ["mouseleave", "mousemove"].indexOf(x.type) >= 0 && r)) {
      var $ = K(!1);
      $ ? n = setTimeout(function() {
        m.state.isVisible && m.hide();
      }, $) : i = requestAnimationFrame(function() {
        m.hide();
      });
    }
  }
  function qt() {
    m.state.isEnabled = !0;
  }
  function zo() {
    m.hide(), m.state.isEnabled = !1;
  }
  function Eo() {
    clearTimeout(s), clearTimeout(n), cancelAnimationFrame(i);
  }
  function $o(x) {
    if (!m.state.isDestroyed) {
      q("onBeforeUpdate", [m, x]), yo();
      var $ = m.props, I = Ci(t, Object.assign({}, $, Ei(x), {
        ignoreAttributes: !0
      }));
      m.props = I, wt(), $.interactiveDebounce !== I.interactiveDebounce && (se(), v = ki(xo, I.interactiveDebounce)), $.triggerTarget && !I.triggerTarget ? Ct($.triggerTarget).forEach(function(F) {
        F.removeAttribute("aria-expanded");
      }) : I.triggerTarget && t.removeAttribute("aria-expanded"), N(), X(), A && A($, I), m.popperInstance && (wo(), Ye().forEach(function(F) {
        requestAnimationFrame(F._tippy.popperInstance.forceUpdate);
      })), q("onAfterUpdate", [m, x]);
    }
  }
  function So(x) {
    m.setProps({
      content: x
    });
  }
  function $c() {
    var x = m.state.isVisible, $ = m.state.isDestroyed, I = !m.state.isEnabled, F = Te.isTouch && !m.props.touch, O = ps(m.props.duration, 0, ke.duration);
    if (!(x || $ || I || F) && !M().hasAttribute("disabled") && (q("onShow", [m], !1), m.props.onShow(m) !== !1)) {
      if (m.state.isVisible = !0, R() && (k.style.visibility = "visible"), X(), we(), m.state.isMounted || (k.style.transition = "none"), R()) {
        var ie = oe(), he = ie.box, kt = ie.content;
        hs([he, kt], 0);
      }
      u = function() {
        var dt;
        if (!(!m.state.isVisible || d)) {
          if (d = !0, k.style.transition = m.props.moveTransition, R() && m.props.animation) {
            var us = oe(), Po = us.box, zt = us.content;
            hs([Po, zt], O), $i([Po, zt], "visible");
          }
          ue(), N(), zi(gs, m), (dt = m.popperInstance) == null || dt.forceUpdate(), q("onMount", [m]), m.props.animation && R() && De(O, function() {
            m.state.isShown = !0, q("onShown", [m]);
          });
        }
      }, Me();
    }
  }
  function Sc() {
    var x = !m.state.isVisible, $ = m.state.isDestroyed, I = !m.state.isEnabled, F = ps(m.props.duration, 1, ke.duration);
    if (!(x || $ || I) && (q("onHide", [m], !1), m.props.onHide(m) !== !1)) {
      if (m.state.isVisible = !1, m.state.isShown = !1, d = !1, r = !1, R() && (k.style.visibility = "hidden"), se(), Re(), X(!0), R()) {
        var O = oe(), ie = O.box, he = O.content;
        m.props.animation && (hs([ie, he], F), $i([ie, he], "hidden"));
      }
      ue(), N(), m.props.animation ? R() && xt(F, m.unmount) : m.unmount();
    }
  }
  function Pc(x) {
    W().addEventListener("mousemove", v), zi(Lo, v), v(x);
  }
  function Cc() {
    m.state.isVisible && m.hide(), m.state.isMounted && (ko(), Ye().forEach(function(x) {
      x._tippy.unmount();
    }), k.parentNode && k.parentNode.removeChild(k), gs = gs.filter(function(x) {
      return x !== m;
    }), m.state.isMounted = !1, q("onHidden", [m]));
  }
  function Tc() {
    m.state.isDestroyed || (m.clearDelayTimeouts(), m.unmount(), yo(), delete t._tippy, m.state.isDestroyed = !0, q("onDestroy", [m]));
  }
}
function go(t, e) {
  e === void 0 && (e = {});
  var o = ke.plugins.concat(e.plugins || []);
  nm();
  var s = Object.assign({}, e, {
    plugins: o
  }), n = em(t), i = n.reduce(function(r, a) {
    var c = a && fm(a, s);
    return c && r.push(c), r;
  }, []);
  return za(t) ? i[0] : i;
}
go.defaultProps = ke;
go.setDefaultProps = dm;
go.currentInput = Te;
Object.assign({}, pa, {
  effect: function(e) {
    var o = e.state, s = {
      popper: {
        position: o.options.strategy,
        left: "0",
        top: "0",
        margin: "0"
      },
      arrow: {
        position: "absolute"
      },
      reference: {}
    };
    Object.assign(o.elements.popper.style, s.popper), o.styles = s, o.elements.arrow && Object.assign(o.elements.arrow.style, s.arrow);
  }
});
var Ws = {
  clientX: 0,
  clientY: 0
}, Ao = [];
function Ca(t) {
  var e = t.clientX, o = t.clientY;
  Ws = {
    clientX: e,
    clientY: o
  };
}
function pm(t) {
  t.addEventListener("mousemove", Ca);
}
function hm(t) {
  t.removeEventListener("mousemove", Ca);
}
var vm = {
  name: "followCursor",
  defaultValue: !1,
  fn: function(e) {
    var o = e.reference, s = $a(e.props.triggerTarget || o), n = !1, i = !1, r = !0, a = e.props;
    function c() {
      return e.props.followCursor === "initial" && e.state.isVisible;
    }
    function d() {
      s.addEventListener("mousemove", u);
    }
    function l() {
      s.removeEventListener("mousemove", u);
    }
    function h() {
      n = !0, e.setProps({
        getReferenceClientRect: null
      }), n = !1;
    }
    function u(g) {
      var y = g.target ? o.contains(g.target) : !0, b = e.props.followCursor, _ = g.clientX, E = g.clientY, m = o.getBoundingClientRect(), P = _ - m.left, k = E - m.top;
      (y || !e.props.interactive) && e.setProps({
        // @ts-ignore - unneeded DOMRect properties
        getReferenceClientRect: function() {
          var T = o.getBoundingClientRect(), z = _, L = E;
          b === "initial" && (z = T.left + P, L = T.top + k);
          var D = b === "horizontal" ? T.top : L, R = b === "vertical" ? T.right : z, M = b === "horizontal" ? T.bottom : L, W = b === "vertical" ? T.left : z;
          return {
            width: R - W,
            height: M - D,
            top: D,
            right: R,
            bottom: M,
            left: W
          };
        }
      });
    }
    function p() {
      e.props.followCursor && (Ao.push({
        instance: e,
        doc: s
      }), pm(s));
    }
    function v() {
      Ao = Ao.filter(function(g) {
        return g.instance !== e;
      }), Ao.filter(function(g) {
        return g.doc === s;
      }).length === 0 && hm(s);
    }
    return {
      onCreate: p,
      onDestroy: v,
      onBeforeUpdate: function() {
        a = e.props;
      },
      onAfterUpdate: function(y, b) {
        var _ = b.followCursor;
        n || _ !== void 0 && a.followCursor !== _ && (v(), _ ? (p(), e.state.isMounted && !i && !c() && d()) : (l(), h()));
      },
      onMount: function() {
        e.props.followCursor && !i && (r && (u(Ws), r = !1), c() || d());
      },
      onTrigger: function(y, b) {
        Ea(b) && (Ws = {
          clientX: b.clientX,
          clientY: b.clientY
        }), i = b.type === "focus";
      },
      onHidden: function() {
        e.props.followCursor && (h(), l(), r = !0);
      }
    };
  }
}, gm = {
  name: "sticky",
  defaultValue: !1,
  fn: function(e) {
    var o = e.reference, s = e.popper;
    function n() {
      return e.popperInstance ? e.popperInstance.state.elements.reference : o;
    }
    function i(d) {
      return e.props.sticky === !0 || e.props.sticky === d;
    }
    var r = null, a = null;
    function c() {
      var d = i("reference") ? n().getBoundingClientRect() : null, l = i("popper") ? s.getBoundingClientRect() : null;
      (d && Ii(r, d) || l && Ii(a, l)) && e.popperInstance && e.popperInstance.update(), r = d, a = l, e.state.isMounted && requestAnimationFrame(c);
    }
    return {
      onMount: function() {
        e.props.sticky && c();
      }
    };
  }
};
function Ii(t, e) {
  return t && e ? t.top !== e.top || t.right !== e.right || t.bottom !== e.bottom || t.left !== e.left : !0;
}
go.setDefaultProps({
  animation: !1
});
const Ho = /* @__PURE__ */ new WeakMap();
let Vo;
typeof MutationObserver < "u" && (Vo = new MutationObserver((t) => {
  t.forEach(function(e) {
    var o;
    e.type === "attributes" && ((o = Ho.get(e.target)) === null || o === void 0 || o.forEach((s) => {
      var n;
      return s((n = e.target.getAttribute("mode")) !== null && n !== void 0 ? n : "light");
    }));
  });
}));
function Ta(t, e) {
  const o = e.closest(t);
  if (o)
    return o;
  const s = e.getRootNode();
  return s === At.document || !(s instanceof ShadowRoot) ? null : Ta(t, s.host);
}
function bm(t, e) {
  var o;
  const s = Ta(xm("cosmos-mode"), t.element);
  s && (e((o = s.getAttribute("mode")) !== null && o !== void 0 ? o : "light"), Ho.has(s) ? Ho.get(s).push(e) : (Vo == null || Vo.observe(s, { attributes: !0 }), Ho.set(s, [e])));
}
function Bt({ instance: t, modeToAppearanceMap: e, callback: o }) {
  t.appearance ? o(t.appearance) : bm(t, (s) => {
    t.appearance || o(e[s]);
  });
}
const ym = "9.5.0", xm = (t) => `${t}-${ym.replace(/\./g, "-")}`, _m = (t) => /^-?\d+$/.test(t), wm = (t) => typeof t == "boolean" ? t : typeof t == "string" && ["", "true", "false"].includes(t) ? t !== "false" : !1;
function Ia(t) {
  if (_m(t))
    return Number(t);
  if (typeof t == "string" || typeof t == "boolean")
    return wm(t) ? 1 : void 0;
}
function La(t) {
  return typeof t == "number" ? t === 1 : !1;
}
function ss(t) {
  return typeof t == "number" ? t > 1 : !1;
}
const km = '@charset "UTF-8";:host{display:block}:host([clamp]){min-width:0}:host{--cosmos-font-family-text:Bull Text, Helvetica, sans-serif}@supports (font-variation-settings: normal){:host{--cosmos-font-family-text:Bull VF, Helvetica, sans-serif}}:host(:lang(ja)){--cosmos-font-family-text:Noto Sans JP, Helvetica, sans-serif}:host(:lang(ar)){--cosmos-font-family-text:Noto Kufi Arabic, Helvetica, sans-serif}:host(:lang(ko)){--cosmos-font-family-text:Noto Sans KR, Helvetica, sans-serif}:host(:lang(hi)){--cosmos-font-family-text:Noto Sans, Helvetica, sans-serif}:host(:lang(he)){--cosmos-font-family-text:Noto Sans Hebrew, Helvetica, sans-serif}:host(:lang(ka)){--cosmos-font-family-text:Noto Sans Georgian, Helvetica, sans-serif}:host(:lang(th)){--cosmos-font-family-text:Noto Sans Thai, Helvetica, sans-serif}:host(:lang(zh)){--cosmos-font-family-text:Microsoft YaHei, ヒラギノ角ゴ Pro W3, Hiragino Kaku Gothic Pro, Hiragino Kaku Gothic ProN W3, Osaka, メイリオ, Meiryo, ＭＳ Ｐゴシック, MS PGothic, Arial Unicode MS, Tahoma, Helvetica, sans-serif}:host(:lang(zh-Hant)){--cosmos-font-family-text:Microsoft JhengHei, Geneva CY, ヒラギノ角ゴ Pro W3, Hiragino Kaku Gothic Pro, Hiragino Kaku Gothic ProN W3, Osaka, メイリオ, Meiryo, ＭＳ Ｐゴシック, MS PGothic, Arial Unicode MS, Tahoma, Helvetica, sans-serif}@supports (font-variation-settings: normal){::slotted(strong),::slotted(b){font-variation-settings:"opsz" 12, "wght" 700}}.cosmos-text{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;color:var(--cosmos-text-color, #000F1E);font-family:var(--cosmos-text-font-family, var(--cosmos-font-family-text));font-style:var(--cosmos-text-font-style, inherit);font-variant-numeric:tabular-nums;font-variation-settings:"opsz" 12, "wght" 400;font-weight:var(--cosmos-text-font-weight, 400);letter-spacing:var(--cosmos-text-letter-spacing, inherit);line-height:var(--cosmos-text-line-height, 1.5);margin:0;text-transform:var(--cosmos-text-text-transform, var(--cosmos-text-transform, inherit))}.cosmos-text--single-line-clamp{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.cosmos-text--multi-line-clamp{-webkit-box-orient:vertical;display:-webkit-box;-webkit-line-clamp:var(--cosmos-text-clamp-length);overflow:hidden;}.cosmos-text--size-xx-small{font-size:var(--cosmos-text-font-size, calc(12rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.25);margin-bottom:0.333333em;padding-top:0.666667em}@media (min-width: 380px){.cosmos-text--size-xx-small{font-size:calc(1 * var(--cosmos-text-font-size, calc( 12rem / var(--cosmos-base-font-size, 16) + 0 * ((100vw - 380px) / 820) )))}}@media (min-width: 1200px){.cosmos-text--size-xx-small{font-size:calc(1 * var(--cosmos-text-font-size, calc(12rem / var(--cosmos-base-font-size, 16))))}}.cosmos-text--size-x-small{font-size:var(--cosmos-text-font-size, calc(14rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.357143);margin-bottom:0.428571em;padding-top:0.714286em}@media (min-width: 380px){.cosmos-text--size-x-small{font-size:calc(1 * var(--cosmos-text-font-size, calc( 14rem / var(--cosmos-base-font-size, 16) + 0 * ((100vw - 380px) / 820) )))}}@media (min-width: 1200px){.cosmos-text--size-x-small{font-size:calc(1 * var(--cosmos-text-font-size, calc(14rem / var(--cosmos-base-font-size, 16))))}}.cosmos-text--size-small{font-size:var(--cosmos-text-font-size, calc(17rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.411765);margin-bottom:0.470588em;padding-top:0.705882em}@media (min-width: 380px){.cosmos-text--size-small{font-size:calc(1 * var(--cosmos-text-font-size, calc( 17rem / var(--cosmos-base-font-size, 16) + 0 * ((100vw - 380px) / 820) )))}}@media (min-width: 1200px){.cosmos-text--size-small{font-size:calc(1 * var(--cosmos-text-font-size, calc(17rem / var(--cosmos-base-font-size, 16))))}}.cosmos-text--size-medium{font-size:var(--cosmos-text-font-size, calc(18rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.5);margin-bottom:0.4em;padding-top:0.6em}@media (min-width: 380px){.cosmos-text--size-medium{font-size:calc(1 * var(--cosmos-text-font-size, calc( 18rem / var(--cosmos-base-font-size, 16) + 2 * ((100vw - 380px) / 820) )))}}@media (min-width: 1200px){.cosmos-text--size-medium{font-size:calc(1 * var(--cosmos-text-font-size, calc(20rem / var(--cosmos-base-font-size, 16))))}}.cosmos-text--size-large{font-size:var(--cosmos-text-font-size, calc(22rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.333333);margin-bottom:0.5em;padding-top:1.083333em}@media (min-width: 380px){.cosmos-text--size-large{font-size:calc(1 * var(--cosmos-text-font-size, calc( 22rem / var(--cosmos-base-font-size, 16) + 2 * ((100vw - 380px) / 820) )))}}@media (min-width: 1200px){.cosmos-text--size-large{font-size:calc(1 * var(--cosmos-text-font-size, calc(24rem / var(--cosmos-base-font-size, 16))))}}.cosmos-text--size-x-large{font-size:var(--cosmos-text-font-size, calc(26rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.137931);margin-bottom:0.413793em;padding-top:1.103448em}@media (min-width: 380px){.cosmos-text--size-x-large{font-size:calc(1 * var(--cosmos-text-font-size, calc( 26rem / var(--cosmos-base-font-size, 16) + 3 * ((100vw - 380px) / 820) )))}}@media (min-width: 1200px){.cosmos-text--size-x-large{font-size:calc(1 * var(--cosmos-text-font-size, calc(29rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 0){.cosmos-text--size-xx-small\\@small{font-size:var(--cosmos-text-font-size, calc(12rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.25);margin-bottom:0.333333em;padding-top:0.666667em}}@media screen and (min-width: 0) and (min-width: 380px){.cosmos-text--size-xx-small\\@small{font-size:calc(1 * var(--cosmos-text-font-size, calc( 12rem / var(--cosmos-base-font-size, 16) + 0 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 0) and (min-width: 1200px){.cosmos-text--size-xx-small\\@small{font-size:calc(1 * var(--cosmos-text-font-size, calc(12rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 0){.cosmos-text--size-x-small\\@small{font-size:var(--cosmos-text-font-size, calc(14rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.357143);margin-bottom:0.428571em;padding-top:0.714286em}}@media screen and (min-width: 0) and (min-width: 380px){.cosmos-text--size-x-small\\@small{font-size:calc(1 * var(--cosmos-text-font-size, calc( 14rem / var(--cosmos-base-font-size, 16) + 0 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 0) and (min-width: 1200px){.cosmos-text--size-x-small\\@small{font-size:calc(1 * var(--cosmos-text-font-size, calc(14rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 0){.cosmos-text--size-small\\@small{font-size:var(--cosmos-text-font-size, calc(17rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.411765);margin-bottom:0.470588em;padding-top:0.705882em}}@media screen and (min-width: 0) and (min-width: 380px){.cosmos-text--size-small\\@small{font-size:calc(1 * var(--cosmos-text-font-size, calc( 17rem / var(--cosmos-base-font-size, 16) + 0 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 0) and (min-width: 1200px){.cosmos-text--size-small\\@small{font-size:calc(1 * var(--cosmos-text-font-size, calc(17rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 0){.cosmos-text--size-medium\\@small{font-size:var(--cosmos-text-font-size, calc(18rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.5);margin-bottom:0.4em;padding-top:0.6em}}@media screen and (min-width: 0) and (min-width: 380px){.cosmos-text--size-medium\\@small{font-size:calc(1 * var(--cosmos-text-font-size, calc( 18rem / var(--cosmos-base-font-size, 16) + 2 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 0) and (min-width: 1200px){.cosmos-text--size-medium\\@small{font-size:calc(1 * var(--cosmos-text-font-size, calc(20rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 0){.cosmos-text--size-large\\@small{font-size:var(--cosmos-text-font-size, calc(22rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.333333);margin-bottom:0.5em;padding-top:1.083333em}}@media screen and (min-width: 0) and (min-width: 380px){.cosmos-text--size-large\\@small{font-size:calc(1 * var(--cosmos-text-font-size, calc( 22rem / var(--cosmos-base-font-size, 16) + 2 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 0) and (min-width: 1200px){.cosmos-text--size-large\\@small{font-size:calc(1 * var(--cosmos-text-font-size, calc(24rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 0){.cosmos-text--size-x-large\\@small{font-size:var(--cosmos-text-font-size, calc(26rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.137931);margin-bottom:0.413793em;padding-top:1.103448em}}@media screen and (min-width: 0) and (min-width: 380px){.cosmos-text--size-x-large\\@small{font-size:calc(1 * var(--cosmos-text-font-size, calc( 26rem / var(--cosmos-base-font-size, 16) + 3 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 0) and (min-width: 1200px){.cosmos-text--size-x-large\\@small{font-size:calc(1 * var(--cosmos-text-font-size, calc(29rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 650px){.cosmos-text--size-xx-small\\@medium{font-size:var(--cosmos-text-font-size, calc(12rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.25);margin-bottom:0.333333em;padding-top:0.666667em}}@media screen and (min-width: 650px) and (min-width: 380px){.cosmos-text--size-xx-small\\@medium{font-size:calc(1 * var(--cosmos-text-font-size, calc( 12rem / var(--cosmos-base-font-size, 16) + 0 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 650px) and (min-width: 1200px){.cosmos-text--size-xx-small\\@medium{font-size:calc(1 * var(--cosmos-text-font-size, calc(12rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 650px){.cosmos-text--size-x-small\\@medium{font-size:var(--cosmos-text-font-size, calc(14rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.357143);margin-bottom:0.428571em;padding-top:0.714286em}}@media screen and (min-width: 650px) and (min-width: 380px){.cosmos-text--size-x-small\\@medium{font-size:calc(1 * var(--cosmos-text-font-size, calc( 14rem / var(--cosmos-base-font-size, 16) + 0 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 650px) and (min-width: 1200px){.cosmos-text--size-x-small\\@medium{font-size:calc(1 * var(--cosmos-text-font-size, calc(14rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 650px){.cosmos-text--size-small\\@medium{font-size:var(--cosmos-text-font-size, calc(17rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.411765);margin-bottom:0.470588em;padding-top:0.705882em}}@media screen and (min-width: 650px) and (min-width: 380px){.cosmos-text--size-small\\@medium{font-size:calc(1 * var(--cosmos-text-font-size, calc( 17rem / var(--cosmos-base-font-size, 16) + 0 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 650px) and (min-width: 1200px){.cosmos-text--size-small\\@medium{font-size:calc(1 * var(--cosmos-text-font-size, calc(17rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 650px){.cosmos-text--size-medium\\@medium{font-size:var(--cosmos-text-font-size, calc(18rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.5);margin-bottom:0.4em;padding-top:0.6em}}@media screen and (min-width: 650px) and (min-width: 380px){.cosmos-text--size-medium\\@medium{font-size:calc(1 * var(--cosmos-text-font-size, calc( 18rem / var(--cosmos-base-font-size, 16) + 2 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 650px) and (min-width: 1200px){.cosmos-text--size-medium\\@medium{font-size:calc(1 * var(--cosmos-text-font-size, calc(20rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 650px){.cosmos-text--size-large\\@medium{font-size:var(--cosmos-text-font-size, calc(22rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.333333);margin-bottom:0.5em;padding-top:1.083333em}}@media screen and (min-width: 650px) and (min-width: 380px){.cosmos-text--size-large\\@medium{font-size:calc(1 * var(--cosmos-text-font-size, calc( 22rem / var(--cosmos-base-font-size, 16) + 2 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 650px) and (min-width: 1200px){.cosmos-text--size-large\\@medium{font-size:calc(1 * var(--cosmos-text-font-size, calc(24rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 650px){.cosmos-text--size-x-large\\@medium{font-size:var(--cosmos-text-font-size, calc(26rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.137931);margin-bottom:0.413793em;padding-top:1.103448em}}@media screen and (min-width: 650px) and (min-width: 380px){.cosmos-text--size-x-large\\@medium{font-size:calc(1 * var(--cosmos-text-font-size, calc( 26rem / var(--cosmos-base-font-size, 16) + 3 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 650px) and (min-width: 1200px){.cosmos-text--size-x-large\\@medium{font-size:calc(1 * var(--cosmos-text-font-size, calc(29rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1000px){.cosmos-text--size-xx-small\\@large{font-size:var(--cosmos-text-font-size, calc(12rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.25);margin-bottom:0.333333em;padding-top:0.666667em}}@media screen and (min-width: 1000px) and (min-width: 380px){.cosmos-text--size-xx-small\\@large{font-size:calc(1 * var(--cosmos-text-font-size, calc( 12rem / var(--cosmos-base-font-size, 16) + 0 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1000px) and (min-width: 1200px){.cosmos-text--size-xx-small\\@large{font-size:calc(1 * var(--cosmos-text-font-size, calc(12rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1000px){.cosmos-text--size-x-small\\@large{font-size:var(--cosmos-text-font-size, calc(14rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.357143);margin-bottom:0.428571em;padding-top:0.714286em}}@media screen and (min-width: 1000px) and (min-width: 380px){.cosmos-text--size-x-small\\@large{font-size:calc(1 * var(--cosmos-text-font-size, calc( 14rem / var(--cosmos-base-font-size, 16) + 0 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1000px) and (min-width: 1200px){.cosmos-text--size-x-small\\@large{font-size:calc(1 * var(--cosmos-text-font-size, calc(14rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1000px){.cosmos-text--size-small\\@large{font-size:var(--cosmos-text-font-size, calc(17rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.411765);margin-bottom:0.470588em;padding-top:0.705882em}}@media screen and (min-width: 1000px) and (min-width: 380px){.cosmos-text--size-small\\@large{font-size:calc(1 * var(--cosmos-text-font-size, calc( 17rem / var(--cosmos-base-font-size, 16) + 0 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1000px) and (min-width: 1200px){.cosmos-text--size-small\\@large{font-size:calc(1 * var(--cosmos-text-font-size, calc(17rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1000px){.cosmos-text--size-medium\\@large{font-size:var(--cosmos-text-font-size, calc(18rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.5);margin-bottom:0.4em;padding-top:0.6em}}@media screen and (min-width: 1000px) and (min-width: 380px){.cosmos-text--size-medium\\@large{font-size:calc(1 * var(--cosmos-text-font-size, calc( 18rem / var(--cosmos-base-font-size, 16) + 2 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1000px) and (min-width: 1200px){.cosmos-text--size-medium\\@large{font-size:calc(1 * var(--cosmos-text-font-size, calc(20rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1000px){.cosmos-text--size-large\\@large{font-size:var(--cosmos-text-font-size, calc(22rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.333333);margin-bottom:0.5em;padding-top:1.083333em}}@media screen and (min-width: 1000px) and (min-width: 380px){.cosmos-text--size-large\\@large{font-size:calc(1 * var(--cosmos-text-font-size, calc( 22rem / var(--cosmos-base-font-size, 16) + 2 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1000px) and (min-width: 1200px){.cosmos-text--size-large\\@large{font-size:calc(1 * var(--cosmos-text-font-size, calc(24rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1000px){.cosmos-text--size-x-large\\@large{font-size:var(--cosmos-text-font-size, calc(26rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.137931);margin-bottom:0.413793em;padding-top:1.103448em}}@media screen and (min-width: 1000px) and (min-width: 380px){.cosmos-text--size-x-large\\@large{font-size:calc(1 * var(--cosmos-text-font-size, calc( 26rem / var(--cosmos-base-font-size, 16) + 3 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1000px) and (min-width: 1200px){.cosmos-text--size-x-large\\@large{font-size:calc(1 * var(--cosmos-text-font-size, calc(29rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1200px){.cosmos-text--size-xx-small\\@x-large{font-size:var(--cosmos-text-font-size, calc(12rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.25);margin-bottom:0.333333em;padding-top:0.666667em}}@media screen and (min-width: 1200px) and (min-width: 380px){.cosmos-text--size-xx-small\\@x-large{font-size:calc(1 * var(--cosmos-text-font-size, calc( 12rem / var(--cosmos-base-font-size, 16) + 0 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1200px) and (min-width: 1200px){.cosmos-text--size-xx-small\\@x-large{font-size:calc(1 * var(--cosmos-text-font-size, calc(12rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1200px){.cosmos-text--size-x-small\\@x-large{font-size:var(--cosmos-text-font-size, calc(14rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.357143);margin-bottom:0.428571em;padding-top:0.714286em}}@media screen and (min-width: 1200px) and (min-width: 380px){.cosmos-text--size-x-small\\@x-large{font-size:calc(1 * var(--cosmos-text-font-size, calc( 14rem / var(--cosmos-base-font-size, 16) + 0 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1200px) and (min-width: 1200px){.cosmos-text--size-x-small\\@x-large{font-size:calc(1 * var(--cosmos-text-font-size, calc(14rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1200px){.cosmos-text--size-small\\@x-large{font-size:var(--cosmos-text-font-size, calc(17rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.411765);margin-bottom:0.470588em;padding-top:0.705882em}}@media screen and (min-width: 1200px) and (min-width: 380px){.cosmos-text--size-small\\@x-large{font-size:calc(1 * var(--cosmos-text-font-size, calc( 17rem / var(--cosmos-base-font-size, 16) + 0 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1200px) and (min-width: 1200px){.cosmos-text--size-small\\@x-large{font-size:calc(1 * var(--cosmos-text-font-size, calc(17rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1200px){.cosmos-text--size-medium\\@x-large{font-size:var(--cosmos-text-font-size, calc(18rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.5);margin-bottom:0.4em;padding-top:0.6em}}@media screen and (min-width: 1200px) and (min-width: 380px){.cosmos-text--size-medium\\@x-large{font-size:calc(1 * var(--cosmos-text-font-size, calc( 18rem / var(--cosmos-base-font-size, 16) + 2 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1200px) and (min-width: 1200px){.cosmos-text--size-medium\\@x-large{font-size:calc(1 * var(--cosmos-text-font-size, calc(20rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1200px){.cosmos-text--size-large\\@x-large{font-size:var(--cosmos-text-font-size, calc(22rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.333333);margin-bottom:0.5em;padding-top:1.083333em}}@media screen and (min-width: 1200px) and (min-width: 380px){.cosmos-text--size-large\\@x-large{font-size:calc(1 * var(--cosmos-text-font-size, calc( 22rem / var(--cosmos-base-font-size, 16) + 2 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1200px) and (min-width: 1200px){.cosmos-text--size-large\\@x-large{font-size:calc(1 * var(--cosmos-text-font-size, calc(24rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1200px){.cosmos-text--size-x-large\\@x-large{font-size:var(--cosmos-text-font-size, calc(26rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.137931);margin-bottom:0.413793em;padding-top:1.103448em}}@media screen and (min-width: 1200px) and (min-width: 380px){.cosmos-text--size-x-large\\@x-large{font-size:calc(1 * var(--cosmos-text-font-size, calc( 26rem / var(--cosmos-base-font-size, 16) + 3 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1200px) and (min-width: 1200px){.cosmos-text--size-x-large\\@x-large{font-size:calc(1 * var(--cosmos-text-font-size, calc(29rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1350px){.cosmos-text--size-xx-small\\@xx-large{font-size:var(--cosmos-text-font-size, calc(12rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.25);margin-bottom:0.333333em;padding-top:0.666667em}}@media screen and (min-width: 1350px) and (min-width: 380px){.cosmos-text--size-xx-small\\@xx-large{font-size:calc(1 * var(--cosmos-text-font-size, calc( 12rem / var(--cosmos-base-font-size, 16) + 0 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1350px) and (min-width: 1200px){.cosmos-text--size-xx-small\\@xx-large{font-size:calc(1 * var(--cosmos-text-font-size, calc(12rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1350px){.cosmos-text--size-x-small\\@xx-large{font-size:var(--cosmos-text-font-size, calc(14rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.357143);margin-bottom:0.428571em;padding-top:0.714286em}}@media screen and (min-width: 1350px) and (min-width: 380px){.cosmos-text--size-x-small\\@xx-large{font-size:calc(1 * var(--cosmos-text-font-size, calc( 14rem / var(--cosmos-base-font-size, 16) + 0 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1350px) and (min-width: 1200px){.cosmos-text--size-x-small\\@xx-large{font-size:calc(1 * var(--cosmos-text-font-size, calc(14rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1350px){.cosmos-text--size-small\\@xx-large{font-size:var(--cosmos-text-font-size, calc(17rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.411765);margin-bottom:0.470588em;padding-top:0.705882em}}@media screen and (min-width: 1350px) and (min-width: 380px){.cosmos-text--size-small\\@xx-large{font-size:calc(1 * var(--cosmos-text-font-size, calc( 17rem / var(--cosmos-base-font-size, 16) + 0 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1350px) and (min-width: 1200px){.cosmos-text--size-small\\@xx-large{font-size:calc(1 * var(--cosmos-text-font-size, calc(17rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1350px){.cosmos-text--size-medium\\@xx-large{font-size:var(--cosmos-text-font-size, calc(18rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.5);margin-bottom:0.4em;padding-top:0.6em}}@media screen and (min-width: 1350px) and (min-width: 380px){.cosmos-text--size-medium\\@xx-large{font-size:calc(1 * var(--cosmos-text-font-size, calc( 18rem / var(--cosmos-base-font-size, 16) + 2 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1350px) and (min-width: 1200px){.cosmos-text--size-medium\\@xx-large{font-size:calc(1 * var(--cosmos-text-font-size, calc(20rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1350px){.cosmos-text--size-large\\@xx-large{font-size:var(--cosmos-text-font-size, calc(22rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.333333);margin-bottom:0.5em;padding-top:1.083333em}}@media screen and (min-width: 1350px) and (min-width: 380px){.cosmos-text--size-large\\@xx-large{font-size:calc(1 * var(--cosmos-text-font-size, calc( 22rem / var(--cosmos-base-font-size, 16) + 2 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1350px) and (min-width: 1200px){.cosmos-text--size-large\\@xx-large{font-size:calc(1 * var(--cosmos-text-font-size, calc(24rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1350px){.cosmos-text--size-x-large\\@xx-large{font-size:var(--cosmos-text-font-size, calc(26rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.137931);margin-bottom:0.413793em;padding-top:1.103448em}}@media screen and (min-width: 1350px) and (min-width: 380px){.cosmos-text--size-x-large\\@xx-large{font-size:calc(1 * var(--cosmos-text-font-size, calc( 26rem / var(--cosmos-base-font-size, 16) + 3 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1350px) and (min-width: 1200px){.cosmos-text--size-x-large\\@xx-large{font-size:calc(1 * var(--cosmos-text-font-size, calc(29rem / var(--cosmos-base-font-size, 16))))}}.cosmos-text--spacing-none{margin-bottom:0;padding-top:0}.cosmos-text--spacing-long-form-bottom{padding-top:0}.cosmos-text--spacing-long-form-top{margin-bottom:0}.cosmos-text--weight-medium{font-variation-settings:"opsz" 12, "wght" 500;font-weight:var(--cosmos-text-font-weight, 500)}.cosmos-text--weight-bold{font-variation-settings:"opsz" 12, "wght" 700;font-weight:var(--cosmos-text-font-weight, 700)}.cosmos-text--kind-normal.cosmos-text--appearance-light{color:var(--cosmos-text-color, #FFFFFF)}.cosmos-text--kind-subtle{color:var(--cosmos-text-color, rgba(0, 15, 30, 0.6))}.cosmos-text--kind-subtle.cosmos-text--appearance-light{color:var(--cosmos-text-color, rgba(255, 255, 255, 0.6))}', zm = km, Em = yt("cosmos-text"), $m = /* @__PURE__ */ V(class extends j {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.appearance = void 0, this.clamp = void 0, this.kind = "normal", this.size = "medium", this.spacing = "none", this.tag = "p", this.weight = "regular", this.computedAppearance = "dark";
  }
  handleAppearanceChange(e) {
    this.computedAppearance = e;
  }
  setNumericClampValue() {
    this.numericClampValue = Ia(this.clamp);
  }
  getSize() {
    return this.size && vn(this.size) ? gn(this.size) : this.size;
  }
  componentWillLoad() {
    Bt({
      instance: this,
      modeToAppearanceMap: { dark: "light", light: "dark" },
      callback: this.handleAppearanceChange.bind(this)
    }), this.setNumericClampValue();
  }
  render() {
    var e;
    const o = (e = this.tag) !== null && e !== void 0 ? e : "p";
    return w(ee, { key: "5db84f7598d24c2f13505660eb915e9d6cf75b78", style: ss(this.numericClampValue) ? { "--cosmos-text-clamp-length": `${this.numericClampValue}` } : {} }, w(o, { key: "f053b2a7b90d4045ec26957a59daa00ac9d845b7", class: Em({
      spacing: this.spacing,
      kind: this.kind,
      weight: this.weight,
      appearance: this.computedAppearance,
      size: this.getSize(),
      "single-line-clamp": La(this.numericClampValue),
      "multi-line-clamp": ss(this.numericClampValue)
    }), part: "base" }, w("slot", { key: "c5c34e966389ddfe04b70c11470e94f4dd20796d" })));
  }
  get element() {
    return this;
  }
  static get watchers() {
    return {
      appearance: ["handleAppearanceChange"],
      clamp: ["setNumericClampValue"]
    };
  }
  static get style() {
    return zm;
  }
}, [1, "cosmos-text-9-5-0", {
  appearance: [513],
  clamp: [520],
  kind: [513],
  size: [513],
  spacing: [513],
  tag: [513],
  weight: [513],
  computedAppearance: [32]
}, void 0, {
  appearance: ["handleAppearanceChange"],
  clamp: ["setNumericClampValue"]
}]);
function $n() {
  if (typeof customElements > "u")
    return;
  ["cosmos-text-9-5-0"].forEach((e) => {
    switch (e) {
      case "cosmos-text-9-5-0":
        customElements.get(e) || customElements.define(e, $m);
        break;
    }
  });
}
const Li = "success", Oo = "error", Ai = "loading", Sm = ':host{display:block;height:100%}.cosmos-image{display:-ms-flexbox;display:flex;height:100%;isolation:isolate;min-height:inherit;overflow:hidden}.cosmos-image--radius-none{border-radius:var(--cosmos-image-border-radius, 0)}.cosmos-image--radius-small{border-radius:var(--cosmos-image-border-radius, 2px)}.cosmos-image--radius-medium{border-radius:var(--cosmos-image-border-radius, 6px)}.cosmos-image--radius-large{border-radius:var(--cosmos-image-border-radius, 8px)}.cosmos-image--radius-full{border-radius:var(--cosmos-image-border-radius, 9999px)}.cosmos-image--fallback.cosmos-image--appearance-light{background-color:rgba(0, 15, 30, 0.05)}.cosmos-image--fallback.cosmos-image--appearance-dark{background-color:rgba(255, 255, 255, 0.1)}.cosmos-image--image-state-loading,.cosmos-image--fit-contain{background-color:transparent}.cosmos-image__container{display:grid;grid-template-areas:"image";height:100%;width:100%}.cosmos-image--has-preview:not(.cosmos-image--has-image) .cosmos-image__container{display:-ms-flexbox;display:flex}.cosmos-image--fit-contain .cosmos-image__container{place-content:center}.cosmos-image__preview-container,.cosmos-image__image{grid-area:image;max-height:100%;min-height:0}.cosmos-image--fit-contain.cosmos-image--radius-none .cosmos-image__preview-container,.cosmos-image--fit-contain.cosmos-image--radius-none .cosmos-image__image{border-radius:var(--cosmos-image-border-radius, 0)}.cosmos-image--fit-contain.cosmos-image--radius-small .cosmos-image__preview-container,.cosmos-image--fit-contain.cosmos-image--radius-small .cosmos-image__image{border-radius:var(--cosmos-image-border-radius, 2px)}.cosmos-image--fit-contain.cosmos-image--radius-medium .cosmos-image__preview-container,.cosmos-image--fit-contain.cosmos-image--radius-medium .cosmos-image__image{border-radius:var(--cosmos-image-border-radius, 6px)}.cosmos-image--fit-contain.cosmos-image--radius-large .cosmos-image__preview-container,.cosmos-image--fit-contain.cosmos-image--radius-large .cosmos-image__image{border-radius:var(--cosmos-image-border-radius, 8px)}.cosmos-image--fit-contain.cosmos-image--radius-full .cosmos-image__preview-container,.cosmos-image--fit-contain.cosmos-image--radius-full .cosmos-image__image{border-radius:var(--cosmos-image-border-radius, 9999px)}.cosmos-image__preview-image,.cosmos-image__image{-o-object-fit:cover;object-fit:cover}.cosmos-image__preview-container{display:-ms-flexbox;display:flex;overflow:hidden;position:relative}.cosmos-image--fit-cover .cosmos-image__preview-container{width:100%}.cosmos-image__preview-image{-webkit-filter:blur(5px);filter:blur(5px);height:calc(100% + 5px * 2);inset:0;position:absolute;-webkit-transform:translate(-5px, -5px);transform:translate(-5px, -5px);width:calc(100% + 5px * 2)}.cosmos-image__preview-dummy{max-width:100%}.cosmos-image--has-preview:not(.cosmos-image--has-image) .cosmos-image__preview-dummy{width:100%}.cosmos-image__image{max-width:100%;-webkit-transition:opacity 0.2s cubic-bezier(0, 0.32, 0.32, 1);transition:opacity 0.2s cubic-bezier(0, 0.32, 0.32, 1);z-index:1}.cosmos-image--image-state-loading .cosmos-image__image{opacity:0}.cosmos-image--image-state-success .cosmos-image__image{opacity:1;width:100%}.cosmos-image--fit-cover .cosmos-image__image{height:100%}', Pm = Sm, Et = yt("cosmos-image"), Cm = /* @__PURE__ */ V(class extends j {
  handleAppearanceChange(e) {
    this.computedAppearance = e;
  }
  handleImageChange(e, o) {
    e !== o && (this.imageState = Ai);
  }
  handleObserveResizeChange(e) {
    this.containerResizeObserver && (this.containerResizeObserver.unobserve(this.container), e && this.containerResizeObserver.observe(this.container));
  }
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.resize = Ds(this, "resize", 5), this.handleImageLoad = () => {
      this.imageState = Li;
    }, this.handleImageError = () => {
      this.imageState = Oo;
    }, this.handlePreviewError = () => {
      this.previewState = Oo;
    }, this.shouldDisplayFallback = () => !(this.shouldDisplayImage() || this.shouldDisplayPreview()), this.shouldDisplayImage = () => !!this.image && this.imageState !== Oo, this.shouldDisplayPreview = () => !!this.imagePreview && this.previewState !== Oo, this.appearance = void 0, this.fit = "cover", this.image = void 0, this.imageAlt = "", this.imagePreview = void 0, this.loading = void 0, this.observeResize = void 0, this.radius = "none", this.sizes = void 0, this.srcset = void 0, this.computedAppearance = "light", this.imageState = void 0, this.previewState = void 0, !po() && (this.containerResizeObserver = new ResizeObserver((e) => this.handleContainerResize(e)));
  }
  componentWillLoad() {
    if (Bt({
      instance: this,
      modeToAppearanceMap: { dark: "dark", light: "light" },
      callback: this.handleAppearanceChange.bind(this)
    }), this.image && typeof Image < "u") {
      const e = new Image();
      e.src = this.image, e.complete ? this.imageState = Li : this.imageState = Ai;
    }
  }
  componentDidLoad() {
    this.observeResize && this.handleObserveResizeChange(this.observeResize);
  }
  handleContainerResize(e) {
    e.forEach((o) => {
      if (o.target === this.container) {
        const { height: s, width: n } = o.contentRect;
        this.resize.emit({
          height: s,
          width: n
        });
      }
    });
  }
  render() {
    return w("div", { key: "1d61bd76e4b048670585b9f21bf379ac240a29dc", class: Et({
      appearance: this.computedAppearance,
      fallback: this.shouldDisplayFallback(),
      fit: this.fit,
      "has-image": !!this.image,
      "has-preview": !!this.imagePreview,
      "image-state": this.imageState,
      radius: this.radius
    }), part: "base", ref: (e) => this.container = e }, !this.shouldDisplayFallback() && w("div", { key: "19017aef9e629b83ab525f9c5183e43c03885643", class: Et("container") }, this.shouldDisplayPreview() && w("div", { key: "9ba921d8ecfad2c6d0f3a645288d967b411adccd", class: Et("preview-container") }, w("img", { key: "72cbb8971282fd3cebd7bb5c3f7c747e1983d930", alt: "", class: Et("preview-image"), onError: this.handlePreviewError, src: this.imagePreview }), w("img", { key: "c459a999d6ae2c64d538040389a9ad6830877c53", alt: "", class: Et("preview-dummy"), src: this.imagePreview })), this.shouldDisplayImage() && w("img", { key: "2a52f3ca09196be8dd5fc86210d1b89080a448dd", alt: this.imageAlt, class: Et("image"), loading: this.loading, onError: this.handleImageError, onLoad: this.handleImageLoad, part: "image", sizes: this.sizes, src: this.image, srcSet: this.srcset })));
  }
  get element() {
    return this;
  }
  static get watchers() {
    return {
      appearance: ["handleAppearanceChange"],
      image: ["handleImageChange"],
      observeResize: ["handleObserveResizeChange"]
    };
  }
  static get style() {
    return Pm;
  }
}, [1, "cosmos-image-9-5-0", {
  appearance: [513],
  fit: [513],
  image: [513],
  imageAlt: [513, "image-alt"],
  imagePreview: [513, "image-preview"],
  loading: [513],
  observeResize: [516, "observe-resize"],
  radius: [513],
  sizes: [513],
  srcset: [513],
  computedAppearance: [32],
  imageState: [32],
  previewState: [32]
}, void 0, {
  appearance: ["handleAppearanceChange"],
  image: ["handleImageChange"],
  observeResize: ["handleObserveResizeChange"]
}]);
function Tm() {
  if (typeof customElements > "u")
    return;
  ["cosmos-image-9-5-0"].forEach((e) => {
    switch (e) {
      case "cosmos-image-9-5-0":
        customElements.get(e) || customElements.define(e, Cm);
        break;
    }
  });
}
const Im = () => Math.floor(Math.random() * 1e3), Lm = ":host{display:block;height:1em;width:1em}.cosmos-spinner{color:var(--cosmos-spinner-color, #000F1E);display:block;height:100%;width:100%}@media screen and (prefers-reduced-motion: no-preference){.cosmos-spinner{-webkit-animation:spin 0.7s linear infinite;animation:spin 0.7s linear infinite}@-webkit-keyframes spin{100%{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@keyframes spin{100%{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}}.cosmos-spinner *{stop-color:currentColor}.cosmos-spinner--appearance-light{color:var(--cosmos-spinner-color, #FFFFFF)}", Am = Lm, Om = yt("cosmos-spinner"), Rm = /* @__PURE__ */ V(class extends j {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.appearance = void 0, this.computedAppearance = "dark";
  }
  handleAppearanceChange(e) {
    this.computedAppearance = e;
  }
  componentWillLoad() {
    Bt({
      instance: this,
      modeToAppearanceMap: { dark: "light", light: "dark" },
      callback: this.handleAppearanceChange.bind(this)
    });
  }
  render() {
    const e = Im();
    return w("svg", { key: "374c57737d7b5b70ec4679898455db8e4e8d6d73", class: Om({
      appearance: this.computedAppearance
    }), viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, w("path", { key: "1435a95c6e15398554ba5cb492ec51b5c67107fa", d: "M16.6292 7.75012C17.1997 8.73827 17.5 9.85919 17.5 11.0002C17.5 12.1412 17.1997 13.2621 16.6292 14.2503", stroke: `url(#segment-1-${e})`, "stroke-width": "3", "vector-effect": "non-scaling-stroke" }), w("path", { key: "ebf732e51233cbfc3a778a372305ec7107294e9c", d: "M16.6291 14.2502C16.0586 15.2384 15.2381 16.0589 14.25 16.6294C13.2619 17.1999 12.141 17.5003 11 17.5003", stroke: `url(#segment-2-${e})`, "stroke-width": "3", "vector-effect": "non-scaling-stroke" }), w("path", { key: "a59583758e1c98e53121987256fb3edbb51667d5", d: "M11 17.5003C9.859 17.5003 8.73812 17.1999 7.75 16.6294C6.76188 16.0589 5.94134 15.2384 5.37085 14.2502", stroke: `url(#segment-3-${e})`, "stroke-width": "3", "vector-effect": "non-scaling-stroke" }), w("path", { key: "ec4be37cac6de84e47ca90a0009f532f367843f7", d: "M5.37086 14.2503C4.80035 13.2621 4.5 12.1412 4.5 11.0002C4.5 9.85919 4.80035 8.73827 5.37086 7.75012", stroke: `url(#segment-4-${e})`, "stroke-width": "3", "vector-effect": "non-scaling-stroke" }), w("path", { key: "25a5a4c84dd1d8bd349637472c8518a1c0cfc2be", d: "M5.37085 7.75008C5.94134 6.76196 6.76188 5.94141 7.75 5.3709C8.73812 4.80039 9.859 4.50003 11 4.5", stroke: `url(#segment-5-${e})`, "stroke-width": "3", "vector-effect": "non-scaling-stroke" }), w("defs", { key: "e836e79ec9f61cfda99d860ff520b67c23b81698" }, w("linearGradient", { key: "c6196e06e68288f89ae3ed287583ce769f295582", id: `segment-1-${e}`, x1: "15.5", y1: "8.5", x2: "15.5", y2: "13.5", gradientUnits: "userSpaceOnUse" }, w("stop", { key: "a360000db92a5dbb18b927ee866b91fd3d875751", "stop-opacity": "0" }), w("stop", { key: "fc9a4c3efff44084c118825b179f53e83dfd7e7b", offset: "1", "stop-opacity": "0.25" })), w("linearGradient", { key: "cfd18e2d0c10b474ebc1cc266b6f414cd611b7fd", id: `segment-2-${e}`, x1: "15.5", y1: "13.5", x2: "13.2074", y2: "17.3236", gradientUnits: "userSpaceOnUse" }, w("stop", { key: "1ea5f466c10a80a0a53ee2985e7964bbc06dd880", "stop-opacity": "0.25" }), w("stop", { key: "53d307e19a92a9750f81b24a495d67a5e0b869cf", offset: "1", "stop-opacity": "0.5" })), w("linearGradient", { key: "9d95eef2526e13637601acbd43b4063fd2f17fb9", id: `segment-3-${e}`, x1: "11", y1: "16", x2: "9.0824", y2: "12.3929", gradientUnits: "userSpaceOnUse" }, w("stop", { key: "443673d879df03fa253e62480a9c053d477a8f70", "stop-opacity": "0.5" }), w("stop", { key: "767cbff4e0381577f2c67e6893c8f62cab260302", offset: "1", "stop-opacity": "0.75" })), w("linearGradient", { key: "467b4413d253003e37eeba613640aaf79d09ff02", id: `segment-4-${e}`, x1: "6.5", y1: "13.5", x2: "6.5", y2: "8.5", gradientUnits: "userSpaceOnUse" }, w("stop", { key: "0b266cb1053c4e291cca54e2c9487d201dada879", "stop-opacity": "0.75" }), w("stop", { key: "b60f9d7cec16515087150985628071938463c9f8", offset: "1" })), w("linearGradient", { key: "6a016e4d9315033489d66b1ca50b4f0192ae2dd4", id: `segment-5-${e}`, x1: "7", y1: "8", x2: "9.13409", y2: "4.76796", gradientUnits: "userSpaceOnUse" }, w("stop", { key: "19cf5cde5431c72ae3cc63bf9dc67e4b6b072136" }), w("stop", { key: "6667bc80bff3ce5705c6da91c3e70bf92bf0a558", offset: "1" }))));
  }
  get element() {
    return this;
  }
  static get watchers() {
    return {
      appearance: ["handleAppearanceChange"]
    };
  }
  static get style() {
    return Am;
  }
}, [1, "cosmos-spinner-9-5-0", {
  appearance: [513],
  computedAppearance: [32]
}, void 0, {
  appearance: ["handleAppearanceChange"]
}]);
function Aa() {
  if (typeof customElements > "u")
    return;
  ["cosmos-spinner-9-5-0"].forEach((e) => {
    switch (e) {
      case "cosmos-spinner-9-5-0":
        customElements.get(e) || customElements.define(e, Rm);
        break;
    }
  });
}
const Dm = ':host{display:inline-block;line-height:0;max-width:100%}:host([width=content]){width:auto}:host([width=full]){width:100%}@media screen and (min-width: 0){:host([width~="content@small"]){width:auto}}@media screen and (min-width: 0){:host([width~="full@small"]){width:100%}}@media screen and (min-width: 650px){:host([width~="content@medium"]){width:auto}}@media screen and (min-width: 650px){:host([width~="full@medium"]){width:100%}}@media screen and (min-width: 1000px){:host([width~="content@large"]){width:auto}}@media screen and (min-width: 1000px){:host([width~="full@large"]){width:100%}}@media screen and (min-width: 1200px){:host([width~="content@x-large"]){width:auto}}@media screen and (min-width: 1200px){:host([width~="full@x-large"]){width:100%}}@media screen and (min-width: 1350px){:host([width~="content@xx-large"]){width:auto}}@media screen and (min-width: 1350px){:host([width~="full@xx-large"]){width:100%}}.cosmos-button{--cosmos-icon-color:currentColor;--focus-offset:var(--cosmos-button-border-width, 1px);-ms-flex-align:center;align-items:center;-webkit-appearance:none;-moz-appearance:none;appearance:none;border-color:var(--cosmos-button-border-color, transparent);border-radius:var(--cosmos-button-border-radius, 6px);border-style:solid;border-width:var(--cosmos-button-border-width, 1px);-webkit-box-sizing:border-box;box-sizing:border-box;cursor:pointer;display:-ms-flexbox;display:flex;height:var(--cosmos-button-height);-ms-flex-pack:center;justify-content:center;max-width:100%;outline:none;padding-block:0;position:relative;text-decoration:none;white-space:nowrap}.cosmos-button:focus,.cosmos-button:focus:not(:focus-visible){outline:none}.cosmos-button:focus:not(:focus-visible)::before{content:none}.cosmos-button:focus::before{border-radius:calc(var(--focus-radius, 6px) * 1.5);bottom:calc((4px + var(--focus-offset, 0px)) * -1);-webkit-box-shadow:inset 0 0 0 2px #1B6AEE, 0 0 0 2px #FFFFFF;box-shadow:inset 0 0 0 2px #1B6AEE, 0 0 0 2px #FFFFFF;left:calc((4px + var(--focus-offset, 0px)) * -1);position:absolute;right:calc((4px + var(--focus-offset, 0px)) * -1);top:calc((4px + var(--focus-offset, 0px)) * -1);content:""}.cosmos-button.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled),.cosmos-button:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled){background:var(--cosmos-button-background-hover);border-color:var(--cosmos-button-border-color-hover, transparent)}.cosmos-button--busy:not(.cosmos-button--has-icon) .cosmos-button__spinner{left:50%;position:absolute;top:50%;-webkit-transform:translate(-50%, -50%);transform:translate(-50%, -50%)}.cosmos-button--busy:not(.cosmos-button--has-icon) .cosmos-button__label{visibility:hidden}.cosmos-button--busy.cosmos-button--has-icon ::slotted([slot=icon]){display:none}.cosmos-button__label{-ms-flex-item-align:baseline;align-self:baseline;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;--cosmos-text-color:currentColor;--cosmos-text-font-family:var(--cosmos-button-font-family);--cosmos-text-font-size:var(--cosmos-button-font-size);--cosmos-text-font-style:var(--cosmos-button-font-style);--cosmos-text-font-weight:var(--cosmos-button-font-weight);--cosmos-text-letter-spacing:var(--cosmos-button-letter-spacing);--cosmos-text-line-height:var(--cosmos-button-line-height);--cosmos-text-text-transform:var(--cosmos-button-text-transform)}:not(.cosmos-button--kind-link).cosmos-button--size-small .cosmos-button__label{--cosmos-text-line-height:var(--cosmos-button-line-height, calc(36rem / var(--cosmos-base-font-size, 16)));-webkit-margin-before:calc(var(--cosmos-button-border-width, 1px) * -1);margin-block-start:calc(var(--cosmos-button-border-width, 1px) * -1)}.cosmos-button--kind-link.cosmos-button--shape-circle.cosmos-button--size-small .cosmos-button__label,.cosmos-button--kind-link.cosmos-button--shape-square.cosmos-button--size-small .cosmos-button__label{--cosmos-text-line-height:var(--cosmos-button-line-height, calc(36rem / var(--cosmos-base-font-size, 16)))}:not(.cosmos-button--kind-link).cosmos-button--size-medium .cosmos-button__label{--cosmos-text-line-height:var(--cosmos-button-line-height, calc(40rem / var(--cosmos-base-font-size, 16)));-webkit-margin-before:calc(var(--cosmos-button-border-width, 1px) * -1);margin-block-start:calc(var(--cosmos-button-border-width, 1px) * -1)}.cosmos-button--kind-link.cosmos-button--shape-circle.cosmos-button--size-medium .cosmos-button__label,.cosmos-button--kind-link.cosmos-button--shape-square.cosmos-button--size-medium .cosmos-button__label{--cosmos-text-line-height:var(--cosmos-button-line-height, calc(40rem / var(--cosmos-base-font-size, 16)))}:not(.cosmos-button--kind-link).cosmos-button--size-large .cosmos-button__label{--cosmos-text-line-height:var(--cosmos-button-line-height, calc(48rem / var(--cosmos-base-font-size, 16)));-webkit-margin-before:calc(var(--cosmos-button-border-width, 1px) * -1);margin-block-start:calc(var(--cosmos-button-border-width, 1px) * -1)}.cosmos-button--kind-link.cosmos-button--shape-circle.cosmos-button--size-large .cosmos-button__label,.cosmos-button--kind-link.cosmos-button--shape-square.cosmos-button--size-large .cosmos-button__label{--cosmos-text-line-height:var(--cosmos-button-line-height, calc(48rem / var(--cosmos-base-font-size, 16)))}.cosmos-button__spinner{--cosmos-spinner-color:currentColor;height:calc(18rem / var(--cosmos-base-font-size, 16));width:calc(18rem / var(--cosmos-base-font-size, 16))}.cosmos-button ::slotted([slot=icon]),.cosmos-button__spinner{-ms-flex-negative:0;flex-shrink:0}.cosmos-button--icon-after{-ms-flex-direction:row-reverse;flex-direction:row-reverse}.cosmos-button--width-content{width:auto}.cosmos-button--width-full{width:100%}@media screen and (min-width: 0){.cosmos-button--width-content\\@small{width:auto}}@media screen and (min-width: 0){.cosmos-button--width-full\\@small{width:100%}}@media screen and (min-width: 650px){.cosmos-button--width-content\\@medium{width:auto}}@media screen and (min-width: 650px){.cosmos-button--width-full\\@medium{width:100%}}@media screen and (min-width: 1000px){.cosmos-button--width-content\\@large{width:auto}}@media screen and (min-width: 1000px){.cosmos-button--width-full\\@large{width:100%}}@media screen and (min-width: 1200px){.cosmos-button--width-content\\@x-large{width:auto}}@media screen and (min-width: 1200px){.cosmos-button--width-full\\@x-large{width:100%}}@media screen and (min-width: 1350px){.cosmos-button--width-content\\@xx-large{width:auto}}@media screen and (min-width: 1350px){.cosmos-button--width-full\\@xx-large{width:100%}}.cosmos-button--size-small{--cosmos-icon-size:var(--cosmos-button-icon-size, calc(16rem / var(--cosmos-base-font-size, 16)));--cosmos-button-height:calc(36rem / var(--cosmos-base-font-size, 16));gap:calc(4rem / var(--cosmos-base-font-size, 16));padding-inline:calc(16rem / var(--cosmos-base-font-size, 16))}.cosmos-button--size-medium{--cosmos-button-height:calc(40rem / var(--cosmos-base-font-size, 16));padding-inline:calc(20rem / var(--cosmos-base-font-size, 16))}.cosmos-button--size-large{--cosmos-button-height:calc(48rem / var(--cosmos-base-font-size, 16));padding-inline:calc(32rem / var(--cosmos-base-font-size, 16))}.cosmos-button--size-medium,.cosmos-button--size-large{--cosmos-icon-size:var(--cosmos-button-icon-size, calc(18rem / var(--cosmos-base-font-size, 16)));gap:calc(6rem / var(--cosmos-base-font-size, 16))}.cosmos-button--shape-pill:not(.cosmos-button--kind-link){--focus-radius:var(--cosmos-button-border-radius, 9999px);border-radius:var(--cosmos-button-border-radius, 9999px)}.cosmos-button--shape-square,.cosmos-button--shape-circle{gap:0;padding:0;width:var(--cosmos-button-height)}.cosmos-button--shape-square .cosmos-button__label,.cosmos-button--shape-circle .cosmos-button__label{-ms-flex-item-align:center;align-self:center}.cosmos-button--shape-square.cosmos-button--busy .cosmos-button__label,.cosmos-button--shape-circle.cosmos-button--busy .cosmos-button__label{display:none}.cosmos-button--shape-circle{--focus-radius:var(--cosmos-button-border-radius, 9999px);border-radius:var(--cosmos-button-border-radius, 9999px)}.cosmos-button--kind-primary.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled),.cosmos-button--kind-primary:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled){background:var(--cosmos-button-background-hover, #C3093B)}.cosmos-button--kind-secondary.cosmos-button--appearance-dark{background:var(--cosmos-button-background, rgba(0, 15, 30, 0.1))}.cosmos-button--kind-secondary.cosmos-button--appearance-dark.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled),.cosmos-button--kind-secondary.cosmos-button--appearance-dark:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled){background:var(--cosmos-button-background-hover, rgba(0, 15, 30, 0.2))}.cosmos-button--kind-secondary.cosmos-button--appearance-light{background:var(--cosmos-button-background, rgba(255, 255, 255, 0.1))}.cosmos-button--kind-secondary.cosmos-button--appearance-light.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled),.cosmos-button--kind-secondary.cosmos-button--appearance-light:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled){background:var(--cosmos-button-background-hover, rgba(255, 255, 255, 0.2))}.cosmos-button--kind-tertiary.cosmos-button--appearance-dark.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled),.cosmos-button--kind-tertiary.cosmos-button--appearance-dark:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled){background:var(--cosmos-button-background-hover, rgba(0, 15, 30, 0.1));border-color:var(--cosmos-button-border-color-hover, rgba(0, 15, 30, 0.2))}.cosmos-button--kind-tertiary.cosmos-button--appearance-light.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled),.cosmos-button--kind-tertiary.cosmos-button--appearance-light:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled){background:var(--cosmos-button-background-hover, rgba(255, 255, 255, 0.1));border-color:var(--cosmos-button-border-color-hover, rgba(255, 255, 255, 0.2))}.cosmos-button--kind-bare.cosmos-button--appearance-dark.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled),.cosmos-button--kind-bare.cosmos-button--appearance-dark:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled){background:var(--cosmos-button-background-hover, rgba(0, 15, 30, 0.1))}.cosmos-button--kind-bare.cosmos-button--appearance-light.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled),.cosmos-button--kind-bare.cosmos-button--appearance-light:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled){background:var(--cosmos-button-background-hover, rgba(255, 255, 255, 0.1))}.cosmos-button--kind-link{border-radius:var(--cosmos-button-border-radius, 0);border-width:0}.cosmos-button--kind-link:not(.cosmos-button--shape-circle,.cosmos-button--shape-square){height:auto;padding:0}.cosmos-button--kind-link.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled),.cosmos-button--kind-link:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled){border-width:0 0 var(--cosmos-button-border-width, 2px) 0;margin-bottom:calc(var(--cosmos-button-border-width, 2px) * -1)}.cosmos-button--kind-link.cosmos-button--appearance-dark.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled),.cosmos-button--kind-link.cosmos-button--appearance-dark:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled){border-color:var(--cosmos-button-border-color-hover, var(--cosmos-button-border-color, rgba(0, 15, 30, 0.2)))}.cosmos-button--kind-link.cosmos-button--appearance-light.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled),.cosmos-button--kind-link.cosmos-button--appearance-light:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled){border-color:var(--cosmos-button-border-color-hover, var(--cosmos-button-border-color, rgba(255, 255, 255, 0.2)))}.cosmos-button--kind-secondary,.cosmos-button--kind-cover-up{-webkit-backdrop-filter:blur(10px);backdrop-filter:blur(10px)}.cosmos-button--kind-tertiary,.cosmos-button--kind-bare,.cosmos-button--kind-link{background:var(--cosmos-button-background, transparent)}.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-primary,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-cover-up{color:var(--cosmos-button-color, #FFFFFF)}.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-primary.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled),.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-primary:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled),.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-cover-up.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled),.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-cover-up:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled){color:var(--cosmos-button-color-hover, #FFFFFF)}.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-secondary.cosmos-button--appearance-dark,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-tertiary.cosmos-button--appearance-dark,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-bare.cosmos-button--appearance-dark,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-link.cosmos-button--appearance-dark{color:var(--cosmos-button-color, #000F1E)}.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-secondary.cosmos-button--appearance-light,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-tertiary.cosmos-button--appearance-light,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-bare.cosmos-button--appearance-light,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-link.cosmos-button--appearance-light{color:var(--cosmos-button-color, #FFFFFF)}.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-secondary.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled).cosmos-button--appearance-dark,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-secondary:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled).cosmos-button--appearance-dark,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-tertiary.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled).cosmos-button--appearance-dark,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-tertiary:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled).cosmos-button--appearance-dark,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-bare.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled).cosmos-button--appearance-dark,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-bare:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled).cosmos-button--appearance-dark,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-link.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled).cosmos-button--appearance-dark,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-link:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled).cosmos-button--appearance-dark{color:var(--cosmos-button-color-hover, #000F1E)}.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-secondary.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled).cosmos-button--appearance-light,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-secondary:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled).cosmos-button--appearance-light,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-tertiary.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled).cosmos-button--appearance-light,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-tertiary:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled).cosmos-button--appearance-light,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-bare.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled).cosmos-button--appearance-light,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-bare:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled).cosmos-button--appearance-light,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-link.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled).cosmos-button--appearance-light,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-link:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled).cosmos-button--appearance-light{color:var(--cosmos-button-color-hover, #FFFFFF)}.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-primary{background:var(--cosmos-button-background, #DB0A40)}.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-tertiary.cosmos-button--appearance-dark{border-color:var(--cosmos-button-border-color, rgba(0, 15, 30, 0.2))}.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-tertiary.cosmos-button--appearance-light{border-color:var(--cosmos-button-border-color, rgba(255, 255, 255, 0.2))}.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-tertiary:focus.cosmos-button--appearance-dark{border-color:var(--cosmos-button-border-color, rgba(0, 15, 30, 0.1))}.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-tertiary:focus.cosmos-button--appearance-light{border-color:var(--cosmos-button-border-color, rgba(255, 255, 255, 0.1))}.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-tertiary.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled),.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-tertiary:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled),.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-bare.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled),.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-bare:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled){-webkit-backdrop-filter:blur(10px);backdrop-filter:blur(10px)}.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-cover-up{background:var(--cosmos-button-background, rgba(0, 15, 30, 0.6));border-color:var(--cosmos-button-border-color, rgba(255, 255, 255, 0.2))}.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-cover-up.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled),.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-cover-up:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled){background:var(--cosmos-button-background-hover, rgba(0, 15, 30, 0.8));border-color:var(--cosmos-button-border-color-hover, rgba(255, 255, 255, 0.45))}.cosmos-button--disabled{cursor:not-allowed}.cosmos-button--disabled.cosmos-button--kind-primary{-webkit-backdrop-filter:blur(10px);backdrop-filter:blur(10px)}.cosmos-button--disabled.cosmos-button--kind-primary.cosmos-button--appearance-dark{background:var(--cosmos-button-background, rgba(0, 15, 30, 0.1))}.cosmos-button--disabled.cosmos-button--kind-primary.cosmos-button--appearance-light{background:var(--cosmos-button-background, rgba(255, 255, 255, 0.1))}.cosmos-button--disabled.cosmos-button--kind-tertiary.cosmos-button--appearance-dark{border-color:var(--cosmos-button-border-color, rgba(0, 15, 30, 0.1))}.cosmos-button--disabled.cosmos-button--kind-tertiary.cosmos-button--appearance-light{border-color:var(--cosmos-button-border-color, rgba(255, 255, 255, 0.1))}.cosmos-button--disabled.cosmos-button--kind-cover-up{color:var(--cosmos-button-color, rgba(255, 255, 255, 0.45))}.cosmos-button--disabled.cosmos-button--kind-cover-up.cosmos-button--appearance-light{background:var(--cosmos-button-background, rgba(0, 15, 30, 0.45));border-color:var(--cosmos-button-border-color, rgba(255, 255, 255, 0.2))}.cosmos-button--disabled.cosmos-button--kind-cover-up.cosmos-button--appearance-dark{background:var(--cosmos-button-background, rgba(0, 15, 30, 0.45))}.cosmos-button--disabled.cosmos-button--appearance-dark:not(.cosmos-button--kind-cover-up){color:var(--cosmos-button-color, rgba(0, 15, 30, 0.45))}.cosmos-button--disabled.cosmos-button--appearance-light:not(.cosmos-button--kind-cover-up){color:var(--cosmos-button-color, rgba(255, 255, 255, 0.45))}', Mm = Dm, Nm = /* @__PURE__ */ V(class extends j {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.handleIconSlotChange = () => {
      this.hasIconSlot = Hs(this.element, "icon");
    }, this.appearance = void 0, this.ariaExpanded = void 0, this.ariaHaspopup = void 0, this.ariaLabel = void 0, this.busy = !1, this.buttonTitle = void 0, this.decorative = !1, this.disabled = !1, this.hovered = !1, this.href = void 0, this.iconPlacement = "before", this.kind = "primary", this.rel = void 0, this.shape = void 0, this.size = "medium", this.target = void 0, this.type = "button", this.width = "content", this.computedAppearance = "dark", this.hasIconSlot = !1;
  }
  handleAppearanceChange(e) {
    this.computedAppearance = e;
  }
  /**
   * Removes focus from the Button.
   */
  async buttonBlur() {
    this.buttonElement && this.buttonElement.blur();
  }
  /**
   * Sets focus on the Button.
   */
  async buttonFocus() {
    this.buttonElement && this.buttonElement.focus();
  }
  handleClick(e) {
    const o = this.element.closest("form");
    if (this.disabled || this.busy) {
      e.stopImmediatePropagation(), e.preventDefault(), e.stopPropagation();
      return;
    }
    if (!(!this.isButton() || this.type === "button" || !o)) {
      if (this.type === "reset")
        return o.reset();
      if (this.type === "submit")
        return Nd(o);
    }
  }
  getTextWeight() {
    return "medium";
  }
  getTextSize() {
    return this.size === "small" ? "x-small" : "small";
  }
  getType() {
    return this.isButton() ? this.type : void 0;
  }
  getWidth() {
    return this.width && vn(this.width) ? gn(this.width) : this.width;
  }
  getHostRole() {
    return this.ariaExpanded || this.ariaHaspopup || this.ariaLabel ? "presentation" : null;
  }
  isButton() {
    return !this.href && !this.decorative;
  }
  isLink() {
    return !!this.href && !this.decorative;
  }
  determineTag() {
    return this.isButton() ? "button" : this.isLink() ? "a" : "div";
  }
  getAriaLabel() {
    var e;
    return this.ariaLabel !== void 0 ? this.ariaLabel : (e = this.element.textContent) === null || e === void 0 ? void 0 : e.trim();
  }
  componentWillLoad() {
    this.hasIconSlot = Hs(this.element, "icon"), Bt({
      instance: this,
      modeToAppearanceMap: { dark: "light", light: "dark" },
      callback: this.handleAppearanceChange.bind(this)
    });
  }
  render() {
    const e = this.determineTag(), o = yt("cosmos-button");
    return w(ee, { key: "85f2845703905e31935c4aaef9c54db64b5ab28a", role: this.getHostRole() }, w(e, { key: "6f1b987bef67b1927e310c0ed10a85b9bc712adc", class: o({
      kind: this.kind,
      busy: this.busy,
      disabled: this.disabled || this.busy,
      appearance: this.computedAppearance,
      shape: this.shape || "pill",
      size: this.size,
      icon: this.iconPlacement,
      hovered: this.hovered,
      width: this.getWidth(),
      "has-icon": this.hasIconSlot
    }), disabled: this.disabled || this.busy, href: this.href, target: this.target, rel: this.rel, ref: (s) => this.buttonElement = s, type: this.getType(), part: "base", "aria-expanded": this.ariaExpanded, "aria-haspopup": this.ariaHaspopup, "aria-label": this.getAriaLabel(), title: this.buttonTitle }, this.busy && w("cosmos-spinner-9-5-0", { key: "8068d32808a096340001254641ce95d433873fee", class: o("spinner") }), w("slot", { key: "7eb60f81b3e30494d4101bcee174580b3229c394", name: "icon", onSlotchange: this.handleIconSlotChange }), w("cosmos-text-9-5-0", { key: "a5691dd339e262fb75ab7aa3b1db7fc99d355069", class: o("label"), size: this.getTextSize(), tag: "span", weight: this.getTextWeight(), exportparts: "base: label" }, w("span", { key: "e1c7926559639f715fc6f132042b45292c5aee1e" }, w("slot", { key: "b68485200ee960ebbc50697d9d6c897edebc6915" })))));
  }
  get element() {
    return this;
  }
  static get watchers() {
    return {
      appearance: ["handleAppearanceChange"]
    };
  }
  static get style() {
    return Mm;
  }
}, [1, "cosmos-button-9-5-0", {
  appearance: [513],
  ariaExpanded: [513, "aria-expanded"],
  ariaHaspopup: [513, "aria-haspopup"],
  ariaLabel: [513, "aria-label"],
  busy: [516],
  buttonTitle: [513, "button-title"],
  decorative: [516],
  disabled: [516],
  hovered: [516],
  href: [513],
  iconPlacement: [513, "icon-placement"],
  kind: [513],
  rel: [513],
  shape: [513],
  size: [513],
  target: [513],
  type: [513],
  width: [513],
  computedAppearance: [32],
  hasIconSlot: [32],
  buttonBlur: [64],
  buttonFocus: [64]
}, [[2, "click", "handleClick"]], {
  appearance: ["handleAppearanceChange"]
}]);
function Fm() {
  if (typeof customElements > "u")
    return;
  ["cosmos-button-9-5-0", "cosmos-spinner-9-5-0", "cosmos-text-9-5-0"].forEach((e) => {
    switch (e) {
      case "cosmos-button-9-5-0":
        customElements.get(e) || customElements.define(e, Nm);
        break;
      case "cosmos-spinner-9-5-0":
        customElements.get(e) || Aa();
        break;
      case "cosmos-text-9-5-0":
        customElements.get(e) || $n();
        break;
    }
  });
}
const Bm = Fm, Um = ".cosmos-mode{display:contents}", Hm = Um, Vm = /* @__PURE__ */ V(class extends j {
  constructor() {
    super(), this.__registerHost(), this.mode = "light";
  }
  render() {
    return w("div", { key: "2ff99bc827978eb74c47969af61460f767385e56", class: "cosmos-mode" }, w("slot", { key: "af5e90e1076920b57f373e7568ad310716a8d326" }));
  }
  get element() {
    return this;
  }
  static get style() {
    return Hm;
  }
}, [4, "cosmos-mode-9-5-0", {
  mode: [513]
}]);
function Oa() {
  if (typeof customElements > "u")
    return;
  ["cosmos-mode-9-5-0"].forEach((e) => {
    switch (e) {
      case "cosmos-mode-9-5-0":
        customElements.get(e) || customElements.define(e, Vm);
        break;
    }
  });
}
const jm = '@charset "UTF-8";:host{display:block}:host([clamp]){min-width:0}:host{--cosmos-font-family-title:Bull, Helvetica, sans-serif}@supports (font-variation-settings: normal){:host{--cosmos-font-family-title:Bull VF, Helvetica, sans-serif}}:host(:lang(ja)){--cosmos-font-family-title:Noto Sans JP, Helvetica, sans-serif}:host(:lang(ar)){--cosmos-font-family-title:Noto Kufi Arabic, Helvetica, sans-serif}:host(:lang(ko)){--cosmos-font-family-title:Noto Sans KR, Helvetica, sans-serif}:host(:lang(he)){--cosmos-font-family-title:Noto Sans Hebrew, Helvetica, sans-serif}:host(:lang(ka)){--cosmos-font-family-title:Noto Sans Georgian, Helvetica, sans-serif}:host(:lang(hi)){--cosmos-font-family-title:Noto Sans, Helvetica, sans-serif}:host(:lang(th)){--cosmos-font-family-title:Noto Sans Thai, Helvetica, sans-serif}:host(:lang(zh)){--cosmos-font-family-title:Microsoft YaHei, ヒラギノ角ゴ Pro W3, Hiragino Kaku Gothic Pro, Hiragino Kaku Gothic ProN W3, Osaka, メイリオ, Meiryo, ＭＳ Ｐゴシック, MS PGothic, Arial Unicode MS, Tahoma, Helvetica, sans-serif}:host(:lang(zh-Hant)){--cosmos-font-family-title:Microsoft JhengHei, Geneva CY, ヒラギノ角ゴ Pro W3, Hiragino Kaku Gothic Pro, Hiragino Kaku Gothic ProN W3, Osaka, メイリオ, Meiryo, ＭＳ Ｐゴシック, MS PGothic, Arial Unicode MS, Tahoma, Helvetica, sans-serif}.cosmos-title{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;color:var(--cosmos-title-color, #000F1E);font-family:var(--cosmos-title-font-family, var(--cosmos-font-family-title));font-style:var(--cosmos-title-font-style, inherit);font-variation-settings:"opsz" 86, "wght" 700;font-weight:var(--cosmos-title-font-weight, 700);letter-spacing:var(--cosmos-title-letter-spacing, inherit);line-height:var(--cosmos-title-line-height, inherit);margin:0;text-transform:var(--cosmos-title-text-transform, var(--cosmos-title-transform, inherit))}.cosmos-title--single-line-clamp{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.cosmos-title--multi-line-clamp{-webkit-box-orient:vertical;display:-webkit-box;-webkit-line-clamp:var(--cosmos-title-clamp-length);overflow:hidden;}.cosmos-title--size-xx-small{font-size:var(--cosmos-title-font-size, calc(17rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.411765));margin-bottom:0.470588em;padding-top:0.705882em}@media (min-width: 380px){.cosmos-title--size-xx-small{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 17rem / var(--cosmos-base-font-size, 16) + 0 * ((100vw - 380px) / 820) )))}}@media (min-width: 1200px){.cosmos-title--size-xx-small{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(17rem / var(--cosmos-base-font-size, 16))))}}.cosmos-title--size-x-small{font-size:var(--cosmos-title-font-size, calc(18rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.5));margin-bottom:0.4em;padding-top:0.6em}@media (min-width: 380px){.cosmos-title--size-x-small{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 18rem / var(--cosmos-base-font-size, 16) + 2 * ((100vw - 380px) / 820) )))}}@media (min-width: 1200px){.cosmos-title--size-x-small{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(20rem / var(--cosmos-base-font-size, 16))))}}.cosmos-title--size-small{font-size:var(--cosmos-title-font-size, calc(22rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.333333));margin-bottom:0.5em;padding-top:1.083333em}@media (min-width: 380px){.cosmos-title--size-small{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 22rem / var(--cosmos-base-font-size, 16) + 2 * ((100vw - 380px) / 820) )))}}@media (min-width: 1200px){.cosmos-title--size-small{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(24rem / var(--cosmos-base-font-size, 16))))}}.cosmos-title--size-medium{font-size:var(--cosmos-title-font-size, calc(26rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.137931));margin-bottom:0.413793em;padding-top:1.103448em}@media (min-width: 380px){.cosmos-title--size-medium{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 26rem / var(--cosmos-base-font-size, 16) + 3 * ((100vw - 380px) / 820) )))}}@media (min-width: 1200px){.cosmos-title--size-medium{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(29rem / var(--cosmos-base-font-size, 16))))}}.cosmos-title--size-large{font-size:var(--cosmos-title-font-size, calc(31rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.097561));margin-bottom:0.439024em;padding-top:0.829268em}@media (min-width: 380px){.cosmos-title--size-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 31rem / var(--cosmos-base-font-size, 16) + 10 * ((100vw - 380px) / 820) )))}}@media (min-width: 1200px){.cosmos-title--size-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(41rem / var(--cosmos-base-font-size, 16))))}}.cosmos-title--size-x-large{font-size:var(--cosmos-title-font-size, calc(37rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.066667));margin-bottom:0.333333em;padding-top:0.666667em}@media (min-width: 380px){.cosmos-title--size-x-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 37rem / var(--cosmos-base-font-size, 16) + 23 * ((100vw - 380px) / 820) )))}}@media (min-width: 1200px){.cosmos-title--size-x-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(60rem / var(--cosmos-base-font-size, 16))))}}.cosmos-title--size-xx-large{font-size:var(--cosmos-title-font-size, calc(45rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1));margin-bottom:0.255814em;padding-top:0.55814em}@media (min-width: 380px){.cosmos-title--size-xx-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 45rem / var(--cosmos-base-font-size, 16) + 41 * ((100vw - 380px) / 820) )))}}@media (min-width: 1200px){.cosmos-title--size-xx-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(86rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 0){.cosmos-title--size-xx-small\\@small{font-size:var(--cosmos-title-font-size, calc(17rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.411765));margin-bottom:0.470588em;padding-top:0.705882em}}@media screen and (min-width: 0) and (min-width: 380px){.cosmos-title--size-xx-small\\@small{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 17rem / var(--cosmos-base-font-size, 16) + 0 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 0) and (min-width: 1200px){.cosmos-title--size-xx-small\\@small{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(17rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 0){.cosmos-title--size-x-small\\@small{font-size:var(--cosmos-title-font-size, calc(18rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.5));margin-bottom:0.4em;padding-top:0.6em}}@media screen and (min-width: 0) and (min-width: 380px){.cosmos-title--size-x-small\\@small{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 18rem / var(--cosmos-base-font-size, 16) + 2 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 0) and (min-width: 1200px){.cosmos-title--size-x-small\\@small{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(20rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 0){.cosmos-title--size-small\\@small{font-size:var(--cosmos-title-font-size, calc(22rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.333333));margin-bottom:0.5em;padding-top:1.083333em}}@media screen and (min-width: 0) and (min-width: 380px){.cosmos-title--size-small\\@small{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 22rem / var(--cosmos-base-font-size, 16) + 2 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 0) and (min-width: 1200px){.cosmos-title--size-small\\@small{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(24rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 0){.cosmos-title--size-medium\\@small{font-size:var(--cosmos-title-font-size, calc(26rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.137931));margin-bottom:0.413793em;padding-top:1.103448em}}@media screen and (min-width: 0) and (min-width: 380px){.cosmos-title--size-medium\\@small{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 26rem / var(--cosmos-base-font-size, 16) + 3 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 0) and (min-width: 1200px){.cosmos-title--size-medium\\@small{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(29rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 0){.cosmos-title--size-large\\@small{font-size:var(--cosmos-title-font-size, calc(31rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.097561));margin-bottom:0.439024em;padding-top:0.829268em}}@media screen and (min-width: 0) and (min-width: 380px){.cosmos-title--size-large\\@small{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 31rem / var(--cosmos-base-font-size, 16) + 10 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 0) and (min-width: 1200px){.cosmos-title--size-large\\@small{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(41rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 0){.cosmos-title--size-x-large\\@small{font-size:var(--cosmos-title-font-size, calc(37rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.066667));margin-bottom:0.333333em;padding-top:0.666667em}}@media screen and (min-width: 0) and (min-width: 380px){.cosmos-title--size-x-large\\@small{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 37rem / var(--cosmos-base-font-size, 16) + 23 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 0) and (min-width: 1200px){.cosmos-title--size-x-large\\@small{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(60rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 0){.cosmos-title--size-xx-large\\@small{font-size:var(--cosmos-title-font-size, calc(45rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1));margin-bottom:0.255814em;padding-top:0.55814em}}@media screen and (min-width: 0) and (min-width: 380px){.cosmos-title--size-xx-large\\@small{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 45rem / var(--cosmos-base-font-size, 16) + 41 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 0) and (min-width: 1200px){.cosmos-title--size-xx-large\\@small{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(86rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 650px){.cosmos-title--size-xx-small\\@medium{font-size:var(--cosmos-title-font-size, calc(17rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.411765));margin-bottom:0.470588em;padding-top:0.705882em}}@media screen and (min-width: 650px) and (min-width: 380px){.cosmos-title--size-xx-small\\@medium{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 17rem / var(--cosmos-base-font-size, 16) + 0 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 650px) and (min-width: 1200px){.cosmos-title--size-xx-small\\@medium{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(17rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 650px){.cosmos-title--size-x-small\\@medium{font-size:var(--cosmos-title-font-size, calc(18rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.5));margin-bottom:0.4em;padding-top:0.6em}}@media screen and (min-width: 650px) and (min-width: 380px){.cosmos-title--size-x-small\\@medium{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 18rem / var(--cosmos-base-font-size, 16) + 2 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 650px) and (min-width: 1200px){.cosmos-title--size-x-small\\@medium{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(20rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 650px){.cosmos-title--size-small\\@medium{font-size:var(--cosmos-title-font-size, calc(22rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.333333));margin-bottom:0.5em;padding-top:1.083333em}}@media screen and (min-width: 650px) and (min-width: 380px){.cosmos-title--size-small\\@medium{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 22rem / var(--cosmos-base-font-size, 16) + 2 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 650px) and (min-width: 1200px){.cosmos-title--size-small\\@medium{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(24rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 650px){.cosmos-title--size-medium\\@medium{font-size:var(--cosmos-title-font-size, calc(26rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.137931));margin-bottom:0.413793em;padding-top:1.103448em}}@media screen and (min-width: 650px) and (min-width: 380px){.cosmos-title--size-medium\\@medium{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 26rem / var(--cosmos-base-font-size, 16) + 3 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 650px) and (min-width: 1200px){.cosmos-title--size-medium\\@medium{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(29rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 650px){.cosmos-title--size-large\\@medium{font-size:var(--cosmos-title-font-size, calc(31rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.097561));margin-bottom:0.439024em;padding-top:0.829268em}}@media screen and (min-width: 650px) and (min-width: 380px){.cosmos-title--size-large\\@medium{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 31rem / var(--cosmos-base-font-size, 16) + 10 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 650px) and (min-width: 1200px){.cosmos-title--size-large\\@medium{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(41rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 650px){.cosmos-title--size-x-large\\@medium{font-size:var(--cosmos-title-font-size, calc(37rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.066667));margin-bottom:0.333333em;padding-top:0.666667em}}@media screen and (min-width: 650px) and (min-width: 380px){.cosmos-title--size-x-large\\@medium{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 37rem / var(--cosmos-base-font-size, 16) + 23 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 650px) and (min-width: 1200px){.cosmos-title--size-x-large\\@medium{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(60rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 650px){.cosmos-title--size-xx-large\\@medium{font-size:var(--cosmos-title-font-size, calc(45rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1));margin-bottom:0.255814em;padding-top:0.55814em}}@media screen and (min-width: 650px) and (min-width: 380px){.cosmos-title--size-xx-large\\@medium{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 45rem / var(--cosmos-base-font-size, 16) + 41 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 650px) and (min-width: 1200px){.cosmos-title--size-xx-large\\@medium{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(86rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1000px){.cosmos-title--size-xx-small\\@large{font-size:var(--cosmos-title-font-size, calc(17rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.411765));margin-bottom:0.470588em;padding-top:0.705882em}}@media screen and (min-width: 1000px) and (min-width: 380px){.cosmos-title--size-xx-small\\@large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 17rem / var(--cosmos-base-font-size, 16) + 0 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1000px) and (min-width: 1200px){.cosmos-title--size-xx-small\\@large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(17rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1000px){.cosmos-title--size-x-small\\@large{font-size:var(--cosmos-title-font-size, calc(18rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.5));margin-bottom:0.4em;padding-top:0.6em}}@media screen and (min-width: 1000px) and (min-width: 380px){.cosmos-title--size-x-small\\@large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 18rem / var(--cosmos-base-font-size, 16) + 2 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1000px) and (min-width: 1200px){.cosmos-title--size-x-small\\@large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(20rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1000px){.cosmos-title--size-small\\@large{font-size:var(--cosmos-title-font-size, calc(22rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.333333));margin-bottom:0.5em;padding-top:1.083333em}}@media screen and (min-width: 1000px) and (min-width: 380px){.cosmos-title--size-small\\@large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 22rem / var(--cosmos-base-font-size, 16) + 2 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1000px) and (min-width: 1200px){.cosmos-title--size-small\\@large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(24rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1000px){.cosmos-title--size-medium\\@large{font-size:var(--cosmos-title-font-size, calc(26rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.137931));margin-bottom:0.413793em;padding-top:1.103448em}}@media screen and (min-width: 1000px) and (min-width: 380px){.cosmos-title--size-medium\\@large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 26rem / var(--cosmos-base-font-size, 16) + 3 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1000px) and (min-width: 1200px){.cosmos-title--size-medium\\@large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(29rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1000px){.cosmos-title--size-large\\@large{font-size:var(--cosmos-title-font-size, calc(31rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.097561));margin-bottom:0.439024em;padding-top:0.829268em}}@media screen and (min-width: 1000px) and (min-width: 380px){.cosmos-title--size-large\\@large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 31rem / var(--cosmos-base-font-size, 16) + 10 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1000px) and (min-width: 1200px){.cosmos-title--size-large\\@large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(41rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1000px){.cosmos-title--size-x-large\\@large{font-size:var(--cosmos-title-font-size, calc(37rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.066667));margin-bottom:0.333333em;padding-top:0.666667em}}@media screen and (min-width: 1000px) and (min-width: 380px){.cosmos-title--size-x-large\\@large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 37rem / var(--cosmos-base-font-size, 16) + 23 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1000px) and (min-width: 1200px){.cosmos-title--size-x-large\\@large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(60rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1000px){.cosmos-title--size-xx-large\\@large{font-size:var(--cosmos-title-font-size, calc(45rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1));margin-bottom:0.255814em;padding-top:0.55814em}}@media screen and (min-width: 1000px) and (min-width: 380px){.cosmos-title--size-xx-large\\@large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 45rem / var(--cosmos-base-font-size, 16) + 41 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1000px) and (min-width: 1200px){.cosmos-title--size-xx-large\\@large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(86rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1200px){.cosmos-title--size-xx-small\\@x-large{font-size:var(--cosmos-title-font-size, calc(17rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.411765));margin-bottom:0.470588em;padding-top:0.705882em}}@media screen and (min-width: 1200px) and (min-width: 380px){.cosmos-title--size-xx-small\\@x-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 17rem / var(--cosmos-base-font-size, 16) + 0 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1200px) and (min-width: 1200px){.cosmos-title--size-xx-small\\@x-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(17rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1200px){.cosmos-title--size-x-small\\@x-large{font-size:var(--cosmos-title-font-size, calc(18rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.5));margin-bottom:0.4em;padding-top:0.6em}}@media screen and (min-width: 1200px) and (min-width: 380px){.cosmos-title--size-x-small\\@x-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 18rem / var(--cosmos-base-font-size, 16) + 2 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1200px) and (min-width: 1200px){.cosmos-title--size-x-small\\@x-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(20rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1200px){.cosmos-title--size-small\\@x-large{font-size:var(--cosmos-title-font-size, calc(22rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.333333));margin-bottom:0.5em;padding-top:1.083333em}}@media screen and (min-width: 1200px) and (min-width: 380px){.cosmos-title--size-small\\@x-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 22rem / var(--cosmos-base-font-size, 16) + 2 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1200px) and (min-width: 1200px){.cosmos-title--size-small\\@x-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(24rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1200px){.cosmos-title--size-medium\\@x-large{font-size:var(--cosmos-title-font-size, calc(26rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.137931));margin-bottom:0.413793em;padding-top:1.103448em}}@media screen and (min-width: 1200px) and (min-width: 380px){.cosmos-title--size-medium\\@x-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 26rem / var(--cosmos-base-font-size, 16) + 3 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1200px) and (min-width: 1200px){.cosmos-title--size-medium\\@x-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(29rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1200px){.cosmos-title--size-large\\@x-large{font-size:var(--cosmos-title-font-size, calc(31rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.097561));margin-bottom:0.439024em;padding-top:0.829268em}}@media screen and (min-width: 1200px) and (min-width: 380px){.cosmos-title--size-large\\@x-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 31rem / var(--cosmos-base-font-size, 16) + 10 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1200px) and (min-width: 1200px){.cosmos-title--size-large\\@x-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(41rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1200px){.cosmos-title--size-x-large\\@x-large{font-size:var(--cosmos-title-font-size, calc(37rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.066667));margin-bottom:0.333333em;padding-top:0.666667em}}@media screen and (min-width: 1200px) and (min-width: 380px){.cosmos-title--size-x-large\\@x-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 37rem / var(--cosmos-base-font-size, 16) + 23 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1200px) and (min-width: 1200px){.cosmos-title--size-x-large\\@x-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(60rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1200px){.cosmos-title--size-xx-large\\@x-large{font-size:var(--cosmos-title-font-size, calc(45rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1));margin-bottom:0.255814em;padding-top:0.55814em}}@media screen and (min-width: 1200px) and (min-width: 380px){.cosmos-title--size-xx-large\\@x-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 45rem / var(--cosmos-base-font-size, 16) + 41 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1200px) and (min-width: 1200px){.cosmos-title--size-xx-large\\@x-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(86rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1350px){.cosmos-title--size-xx-small\\@xx-large{font-size:var(--cosmos-title-font-size, calc(17rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.411765));margin-bottom:0.470588em;padding-top:0.705882em}}@media screen and (min-width: 1350px) and (min-width: 380px){.cosmos-title--size-xx-small\\@xx-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 17rem / var(--cosmos-base-font-size, 16) + 0 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1350px) and (min-width: 1200px){.cosmos-title--size-xx-small\\@xx-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(17rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1350px){.cosmos-title--size-x-small\\@xx-large{font-size:var(--cosmos-title-font-size, calc(18rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.5));margin-bottom:0.4em;padding-top:0.6em}}@media screen and (min-width: 1350px) and (min-width: 380px){.cosmos-title--size-x-small\\@xx-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 18rem / var(--cosmos-base-font-size, 16) + 2 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1350px) and (min-width: 1200px){.cosmos-title--size-x-small\\@xx-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(20rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1350px){.cosmos-title--size-small\\@xx-large{font-size:var(--cosmos-title-font-size, calc(22rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.333333));margin-bottom:0.5em;padding-top:1.083333em}}@media screen and (min-width: 1350px) and (min-width: 380px){.cosmos-title--size-small\\@xx-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 22rem / var(--cosmos-base-font-size, 16) + 2 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1350px) and (min-width: 1200px){.cosmos-title--size-small\\@xx-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(24rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1350px){.cosmos-title--size-medium\\@xx-large{font-size:var(--cosmos-title-font-size, calc(26rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.137931));margin-bottom:0.413793em;padding-top:1.103448em}}@media screen and (min-width: 1350px) and (min-width: 380px){.cosmos-title--size-medium\\@xx-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 26rem / var(--cosmos-base-font-size, 16) + 3 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1350px) and (min-width: 1200px){.cosmos-title--size-medium\\@xx-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(29rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1350px){.cosmos-title--size-large\\@xx-large{font-size:var(--cosmos-title-font-size, calc(31rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.097561));margin-bottom:0.439024em;padding-top:0.829268em}}@media screen and (min-width: 1350px) and (min-width: 380px){.cosmos-title--size-large\\@xx-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 31rem / var(--cosmos-base-font-size, 16) + 10 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1350px) and (min-width: 1200px){.cosmos-title--size-large\\@xx-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(41rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1350px){.cosmos-title--size-x-large\\@xx-large{font-size:var(--cosmos-title-font-size, calc(37rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.066667));margin-bottom:0.333333em;padding-top:0.666667em}}@media screen and (min-width: 1350px) and (min-width: 380px){.cosmos-title--size-x-large\\@xx-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 37rem / var(--cosmos-base-font-size, 16) + 23 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1350px) and (min-width: 1200px){.cosmos-title--size-x-large\\@xx-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(60rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1350px){.cosmos-title--size-xx-large\\@xx-large{font-size:var(--cosmos-title-font-size, calc(45rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1));margin-bottom:0.255814em;padding-top:0.55814em}}@media screen and (min-width: 1350px) and (min-width: 380px){.cosmos-title--size-xx-large\\@xx-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 45rem / var(--cosmos-base-font-size, 16) + 41 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1350px) and (min-width: 1200px){.cosmos-title--size-xx-large\\@xx-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(86rem / var(--cosmos-base-font-size, 16))))}}.cosmos-title--spacing-none{margin-bottom:0;padding-top:0}.cosmos-title--spacing-long-form-bottom{padding-top:0}.cosmos-title--spacing-long-form-top{margin-bottom:0}.cosmos-title--appearance-light{color:var(--cosmos-title-color, #FFFFFF)}.cosmos-title--weight-heavy{font-variation-settings:"opsz" 86, "wght" 800;font-weight:var(--cosmos-title-font-weight, 800)}.cosmos-title--kind-subtle{color:var(--cosmos-title-color, rgba(0, 15, 30, 0.6))}.cosmos-title--kind-subtle.cosmos-title--appearance-light{color:var(--cosmos-title-color, rgba(255, 255, 255, 0.6))}', Wm = jm, qm = yt("cosmos-title"), Gm = /* @__PURE__ */ V(class extends j {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.appearance = void 0, this.clamp = void 0, this.kind = "normal", this.size = "medium", this.spacing = "none", this.tag = "p", this.weight = "bold", this.computedAppearance = "dark";
  }
  handleAppearanceChange(e) {
    this.computedAppearance = e;
  }
  setNumericClampValue() {
    this.numericClampValue = Ia(this.clamp);
  }
  componentWillLoad() {
    Bt({
      instance: this,
      modeToAppearanceMap: { dark: "light", light: "dark" },
      callback: this.handleAppearanceChange.bind(this)
    }), this.setNumericClampValue();
  }
  getSize() {
    return this.size && vn(this.size) ? gn(this.size) : this.size;
  }
  render() {
    var e;
    const o = (e = this.tag) !== null && e !== void 0 ? e : "p";
    return w(ee, { key: "69768cc2df4591bfa54fecb451c78ad8638d863e", style: ss(this.numericClampValue) ? { "--cosmos-title-clamp-length": `${this.numericClampValue}` } : {} }, w(o, { key: "77f30fd8328e3a5f282ba064dcbdfa148a2261e2", class: qm({
      appearance: this.computedAppearance,
      size: this.getSize(),
      spacing: this.spacing,
      weight: this.weight,
      "single-line-clamp": La(this.numericClampValue),
      "multi-line-clamp": ss(this.numericClampValue),
      kind: this.kind
    }), part: "base" }, w("slot", { key: "a96334773ac27d48055ee63e08f81fb6e36610bc" })));
  }
  get element() {
    return this;
  }
  static get watchers() {
    return {
      appearance: ["handleAppearanceChange"],
      clamp: ["setNumericClampValue"]
    };
  }
  static get style() {
    return Wm;
  }
}, [1, "cosmos-title-9-5-0", {
  appearance: [513],
  clamp: [520],
  kind: [513],
  size: [513],
  spacing: [513],
  tag: [513],
  weight: [513],
  computedAppearance: [32]
}, void 0, {
  appearance: ["handleAppearanceChange"],
  clamp: ["setNumericClampValue"]
}]);
function Zm() {
  if (typeof customElements > "u")
    return;
  ["cosmos-title-9-5-0"].forEach((e) => {
    switch (e) {
      case "cosmos-title-9-5-0":
        customElements.get(e) || customElements.define(e, Gm);
        break;
    }
  });
}
const Ym = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", Km = Ym, Xm = /* @__PURE__ */ V(class extends j {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return w(ee, { key: "6d802ee881fdb4abb72417a18ce220de677a2034", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, w("svg", { key: "5ee9cbd2f39da1f52d2891748fbbe1e2d2bfb99e", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, w("path", { key: "63f2acd9e45159929c69780d22f5360cafff5cb6", d: "M13.71 10.213c.246 0 .448-.068.583-.158.135-.09.203-.247.203-.427 0-.134-.023-.224-.113-.314s-.224-.157-.45-.247l-.673-.247c-.584-.225-.876-.607-.876-1.124a1 1 0 0 1 .404-.831c.27-.202.629-.315 1.056-.315.337 0 .674.068 1.011.18.067.023.112.045.135.09.022.045.045.09.045.157v.225c0 .09-.045.135-.113.135a.51.51 0 0 1-.087-.02 3.688 3.688 0 0 0-.092-.025 2.716 2.716 0 0 0-.854-.135c-.517 0-.764.18-.764.517 0 .157.045.247.135.337.067.09.247.18.494.27l.63.246c.314.113.538.27.673.427.135.18.202.382.202.652 0 .382-.134.674-.426.899-.293.224-.652.337-1.124.337-.45 0-.854-.068-1.213-.225a.345.345 0 0 1-.135-.09c-.022-.044-.045-.09-.045-.157v-.225c0-.09.023-.135.09-.135.033 0 .078.013.135.028l.067.017c.36.113.72.158 1.101.158ZM16.316 5c.157 0 .292.045.381.135.09.067.113.202.113.337a.457.457 0 0 1-.135.337.474.474 0 0 1-.36.135.474.474 0 0 1-.36-.135c-.089-.068-.134-.202-.134-.337s.045-.247.135-.337a.475.475 0 0 1 .36-.135Zm-.226 1.663h.473c.112 0 .157.067.157.157v3.73c0 .112-.045.157-.157.157h-.472c-.113 0-.158-.045-.158-.157V6.82c0-.112.046-.157.158-.157Zm3.55.561c-.449 0-.763.113-.965.337-.203.225-.293.585-.315 1.079v.112c0 .472.09.831.292 1.056.202.225.517.337.944.337.224 0 .472-.045.719-.112.045-.023.09-.023.112-.023.067 0 .112.045.112.158v.224c0 .068 0 .135-.022.158-.023.045-.067.067-.135.09-.247.112-.562.157-.899.157-.629 0-1.1-.18-1.437-.54-.337-.359-.495-.876-.495-1.55s.18-1.213.517-1.573c.36-.381.831-.561 1.46-.561.27 0 .561.067.853.134h.001a.49.49 0 0 1 .111.09h.002c.022.023.044.09.044.158v.224c0 .113-.045.158-.112.158-.045 0-.067 0-.135-.023a2.076 2.076 0 0 0-.651-.09ZM6.969 10.707h-.472c-.112 0-.157-.045-.157-.157V7.966c0-.27-.068-.45-.158-.584-.09-.135-.247-.203-.471-.203-.382 0-.764.113-1.169.36v3.01c0 .113-.045.158-.157.158h-.472c-.112 0-.157-.045-.157-.157V7.966c0-.27-.068-.45-.157-.584-.09-.135-.248-.203-.472-.203-.405 0-.787.135-1.169.36v3.033c0 .112-.045.157-.157.157H1.33c-.112 0-.157-.045-.157-.157v-3.73c0-.112.045-.157.157-.157h.36c.045 0 .09 0 .112.023.045.022.068.045.068.112l.044.247c.495-.337.99-.517 1.483-.517.495 0 .832.18 1.011.562.517-.382 1.056-.562 1.573-.562.382 0 .652.113.854.315.202.202.292.494.292.876v2.809c0 .112-.045.157-.157.157Zm3.797-.899V6.82c0-.09.045-.157.18-.157h.472c.112 0 .157.045.157.157v3.707c0 .112-.045.157-.157.157h-.338c-.067 0-.112 0-.134-.022-.045-.023-.068-.045-.068-.112l-.045-.27c-.494.36-1.01.54-1.528.54-.382 0-.674-.113-.876-.315-.202-.203-.292-.517-.292-.899V6.82c0-.112.045-.157.157-.157h.472c.113 0 .157.045.157.157v2.539c0 .292.045.494.158.629.112.135.292.202.539.202.382 0 .764-.135 1.146-.382Zm10.155 2.652c.247.314-.067 2.358-1.235 3.347-.203.135-.36.067-.292-.135.27-.651.853-2.134.584-2.494-.292-.36-1.865-.18-2.562-.09-.202.023-.247-.157-.045-.292.652-.449 1.506-.606 2.225-.606.674 0 1.213.135 1.325.27Z", fill: "currentColor" }), w("path", { key: "b78e4dccb4f36f470f310526c097941ea2cb26d7", d: "M11.193 15.245c2.426 0 5.1-.516 7.549-1.55.382-.157.696.247.314.517-2.179 1.618-5.347 2.471-8.088 2.471-3.82 0-7.28-1.415-9.886-3.774-.157-.158-.067-.337.09-.337.045 0 .09.022.134.044 2.808 1.64 6.292 2.63 9.887 2.63Z", fill: "currentColor" })));
  }
  static get style() {
    return Km;
  }
}, [1, "cosmos-icon-amazon-music-9-5-0", {
  ariaLabel: [513, "aria-label"]
}]);
function Jm() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-amazon-music-9-5-0"].forEach((e) => {
    switch (e) {
      case "cosmos-icon-amazon-music-9-5-0":
        customElements.get(e) || customElements.define(e, Xm);
        break;
    }
  });
}
const Qm = Jm, ef = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", tf = ef, of = /* @__PURE__ */ V(class extends j {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return w(ee, { key: "e5c83a9d255870112c9c6804d1de1aeab35f8129", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, w("svg", { key: "267ee052f90f14e866fb76720609c2b7abe4474e", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, w("path", { key: "1d0364dfc45f28f3e9a64ffe13d4f8b31e94ab87", d: "M12.523 12.599c-.31-.328-.856-.538-1.5-.538-.643 0-1.188.21-1.499.537a.951.951 0 0 0-.274.596c-.053.484-.023.9.033 1.565.054.634.157 1.48.29 2.34.095.614.173.945.243 1.181.114.384.54.72 1.208.72.667 0 1.093-.336 1.207-.72.07-.236.148-.567.243-1.18.134-.861.236-1.707.29-2.34.057-.666.086-1.082.034-1.566a.95.95 0 0 0-.275-.596Zm-3.19-2.917a1.693 1.693 0 1 0 3.385 0 1.693 1.693 0 0 0-3.386 0ZM11.003 3c-3.96.011-7.204 3.224-7.253 7.184-.04 3.207 2.007 5.95 4.867 6.957a.097.097 0 0 0 .128-.106 41.6 41.6 0 0 1-.105-.746.25.25 0 0 0-.147-.197 6.353 6.353 0 0 1-3.813-5.879c.034-3.445 2.847-6.254 6.292-6.282a6.351 6.351 0 0 1 6.397 6.344 6.353 6.353 0 0 1-3.814 5.817.25.25 0 0 0-.146.198 41.69 41.69 0 0 1-.106.745c-.01.072.06.13.13.106 2.831-.996 4.867-3.698 4.867-6.866 0-4.018-3.276-7.286-7.297-7.275Zm-.131 3.338a3.947 3.947 0 0 1 4.098 3.94c0 1.131-.48 2.153-1.246 2.873a.301.301 0 0 0-.095.237c.016.27.01.534-.008.83-.005.08.084.13.15.086a4.872 4.872 0 0 0 2.13-4.027 4.88 4.88 0 0 0-5.066-4.87 4.888 4.888 0 0 0-4.68 4.807 4.872 4.872 0 0 0 2.13 4.09.096.096 0 0 0 .15-.085 6.977 6.977 0 0 1-.01-.831.302.302 0 0 0-.094-.237 3.932 3.932 0 0 1-1.245-2.98 3.954 3.954 0 0 1 3.786-3.833Z", fill: "currentColor" })));
  }
  static get style() {
    return tf;
  }
}, [1, "cosmos-icon-apple-podcasts-9-5-0", {
  ariaLabel: [513, "aria-label"]
}]);
function sf() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-apple-podcasts-9-5-0"].forEach((e) => {
    switch (e) {
      case "cosmos-icon-apple-podcasts-9-5-0":
        customElements.get(e) || customElements.define(e, of);
        break;
    }
  });
}
const nf = sf, rf = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", af = rf, cf = /* @__PURE__ */ V(class extends j {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return w(ee, { key: "ab60af8995a991deecfc043c5d38c7a95eae9c46", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, w("svg", { key: "e78b7865abb401fc3ea3278224b74fecf56629b3", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, w("path", { key: "638b840251c3b1e59af7ae415116afe58065d335", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M9 6.472h4.628a5.11 5.11 0 0 1 5.162 4.824 4.852 4.852 0 0 1-1.362 3.562 5 5 0 0 1-2.841 1.493.509.509 0 0 1-.587-.5v-.532a.51.51 0 0 1 .425-.493c.73-.137 1.4-.49 1.926-1.015a3.323 3.323 0 0 0 .939-2.473 3.6 3.6 0 0 0-3.662-3.362H9v2.3a.5.5 0 0 1-.854.352L5.114 7.576a.5.5 0 0 1 0-.706l3.033-3.024A.5.5 0 0 1 9 4.2v2.272Zm.19 6.846c.312-.3.738-.453 1.169-.418a1.5 1.5 0 0 1 1.62 1.567V15.7a1.5 1.5 0 0 1-1.62 1.571A1.507 1.507 0 0 1 8.732 15.7v-1.229c-.02-.432.147-.852.459-1.153Zm1.594 2.361c0 .349-.143.531-.425.531-.282 0-.431-.187-.431-.531v-1.187c0-.344.143-.532.431-.532.288 0 .425.182.425.532v1.187ZM8.309 16.95v-.621a.231.231 0 0 0-.24-.239h-.46v-2.87a.23.23 0 0 0-.24-.24h-.61a.85.85 0 0 0-.23.03l-1.05.33a.234.234 0 0 0-.16.29l.14.53a.235.235 0 0 0 .32.17l.64-.2v1.96h-.66a.23.23 0 0 0-.24.24v.62a.231.231 0 0 0 .24.24h2.31a.231.231 0 0 0 .24-.24Z", fill: "currentColor" })));
  }
  static get style() {
    return af;
  }
}, [1, "cosmos-icon-back-10-9-5-0", {
  ariaLabel: [513, "aria-label"]
}]);
function lf() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-back-10-9-5-0"].forEach((e) => {
    switch (e) {
      case "cosmos-icon-back-10-9-5-0":
        customElements.get(e) || customElements.define(e, cf);
        break;
    }
  });
}
const df = lf, uf = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", mf = uf, ff = /* @__PURE__ */ V(class extends j {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return w(ee, { key: "a3e3904247852ced48e21cc2c74209a28a330662", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, w("svg", { key: "784f36ae1f3c637c9189d769d5b23a37a33a7f4a", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, w("path", { key: "38aedf7ece4199e2ceee87db6f01a8e906dc8ded", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m11.36 15.18 5.82-5.83a.48.48 0 0 0 0-.7l-.35-.36a.51.51 0 0 0-.71 0L11 13.41 5.89 8.29a.51.51 0 0 0-.71 0l-.35.36a.48.48 0 0 0 0 .7l5.82 5.83a.51.51 0 0 0 .71 0Z", fill: "currentColor" })));
  }
  static get style() {
    return mf;
  }
}, [1, "cosmos-icon-chevron-down-9-5-0", {
  ariaLabel: [513, "aria-label"]
}]);
function pf() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-chevron-down-9-5-0"].forEach((e) => {
    switch (e) {
      case "cosmos-icon-chevron-down-9-5-0":
        customElements.get(e) || customElements.define(e, ff);
        break;
    }
  });
}
const hf = pf, vf = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", gf = vf, bf = /* @__PURE__ */ V(class extends j {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return w(ee, { key: "05df4208b9a9f8d4835ca49d9f9964a455f7e184", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, w("svg", { key: "fd8457c3b38a7f7998cf5656213a0db4599f616d", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, w("path", { key: "04e1fd3ca15cb3dbe443a50f19c2325fc2243fe5", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M5.784 5.65c-.143-.826-.352-1.346-.583-1.347-.433.002-.783 1.803-.783 4.026 0 2.224.35 4.026.783 4.026.177 0 .341-.306.473-.819.208 1.878.64 3.168 1.14 3.168.386 0 .733-.775.967-1.998.159 2.326.56 3.975 1.027 3.975.294 0 .562-.653.76-1.718.239 2.198.79 3.737 1.432 3.737.642 0 1.194-1.539 1.431-3.737.197 1.065.465 1.718.76 1.718.468 0 .868-1.65 1.028-3.975.233 1.223.58 1.998.967 1.998.5 0 .932-1.29 1.14-3.168.13.515.295.82.472.82.433 0 .783-1.803.783-4.027 0-2.223-.35-4.026-.783-4.026-.232 0-.44.521-.583 1.347-.23-1.424-.605-2.35-1.029-2.35-.503 0-.939 1.309-1.145 3.21-.201-1.384-.507-2.266-.85-2.266-.48 0-.889 1.735-1.04 4.154-.285-1.24-.696-2.018-1.152-2.018-.456 0-.868.778-1.152 2.018-.152-2.42-.56-4.154-1.04-4.154-.342 0-.647.882-.85 2.266C7.75 4.609 7.315 3.3 6.813 3.3c-.422 0-.798.926-1.03 2.35ZM18.7 7.933c0-.994-.199-1.8-.444-1.8s-.444.806-.444 1.8.199 1.8.444 1.8.444-.806.444-1.8Zm-14.512 0c0-.994-.199-1.8-.444-1.8s-.444.806-.444 1.8.199 1.8.444 1.8.444-.806.444-1.8Z", fill: "currentColor" })));
  }
  static get style() {
    return gf;
  }
}, [1, "cosmos-icon-deezer-9-5-0", {
  ariaLabel: [513, "aria-label"]
}]);
function yf() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-deezer-9-5-0"].forEach((e) => {
    switch (e) {
      case "cosmos-icon-deezer-9-5-0":
        customElements.get(e) || customElements.define(e, bf);
        break;
    }
  });
}
const xf = yf, _f = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", wf = _f, kf = /* @__PURE__ */ V(class extends j {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return w(ee, { key: "b30f8798b0717efb2d065e5068bc7bd9341890f6", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, w("svg", { key: "52e6318e48135e0382f009893f8338a610b8676a", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, w("path", { key: "07b8ed534409a1ec6841b6786ef59142673bbf7e", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M14 6.472H9.372a5.11 5.11 0 0 0-5.162 4.817 4.852 4.852 0 0 0 1.362 3.565 5 5 0 0 0 2.841 1.493.51.51 0 0 0 .587-.5v-.532a.51.51 0 0 0-.425-.493c-.73-.137-1.4-.49-1.926-1.015a3.323 3.323 0 0 1-.939-2.473 3.6 3.6 0 0 1 3.662-3.358H14v2.3a.5.5 0 0 0 .854.352l3.032-3.052a.5.5 0 0 0 0-.706l-3.033-3.024A.5.5 0 0 0 14 4.2v2.272Zm.149 10.478v-.621a.23.23 0 0 0-.239-.239h-.46v-2.87a.23.23 0 0 0-.24-.24h-.61a.851.851 0 0 0-.23.03l-1.05.33a.234.234 0 0 0-.16.29l.14.53a.235.235 0 0 0 .32.17l.64-.2v1.96h-.66a.23.23 0 0 0-.24.24v.62a.231.231 0 0 0 .24.24h2.309a.231.231 0 0 0 .24-.24Zm.451-1.25v-1.233a1.506 1.506 0 0 1 1.63-1.567 1.505 1.505 0 0 1 1.621 1.571V15.7a1.5 1.5 0 0 1-1.621 1.57 1.506 1.506 0 0 1-1.63-1.57Zm2.051-1.208v1.184l.004-.001c0 .349-.141.531-.429.531-.288 0-.431-.187-.431-.531v-1.183c0-.344.149-.532.431-.532.282 0 .425.182.425.532Z", fill: "currentColor" })));
  }
  static get style() {
    return wf;
  }
}, [1, "cosmos-icon-forward-10-9-5-0", {
  ariaLabel: [513, "aria-label"]
}]);
function zf() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-forward-10-9-5-0"].forEach((e) => {
    switch (e) {
      case "cosmos-icon-forward-10-9-5-0":
        customElements.get(e) || customElements.define(e, kf);
        break;
    }
  });
}
const Ef = zf, $f = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", Sf = $f, Pf = /* @__PURE__ */ V(class extends j {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return w(ee, { key: "93c9290691a7eb8aaa81992e7deedc9f3c9bf1d2", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, w("svg", { key: "c3542f4878b5e92e06f6fa81ce8cc55bf2632671", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, w("path", { key: "eb7f2e00ceb873f75f9fb040df39aef355a3e927", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M11 3a1 1 0 0 0-1 1v1.09a1 1 0 1 0 2 0V4a1 1 0 0 0-1-1ZM7.455 6.182a1 1 0 0 0-1 1v3.568a1 1 0 0 0 1.999 0V7.182a1 1 0 0 0-1-1ZM4 9.455a1 1 0 0 0-1 1v1.09a1 1 0 1 0 2 0v-1.09a1 1 0 0 0-1-1Zm14 0a1 1 0 0 0-1 1v1.09a1 1 0 1 0 2 0v-1.09a1 1 0 0 0-1-1ZM6.455 13.727a1 1 0 1 1 2 0v1.091a1 1 0 1 1-2 0v-1.09Zm7.09-6.545a1 1 0 1 1 2 0v1.09a1 1 0 1 1-2 0v-1.09ZM10 16.909a1 1 0 1 1 2 0V18a1 1 0 1 1-2 0v-1.09Zm4.546-6.636a1 1 0 0 0-1 1v3.545a1 1 0 1 0 2 0v-3.545a1 1 0 0 0-1-1ZM11 7.09a1 1 0 0 1 1 1v5.818a1 1 0 1 1-2 0V8.091a1 1 0 0 1 1-1Z", fill: "currentColor" })));
  }
  static get style() {
    return Sf;
  }
}, [1, "cosmos-icon-google-podcasts-9-5-0", {
  ariaLabel: [513, "aria-label"]
}]);
function Cf() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-google-podcasts-9-5-0"].forEach((e) => {
    switch (e) {
      case "cosmos-icon-google-podcasts-9-5-0":
        customElements.get(e) || customElements.define(e, Pf);
        break;
    }
  });
}
const Tf = Cf, If = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", Lf = If, Af = /* @__PURE__ */ V(class extends j {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return w(ee, { key: "fbef4de0bacfa96fe798accddc18648f952976b9", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, w("svg", { key: "7825f1059a978e95a2e2477f34e9893cfb0ca9d9", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, w("path", { key: "0b8bdf42719f9a8354b85e0bae42affe7ca496a4", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M16.25 11.636C16.234 8.138 14.21 5.75 11 5.75s-5.234 2.388-5.25 5.886h.875c.483 0 .875.428.875.955v4.455c0 .526-.392.954-.875.954h-1.75C4.392 18 4 17.572 4 17.046v-5.41C4.016 7.436 7.146 4 11 4s6.984 3.436 7 7.636v5.41c0 .526-.392.954-.875.954h-1.75c-.483 0-.875-.428-.875-.954V12.59c0-.527.392-.955.875-.955h.875Z", fill: "currentColor" })));
  }
  static get style() {
    return Lf;
  }
}, [1, "cosmos-icon-headphones-9-5-0", {
  ariaLabel: [513, "aria-label"]
}]);
function Of() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-headphones-9-5-0"].forEach((e) => {
    switch (e) {
      case "cosmos-icon-headphones-9-5-0":
        customElements.get(e) || customElements.define(e, Af);
        break;
    }
  });
}
const Rf = Of, Df = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", Mf = Df, Nf = /* @__PURE__ */ V(class extends j {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return w(ee, { key: "9be8e312eabe13d5a0414f0a4fb92aad5fa3b8d1", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, w("svg", { key: "ec47082927fe95ae5265052c90fdd70c1e98b7c0", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, w("path", { key: "c06e8aa6247d4ea5ea367f4413337253baf83c88", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M6.253 5.193A7.469 7.469 0 0 1 11 3.5a7.51 7.51 0 0 1 7.5 7.5 7.47 7.47 0 0 1-1.693 4.747L6.253 5.193Zm-1.06 1.06a7.5 7.5 0 0 0 10.554 10.554L5.192 6.253ZM2 11a9 9 0 0 1 9-9 9.01 9.01 0 0 1 9 9 9 9 0 1 1-18 0Z", fill: "currentColor" })));
  }
  static get style() {
    return Mf;
  }
}, [1, "cosmos-icon-no-data-9-5-0", {
  ariaLabel: [513, "aria-label"]
}]);
function Ff() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-no-data-9-5-0"].forEach((e) => {
    switch (e) {
      case "cosmos-icon-no-data-9-5-0":
        customElements.get(e) || customElements.define(e, Nf);
        break;
    }
  });
}
const Bf = Ff, Uf = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", Hf = Uf, Vf = /* @__PURE__ */ V(class extends j {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return w(ee, { key: "64254dc5a42b603017460e59118774b5ba274601", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, w("svg", { key: "0483fae82659282f911df950a43bf46be5a2b8d2", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, w("path", { key: "a1ef02e675e5d08af0635dc2f0b7e1e976add903", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M5 4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V4Zm8 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V4Z", fill: "currentColor" })));
  }
  static get style() {
    return Hf;
  }
}, [1, "cosmos-icon-pause-9-5-0", {
  ariaLabel: [513, "aria-label"]
}]);
function jf() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-pause-9-5-0"].forEach((e) => {
    switch (e) {
      case "cosmos-icon-pause-9-5-0":
        customElements.get(e) || customElements.define(e, Vf);
        break;
    }
  });
}
const Wf = jf, qf = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", Gf = qf, Zf = /* @__PURE__ */ V(class extends j {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return w(ee, { key: "b3b5d93db0909059c7da9b98f05f837f760d1ddd", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, w("svg", { key: "ae29ba8f0d90c790a2776c5406e21493b5489eaf", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, w("path", { key: "f7f11ae7f621a38739b87ea575ebf4c416dc8edd", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m7.22 17.44 10.38-5.905a.608.608 0 0 0 .283-.531.607.607 0 0 0-.282-.531L7.22 4.568a.426.426 0 0 0-.495.023.615.615 0 0 0-.225.52v11.81a.618.618 0 0 0 .239.492.434.434 0 0 0 .48.027Z", fill: "currentColor" })));
  }
  static get style() {
    return Gf;
  }
}, [1, "cosmos-icon-play-9-5-0", {
  ariaLabel: [513, "aria-label"]
}]);
function Yf() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-play-9-5-0"].forEach((e) => {
    switch (e) {
      case "cosmos-icon-play-9-5-0":
        customElements.get(e) || customElements.define(e, Zf);
        break;
    }
  });
}
const Kf = Yf, Xf = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", Jf = Xf, Qf = /* @__PURE__ */ V(class extends j {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return w(ee, { key: "53fb39e861e41bda2309b6d95e72ee9275c17b8a", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, w("svg", { key: "4736ec5070255e33b4dc490d24eace01c40d2706", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, w("path", { key: "fd7f81d0e2ba5fa7393189e4856ba0b85b260558", d: "M10.993 18.6a6.504 6.504 0 0 1-6.487-6 .532.532 0 0 0-.52-.5h-.5a.477.477 0 0 0-.485.5 8.005 8.005 0 0 0 7.992 7.5c4.422 0 8.007-3.582 8.007-8s-3.585-8-8.007-8H8.674l-.003-2.196a.4.4 0 0 0-.68-.29l-3.004 3a.4.4 0 0 0 0 .56l3.003 3a.4.4 0 0 0 .69-.29L8.678 5.6h2.316a6.503 6.503 0 0 1 6.506 6.5c0 3.59-2.913 6.5-6.506 6.5Z", fill: "currentColor" })));
  }
  static get style() {
    return Jf;
  }
}, [1, "cosmos-icon-replay-9-5-0", {
  ariaLabel: [513, "aria-label"]
}]);
function ep() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-replay-9-5-0"].forEach((e) => {
    switch (e) {
      case "cosmos-icon-replay-9-5-0":
        customElements.get(e) || customElements.define(e, Qf);
        break;
    }
  });
}
const tp = ep, op = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", sp = op, np = /* @__PURE__ */ V(class extends j {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return w(ee, { key: "b1a1734791088765141547804d9634c093e2d2ec", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, w("svg", { key: "97cdde3be932273d7fedd4704c4e824ef1f0b646", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, w("path", { key: "ad5958a8e5b8b1b3df56483135c5318f9bde5d1e", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M16.324 9.979C13.423 8.256 8.637 8.097 5.868 8.938a.842.842 0 1 1-.489-1.611c3.18-.965 8.464-.779 11.804 1.204a.842.842 0 0 1-.86 1.448Zm-.095 2.552a.702.702 0 0 1-.965.23c-2.419-1.486-6.107-1.917-8.969-1.048a.703.703 0 0 1-.407-1.343c3.268-.992 7.332-.511 10.11 1.196a.7.7 0 0 1 .23.964Zm-1.101 2.45a.56.56 0 0 1-.772.187c-2.113-1.292-4.773-1.583-7.906-.868a.56.56 0 1 1-.25-1.093c3.428-.784 6.37-.447 8.741 1.003a.561.561 0 0 1 .187.771ZM11 2a9 9 0 1 0 0 18 9 9 0 0 0 0-18Z", fill: "currentColor" })));
  }
  static get style() {
    return sp;
  }
}, [1, "cosmos-icon-spotify-9-5-0", {
  ariaLabel: [513, "aria-label"]
}]);
function ip() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-spotify-9-5-0"].forEach((e) => {
    switch (e) {
      case "cosmos-icon-spotify-9-5-0":
        customElements.get(e) || customElements.define(e, np);
        break;
    }
  });
}
const rp = ip, ap = Tm, cp = "@-webkit-keyframes cosmos-link-dim-border{0%{-webkit-text-decoration-color:transparent;text-decoration-color:transparent}100%{-webkit-text-decoration-color:currentColor;text-decoration-color:currentColor}}@keyframes cosmos-link-dim-border{0%{-webkit-text-decoration-color:transparent;text-decoration-color:transparent}100%{-webkit-text-decoration-color:currentColor;text-decoration-color:currentColor}}.cosmos-link{-webkit-appearance:none;-moz-appearance:none;appearance:none;background:transparent;border:0;color:inherit;cursor:pointer;font-family:inherit;font-size:inherit;font-variation-settings:inherit;font-weight:inherit;line-height:inherit;margin:0;outline:none;padding:0;color:inherit;font:inherit;font-variant-numeric:inherit;letter-spacing:inherit;position:relative;text-align:inherit;text-decoration:none}.cosmos-link:not(:focus):hover{-webkit-animation:none;animation:none;border-color:currentColor;-o-border-image:none;border-image:none}.cosmos-link:focus-visible{border-radius:0.2em;-webkit-box-shadow:0 0 0 2px #fff, inset 0 0 0 2px #1B6AEE;box-shadow:0 0 0 2px #fff, inset 0 0 0 2px #1B6AEE;margin:0 -2px;padding:0 2px;text-decoration:none}.cosmos-link--kind-underlined{text-decoration:underline;text-decoration-thickness:0.105em;text-transform:inherit;text-underline-offset:0.125em}.cosmos-link--kind-underlined:not(:focus){-webkit-animation:1s cosmos-link-dim-border steps(2, start) infinite paused;animation:1s cosmos-link-dim-border steps(2, start) infinite paused}", lp = cp, dp = yt("cosmos-link"), up = /* @__PURE__ */ V(class extends j {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.handleKeyDown = (e) => {
      this.href || (e.key === "Enter" || e.key === " ") && (e.preventDefault(), e.target.click());
    }, this.href = void 0, this.kind = "underlined", this.rel = void 0, this.target = void 0;
  }
  render() {
    const e = this.href ? "a" : "span", o = e === "span" ? "button" : void 0;
    return w(e, { key: "b0acd57639aa98839ec1a5b2b893234884e61f15", class: dp({
      kind: this.kind
    }), href: this.href, onKeyDown: this.handleKeyDown, part: "base", rel: this.rel, role: o, tabIndex: 0, target: this.target }, w("slot", { key: "85c6aa2dd812d5f78c66157d333582f175192d3a" }));
  }
  static get style() {
    return lp;
  }
}, [1, "cosmos-link-9-5-0", {
  href: [513],
  kind: [513],
  rel: [513],
  target: [513]
}]);
function mp() {
  if (typeof customElements > "u")
    return;
  ["cosmos-link-9-5-0"].forEach((e) => {
    switch (e) {
      case "cosmos-link-9-5-0":
        customElements.get(e) || customElements.define(e, up);
        break;
    }
  });
}
const fp = mp, pp = Oa, hp = Aa, vp = $n, gp = Zm, bp = (t) => t == null, Oi = 300, yp = 8;
class xp {
  constructor() {
    this.emitter = new Md(), this.placementMap = {
      left: "before",
      right: "after",
      bottom: "below",
      top: "above"
    }, this.cssTransition = new Td();
  }
  create({ target: e, content: o, appendTo: s, interactive: n, placement: i, showOnCreate: r, follow: a, sticky: c, offset: d = yp, enterDuration: l = Oi, leaveDuration: h = Oi, trigger: u }) {
    this.target = e, this.leaveDuration = h, this.enterDuration = l, this.element = o, this.element.style.display = "block", o.remove(), this.tooltipInstance = go(this.target, {
      appendTo: s,
      hideOnClick: !1,
      interactive: n,
      offset: [0, d],
      placement: this.cosmosToPopperPlacement(i),
      showOnCreate: r || !1,
      touch: !1,
      delay: [null, this.leaveDuration],
      trigger: u || void 0,
      sticky: c,
      plugins: [vm, gm],
      onMount: ({ popperInstance: p, popper: v }) => {
        var g;
        const y = a ? "follow" : p == null ? void 0 : p.state.placement;
        (g = v.firstElementChild) === null || g === void 0 || g.setAttribute("data-cosmos-tooltip-placement", this.popperToCosmosPlacement(y)), this.cssTransition.enter(v.firstElementChild, this.enterDuration);
      },
      onShow: () => {
        this.onShowHandler();
      },
      onUntrigger: async () => {
        await this.onHideHandler();
      },
      render: () => ({
        popper: this.element
      })
    }), a && requestAnimationFrame(() => {
      var p;
      this.tooltipInstance && typeof this.tooltipInstance.setProps == "function" && ((p = this.tooltipInstance) === null || p === void 0 || p.setProps({ followCursor: this.getTippyFollowDirection(i) }));
    });
  }
  on(e, o) {
    this.emitter.on(e, o);
  }
  off(e, o) {
    this.emitter.off(e, o);
  }
  show() {
    var e, o, s;
    !((e = this.tooltipInstance) === null || e === void 0) && e.unmount && ((o = this.tooltipInstance) === null || o === void 0 || o.unmount()), (s = this.tooltipInstance) === null || s === void 0 || s.show();
  }
  async hide() {
    await this.onHideHandler(), this.tooltipInstance.hide();
  }
  async update() {
    var e;
    this.isVisible() && (await ua(), await ((e = this.tooltipInstance.popperInstance) === null || e === void 0 ? void 0 : e.update()));
  }
  isVisible() {
    return this.tooltipInstance.state.isVisible;
  }
  setProps(e) {
    var o;
    (o = this.tooltipInstance) === null || o === void 0 || o.setProps(e);
  }
  destroy() {
    this.tooltipInstance.destroy();
  }
  popperToCosmosPlacement(e) {
    return this.placementMap[e];
  }
  cosmosToPopperPlacement(e) {
    return Object.keys(this.placementMap).find((s) => this.placementMap[s] === e) || "top";
  }
  getTippyFollowDirection(e) {
    return e === "above" || e === "below" ? "horizontal" : "vertical";
  }
  onShowHandler() {
    this.emitter.emit("show"), this.target.setAttribute("aria-expanded", "true");
  }
  onHideHandler() {
    return this.emitter.emit("hide"), this.triggerCssLeaveTransition();
  }
  triggerCssLeaveTransition() {
    return this.cssTransition.leave(this.element.firstElementChild, this.leaveDuration);
  }
}
const _p = '@supports (font-variation-settings: normal){::slotted(strong),::slotted(b){font-variation-settings:"opsz" 12, "wght" 700}}:host{display:contents}.tippy-mount{display:inline-block;height:0;width:0}.tippy-element{display:none;z-index:var(--cosmos-tooltip-z-index, 9999) !important}.cosmos-tooltip{--cosmos-text-color:var(--cosmos-tooltip-color);--cosmos-text-font-family:var(--cosmos-tooltip-font-family);--cosmos-text-font-size:var(--cosmos-tooltip-font-size);--cosmos-text-font-style:var(--cosmos-tooltip-font-style);--cosmos-text-font-weight:var(--cosmos-tooltip-font-weight);--cosmos-text-letter-spacing:var(--cosmos-tooltip-letter-spacing);--cosmos-text-line-height:var(--cosmos-tooltip-line-height);--cosmos-text-text-transform:var(--cosmos-tooltip-text-transform);background-color:var(--cosmos-tooltip-background, #FFFFFF);border-color:var(--cosmos-tooltip-border-color, transparent);border-radius:var(--cosmos-tooltip-border-radius, 6px);border-style:solid;border-width:var(--cosmos-tooltip-border-width, 0);-webkit-box-shadow:var(--cosmos-tooltip-box-shadow, 0px 16px 24px 0px rgba(0, 15, 30, 0.0588235294), 0px 4px 8px 0px rgba(0, 15, 30, 0.0196078431));box-shadow:var(--cosmos-tooltip-box-shadow, 0px 16px 24px 0px rgba(0, 15, 30, 0.0588235294), 0px 4px 8px 0px rgba(0, 15, 30, 0.0196078431));max-width:calc(288rem / var(--cosmos-base-font-size, 16));padding:var(--cosmos-tooltip-padding, 4px 8px)}.cosmos-tooltip--spacing-loose{padding:var(--cosmos-tooltip-padding, 8px 12px)}.cosmos-tooltip--appearance-dark{background-color:var(--cosmos-tooltip-background, #00162B)}.cosmos-tooltip.enter{opacity:0}.cosmos-tooltip[data-cosmos-tooltip-placement=above].enter{-webkit-transform:translate(0, 8px);transform:translate(0, 8px)}.cosmos-tooltip[data-cosmos-tooltip-placement=below].enter{-webkit-transform:translate(0, -8px);transform:translate(0, -8px)}.cosmos-tooltip[data-cosmos-tooltip-placement=before].enter{-webkit-transform:translate(8px, 0);transform:translate(8px, 0)}.cosmos-tooltip[data-cosmos-tooltip-placement=after].enter{-webkit-transform:translate(-8px, 0);transform:translate(-8px, 0)}.cosmos-tooltip[data-cosmos-tooltip-placement].enter-active{opacity:1;-webkit-transform:translate(0, 0);transform:translate(0, 0);-webkit-transition:0.15s cubic-bezier(0.33, 1, 0.68, 1);transition:0.15s cubic-bezier(0.33, 1, 0.68, 1)}.cosmos-tooltip.leave{opacity:1}.cosmos-tooltip.leave-active{opacity:0;-webkit-transition:0.15s cubic-bezier(0, 0.32, 0.32, 1);transition:0.15s cubic-bezier(0, 0.32, 0.32, 1)}.cosmos-tooltip--empty{display:none}', wp = _p, kp = yt("cosmos-tooltip"), zp = /* @__PURE__ */ V(class extends j {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.hideEvent = Ds(this, "hide", 7), this.showEvent = Ds(this, "show", 7), this.tippyElement = void 0, this.tippyMount = void 0, this.tooltipInstance = void 0, this.onDefaultSlotChange = () => {
      this.tooltipInstance && !this.getTooltipTarget ? (this.tooltipInstance.destroy(), this.tooltipInstance = void 0) : (this.instantiateTooltip(), this.createTooltip());
    }, this.showHandler = () => {
      this.showEvent.emit();
    }, this.hideHandler = () => {
      this.hideEvent.emit();
    }, this.appearance = void 0, this.content = "", this.controlled = !1, this.follow = !1, this.offset = 8, this.placement = "above", this.spacing = "tight", this.unreachable = !1, this.visible = !1, this.computedAppearance = "light", this.hasContent = !1;
  }
  /**
   * Triggers an update of the tooltip positioning.
   */
  async update() {
    var e;
    this.tooltipInstance && await ((e = this.tooltipInstance) === null || e === void 0 ? void 0 : e.update());
  }
  handleAppearanceChange(e) {
    this.computedAppearance = e;
  }
  componentWillLoad() {
    this.instantiateTooltip(), Bt({
      instance: this,
      modeToAppearanceMap: { dark: "dark", light: "light" },
      callback: this.handleAppearanceChange.bind(this)
    });
  }
  componentDidLoad() {
    this.createTooltip(), this.createObserver();
  }
  disconnectedCallback() {
    var e, o;
    this.removeTooltipListeners(), (e = this.tooltipInstance) === null || e === void 0 || e.destroy(), (o = this.observer) === null || o === void 0 || o.disconnect();
  }
  handleShowChange() {
    var e, o, s, n;
    (e = this.tooltipInstance) === null || e === void 0 || e.setProps({ touch: !0 }), this.visible ? (o = this.tooltipInstance) === null || o === void 0 || o.show() : (s = this.tooltipInstance) === null || s === void 0 || s.hide(), (n = this.tooltipInstance) === null || n === void 0 || n.setProps({ touch: !1 });
  }
  createObserver() {
    const e = this.element.querySelector('[slot="content"]');
    if (!e || typeof MutationObserver > "u")
      return;
    const o = new MutationObserver((s) => {
      s.forEach((n) => {
        n.type === "childList" && this.update();
      });
    });
    o.observe(e, {
      childList: !0,
      subtree: !0
    }), this.observer = o;
  }
  instantiateTooltip() {
    po() || !this.getTooltipTarget() || (this.tooltipInstance = new xp());
  }
  createTooltip() {
    var e;
    this.tooltipInstance && (this.tooltipOptions = {
      target: this.getTooltipTarget(),
      appendTo: this.tippyMount,
      showOnCreate: this.visible,
      placement: this.placement || "above",
      content: this.tippyElement,
      follow: this.normalizedFollowValue,
      sticky: this.follow === "target",
      interactive: !this.unreachable,
      offset: this.offset,
      enterDuration: 150,
      leaveDuration: 150,
      trigger: this.controlled ? "manual" : void 0
    }, (e = this.tooltipInstance) === null || e === void 0 || e.create(this.tooltipOptions), this.addTooltipListeners());
  }
  addTooltipListeners() {
    var e, o;
    this.tooltipInstance && ((e = this.tooltipInstance) === null || e === void 0 || e.on("show", this.showHandler), (o = this.tooltipInstance) === null || o === void 0 || o.on("hide", this.hideHandler));
  }
  removeTooltipListeners() {
    var e, o;
    this.tooltipInstance && ((e = this.tooltipInstance) === null || e === void 0 || e.off("show", this.showHandler), (o = this.tooltipInstance) === null || o === void 0 || o.off("hide", this.hideHandler));
  }
  getTooltipTarget() {
    return Array.from(this.element.children).find((e) => e.tagName.toLowerCase() !== "style" && e.getAttribute("slot") !== "content");
  }
  getContent() {
    return this.content && w("cosmos-text-9-5-0", { size: "x-small", weight: "medium", exportparts: "base: text" }, this.content);
  }
  determineIfTooltipHasContent() {
    const e = Hs(this.element, "content");
    this.hasContent = !bp(this.content) && this.content !== "" || e;
  }
  componentWillRender() {
    this.normalizedFollowValue = this.normalizeFollowValue(), this.determineIfTooltipHasContent();
  }
  /**
   * Since the follow value can be a string or a boolean, we need to normalize it
   * and split it since in tippy follow and sticky are two different options.
   */
  normalizeFollowValue() {
    return this.follow === !0 || this.follow === "" ? !0 : this.follow === "cursor";
  }
  async handleContentChange() {
    await this.update();
  }
  render() {
    return w(ee, { key: "98b367c27394d476e43fdb9c18ae83e717c1b700" }, w("div", { key: "da504ddd34a9c5bb7a3609fb4a8c820f942dfc63", class: "tippy-mount", ref: (e) => this.tippyMount = e }), w("div", { key: "d9e9c17a881c1a0913ca47a59979ba278b123d03", class: "tippy-element", ref: (e) => this.tippyElement = e }, w("div", { key: "e384e77d810760ad44c942552768b50a7478096a", class: kp({
      spacing: this.spacing,
      appearance: this.computedAppearance,
      unreachable: this.unreachable,
      empty: !this.hasContent
    }), part: "base" }, w("cosmos-mode-9-5-0", { key: "9f3eced21326c4b94f4ed14591fb2e214615c4ad", mode: this.computedAppearance }, w("span", { key: "4e86d185d1cc9b1abccca0a12a1587652d32e1ab" }, w("slot", { key: "4abed24fef691960084c07e59c6b554c9abf5deb", name: "content", onSlotchange: () => this.determineIfTooltipHasContent() }, this.getContent()))))), w("slot", { key: "cbfeefa8374a6183c733c5ab73d4ca3e875704ce", onSlotchange: this.onDefaultSlotChange }));
  }
  get element() {
    return this;
  }
  static get watchers() {
    return {
      appearance: ["handleAppearanceChange"],
      visible: ["handleShowChange"],
      content: ["handleContentChange"]
    };
  }
  static get style() {
    return wp;
  }
}, [1, "cosmos-tooltip-9-5-0", {
  appearance: [513],
  content: [513],
  controlled: [516],
  follow: [520],
  offset: [514],
  placement: [513],
  spacing: [513],
  unreachable: [516],
  visible: [516],
  computedAppearance: [32],
  hasContent: [32],
  update: [64]
}, void 0, {
  appearance: ["handleAppearanceChange"],
  visible: ["handleShowChange"],
  content: ["handleContentChange"]
}]);
function Ep() {
  if (typeof customElements > "u")
    return;
  ["cosmos-tooltip-9-5-0", "cosmos-mode-9-5-0", "cosmos-text-9-5-0"].forEach((e) => {
    switch (e) {
      case "cosmos-tooltip-9-5-0":
        customElements.get(e) || customElements.define(e, zp);
        break;
      case "cosmos-mode-9-5-0":
        customElements.get(e) || Oa();
        break;
      case "cosmos-text-9-5-0":
        customElements.get(e) || $n();
        break;
    }
  });
}
const $p = Ep, Sn = /* @__PURE__ */ H({
  tagName: "cosmos-button-9-5-0",
  defaultProps: { busy: !1, decorative: !1, disabled: !1, hovered: !1, href: void 0, iconPlacement: "before", kind: "primary", size: "medium", type: "button", width: "content" },
  defineCustomElement: Bm
}), Sp = /* @__PURE__ */ H({
  tagName: "cosmos-icon-amazon-music-9-5-0",
  defaultProps: {},
  defineCustomElement: Qm
}), Pp = /* @__PURE__ */ H({
  tagName: "cosmos-icon-apple-podcasts-9-5-0",
  defaultProps: {},
  defineCustomElement: nf
}), Cp = /* @__PURE__ */ H({
  tagName: "cosmos-icon-back-10-9-5-0",
  defaultProps: {},
  defineCustomElement: df
}), Tp = /* @__PURE__ */ H({
  tagName: "cosmos-icon-chevron-down-9-5-0",
  defaultProps: {},
  defineCustomElement: hf
}), Ip = /* @__PURE__ */ H({
  tagName: "cosmos-icon-deezer-9-5-0",
  defaultProps: {},
  defineCustomElement: xf
}), Lp = /* @__PURE__ */ H({
  tagName: "cosmos-icon-forward-10-9-5-0",
  defaultProps: {},
  defineCustomElement: Ef
}), Ap = /* @__PURE__ */ H({
  tagName: "cosmos-icon-google-podcasts-9-5-0",
  defaultProps: {},
  defineCustomElement: Tf
}), cs = /* @__PURE__ */ H({
  tagName: "cosmos-icon-headphones-9-5-0",
  defaultProps: {},
  defineCustomElement: Rf
}), Op = /* @__PURE__ */ H({
  tagName: "cosmos-icon-no-data-9-5-0",
  defaultProps: {},
  defineCustomElement: Bf
}), Rp = /* @__PURE__ */ H({
  tagName: "cosmos-icon-pause-9-5-0",
  defaultProps: {},
  defineCustomElement: Wf
}), Ra = /* @__PURE__ */ H({
  tagName: "cosmos-icon-play-9-5-0",
  defaultProps: {},
  defineCustomElement: Kf
}), Dp = /* @__PURE__ */ H({
  tagName: "cosmos-icon-replay-9-5-0",
  defaultProps: {},
  defineCustomElement: tp
}), Mp = /* @__PURE__ */ H({
  tagName: "cosmos-icon-spotify-9-5-0",
  defaultProps: {},
  defineCustomElement: rp
}), Da = /* @__PURE__ */ H({
  tagName: "cosmos-image-9-5-0",
  defaultProps: { fit: "cover", imageAlt: "", radius: "none" },
  defineCustomElement: ap
}), Np = /* @__PURE__ */ H({
  tagName: "cosmos-link-9-5-0",
  defaultProps: { kind: "underlined" },
  defineCustomElement: fp
}), Fp = /* @__PURE__ */ H({
  tagName: "cosmos-mode-9-5-0",
  defaultProps: { mode: "light" },
  defineCustomElement: pp
}), Bp = /* @__PURE__ */ H({
  tagName: "cosmos-spinner-9-5-0",
  defaultProps: {},
  defineCustomElement: hp
}), Q = /* @__PURE__ */ H({
  tagName: "cosmos-text-9-5-0",
  defaultProps: { kind: "normal", size: "medium", spacing: "none", tag: "p", weight: "regular" },
  defineCustomElement: vp
}), Up = /* @__PURE__ */ H({
  tagName: "cosmos-title-9-5-0",
  defaultProps: { kind: "normal", size: "medium", spacing: "none", tag: "p", weight: "bold" },
  defineCustomElement: gp
}), Pn = /* @__PURE__ */ H({
  tagName: "cosmos-tooltip-9-5-0",
  defaultProps: { content: "", controlled: !1, follow: !1, offset: 8, placement: "above", spacing: "tight", unreachable: !1, visible: !1 },
  defineCustomElement: $p
});
var ot, U, bs, Ri, Nt = 0, Ma = [], jo = [], Di = S.__b, Mi = S.__r, Ni = S.diffed, Fi = S.__c, Bi = S.unmount;
function Ut(t, e) {
  S.__h && S.__h(U, t, Nt || e), Nt = 0;
  var o = U.__H || (U.__H = { __: [], __h: [] });
  return t >= o.__.length && o.__.push({ __V: jo }), o.__[t];
}
function J(t) {
  return Nt = 1, Na(Ba, t);
}
function Na(t, e, o) {
  var s = Ut(ot++, 2);
  if (s.t = t, !s.__c && (s.__ = [o ? o(e) : Ba(void 0, e), function(a) {
    var c = s.__N ? s.__N[0] : s.__[0], d = s.t(c, a);
    c !== d && (s.__N = [d, s.__[1]], s.__c.setState({}));
  }], s.__c = U, !U.u)) {
    var n = function(a, c, d) {
      if (!s.__c.__H)
        return !0;
      var l = s.__c.__H.__.filter(function(u) {
        return u.__c;
      });
      if (l.every(function(u) {
        return !u.__N;
      }))
        return !i || i.call(this, a, c, d);
      var h = !1;
      return l.forEach(function(u) {
        if (u.__N) {
          var p = u.__[0];
          u.__ = u.__N, u.__N = void 0, p !== u.__[0] && (h = !0);
        }
      }), !(!h && s.__c.props === a) && (!i || i.call(this, a, c, d));
    };
    U.u = !0;
    var i = U.shouldComponentUpdate, r = U.componentWillUpdate;
    U.componentWillUpdate = function(a, c, d) {
      if (this.__e) {
        var l = i;
        i = void 0, n(a, c, d), i = l;
      }
      r && r.call(this, a, c, d);
    }, U.shouldComponentUpdate = n;
  }
  return s.__N || s.__;
}
function _e(t, e) {
  var o = Ut(ot++, 3);
  !S.__s && Tn(o.__H, e) && (o.__ = t, o.i = e, U.__H.__h.push(o));
}
function ls(t, e) {
  var o = Ut(ot++, 4);
  !S.__s && Tn(o.__H, e) && (o.__ = t, o.i = e, U.__h.push(o));
}
function Y(t) {
  return Nt = 5, ae(function() {
    return { current: t };
  }, []);
}
function Cn(t, e, o) {
  Nt = 6, ls(function() {
    return typeof t == "function" ? (t(e()), function() {
      return t(null);
    }) : t ? (t.current = e(), function() {
      return t.current = null;
    }) : void 0;
  }, o == null ? o : o.concat(t));
}
function ae(t, e) {
  var o = Ut(ot++, 7);
  return Tn(o.__H, e) ? (o.__V = t(), o.i = e, o.__h = t, o.__V) : o.__;
}
function B(t, e) {
  return Nt = 8, ae(function() {
    return t;
  }, e);
}
function Fa(t) {
  var e = U.context[t.__c], o = Ut(ot++, 9);
  return o.c = t, e ? (o.__ == null && (o.__ = !0, e.sub(U)), e.props.value) : t.__;
}
function Hp(t, e) {
  S.useDebugValue && S.useDebugValue(e ? e(t) : t);
}
function Vp() {
  var t = Ut(ot++, 11);
  if (!t.__) {
    for (var e = U.__v; e !== null && !e.__m && e.__ !== null; )
      e = e.__;
    var o = e.__m || (e.__m = [0, 0]);
    t.__ = "P" + o[0] + "-" + o[1]++;
  }
  return t.__;
}
function jp() {
  for (var t; t = Ma.shift(); )
    if (t.__P && t.__H)
      try {
        t.__H.__h.forEach(Wo), t.__H.__h.forEach(qs), t.__H.__h = [];
      } catch (e) {
        t.__H.__h = [], S.__e(e, t.__v);
      }
}
S.__b = function(t) {
  U = null, Di && Di(t);
}, S.__r = function(t) {
  Mi && Mi(t), ot = 0;
  var e = (U = t.__c).__H;
  e && (bs === U ? (e.__h = [], U.__h = [], e.__.forEach(function(o) {
    o.__N && (o.__ = o.__N), o.__V = jo, o.__N = o.i = void 0;
  })) : (e.__h.forEach(Wo), e.__h.forEach(qs), e.__h = [], ot = 0)), bs = U;
}, S.diffed = function(t) {
  Ni && Ni(t);
  var e = t.__c;
  e && e.__H && (e.__H.__h.length && (Ma.push(e) !== 1 && Ri === S.requestAnimationFrame || ((Ri = S.requestAnimationFrame) || Wp)(jp)), e.__H.__.forEach(function(o) {
    o.i && (o.__H = o.i), o.__V !== jo && (o.__ = o.__V), o.i = void 0, o.__V = jo;
  })), bs = U = null;
}, S.__c = function(t, e) {
  e.some(function(o) {
    try {
      o.__h.forEach(Wo), o.__h = o.__h.filter(function(s) {
        return !s.__ || qs(s);
      });
    } catch (s) {
      e.some(function(n) {
        n.__h && (n.__h = []);
      }), e = [], S.__e(s, o.__v);
    }
  }), Fi && Fi(t, e);
}, S.unmount = function(t) {
  Bi && Bi(t);
  var e, o = t.__c;
  o && o.__H && (o.__H.__.forEach(function(s) {
    try {
      Wo(s);
    } catch (n) {
      e = n;
    }
  }), o.__H = void 0, e && S.__e(e, o.__v));
};
var Ui = typeof requestAnimationFrame == "function";
function Wp(t) {
  var e, o = function() {
    clearTimeout(s), Ui && cancelAnimationFrame(e), setTimeout(t);
  }, s = setTimeout(o, 100);
  Ui && (e = requestAnimationFrame(o));
}
function Wo(t) {
  var e = U, o = t.__c;
  typeof o == "function" && (t.__c = void 0, o()), U = e;
}
function qs(t) {
  var e = U;
  t.__c = t.__(), U = e;
}
function Tn(t, e) {
  return !t || t.length !== e.length || e.some(function(o, s) {
    return o !== t[s];
  });
}
function Ba(t, e) {
  return typeof e == "function" ? e(t) : e;
}
function Ua(t, e) {
  for (var o in e)
    t[o] = e[o];
  return t;
}
function Gs(t, e) {
  for (var o in t)
    if (o !== "__source" && !(o in e))
      return !0;
  for (var s in e)
    if (s !== "__source" && t[s] !== e[s])
      return !0;
  return !1;
}
function ys(t, e) {
  return t === e && (t !== 0 || 1 / t == 1 / e) || t != t && e != e;
}
function Zs(t) {
  this.props = t;
}
function qp(t, e) {
  function o(n) {
    var i = this.props.ref, r = i == n.ref;
    return !r && i && (i.call ? i(null) : i.current = null), e ? !e(this.props, n) || !r : Gs(this.props, n);
  }
  function s(n) {
    return this.shouldComponentUpdate = o, re(t, n);
  }
  return s.displayName = "Memo(" + (t.displayName || t.name) + ")", s.prototype.isReactComponent = !0, s.__f = !0, s;
}
(Zs.prototype = new Ie()).isPureReactComponent = !0, Zs.prototype.shouldComponentUpdate = function(t, e) {
  return Gs(this.props, t) || Gs(this.state, e);
};
var Hi = S.__b;
S.__b = function(t) {
  t.type && t.type.__f && t.ref && (t.props.ref = t.ref, t.ref = null), Hi && Hi(t);
};
var Gp = typeof Symbol < "u" && Symbol.for && Symbol.for("react.forward_ref") || 3911;
function nt(t) {
  function e(o) {
    var s = Ua({}, o);
    return delete s.ref, t(s, o.ref || null);
  }
  return e.$$typeof = Gp, e.render = e, e.prototype.isReactComponent = e.__f = !0, e.displayName = "ForwardRef(" + (t.displayName || t.name) + ")", e;
}
var Vi = function(t, e) {
  return t == null ? null : He(He(t).map(e));
}, Zp = { map: Vi, forEach: Vi, count: function(t) {
  return t ? He(t).length : 0;
}, only: function(t) {
  var e = He(t);
  if (e.length !== 1)
    throw "Children.only";
  return e[0];
}, toArray: He }, Yp = S.__e;
S.__e = function(t, e, o, s) {
  if (t.then) {
    for (var n, i = e; i = i.__; )
      if ((n = i.__c) && n.__c)
        return e.__e == null && (e.__e = o.__e, e.__k = o.__k), n.__c(t, e);
  }
  Yp(t, e, o, s);
};
var ji = S.unmount;
function Ha(t, e, o) {
  return t && (t.__c && t.__c.__H && (t.__c.__H.__.forEach(function(s) {
    typeof s.__c == "function" && s.__c();
  }), t.__c.__H = null), (t = Ua({}, t)).__c != null && (t.__c.__P === o && (t.__c.__P = e), t.__c = null), t.__k = t.__k && t.__k.map(function(s) {
    return Ha(s, e, o);
  })), t;
}
function Va(t, e, o) {
  return t && (t.__v = null, t.__k = t.__k && t.__k.map(function(s) {
    return Va(s, e, o);
  }), t.__c && t.__c.__P === e && (t.__e && o.insertBefore(t.__e, t.__d), t.__c.__e = !0, t.__c.__P = o)), t;
}
function qo() {
  this.__u = 0, this.t = null, this.__b = null;
}
function ja(t) {
  var e = t.__.__c;
  return e && e.__a && e.__a(t);
}
function Kp(t) {
  var e, o, s;
  function n(i) {
    if (e || (e = t()).then(function(r) {
      o = r.default || r;
    }, function(r) {
      s = r;
    }), s)
      throw s;
    if (!o)
      throw e;
    return re(o, i);
  }
  return n.displayName = "Lazy", n.__f = !0, n;
}
function Kt() {
  this.u = null, this.o = null;
}
S.unmount = function(t) {
  var e = t.__c;
  e && e.__R && e.__R(), e && t.__h === !0 && (t.type = null), ji && ji(t);
}, (qo.prototype = new Ie()).__c = function(t, e) {
  var o = e.__c, s = this;
  s.t == null && (s.t = []), s.t.push(o);
  var n = ja(s.__v), i = !1, r = function() {
    i || (i = !0, o.__R = null, n ? n(a) : a());
  };
  o.__R = r;
  var a = function() {
    if (!--s.__u) {
      if (s.state.__a) {
        var d = s.state.__a;
        s.__v.__k[0] = Va(d, d.__c.__P, d.__c.__O);
      }
      var l;
      for (s.setState({ __a: s.__b = null }); l = s.t.pop(); )
        l.forceUpdate();
    }
  }, c = e.__h === !0;
  s.__u++ || c || s.setState({ __a: s.__b = s.__v.__k[0] }), t.then(r, r);
}, qo.prototype.componentWillUnmount = function() {
  this.t = [];
}, qo.prototype.render = function(t, e) {
  if (this.__b) {
    if (this.__v.__k) {
      var o = document.createElement("div"), s = this.__v.__k[0].__c;
      this.__v.__k[0] = Ha(this.__b, o, s.__O = s.__P);
    }
    this.__b = null;
  }
  var n = e.__a && re(et, null, t.fallback);
  return n && (n.__h = null), [re(et, null, e.__a ? null : t.children), n];
};
var Wi = function(t, e, o) {
  if (++o[1] === o[0] && t.o.delete(e), t.props.revealOrder && (t.props.revealOrder[0] !== "t" || !t.o.size))
    for (o = t.u; o; ) {
      for (; o.length > 3; )
        o.pop()();
      if (o[1] < o[0])
        break;
      t.u = o = o[2];
    }
};
function Xp(t) {
  return this.getChildContext = function() {
    return t.context;
  }, t.children;
}
function Jp(t) {
  var e = this, o = t.i;
  e.componentWillUnmount = function() {
    tt(null, e.l), e.l = null, e.i = null;
  }, e.i && e.i !== o && e.componentWillUnmount(), t.__v ? (e.l || (e.i = o, e.l = { nodeType: 1, parentNode: o, childNodes: [], appendChild: function(s) {
    this.childNodes.push(s), e.i.appendChild(s);
  }, insertBefore: function(s, n) {
    this.childNodes.push(s), e.i.appendChild(s);
  }, removeChild: function(s) {
    this.childNodes.splice(this.childNodes.indexOf(s) >>> 1, 1), e.i.removeChild(s);
  } }), tt(re(Xp, { context: e.context }, t.__v), e.l)) : e.l && e.componentWillUnmount();
}
function Qp(t, e) {
  var o = re(Jp, { __v: t, i: e });
  return o.containerInfo = e, o;
}
(Kt.prototype = new Ie()).__a = function(t) {
  var e = this, o = ja(e.__v), s = e.o.get(t);
  return s[0]++, function(n) {
    var i = function() {
      e.props.revealOrder ? (s.push(n), Wi(e, t, s)) : n();
    };
    o ? o(i) : i();
  };
}, Kt.prototype.render = function(t) {
  this.u = null, this.o = /* @__PURE__ */ new Map();
  var e = He(t.children);
  t.revealOrder && t.revealOrder[0] === "b" && e.reverse();
  for (var o = e.length; o--; )
    this.o.set(e[o], this.u = [1, 0, this.u]);
  return t.children;
}, Kt.prototype.componentDidUpdate = Kt.prototype.componentDidMount = function() {
  var t = this;
  this.o.forEach(function(e, o) {
    Wi(t, o, e);
  });
};
var Wa = typeof Symbol < "u" && Symbol.for && Symbol.for("react.element") || 60103, eh = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|dominant|fill|flood|font|glyph(?!R)|horiz|image(!S)|letter|lighting|marker(?!H|W|U)|overline|paint|pointer|shape|stop|strikethrough|stroke|text(?!L)|transform|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/, th = /^on(Ani|Tra|Tou|BeforeInp|Compo)/, oh = /[A-Z0-9]/g, sh = typeof document < "u", nh = function(t) {
  return (typeof Symbol < "u" && typeof Symbol() == "symbol" ? /fil|che|rad/ : /fil|che|ra/).test(t);
};
function ih(t, e, o) {
  return e.__k == null && (e.textContent = ""), tt(t, e), typeof o == "function" && o(), t ? t.__c : null;
}
function rh(t, e, o) {
  return tn(t, e), typeof o == "function" && o(), t ? t.__c : null;
}
Ie.prototype.isReactComponent = {}, ["componentWillMount", "componentWillReceiveProps", "componentWillUpdate"].forEach(function(t) {
  Object.defineProperty(Ie.prototype, t, { configurable: !0, get: function() {
    return this["UNSAFE_" + t];
  }, set: function(e) {
    Object.defineProperty(this, t, { configurable: !0, writable: !0, value: e });
  } });
});
var qi = S.event;
function ah() {
}
function ch() {
  return this.cancelBubble;
}
function lh() {
  return this.defaultPrevented;
}
S.event = function(t) {
  return qi && (t = qi(t)), t.persist = ah, t.isPropagationStopped = ch, t.isDefaultPrevented = lh, t.nativeEvent = t;
};
var In, dh = { enumerable: !1, configurable: !0, get: function() {
  return this.class;
} }, Gi = S.vnode;
S.vnode = function(t) {
  typeof t.type == "string" && function(e) {
    var o = e.props, s = e.type, n = {};
    for (var i in o) {
      var r = o[i];
      if (!(i === "value" && "defaultValue" in o && r == null || sh && i === "children" && s === "noscript" || i === "class" || i === "className")) {
        var a = i.toLowerCase();
        i === "defaultValue" && "value" in o && o.value == null ? i = "value" : i === "download" && r === !0 ? r = "" : a === "ondoubleclick" ? i = "ondblclick" : a !== "onchange" || s !== "input" && s !== "textarea" || nh(o.type) ? a === "onfocus" ? i = "onfocusin" : a === "onblur" ? i = "onfocusout" : th.test(i) ? i = a : s.indexOf("-") === -1 && eh.test(i) ? i = i.replace(oh, "-$&").toLowerCase() : r === null && (r = void 0) : a = i = "oninput", a === "oninput" && n[i = a] && (i = "oninputCapture"), n[i] = r;
      }
    }
    s == "select" && n.multiple && Array.isArray(n.value) && (n.value = He(o.children).forEach(function(c) {
      c.props.selected = n.value.indexOf(c.props.value) != -1;
    })), s == "select" && n.defaultValue != null && (n.value = He(o.children).forEach(function(c) {
      c.props.selected = n.multiple ? n.defaultValue.indexOf(c.props.value) != -1 : n.defaultValue == c.props.value;
    })), o.class && !o.className ? (n.class = o.class, Object.defineProperty(n, "className", dh)) : (o.className && !o.class || o.class && o.className) && (n.class = n.className = o.className), e.props = n;
  }(t), t.$$typeof = Wa, Gi && Gi(t);
};
var Zi = S.__r;
S.__r = function(t) {
  Zi && Zi(t), In = t.__c;
};
var Yi = S.diffed;
S.diffed = function(t) {
  Yi && Yi(t);
  var e = t.props, o = t.__e;
  o != null && t.type === "textarea" && "value" in e && e.value !== o.value && (o.value = e.value == null ? "" : e.value), In = null;
};
var uh = { ReactCurrentDispatcher: { current: { readContext: function(t) {
  return In.__n[t.__c].props.value;
} } } };
function mh(t) {
  return re.bind(null, t);
}
function qa(t) {
  return !!t && t.$$typeof === Wa;
}
function fh(t) {
  return qa(t) ? on.apply(null, arguments) : t;
}
function ph(t) {
  return !!t.__k && (tt(null, t), !0);
}
function hh(t) {
  return t && (t.base || t.nodeType === 1 && t) || null;
}
var vh = function(t, e) {
  return t(e);
}, gh = function(t, e) {
  return t(e);
}, bh = et;
function Ga(t) {
  t();
}
function yh(t) {
  return t;
}
function xh() {
  return [!1, Ga];
}
var _h = ls;
function wh(t, e) {
  var o = e(), s = J({ h: { __: o, v: e } }), n = s[0].h, i = s[1];
  return ls(function() {
    n.__ = o, n.v = e, ys(n.__, e()) || i({ h: n });
  }, [t, o, e]), _e(function() {
    return ys(n.__, n.v()) || i({ h: n }), t(function() {
      ys(n.__, n.v()) || i({ h: n });
    });
  }, [t]), o;
}
var f = { useState: J, useId: Vp, useReducer: Na, useEffect: _e, useLayoutEffect: ls, useInsertionEffect: _h, useTransition: xh, useDeferredValue: yh, useSyncExternalStore: wh, startTransition: Ga, useRef: Y, useImperativeHandle: Cn, useMemo: ae, useCallback: B, useContext: Fa, useDebugValue: Hp, version: "17.0.2", Children: Zp, render: ih, hydrate: rh, unmountComponentAtNode: ph, createPortal: Qp, createElement: re, createContext: sn, createFactory: mh, cloneElement: fh, createRef: Pr, Fragment: et, isValidElement: qa, findDOMNode: hh, Component: Ie, PureComponent: Zs, memo: qp, forwardRef: nt, flushSync: gh, unstable_batchedUpdates: vh, StrictMode: bh, Suspense: qo, SuspenseList: Kt, lazy: Kp, __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: uh };
const kh = ({
  Icon: t,
  dataAttribute: e,
  disabled: o = !1,
  label: s,
  onPointerUp: n,
  onTooltipUpdate: i,
  size: r,
  tooltipText: a,
  shape: c = "circle",
  appearance: d,
  kind: l = "bare",
  buttonLabel: h,
  style: u = ""
}, p) => {
  const v = Pr(), g = ae(() => ({
    focus() {
      v.current.base.buttonFocus().catch((_) => console.error("Could not set focus on CosmosButton", _));
    }
  }), [v]);
  Cn(p, () => g, [g]);
  const y = B(
    (b) => {
      !o && b.key === Yc && n(b);
    },
    [o, n]
  );
  return /* @__PURE__ */ f.createElement(
    Sn,
    {
      style: u,
      [e]: !0,
      ref: v,
      "data-rbup-button": !0,
      "data-rbup": e,
      disabled: o,
      appearance: d,
      ariaLabel: s,
      kind: l,
      shape: c,
      size: r ?? "medium",
      onPointerup: (b) => {
        !o && (al(b) || ll(b)) && n(b);
      },
      onPointerEnter: (b) => {
        a && i && i(a, b);
      },
      onKeyPress: y
    },
    t,
    h
  );
}, Ys = nt(kh);
function Za(t) {
  var e;
  return (t == null ? void 0 : t.getPlaybackMode()) === "LIVE" && ((e = t.getLiveVariant) == null ? void 0 : e.call(t)) === "LINEAR";
}
function zh(t) {
  var e;
  return (t == null ? void 0 : t.getPlaybackMode()) === "LIVE" && ((e = t.getLiveVariant) == null ? void 0 : e.call(t)) === "DVR";
}
function Ft(t) {
  return t.getPlayerType() === "VIDEO";
}
function Eh(t) {
  const { eventPlaybackPosition: e, existingTimeCorrection: o, lastPlaybackPosition: s, playbackPositionCalculator: n } = t, r = n(e) - s;
  return o + r;
}
function it(t) {
  if (!Ft(t))
    return;
  const e = t.getAudioLanguage();
  return e || "und";
}
function ze(t, e) {
  if (Ft(e)) {
    if (e.isInFullscreenMode())
      return "fullscreen";
    if (e.isInPictureInPictureMode())
      return "picture-in-picture";
    if (e.isPlayingVideoViaAirPlay())
      return "airplay";
  }
  return t.tracking.configs.googleAnalytics.defaultPlayerMode;
}
function rt(t) {
  if (!Ft(t))
    return;
  const e = t.getSubtitleTrackLanguage();
  if (e)
    return e;
}
function We(t, e) {
  const o = t.toLowerCase(), s = e.toLowerCase();
  return `${o}_${s}`;
}
function qe(t) {
  switch (t.getPlayerType()) {
    case "VIDEO":
      return "rbVideoTracking";
    case "AUDIO":
      return "rbAudioTracking";
    default:
      throw new Error(`unknown player type ${t.getPlayerType()}`);
  }
}
function Ee(t) {
  if (Ft(t)) {
    const e = t.getPlaybackMode();
    switch (e) {
      case "LIVE":
        return t.getLiveVariant() === "LINEAR" ? "linear" : t.getTimeShiftInSec() >= -1 ? "live" : "vod";
      case "VOD":
        return "vod";
      default:
        throw new Error(`unexpected playback mode ${e}`);
    }
  } else
    return "vod";
}
function Ge(t) {
  if (!t)
    return "0";
  const e = t < 0, o = Math.floor(Math.abs(t)), s = String(o);
  return e ? `-${s}` : s;
}
const $h = de.getLogger("TrackingService");
function at(t, e, o) {
  return (t < 0 || t > e) && $h.error(
    "videoPos",
    t,
    " exceeds bounds for reporting interval",
    e,
    "for event",
    o
  ), Math.max(0, Math.min(e, Math.round(t)));
}
function Sh(t, e, o, s, n) {
  return {
    event: qe(e),
    eventAction: "eof",
    event_name: We(e.getPlayerType(), "eof"),
    current_pos: Ge(o),
    media_id: t.assetId,
    player_mode: ze(t, e),
    video_audio_language: it(e),
    video_subtitles_language: rt(e),
    video_stream_type: Ee(e),
    video_pos: at(s, n, "eof")
  };
}
let Ro;
const Ph = new Uint8Array(16);
function Ch() {
  if (!Ro && (Ro = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !Ro))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return Ro(Ph);
}
const te = [];
for (let t = 0; t < 256; ++t)
  te.push((t + 256).toString(16).slice(1));
function Th(t, e = 0) {
  return (te[t[e + 0]] + te[t[e + 1]] + te[t[e + 2]] + te[t[e + 3]] + "-" + te[t[e + 4]] + te[t[e + 5]] + "-" + te[t[e + 6]] + te[t[e + 7]] + "-" + te[t[e + 8]] + te[t[e + 9]] + "-" + te[t[e + 10]] + te[t[e + 11]] + te[t[e + 12]] + te[t[e + 13]] + te[t[e + 14]] + te[t[e + 15]]).toLowerCase();
}
const Ih = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), Ki = {
  randomUUID: Ih
};
function ds(t, e, o) {
  if (Ki.randomUUID && !e && !t)
    return Ki.randomUUID();
  t = t || {};
  const s = t.random || (t.rng || Ch)();
  if (s[6] = s[6] & 15 | 64, s[8] = s[8] & 63 | 128, e) {
    o = o || 0;
    for (let n = 0; n < 16; ++n)
      e[o + n] = s[n];
    return e;
  }
  return Th(s);
}
const Ln = "18.14.1";
function Lh(t) {
  const e = new URL(t);
  return `${e.protocol}//${e.host}${e.pathname}`;
}
function Ya(t, e, o) {
  return t ? !0 : o ? e === "LIVE" : !1;
}
function lo(t) {
  return t.configurationType === "VIDEO";
}
function Ka(t, e) {
  return lo(t);
}
function Ah(t, e) {
  return e ? !lo(t) : !1;
}
function Xa(t) {
  return new URL(t).host;
}
function Oh(t, e, o, s, n) {
  const i = lo(t) ? t.phasing : !1, r = t.tracking.configs.googleAnalytics, a = n.getPlaybackMode(), c = (e == null ? void 0 : e.duration) ?? 0, d = Xa(o);
  return {
    ...r.customInitAttributes,
    video_account_name: r.accountName,
    brand: r.brand,
    video_chapter: e == null ? void 0 : e.chapter,
    video_name: e == null ? void 0 : e.title,
    video_display_url: o,
    environment: s ? "on-site" : "off-site",
    event: "rbVideoTracking",
    eventAction: "init",
    event_name: "video_init",
    video_display_domain: d,
    video_stream: Ya(i, a, n.isPlayerLoaded()),
    video_autoplay: t.autoplay,
    video_label: e == null ? void 0 : e.label,
    video_label_group: e == null ? void 0 : e.labelGroup,
    media_asset_id: e == null ? void 0 : e.vin,
    media_id: t.assetId,
    device_platform: "web",
    video_player_id: r.playerId,
    player_mode: ze(t, n),
    property_name: r.propertyName,
    site_type: "website",
    video_season: e == null ? void 0 : e.season,
    rb_source: r.source,
    player_version: Ln,
    video_asset_id: t.assetId,
    video_length: a === "LIVE" ? 0 : c,
    video_play_id: ds(),
    video_stream_type: Ee(n)
  };
}
function Rh(t, e, o, s, n) {
  const i = t.tracking.configs.googleAnalytics, r = o.getPlaybackMode(), a = o.getDurationInSec(), c = Xa(s);
  return {
    ...i.customInitAttributes,
    video_account_name: i.accountName,
    brand: i.brand,
    video_name: e == null ? void 0 : e.title,
    video_display_url: s,
    environment: n ? "on-site" : "off-site",
    event: "rbAudioTracking",
    eventAction: "init",
    event_name: "audio_init",
    video_display_domain: c,
    video_stream: Ya(!1, r, o.isPlayerLoaded()),
    video_autoplay: !1,
    media_asset_id: e == null ? void 0 : e.vin,
    media_id: t.assetId,
    device_platform: "web",
    video_player_id: i.playerId,
    player_mode: ze(t, o),
    property_name: i.propertyName,
    site_type: "website",
    rb_source: i.source,
    spreaker_id: e == null ? void 0 : e.spreakerId,
    megaphone_episode_id: e == null ? void 0 : e.megaphoneEpisodeId,
    megaphone_network_id: e == null ? void 0 : e.megaphoneNetworkId,
    megaphone_show_id: e == null ? void 0 : e.megaphoneShowId,
    player_version: Ln,
    video_asset_id: t.assetId,
    video_chapter: e == null ? void 0 : e.chapter,
    video_label: e == null ? void 0 : e.label,
    video_label_group: e == null ? void 0 : e.labelGroup,
    video_length: isNaN(a) ? (e == null ? void 0 : e.duration) ?? 0 : a,
    video_play_id: ds(),
    video_season: e == null ? void 0 : e.season,
    video_stream_type: Ee(o)
  };
}
function Dh() {
  return window.self !== window.top ? document.referrer : window.location.href;
}
function Mh(t, e, o, s) {
  const n = t.tracking.configs.googleAnalytics.overrideEmbedUrl ?? Dh(), i = Lh(n);
  if (lo(t) && (Ka(t) || !e))
    return Oh(t, e, i, s, o);
  if (!lo(t) && (Ah(t, e) || !e))
    return Rh(t, e, o, i, s);
  throw new Error("unexpected player config");
}
function Nh(t, e, o) {
  return {
    event: "rbAudioTracking",
    event_name: "audio_interaction",
    video_interaction: {
      value: "Next Up",
      method: e === "USER" ? "Click" : "Auto",
      video_name: t.title,
      media_id: o,
      device_platform: "web",
      widget_type: "Audio Playlist"
    }
  };
}
function Fh(t, e, o) {
  return {
    event: "rbVideoTracking",
    event_name: "video_interaction",
    video_interaction: {
      value: "Next Up",
      method: e,
      video_name: t.title,
      media_id: o,
      device_platform: "web",
      widget_type: "Next Up Bar"
    }
  };
}
function Xi(t, e, o, s, n) {
  return {
    current_pos: Ge(o),
    event: qe(e),
    eventAction: "pause",
    event_name: We(e.getPlayerType(), "pause"),
    video_audio_language: it(e),
    video_subtitles_language: rt(e),
    media_id: t.assetId,
    player_mode: ze(t, e),
    video_stream_type: Ee(e),
    video_pos: at(s, n, "pause")
  };
}
function Bh(t) {
  switch (t) {
    case "PRE_ROLL":
      return "pre";
    case "MID_ROLL":
      return "mid";
    case "POST_ROLL":
      return "post";
    default:
      throw new Error(`unexpected ad type ${t}`);
  }
}
const Uh = "not available";
function Hh(t) {
  return t > 1 ? t : Uh;
}
function Vh(t, e) {
  return t === "pre" ? 0 : e;
}
function jh(t, e, o, s, n, i) {
  const r = Bh(t.adType);
  return {
    ad_length: Hh(t.duration),
    ad_plays: 1,
    ad_position: Vh(r, o.getLastMainMediaPositionInSec()),
    ad_type: r,
    current_pos: Ge(s),
    event: qe(o),
    video_audio_language: void 0,
    video_subtitles_language: void 0,
    eventAction: "playAd",
    event_name: We(o.getPlayerType(), "playAd"),
    media_id: e.assetId,
    player_mode: ze(e, o),
    video_stream_type: Ee(o),
    video_pos: at(n, i, "playAd")
  };
}
function Wh(t, e, o) {
  return {
    video_audio_language: it(o),
    current_pos: Ge(e),
    event: qe(o),
    eventAction: "playInitial",
    event_name: We(o.getPlayerType(), "playInitial"),
    media_id: t.assetId,
    player_mode: ze(t, o),
    video_subtitles_language: rt(o),
    video_plays: 1,
    video_stream_type: Ee(o),
    video_pos: 0
  };
}
function Ji(t, e, o, s, n) {
  return {
    current_pos: Ge(o),
    media_id: t.assetId,
    player_mode: ze(t, e),
    event: qe(e),
    eventAction: "play",
    video_audio_language: it(e),
    video_subtitles_language: rt(e),
    event_name: We(e.getPlayerType(), "play"),
    video_stream_type: Ee(e),
    video_pos: at(s, n, "play")
  };
}
function qh(t, e, o) {
  return {
    event: "rbAudioTracking",
    event_name: "audio_interaction",
    video_interaction: {
      value: e,
      video_name: t.title,
      media_id: o,
      device_platform: "web",
      widget_type: "Podcast player::inline"
    }
  };
}
function Gh(t, e, o, s, n, i) {
  return {
    eventAction: "posRelative",
    event_name: We(o.getPlayerType(), "posRelative"),
    event: qe(o),
    current_pos: Ge(e),
    video_audio_language: it(o),
    video_subtitles_language: rt(o),
    player_mode: ze(t, o),
    video_posrelative: s,
    media_id: t.assetId,
    video_stream_type: Ee(o),
    video_pos: at(n, i, "posRelative")
  };
}
function Zh(t, e, o, s, n) {
  return {
    eventAction: "pos",
    event_name: We(o.getPlayerType(), "pos"),
    event: qe(o),
    video_audio_language: it(o),
    video_subtitles_language: rt(o),
    current_pos: Ge(e),
    player_mode: ze(t, o),
    media_id: t.assetId,
    video_stream_type: Ee(o),
    video_pos: at(s, n, "pos")
  };
}
function Yh(t, e, o, s, n) {
  return {
    eventAction: "seek",
    event_name: We(o.getPlayerType(), "seek"),
    event: qe(o),
    current_pos: Ge(e),
    player_mode: ze(t, o),
    media_id: t.assetId,
    video_audio_language: it(o),
    video_subtitles_language: rt(o),
    video_stream_type: Ee(o),
    video_pos: at(s, n, "seek")
  };
}
const Qi = "stop";
function Kh(t, e, o, s, n) {
  if (!s)
    throw new Error("unexpectedly dont have player config");
  if (!n)
    throw new Error("unexpectedly dont have player data accessor");
  return {
    current_pos: Ge(t),
    event: qe(n),
    eventAction: Qi,
    event_name: We(n.getPlayerType(), Qi),
    media_id: s.assetId,
    video_audio_language: it(n),
    video_subtitles_language: rt(n),
    player_mode: ze(s, n),
    video_pos: at(e, o, "stop"),
    video_stream_type: Ee(n)
  };
}
function Xh(t) {
  return t.eventAction === "init";
}
function Jh(t) {
  return t.event_name === "video_interaction";
}
function An(t) {
  return typeof t == "boolean" ? t.toString() : t;
}
function Qh(t) {
  return Xh(t) ? tv(t) : Jh(t) ? ov(t) : sv(t);
}
const ev = [
  "event",
  "eventAction",
  "event_name",
  "player_mode",
  "video_stream_type"
];
function tv(t) {
  const e = {}, o = {};
  for (const [s, n] of Object.entries(t))
    ev.includes(s) ? e[s] = n : o[s] = An(n), s === "video_stream_type" && (o[s] = n);
  return Object.keys(o).length > 0 && (e.videos = { [t.media_id]: o }), e;
}
function ov(t) {
  const e = {}, o = {};
  e.event = t.event, e.event_name = t.event_name;
  for (const [s, n] of Object.entries(t.video_interaction))
    o[s] = An(n);
  return e.video_interaction = o, e;
}
function sv(t) {
  const e = {};
  for (const [o, s] of Object.entries(t))
    e[o] = An(s);
  return e;
}
const ut = de.getLogger("TrackingService"), nv = ["rbVideoTracking", "rbAudioTracking"], xs = ["beforeunload", "unload"];
function iv(t) {
  return nv.includes(t.event);
}
function er(t, e) {
  return Math.floor(t / e);
}
const me = 60;
class rv {
  constructor(e, o = window.dataLayer) {
    C(this, "eventStream", []);
    C(this, "videoDurationInSec", 0);
    C(this, "lastPlaybackPosition", 0);
    C(this, "videoStartTimestamp", 0);
    C(this, "timeCorrection", 0);
    C(this, "playbackPositionOfPauseOrPlayEvent", 0);
    C(this, "alreadyPlayedLanguages", /* @__PURE__ */ new Set());
    C(this, "lastTimeChangedPlaybackPosition", 0);
    C(this, "onPlayerEvent", (e) => {
      const o = this.coordinator.getPlayerConfiguration(), s = this.coordinator.getPlayerData();
      if (!o)
        throw new Error("unexpectedly dont have player config");
      if (!s)
        throw new Error("unexpectedly dont have video player data accessor");
      const n = Ft(s) && s.isShowingAd();
      if (ut.debug("onPlayerEvent: ", e), n) {
        this.handlePlayerEventWhileShowingAd(e, o, s);
        return;
      }
      this.handlePlayerEventWithoutAd(e, o, s), this.handleCustomEvent(e, s);
    });
    C(this, "handleUnloadEvent", () => {
      xs.forEach((a) => window.removeEventListener(a, this.handleUnloadEvent));
      const e = this.coordinator.getPlayerConfiguration(), o = this.coordinator.getPlayerData(), s = (o == null ? void 0 : o.getCurrentTimeInSec()) ?? 0, n = this.calculateCorrectedPlaybackPosition(this.lastTimeChangedPlaybackPosition), i = this.calculateVideoPos(n), r = Kh(
        s,
        i,
        me,
        e,
        o
      );
      this.sendEvent(r, s);
    });
    var s;
    this.coordinator = e, this.dataLayer = o, e.addEventListener(this.onPlayerEvent), xs.forEach((n) => window.addEventListener(n, this.handleUnloadEvent)), this.videoDurationInSec = ((s = e.getPlayerData()) == null ? void 0 : s.getDurationInSec()) ?? 0;
  }
  hasSentEventAction(e) {
    return !!this.eventStream.find((o) => iv(o.event) && o.event.eventAction === e);
  }
  destroy() {
    this.coordinator.removeEventListener(this.onPlayerEvent), xs.forEach((e) => window.removeEventListener(e, this.handleUnloadEvent)), this.alreadyPlayedLanguages.clear();
  }
  reset() {
    this.alreadyPlayedLanguages.clear(), this.eventStream = [], this.videoStartTimestamp = 0, this.lastPlaybackPosition = 0, this.timeCorrection = 0, this.playbackPositionOfPauseOrPlayEvent = 0, this.lastTimeChangedPlaybackPosition = 0;
  }
  restart() {
    this.reset();
    const e = this.coordinator.getPlayerConfiguration();
    if (!e)
      throw new Error("dont have player config");
    const o = this.coordinator.getMediaMetaData();
    if (!o)
      throw new Error("dont have player metadata");
    const s = this.coordinator.getPlayerData();
    if (!s)
      throw new Error("unexpectedly dont have video player data accessor");
    this.sendInitEvent(e, o, s);
  }
  // can't make the switch simpler than that
  // eslint-disable-next-line complexity
  handlePlayerEventWithoutAd(e, o, s) {
    switch (e.type) {
      case "loaded":
        this.handleLoadedEvent(e, o, s);
        break;
      case "play":
        this.handlePlayEvent(e, s);
        break;
      case "playing":
        this.handlePlayingEvent(e, s);
        break;
      case "paused":
        this.handlePausedEvent(e, o, s);
        break;
      case "timeChanged":
        this.handleTimeChangedEvent(e, s);
        break;
      case "timeSkipped":
        this.handleTimeSkippedEvent(e, s);
        break;
      case "seeking":
      case "timeshifting":
        this.handleSeekingEvent(e, s);
        break;
      case "seekingDone":
      case "timeshiftingDone":
        this.handleSeekingDoneEventForStreamTypes(e, s);
        break;
      case "playbackFinished":
        this.handlePlaybackFinishedEvent(e, s);
        break;
      case "sourceUnloaded":
        this.handleUnloadEvent();
        break;
    }
  }
  handleSeekingDoneEventForStreamTypes(e, o) {
    Za(o) ? this.timeCorrection = Eh({
      eventPlaybackPosition: e.playbackPosition,
      existingTimeCorrection: this.timeCorrection,
      lastPlaybackPosition: this.lastPlaybackPosition,
      playbackPositionCalculator: (n) => this.calculateCorrectedPlaybackPosition(n)
    }) : this.handleSeekingDoneEvent(e, o);
  }
  handlePlayerEventWhileShowingAd(e, o, s) {
    switch (e.type) {
      case "loaded":
        this.handleLoadedEvent(e, o, s);
        break;
      case "adStarted":
        this.handleAdStartedEvent(e, o, s);
        break;
    }
  }
  handleCustomEvent(e, o) {
    switch (e.type) {
      case "nextUpCancelled":
        this.handleNextUpToastEvent(e, "Close", o);
        break;
      case "nextUpClicked":
        this.handleNextUpToastEvent(e, "Click", o), this.handleUnloadEvent();
        break;
      case "nextUpTimeout":
        this.handleNextUpToastEvent(e, "Auto", o), this.handleUnloadEvent();
        break;
      case "podcastTitleClick":
        this.handlePodcastTitleClickEvent(e, o);
        break;
      case "nextEpisodeTriggered":
        this.handleNextEpisodeEvent(e, o);
        break;
    }
  }
  handlePodcastTitleClickEvent(e, o) {
    const s = this.coordinator.getPlayerConfiguration();
    if (!s)
      throw new Error("dont have player config");
    const n = o.getCurrentTimeInSec(), i = this.coordinator.getMediaMetaData();
    if (!i)
      throw new Error("dont have player metadata");
    this.sendEvent(
      qh(i, e.titleType, s.assetId),
      n
    );
  }
  handleNextUpToastEvent(e, o, s) {
    if (e.issuer === "CONTEXTUAL")
      return;
    const n = this.coordinator.getPlayerConfiguration();
    if (!n)
      throw new Error("dont have player config");
    const i = s.getCurrentTimeInSec(), r = this.coordinator.getMediaMetaData();
    if (!r)
      throw new Error("dont have player metadata");
    this.sendEvent(
      Fh(r, o, n.assetId),
      i
    );
  }
  handlePlaybackFinishedEvent(e, o) {
    const s = this.calculateCorrectedPlaybackPosition(e.playbackPosition), n = this.coordinator.getPlayerConfiguration();
    if (!n)
      throw new Error("dont have player config");
    const i = this.calculateVideoPos(s);
    this.sendEvent(
      Sh(n, o, s, i, me),
      s
    );
  }
  handleNextEpisodeEvent(e, o) {
    const s = this.coordinator.getPlayerConfiguration();
    if (!s)
      throw new Error("dont have player config");
    const n = o.getCurrentTimeInSec(), i = this.coordinator.getMediaMetaData();
    if (!i)
      throw new Error("dont have player metadata");
    const { issuer: r } = e, { assetId: a } = s;
    this.sendEvent(Nh(i, r, a), n), r === "USER" && this.handleUnloadEvent();
  }
  handleSeekingDoneEvent(e, o) {
    if (e.issuer !== "USER")
      return;
    const s = this.coordinator.getPlayerConfiguration();
    if (!s)
      throw new Error("dont have player config");
    const n = this.calculateCorrectedPlaybackPosition(e.playbackPosition);
    o.getPlayerStatus() === "PAUSED" ? this.sendEvent(
      Xi(s, o, n, 0, me),
      n
    ) : this.sendEvent(
      Ji(s, o, n, 0, me),
      n
    ), this.lastPlaybackPosition = n;
  }
  handleSeekingEvent(e, o) {
    if (e.issuer === "RESTART") {
      this.restart();
      return;
    }
    const s = e.targetPosition;
    e.issuer === "INITIAL" && (this.lastPlaybackPosition = s), o.getPlaybackMode() === "LIVE" && this.lastPlaybackPosition === 0 && (this.videoStartTimestamp = e.playbackPosition, this.lastPlaybackPosition = this.calculateCorrectedPlaybackPosition(e.playbackPosition));
    const n = this.calculateCorrectedPlaybackPosition(e.playbackPosition);
    if (e.issuer !== "USER")
      return;
    this.handleTimeChangedForPlayInitial(n + 0.1, o);
    const i = this.calculateVideoPos(n), r = this.coordinator.getPlayerConfiguration();
    if (!r)
      throw new Error("dont have player config");
    this.sendEvent(
      Yh(r, n, o, i, me),
      n
    ), this.playbackPositionOfPauseOrPlayEvent = 0;
  }
  handleTimeSkippedEvent(e, o) {
    if (Ft(o) && o.getPlaybackMode() === "LIVE" && !o.isShowingAd()) {
      const s = e.currentPlaybackTimeInSec - e.previousPlaybackTimeInSec;
      this.timeCorrection += s, this.lastPlaybackPosition = this.calculateCorrectedPlaybackPosition(
        e.currentPlaybackTimeInSec
      );
    }
  }
  // eslint-disable-next-line complexity
  handleTimeChangedEvent(e, o) {
    const s = o.getMainMediaDurationInSec();
    isNaN(this.videoDurationInSec) && !isNaN(s) && (this.videoDurationInSec = s), o.getPlaybackMode() === "LIVE" && this.videoStartTimestamp === 0 && (this.videoStartTimestamp = e.playbackPosition), this.lastTimeChangedPlaybackPosition = e.playbackPosition;
    const n = this.calculateCorrectedPlaybackPosition(e.playbackPosition), i = this.coordinator.getCumulatedPlayTimeInSec();
    ut.debug(
      "TRACK timeChanged",
      n,
      "cumulated",
      i,
      "corr",
      this.timeCorrection
    ), this.handleTimeChangedForPlayInitial(n, o);
    const r = this.lastPlaybackPosition;
    o.getPlaybackMode() === "VOD" && this.handlePosRelativeAspect(r, n, o), this.handlePosAspect(r, n, o), this.lastPlaybackPosition = n;
  }
  handleTimeChangedForPlayInitial(e, o) {
    const s = this.hasSentEventAction("playInitial");
    if (e >= 0.1 && !s) {
      const n = this.coordinator.getPlayerConfiguration();
      if (!n)
        throw new Error("dont have player config");
      const i = Wh(n, e, o);
      this.sendEvent(i, e);
    }
  }
  handlePosAspect(e, o, s) {
    const n = er(e, me), i = er(o, me);
    if (n !== i) {
      ut.debug(
        `TRACK: ${me}s changed, last frac: ${n}, cur frac: ${i}, playback: ${o}s`
      );
      const r = this.calculateVideoPos(o), a = this.coordinator.getPlayerConfiguration();
      if (!a)
        throw new Error("dont have player config");
      this.sendEvent(
        Zh(a, o, s, r, me),
        o
      );
    }
  }
  calculateVideoPos(e) {
    if (this.eventStream.length < 1)
      return 0;
    const o = [...this.eventStream].reverse().find((r) => r.event.hasOwnProperty("video_pos")), s = Math.floor((o == null ? void 0 : o.playbackPosInSec) ?? 0), i = (isNaN(e) ? 0 : Math.floor(e)) - s;
    return i < 0 && ut.error("videoPos is < 0", i), Math.max(0, i);
  }
  handlePosRelativeAspect(e, o, s) {
    const n = this.videoDurationInSec / 10, i = Math.floor(e / n), r = Math.floor(o / n);
    if (r % 10 !== 0 && i !== r) {
      ut.debug(
        "TRACK: 10 percent changed, last frac: ",
        i,
        "cur frac",
        r,
        "playback",
        o / this.videoDurationInSec * 100,
        "%"
      );
      const c = this.calculateVideoPos(o), d = this.coordinator.getPlayerConfiguration();
      if (!d)
        throw new Error("dont have player config");
      this.sendEvent(
        Gh(
          d,
          o,
          s,
          `${r}0%`,
          c,
          me
        ),
        o
      );
    }
  }
  handlePlayingEvent(e, o) {
    if (o.getPlaybackMode() === "LIVE")
      if (this.lastPlaybackPosition === 0)
        this.videoStartTimestamp = e.playbackPosition, this.lastPlaybackPosition = this.calculateCorrectedPlaybackPosition(
          e.playbackPosition
        );
      else {
        if (this.playbackPositionOfPauseOrPlayEvent) {
          const s = e.playbackPosition - this.playbackPositionOfPauseOrPlayEvent;
          this.timeCorrection += s;
        }
        this.lastPlaybackPosition = this.calculateCorrectedPlaybackPosition(
          e.playbackPosition
        );
      }
    this.playbackPositionOfPauseOrPlayEvent = 0;
  }
  calculatePlaybackPositionOfPauseOrPlayEvent(e) {
    if (this.playbackPositionOfPauseOrPlayEvent) {
      const o = e.playbackPosition - this.playbackPositionOfPauseOrPlayEvent;
      o > 1 && (this.timeCorrection += o, this.playbackPositionOfPauseOrPlayEvent = e.playbackPosition);
    } else
      this.playbackPositionOfPauseOrPlayEvent = e.playbackPosition;
  }
  handlePlayEvent(e, o) {
    this.calculatePlaybackPositionOfPauseOrPlayEvent(e);
    const s = this.calculateCorrectedPlaybackPosition(e.playbackPosition), n = this.coordinator.getPlayerConfiguration();
    if (this.hasSentEventAction("playInitial")) {
      if (!n)
        throw new Error("dont have player config");
      const i = this.calculateVideoPos(s), r = Ji(
        n,
        o,
        s,
        i,
        me
      );
      this.sendEvent(r, s);
    }
  }
  handlePausedEvent(e, o, s) {
    if (e.playbackPosition) {
      const n = this.calculateCorrectedPlaybackPosition(e.playbackPosition), i = this.calculateVideoPos(n), r = Xi(
        o,
        s,
        n,
        i,
        me
      );
      this.sendEvent(r, n), this.playbackPositionOfPauseOrPlayEvent = e.playbackPosition;
    }
  }
  handleLoadedEvent(e, o, s) {
    this.videoDurationInSec = s.getMainMediaDurationInSec(), this.videoStartTimestamp = 0, this.lastPlaybackPosition = 0, this.timeCorrection = 0, this.playbackPositionOfPauseOrPlayEvent = 0, ut.debug("TRACK: got duration", this.videoDurationInSec), this.sendInitEvent(o, e.data, s);
  }
  sendInitEvent(e, o, s) {
    var r;
    const n = ((r = window.google_tag_manager) == null ? void 0 : r.isRedBullPage) ?? !1, i = Mh(e, o, s, n);
    this.sendEvent(i, 0);
  }
  handleAdStartedEvent(e, o, s) {
    const n = this.calculateCorrectedPlaybackPosition(this.lastTimeChangedPlaybackPosition), i = this.calculateVideoPos(s.getLastMainMediaPositionInSec()), r = jh(
      e,
      o,
      s,
      n,
      i,
      me
    );
    this.sendEvent(r, s.getLastMainMediaPositionInSec());
  }
  sendEvent(e, o) {
    var c;
    if (!this.dataLayer)
      throw new Error("dont have a data layer! Did you forget to initialize Google Tag Manager?");
    const s = this.coordinator.getPlayerConfiguration();
    if (!s)
      throw new Error("dont have player config");
    const n = s.tracking.configs.googleAnalytics, i = this.coordinator.getMediaMetaData(), r = ((c = n.eventCustomizer) == null ? void 0 : c.customize(e, i)) ?? e;
    this.eventStream.push({ playbackPosInSec: o, event: r });
    const a = Qh(r);
    ut.debug("Tracking: Sending", a), this.dataLayer.push(a);
  }
  calculateCorrectedPlaybackPosition(e) {
    return e - (this.videoStartTimestamp + this.timeCorrection);
  }
}
function av(t, e = window.dataLayer) {
  var n;
  const o = document.querySelectorAll('script[src*="GTM-5XHDS9"]').length > 0;
  if ((((n = window.google_tag_manager) == null ? void 0 : n.isRedBullPage) ?? !1) || o)
    return new rv(t, e);
}
function _s(t) {
  const e = t.getMediaMetaData();
  if (!e)
    throw new Error("do not have player metadata");
  return e;
}
function tr(t) {
  const e = t.getPlayerConfiguration();
  if (!e)
    throw new Error("do not have player configuration");
  return e;
}
function Se(t, e) {
  navigator.mediaSession.setActionHandler(t, e);
}
function or(t) {
  const e = t && new MediaMetadata(t);
  navigator.mediaSession.metadata = e;
}
function sr(t) {
  navigator.mediaSession.playbackState = t;
}
function ws(t, e, o) {
  isNaN(t) || isNaN(e) || isNaN(o) || navigator.mediaSession.setPositionState({
    duration: t,
    playbackRate: e,
    position: o
  });
}
const Pe = de.getLogger("MediaSessionService"), Ks = 60, Ja = Ks * Ks, cv = 24 * Ja;
class lv {
  constructor(e) {
    C(this, "DEFAULT_MEDIA_SESSION_SEEK_SECONDS", 10);
    C(this, "onPlayerEvent", (e) => {
      switch (e.type) {
        case "play":
          this.handlePlayEvent();
          break;
        case "paused":
          this.handlePausedEvent();
          break;
        case "timeChanged":
          this.handleTimeChangedEvent();
          break;
      }
    });
    this.coordinator = e, e.addEventListener(this.onPlayerEvent);
  }
  destroy() {
    Pe.info("destroying media-session-service"), this.coordinator.removeEventListener(this.onPlayerEvent), this.reset();
  }
  reset() {
    Pe.info("resetting media-session-service"), or(null), this.resetMediaSessionActionHandler();
  }
  setupMediaSessionActionHandler() {
    Se("play", () => {
      Pe.info("Play clicked via Media Session API"), this.coordinator.play();
    }), Se("pause", () => {
      Pe.info("Pause clicked via Media Session API"), this.coordinator.pause();
    }), Se("seekto", (e) => {
      if (this.isVOD()) {
        const o = e.seekTime;
        Pe.info(`Seek to ${o} via Media Session API`), o && this.coordinator.seek(o);
      } else if (this.isDVR()) {
        const o = e.seekTime;
        if (Pe.info(`Shift to ${o} via Media Session API`), o) {
          const s = o - Math.abs(this.coordinator.getMaxTimeShiftInSec());
          this.coordinator.timeShift(s);
        }
      }
    }), Se("seekbackward", () => {
      this.isVOD() ? (Pe.info(`Seek ${this.DEFAULT_MEDIA_SESSION_SEEK_SECONDS} backward`), this.coordinator.seekRelative(-this.DEFAULT_MEDIA_SESSION_SEEK_SECONDS)) : this.isDVR() && this.coordinator.getPlayerData() && (Pe.info(`Shift ${this.DEFAULT_MEDIA_SESSION_SEEK_SECONDS} backward`), this.coordinator.seekOrTimeshiftRelative(-this.DEFAULT_MEDIA_SESSION_SEEK_SECONDS));
    }), Se("seekforward", () => {
      this.isVOD() ? (Pe.info(`Seek ${this.DEFAULT_MEDIA_SESSION_SEEK_SECONDS} forward`), this.coordinator.seekRelative(this.DEFAULT_MEDIA_SESSION_SEEK_SECONDS)) : this.isDVR() && (Pe.info(`Shift ${this.DEFAULT_MEDIA_SESSION_SEEK_SECONDS} forward`), this.coordinator.seekOrTimeshiftRelative(this.DEFAULT_MEDIA_SESSION_SEEK_SECONDS));
    });
  }
  resetMediaSessionActionHandler() {
    Se("play", null), Se("pause", null), Se("seekto", null), Se("seekbackward", null), Se("seekforward", null);
  }
  handlePlayEvent() {
    const e = this.getTitle(), o = this.getArtist(), s = this.getAlbum(), n = Qc(this.getPosterImageUrl());
    or({ title: e, artist: o, album: s, artwork: n }), sr("playing"), this.setupMediaSessionActionHandler();
  }
  handlePausedEvent() {
    sr("paused");
  }
  handleTimeChangedEvent() {
    if (this.isVOD()) {
      const e = this.coordinator.getPlayerData();
      if (e) {
        const o = e.getDurationInSec(), s = e.getPlaybackSpeed(), n = e.getCurrentTimeInSec();
        ws(o, s, n);
      }
      return;
    }
    if (this.isLinear()) {
      const e = cv, o = 1, s = this.getCurrentTimeInSeconds();
      ws(e, o, s);
      return;
    }
    if (this.isDVR()) {
      const e = this.coordinator.getPlayerData();
      if (e) {
        const o = e.getCurrentTimeInSec(), s = Math.abs(this.coordinator.getMaxTimeShiftInSec()), n = e.getPlaybackSpeed(), i = s - Math.abs(o);
        ws(s, n, i);
      }
      return;
    }
  }
  getCurrentTimeInSeconds() {
    const e = /* @__PURE__ */ new Date();
    return e.getSeconds() + e.getMinutes() * Ks + e.getHours() * Ja;
  }
  getTitle() {
    return _s(this.coordinator).title;
  }
  getArtist() {
    return tr(this.coordinator).mediaSessionArtist;
  }
  getAlbum() {
    return _s(this.coordinator).label;
  }
  getPosterImageUrl() {
    const e = tr(this.coordinator), o = _s(this.coordinator);
    return Ka(e) ? o.posterImageUrl : o.coverArt;
  }
  isVOD() {
    var e;
    return ((e = this.coordinator.getPlayerData()) == null ? void 0 : e.getPlaybackMode()) === "VOD";
  }
  isLinear() {
    return Za(this.coordinator.getPlayerData());
  }
  isDVR() {
    return zh(this.coordinator.getPlayerData());
  }
}
const nr = de.getLogger("HookService");
class dv {
  constructor(e) {
    this.hooks = e;
  }
  async callHookMethod(e, o, s, n) {
    if (e) {
      nr.debug("calling hook", e.name, "hook:", e);
      try {
        return await e(o, s, n);
      } catch (i) {
        nr.error("error calling hook", e.name, "on", e, "error", i);
      }
    }
    return o;
  }
  async beforeLoad(e, o, s) {
    var i;
    let n = e;
    for (const r of this.hooks)
      n = await this.callHookMethod((i = r.onBeforeLoad) == null ? void 0 : i.bind(r), n, o, s) ?? n;
    return n;
  }
  async afterLoad(e, o, s) {
    var i;
    let n = e;
    for (const r of this.hooks)
      n = await this.callHookMethod((i = r.onAfterLoad) == null ? void 0 : i.bind(r), n, o, s) ?? n;
    return n;
  }
  async beforeDestroy(e, o, s) {
    var i;
    let n = e;
    for (const r of this.hooks)
      n = await this.callHookMethod(
        (i = r.destroy) == null ? void 0 : i.bind(r),
        n ?? {},
        o ?? {},
        s
      );
    return n;
  }
}
const uv = (t) => {
  var s;
  const e = Y();
  if (e.current)
    return e.current;
  const o = (s = t.current) == null ? void 0 : s.getRootNode();
  if (o && "host" in o) {
    const n = o.host.tagName;
    return e.current = n.toLocaleLowerCase(), e.current;
  }
}, Xs = de.getLogger("UsageReport"), mv = /^(?:.*?\.)?([a-zA-Z0-9\-_]{3,}\.(?:\w{2,8}|\w{2,4}\.\w{2,4}))$/;
function fv() {
  var t, e;
  try {
    const { hostname: o, href: s } = window.location;
    return { platform: ((e = (t = mv.exec(o)) == null ? void 0 : t.groups) == null ? void 0 : e[1]) ?? o, location: s };
  } catch (o) {
    const s = cn(o);
    return Xs.warn({ message: "failed to resolve host", error: s }), {};
  }
}
const pv = (t, e) => {
  const o = Y(!1), s = uv(t), { location: n, platform: i } = fv();
  if (o.current)
    return !1;
  if (s && i) {
    o.current = !0;
    const r = rn(e ?? "PRODUCTION"), a = {
      package: s,
      version: Ln,
      platform: i,
      location: n
    };
    return fetch(`${r}/report-usage?${new URLSearchParams(a)}`).then((c) => Xs.info({ message: "reported usage", queryParams: a, response: c })).catch((c) => {
      const d = cn(c);
      Xs.warn({ message: "failed in reporting usage", queryParams: a, error: d });
    }), !0;
  }
  return !1;
};
function hv(t) {
  return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(t)}`;
}
function vv(t, e = "", o = "") {
  return `https://pinterest.com/pin/create/button/?url=${encodeURIComponent(t)}&media=${encodeURIComponent(
    o
  )}&description=${e}`;
}
function gv(t) {
  return `https://www.reddit.com/submit?url=${encodeURIComponent(t)}`;
}
function bv(t, e = "") {
  return `https://twitter.com/intent/tweet?url=${encodeURIComponent(t)}&text=${e}`;
}
const Qa = "rbup-media-time", ec = "rbup-media-id", yv = "time";
function xv(t, e, o) {
  if (o) {
    const s = new URL(t), n = s.searchParams;
    return n.set(Qa, String(o)), n.set(ec, e), s.href;
  }
  return t;
}
class tc {
  calculateShareUrl(e, o) {
    const s = this.calculateBaseUrl(), n = xv(s, o.assetId, o.mediaPositionInSec);
    switch (e) {
      case "FACEBOOK":
        return hv(n);
      case "PINTEREST":
        return vv(n, o.title, o.imageUrl);
      case "REDDIT":
        return gv(n);
      case "TWITTER":
        return bv(n, o.title);
      case "PAGE":
        return n;
      default:
        throw new Error(`unexpected share service ${e}`);
    }
  }
  determineInitialSeek(e) {
    const o = window.location.search;
    if (!o)
      return;
    const s = new URLSearchParams(o), n = s.get(Qa);
    if (s.get(ec) === e && n) {
      const a = parseInt(n, 10);
      if (!isNaN(a))
        return a;
    }
    const r = s.get(yv);
    if (r) {
      const a = parseInt(r, 10);
      if (!isNaN(a))
        return a;
    }
  }
  isSharingEnabled() {
    return !!this.calculateBaseUrl();
  }
  calculateBaseUrl() {
    return window.location.href;
  }
}
const _v = {
  "ad-endsin": "Werbung endet in {{sec}} Sekunden",
  "audio-mediaInfo-episodeText": "E{{episodeNumber}}",
  "audio-mediaInfo-seasonText": "S{{seasonNumber}}",
  "audio-podcast-listenOn": "Anhören auf",
  "button-close": "Schließen",
  "button-closeMenu": "Menü schließen",
  "error-default-message": "Dieses Video ist leider nicht verfügbar.",
  "error-fsk-message": "Dieses Video ist erst ab {{hour}} Uhr verfügbar.",
  "error-fsk-title": "Freigegeben ab {{age}} Jahren",
  "error-geo-message": "Dieses Video ist in Ihrem Land leider nicht verfügbar.",
  "error-geo-title": "Länderbeschränkung",
  "error-missed-message": "Dieses Video ist leider nicht mehr verfügbar.",
  "error-missed-title": "Schade verpasst",
  "error-unauthorized-message": "Leider dürfen Sie diesen Content nicht sehen.",
  "error-unauthorized-title": "Nicht autorisiert",
  "error-upcoming-message": "Dieses Video kann ab {{localizedDate}} Uhr abgespielt werden.",
  "error-upcoming-title": "Bald verfügbar",
  "endslate-title": "Ähnliche Videos",
  "endslate-replay": "Nochmal abspielen",
  "global-month-short-april": "Apr",
  "global-month-short-august": "Aug",
  "global-month-short-december": "Dez",
  "global-month-short-february": "Feb",
  "global-month-short-january": "Jän",
  "global-month-short-july": "Jul",
  "global-month-short-june": "Jun",
  "global-month-short-march": "Mär",
  "global-month-short-may": "Mai",
  "global-month-short-november": "Nov",
  "global-month-short-october": "Okt",
  "global-month-short-september": "Sep",
  "liveStream-airedOn": "Ausgestrahlt am {{date}}",
  "liveStream-canceled": "Abgesagt",
  "liveStream-days": "Tage",
  "liveStream-backToEvent": "Zurück zum Event Hub",
  "liveStream-hours": "Stunden",
  "liveStream-minutes": "Minuten",
  "liveStream-seconds": "Sekunden",
  "liveStream-trimming": "Replay in Kürze verfügbar",
  "liveStream-unconfirmed": "Unbestätigt",
  "liveStream-seekBackToLive": "Zurück zu Live",
  "liveStream-live": "Live",
  "menu-audioTracks": "Tonspuren",
  "menu-feedback": "Rückmeldung geben",
  "menu-quality": "Qualität",
  "menu-quality-auto": "Automatisch",
  "menu-sharing": "Teilen",
  "menu-sharing-copied": "Kopiert",
  "menu-sharing-copyLink": "Link kopieren",
  "menu-sharing-embed": "Embed kopieren",
  "menu-sharing-facebook": "Facebook",
  "menu-sharing-pinterest": "Pinterest",
  "menu-sharing-playFrom": "Abspielen von",
  "menu-sharing-reddit": "Reddit",
  "menu-sharing-twitter": "Twitter",
  "menu-speeds": "Geschwindigkeit",
  "menu-speeds-normal": "Normal",
  "menu-subtitles": "Untertitel",
  "menu-subtitles-off": "Aus",
  "multiChannel-singleStreamLive": "{{figure}} Stream live",
  "multiChannel-multipleStreamsLive": "{{figure}} Streams live",
  "multiChannel-seeSchedule": "Alle Livestreams",
  "multiChannel-schedule": "Livestreams",
  "multiChannel-label-live": "Jetzt live",
  "multiChannel-label-liveIn": "Live in",
  "multiChannel-label-replay": "Aufzeichnung verfügbar",
  "multiChannel-label-trim": "Aufzeichnung bald verfügbar",
  "multiChannel-label-nowWatching": "Das siehst du gerade",
  "nerdMode-assetId": "Asset ID",
  "nerdMode-copyId": "Kopiere ID",
  "nerdMode-crepoId": "CRID",
  "nerdMode-geolocation": "Abgeleitete Geo",
  "nerdMode-idCopied": "ID kopiert",
  "nerdMode-playerVersion": "Player Version",
  "nerdMode-techVersion": "Bitmovin Version",
  "nerdMode-rendition": "Aktuelle Qualität",
  "nerdMode-unknownValue": "unbekannt",
  "nextVideoCountdown-replay": "Nochmal ansehen",
  "nextVideoCountdown-title": "Als nächstes",
  "rbcom-subtitlesAvailable": "Untertitel verfügbar",
  "tooltip-airplay": "AirPlay",
  "tooltip-audioTracks": "Tonspuren",
  "tooltip-changeVolume": "Lautstärke anpassen",
  "tooltip-dvr": "Zurück zu LIVE",
  "tooltip-forward": "Vorspulen",
  "tooltip-fullscreen": "Vollbild",
  "tooltip-loading": "Laden",
  "tooltip-mute": "Ton aus",
  "tooltip-normalscreen": "Vollbild beenden",
  "tooltip-pause": "Pausieren",
  "tooltip-pip": "Bild in Bild",
  "tooltip-play": "Abspielen",
  "tooltip-replay": "Nochmal ansehen",
  "tooltip-rewind": "Zurückspulen",
  "tooltip-settings": "Einstellungen",
  "tooltip-subtitles": "Untertitel",
  "tooltip-unmute": "Ton an",
  "ad-from-ads": "Werbung {{adPosition}} von {{totalAds}}",
  "audio-duration-hour": "Std.",
  "audio-duration-minute": "Min.",
  "audio-error-default-description": "Diese Podcast-Episode ist nicht mehr verfügbar. Vielleicht wurde sie gelöscht oder entfernt. Schau später nochmal vorbei oder entdecke andere Podcasts.",
  "audio-error-default-title": "Inhalt ist nicht verfügbar",
  "audio-podcast-currently-playing": "Läuft gerade",
  "audio-podcast-playlist-additional-episodes-on": "{{additionalEpisodes}} weitere Folge auf",
  "audio-podcast-playlist-additional-episodes-on_plural": "{{additionalEpisodes}} weitere Folgen auf",
  "audio-podcast-playlist-all-episodes-on": "Alle Folgen auf",
  "nerdMode-audioLanguageOverride": "Audiosprache Überschreibung",
  "nerdMode-localeStorage": "Locale storage",
  "nerdMode-overrideReference": "Überschreibungs Referenz",
  "nerdMode-playerConfiguration": "Player-Konfiguration",
  "nerdMode-subtitlesLanguageOverride": "Untertitel Überschreibung",
  "nerdMode-translationsLanguageOverride": "Übersetzungen Überschreibung",
  "tooltip-stop": "Stop"
}, wv = {
  "ad-endsin": "Ad ends in {{sec}} seconds",
  "audio-mediaInfo-episodeText": "E{{episodeNumber}}",
  "audio-mediaInfo-seasonText": "S{{seasonNumber}}",
  "audio-podcast-listenOn": "Listen on",
  "button-close": "Close",
  "button-closeMenu": "Close menu",
  "error-default-message": "This video is currently unavailable.",
  "error-fsk-message": "This video is only allowed for playback from {{hour}}:00.",
  "error-fsk-title": "Released to age {{age}}",
  "error-geo-message": "This video is not available in your country.",
  "error-geo-title": "Geo restricted",
  "error-missed-message": "This video is not available anymore.",
  "error-missed-title": "You've missed it",
  "error-unauthorized-message": "You have insufficient rights to watch this content.",
  "error-unauthorized-title": "Unauthorized",
  "error-upcoming-message": "This video is available from {{localizedDate}}.",
  "error-upcoming-title": "Upcoming",
  "endslate-title": "Related videos",
  "endslate-replay": "Replay video",
  "global-month-short-april": "Apr",
  "global-month-short-august": "Aug",
  "global-month-short-december": "Dec",
  "global-month-short-february": "Feb",
  "global-month-short-january": "Jan",
  "global-month-short-july": "Jul",
  "global-month-short-june": "Jun",
  "global-month-short-march": "Mar",
  "global-month-short-may": "May",
  "global-month-short-november": "Nov",
  "global-month-short-october": "Oct",
  "global-month-short-september": "Sep",
  "liveStream-airedOn": "Aired on {{date}}",
  "liveStream-canceled": "Cancelled",
  "liveStream-days": "Days",
  "liveStream-backToEvent": "Back to Event Hub",
  "liveStream-hours": "Hours",
  "liveStream-minutes": "Minutes",
  "liveStream-seconds": "Seconds",
  "liveStream-trimming": "Awaiting replay",
  "liveStream-unconfirmed": "Unconfirmed",
  "liveStream-seekBackToLive": "Back to Live",
  "liveStream-live": "Live",
  "menu-audioTracks": "Audio Language",
  "menu-feedback": "Give feedback",
  "menu-quality": "Quality",
  "menu-quality-auto": "Auto",
  "menu-sharing": "Share",
  "menu-sharing-copied": "Copied",
  "menu-sharing-copyLink": "Copy link",
  "menu-sharing-embed": "Copy embed",
  "menu-sharing-facebook": "Facebook",
  "menu-sharing-pinterest": "Pinterest",
  "menu-sharing-playFrom": "Play from",
  "menu-sharing-reddit": "Reddit",
  "menu-sharing-twitter": "Twitter",
  "menu-speeds": "Speed",
  "menu-speeds-normal": "Normal",
  "menu-subtitles": "Subtitles",
  "menu-subtitles-off": "Off",
  "multiChannel-singleStreamLive": "{{figure}} stream live",
  "multiChannel-multipleStreamsLive": "{{figure}} streams live",
  "multiChannel-seeSchedule": "See schedule",
  "multiChannel-schedule": "Live streams",
  "multiChannel-label-live": "Live now",
  "multiChannel-label-liveIn": "Live in",
  "multiChannel-label-replay": "Replay available",
  "multiChannel-label-trim": "Awaiting replay",
  "multiChannel-label-nowWatching": "You are now watching",
  "nerdMode-assetId": "Asset ID",
  "nerdMode-copyId": "Copy ID",
  "nerdMode-crepoId": "CRID",
  "nerdMode-geolocation": "Derived geolocation",
  "nerdMode-idCopied": "ID copied to clipboard",
  "nerdMode-playerVersion": "Player Version",
  "nerdMode-techVersion": "Bitmovin Version",
  "nerdMode-rendition": "Current Rendition",
  "nerdMode-unknownValue": "unknown",
  "nextVideoCountdown-replay": "Replay",
  "nextVideoCountdown-title": "Up next",
  "rbcom-subtitlesAvailable": "Subtitles Available",
  "tooltip-airplay": "AirPlay",
  "tooltip-audioTracks": "Audio Language",
  "tooltip-changeVolume": "Change Volume",
  "tooltip-dvr": "Return to LIVE",
  "tooltip-forward": "Seek forward",
  "tooltip-fullscreen": "Enter Fullscreen",
  "tooltip-loading": "Loading",
  "tooltip-mute": "Mute",
  "tooltip-normalscreen": "Leave Fullscreen",
  "tooltip-pause": "Pause",
  "tooltip-pip": "Picture In Picture",
  "tooltip-play": "Play",
  "tooltip-replay": "Replay",
  "tooltip-rewind": "Seek back",
  "tooltip-settings": "Settings",
  "tooltip-subtitles": "Subtitles",
  "tooltip-unmute": "Unmute",
  "ad-from-ads": "Ad {{adPosition}} of {{totalAds}}",
  "audio-duration-hour": "hr",
  "audio-duration-minute": "min",
  "audio-error-default-description": "This podcast episode is no longer available. It may have been deleted or made unavailable by the provider. Please check back later or explore other podcasts.",
  "audio-error-default-title": "Content is not available",
  "audio-podcast-currently-playing": "Currently playing",
  "audio-podcast-playlist-additional-episodes-on": "{{additionalEpisodes}} additional episode on",
  "audio-podcast-playlist-additional-episodes-on_plural": "{{additionalEpisodes}} additional episodes on",
  "audio-podcast-playlist-all-episodes-on": "All episodes on",
  "nerdMode-audioLanguageOverride": "Audio language override",
  "nerdMode-localeStorage": "Locale storage",
  "nerdMode-overrideReference": "Override reference",
  "nerdMode-playerConfiguration": "Player config",
  "nerdMode-subtitlesLanguageOverride": "Subtitles language override",
  "nerdMode-translationsLanguageOverride": "Translations language override",
  "tooltip-stop": "Stop"
}, kv = "https://translations.redbull.com/player/", zv = de.getLogger("TranslationService");
class Ev {
  constructor() {
    C(this, "translationsLoaded", !1);
    C(this, "translationsLoadedCallback");
    C(this, "preferredLanguage");
    C(this, "currentTranslationData");
  }
  getTranslationForKey(e) {
    return this.getTranslationFile()[e];
  }
  async fetchTranslationData(e) {
    try {
      const o = await fetch(`${kv}${e}`, { redirect: "manual" });
      if (o.ok)
        return await o.json();
    } catch {
      zv.debug(`Could not load translations for ${e} using fallback instead`);
    }
    return this.getFallbackTranslation(e);
  }
  getTranslationFile() {
    const e = this.preferredLanguage ?? qn();
    return this.currentTranslationData ?? this.getFallbackTranslation(e);
  }
  getFallbackTranslation(e) {
    return e != null && e.startsWith("de") ? _v : wv;
  }
  async setAndFetchCurrentLanguage(e) {
    const o = e ?? qn(), s = await this.fetchTranslationData(o);
    return this.preferredLanguage = o, this.currentTranslationData = s, Promise.resolve();
  }
}
const Xe = new Ev();
async function $v(t) {
  return Xe.translationsLoaded = !1, await Xe.setAndFetchCurrentLanguage(t).then(() => {
    Xe.translationsLoaded = !0, Xe.translationsLoadedCallback && Xe.translationsLoadedCallback();
  });
}
function Sv(t) {
  Xe.translationsLoadedCallback = t;
}
function Pv() {
  return Xe.translationsLoaded;
}
function Z(t, e = {}) {
  const o = Xe.getTranslationForKey(t);
  return Object.keys(e).reduce((n, i) => n.replace(`{{${i}}}`, e[i]), o);
}
var ht = [], Cv = function() {
  return ht.some(function(t) {
    return t.activeTargets.length > 0;
  });
}, Tv = function() {
  return ht.some(function(t) {
    return t.skippedTargets.length > 0;
  });
}, ir = "ResizeObserver loop completed with undelivered notifications.", Iv = function() {
  var t;
  typeof ErrorEvent == "function" ? t = new ErrorEvent("error", {
    message: ir
  }) : (t = document.createEvent("Event"), t.initEvent("error", !1, !1), t.message = ir), window.dispatchEvent(t);
}, uo;
(function(t) {
  t.BORDER_BOX = "border-box", t.CONTENT_BOX = "content-box", t.DEVICE_PIXEL_CONTENT_BOX = "device-pixel-content-box";
})(uo || (uo = {}));
var vt = function(t) {
  return Object.freeze(t);
}, Lv = function() {
  function t(e, o) {
    this.inlineSize = e, this.blockSize = o, vt(this);
  }
  return t;
}(), oc = function() {
  function t(e, o, s, n) {
    return this.x = e, this.y = o, this.width = s, this.height = n, this.top = this.y, this.left = this.x, this.bottom = this.top + this.height, this.right = this.left + this.width, vt(this);
  }
  return t.prototype.toJSON = function() {
    var e = this, o = e.x, s = e.y, n = e.top, i = e.right, r = e.bottom, a = e.left, c = e.width, d = e.height;
    return { x: o, y: s, top: n, right: i, bottom: r, left: a, width: c, height: d };
  }, t.fromRect = function(e) {
    return new t(e.x, e.y, e.width, e.height);
  }, t;
}(), On = function(t) {
  return t instanceof SVGElement && "getBBox" in t;
}, sc = function(t) {
  if (On(t)) {
    var e = t.getBBox(), o = e.width, s = e.height;
    return !o && !s;
  }
  var n = t, i = n.offsetWidth, r = n.offsetHeight;
  return !(i || r || t.getClientRects().length);
}, rr = function(t) {
  var e;
  if (t instanceof Element)
    return !0;
  var o = (e = t == null ? void 0 : t.ownerDocument) === null || e === void 0 ? void 0 : e.defaultView;
  return !!(o && t instanceof o.Element);
}, Av = function(t) {
  switch (t.tagName) {
    case "INPUT":
      if (t.type !== "image")
        break;
    case "VIDEO":
    case "AUDIO":
    case "EMBED":
    case "OBJECT":
    case "CANVAS":
    case "IFRAME":
    case "IMG":
      return !0;
  }
  return !1;
}, so = typeof window < "u" ? window : {}, Do = /* @__PURE__ */ new WeakMap(), ar = /auto|scroll/, Ov = /^tb|vertical/, Rv = /msie|trident/i.test(so.navigator && so.navigator.userAgent), Ce = function(t) {
  return parseFloat(t || "0");
}, It = function(t, e, o) {
  return t === void 0 && (t = 0), e === void 0 && (e = 0), o === void 0 && (o = !1), new Lv((o ? e : t) || 0, (o ? t : e) || 0);
}, cr = vt({
  devicePixelContentBoxSize: It(),
  borderBoxSize: It(),
  contentBoxSize: It(),
  contentRect: new oc(0, 0, 0, 0)
}), nc = function(t, e) {
  if (e === void 0 && (e = !1), Do.has(t) && !e)
    return Do.get(t);
  if (sc(t))
    return Do.set(t, cr), cr;
  var o = getComputedStyle(t), s = On(t) && t.ownerSVGElement && t.getBBox(), n = !Rv && o.boxSizing === "border-box", i = Ov.test(o.writingMode || ""), r = !s && ar.test(o.overflowY || ""), a = !s && ar.test(o.overflowX || ""), c = s ? 0 : Ce(o.paddingTop), d = s ? 0 : Ce(o.paddingRight), l = s ? 0 : Ce(o.paddingBottom), h = s ? 0 : Ce(o.paddingLeft), u = s ? 0 : Ce(o.borderTopWidth), p = s ? 0 : Ce(o.borderRightWidth), v = s ? 0 : Ce(o.borderBottomWidth), g = s ? 0 : Ce(o.borderLeftWidth), y = h + d, b = c + l, _ = g + p, E = u + v, m = a ? t.offsetHeight - E - t.clientHeight : 0, P = r ? t.offsetWidth - _ - t.clientWidth : 0, k = n ? y + _ : 0, A = n ? b + E : 0, T = s ? s.width : Ce(o.width) - k - P, z = s ? s.height : Ce(o.height) - A - m, L = T + y + P + _, D = z + b + m + E, R = vt({
    devicePixelContentBoxSize: It(Math.round(T * devicePixelRatio), Math.round(z * devicePixelRatio), i),
    borderBoxSize: It(L, D, i),
    contentBoxSize: It(T, z, i),
    contentRect: new oc(h, c, T, z)
  });
  return Do.set(t, R), R;
}, ic = function(t, e, o) {
  var s = nc(t, o), n = s.borderBoxSize, i = s.contentBoxSize, r = s.devicePixelContentBoxSize;
  switch (e) {
    case uo.DEVICE_PIXEL_CONTENT_BOX:
      return r;
    case uo.BORDER_BOX:
      return n;
    default:
      return i;
  }
}, Dv = function() {
  function t(e) {
    var o = nc(e);
    this.target = e, this.contentRect = o.contentRect, this.borderBoxSize = vt([o.borderBoxSize]), this.contentBoxSize = vt([o.contentBoxSize]), this.devicePixelContentBoxSize = vt([o.devicePixelContentBoxSize]);
  }
  return t;
}(), rc = function(t) {
  if (sc(t))
    return 1 / 0;
  for (var e = 0, o = t.parentNode; o; )
    e += 1, o = o.parentNode;
  return e;
}, Mv = function() {
  var t = 1 / 0, e = [];
  ht.forEach(function(r) {
    if (r.activeTargets.length !== 0) {
      var a = [];
      r.activeTargets.forEach(function(d) {
        var l = new Dv(d.target), h = rc(d.target);
        a.push(l), d.lastReportedSize = ic(d.target, d.observedBox), h < t && (t = h);
      }), e.push(function() {
        r.callback.call(r.observer, a, r.observer);
      }), r.activeTargets.splice(0, r.activeTargets.length);
    }
  });
  for (var o = 0, s = e; o < s.length; o++) {
    var n = s[o];
    n();
  }
  return t;
}, lr = function(t) {
  ht.forEach(function(o) {
    o.activeTargets.splice(0, o.activeTargets.length), o.skippedTargets.splice(0, o.skippedTargets.length), o.observationTargets.forEach(function(n) {
      n.isActive() && (rc(n.target) > t ? o.activeTargets.push(n) : o.skippedTargets.push(n));
    });
  });
}, Nv = function() {
  var t = 0;
  for (lr(t); Cv(); )
    t = Mv(), lr(t);
  return Tv() && Iv(), t > 0;
}, ks, ac = [], Fv = function() {
  return ac.splice(0).forEach(function(t) {
    return t();
  });
}, Bv = function(t) {
  if (!ks) {
    var e = 0, o = document.createTextNode(""), s = { characterData: !0 };
    new MutationObserver(function() {
      return Fv();
    }).observe(o, s), ks = function() {
      o.textContent = "".concat(e ? e-- : e++);
    };
  }
  ac.push(t), ks();
}, Uv = function(t) {
  Bv(function() {
    requestAnimationFrame(t);
  });
}, Go = 0, Hv = function() {
  return !!Go;
}, Vv = 250, jv = { attributes: !0, characterData: !0, childList: !0, subtree: !0 }, dr = [
  "resize",
  "load",
  "transitionend",
  "animationend",
  "animationstart",
  "animationiteration",
  "keyup",
  "keydown",
  "mouseup",
  "mousedown",
  "mouseover",
  "mouseout",
  "blur",
  "focus"
], ur = function(t) {
  return t === void 0 && (t = 0), Date.now() + t;
}, zs = !1, Wv = function() {
  function t() {
    var e = this;
    this.stopped = !0, this.listener = function() {
      return e.schedule();
    };
  }
  return t.prototype.run = function(e) {
    var o = this;
    if (e === void 0 && (e = Vv), !zs) {
      zs = !0;
      var s = ur(e);
      Uv(function() {
        var n = !1;
        try {
          n = Nv();
        } finally {
          if (zs = !1, e = s - ur(), !Hv())
            return;
          n ? o.run(1e3) : e > 0 ? o.run(e) : o.start();
        }
      });
    }
  }, t.prototype.schedule = function() {
    this.stop(), this.run();
  }, t.prototype.observe = function() {
    var e = this, o = function() {
      return e.observer && e.observer.observe(document.body, jv);
    };
    document.body ? o() : so.addEventListener("DOMContentLoaded", o);
  }, t.prototype.start = function() {
    var e = this;
    this.stopped && (this.stopped = !1, this.observer = new MutationObserver(this.listener), this.observe(), dr.forEach(function(o) {
      return so.addEventListener(o, e.listener, !0);
    }));
  }, t.prototype.stop = function() {
    var e = this;
    this.stopped || (this.observer && this.observer.disconnect(), dr.forEach(function(o) {
      return so.removeEventListener(o, e.listener, !0);
    }), this.stopped = !0);
  }, t;
}(), Js = new Wv(), mr = function(t) {
  !Go && t > 0 && Js.start(), Go += t, !Go && Js.stop();
}, qv = function(t) {
  return !On(t) && !Av(t) && getComputedStyle(t).display === "inline";
}, Gv = function() {
  function t(e, o) {
    this.target = e, this.observedBox = o || uo.CONTENT_BOX, this.lastReportedSize = {
      inlineSize: 0,
      blockSize: 0
    };
  }
  return t.prototype.isActive = function() {
    var e = ic(this.target, this.observedBox, !0);
    return qv(this.target) && (this.lastReportedSize = e), this.lastReportedSize.inlineSize !== e.inlineSize || this.lastReportedSize.blockSize !== e.blockSize;
  }, t;
}(), Zv = function() {
  function t(e, o) {
    this.activeTargets = [], this.skippedTargets = [], this.observationTargets = [], this.observer = e, this.callback = o;
  }
  return t;
}(), Mo = /* @__PURE__ */ new WeakMap(), fr = function(t, e) {
  for (var o = 0; o < t.length; o += 1)
    if (t[o].target === e)
      return o;
  return -1;
}, No = function() {
  function t() {
  }
  return t.connect = function(e, o) {
    var s = new Zv(e, o);
    Mo.set(e, s);
  }, t.observe = function(e, o, s) {
    var n = Mo.get(e), i = n.observationTargets.length === 0;
    fr(n.observationTargets, o) < 0 && (i && ht.push(n), n.observationTargets.push(new Gv(o, s && s.box)), mr(1), Js.schedule());
  }, t.unobserve = function(e, o) {
    var s = Mo.get(e), n = fr(s.observationTargets, o), i = s.observationTargets.length === 1;
    n >= 0 && (i && ht.splice(ht.indexOf(s), 1), s.observationTargets.splice(n, 1), mr(-1));
  }, t.disconnect = function(e) {
    var o = this, s = Mo.get(e);
    s.observationTargets.slice().forEach(function(n) {
      return o.unobserve(e, n.target);
    }), s.activeTargets.splice(0, s.activeTargets.length);
  }, t;
}(), Yv = function() {
  function t(e) {
    if (arguments.length === 0)
      throw new TypeError("Failed to construct 'ResizeObserver': 1 argument required, but only 0 present.");
    if (typeof e != "function")
      throw new TypeError("Failed to construct 'ResizeObserver': The callback provided as parameter 1 is not a function.");
    No.connect(this, e);
  }
  return t.prototype.observe = function(e, o) {
    if (arguments.length === 0)
      throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': 1 argument required, but only 0 present.");
    if (!rr(e))
      throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': parameter 1 is not of type 'Element");
    No.observe(this, e, o);
  }, t.prototype.unobserve = function(e) {
    if (arguments.length === 0)
      throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': 1 argument required, but only 0 present.");
    if (!rr(e))
      throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': parameter 1 is not of type 'Element");
    No.unobserve(this, e);
  }, t.prototype.disconnect = function() {
    No.disconnect(this);
  }, t.toString = function() {
    return "function ResizeObserver () { [polyfill code] }";
  }, t;
}();
function cc(t) {
  return new (window.ResizeObserver ?? Yv)(t);
}
function lc(t, e) {
  const [o, s] = J([]), n = B(
    (r) => {
      const a = new Set(o), c = new Set(o);
      if (r.forEach((d) => {
        e.forEach((l) => {
          d.contentRect.width >= l ? a.add(l) : a.delete(l);
        });
      }), !ul(c, a)) {
        const d = Array.from(a);
        s(d);
      }
    },
    [e, o]
  );
  _e(() => {
    const r = t.current;
    if (!r)
      return function() {
      };
    const a = cc((c) => {
      window.requestAnimationFrame(() => n(c));
    });
    return a.observe(r), function() {
      a.unobserve(r);
    };
  }, [e, o, t, n]);
  const i = ae(
    () => o.map((r) => `cq-${r}`).join(" "),
    [o]
  );
  if (i === void 0)
    throw new Error("Hooks are broken! Please check RBV-1627 to get more info!");
  return i;
}
function Kv(t, e) {
  return t.includes(`cq-${e}`);
}
function dc(t, e) {
  const o = Y(), s = Y(), n = Y(t);
  n.current = t;
  const i = (r) => {
    window.requestAnimationFrame(() => {
      r.forEach((a) => {
        const c = o.current;
        (a.contentRect.width !== (c == null ? void 0 : c.width) || a.contentRect.height !== c.height) && (o.current = {
          width: a.contentRect.width,
          height: a.contentRect.height
        }, n.current(a.contentRect));
      });
    });
  };
  s.current || (s.current = cc(i)), _e(() => {
    const r = e == null ? void 0 : e.current;
    if (!r)
      return () => {
      };
    const a = s.current;
    return a == null || a.observe(r), () => {
      a == null || a.unobserve(r);
    };
  }, [e]);
}
sn({});
de.getLogger("useInformPlaywright");
function Xv() {
  return {
    playerState: {
      audioLoaded: !1,
      bufferLengthInSec: 0,
      cumulatedPlayTimeInSec: 0,
      durationInSec: 0,
      playbackPosInSec: 0,
      playbackSpeed: 1,
      playerStatus: "IDLE",
      uiMode: "dark"
    },
    init: () => {
    }
  };
}
const uc = Xv(), mc = sn(uc);
function pr(t) {
  var e;
  return {
    audioLoaded: t.isAudioLoaded,
    bufferLengthInSec: t.getBufferLengthInSec(),
    coverArt: t.getCoverArt(),
    cumulatedPlayTimeInSec: t.getCumulatedPlayTimeInSec(),
    currentErrorDetails: t.getCurrentErrorDetails(),
    durationInSec: t.getDurationInSec(),
    mediaMetaData: t.getMediaMetaData(),
    playbackPosInSec: ((e = t.getPlayerData()) == null ? void 0 : e.getCurrentTimeInSec()) ?? 0,
    playbackSpeed: t.getPlaybackSpeed(),
    playerConfiguration: t.getPlayerConfiguration(),
    playerCoordinator: t,
    playerStatus: t.getPlayerStatus(),
    uiMode: t.getUIMode()
  };
}
const fc = ({ children: t }) => {
  const [e, o] = J(uc.playerState), [s, n] = J(), i = B((a) => {
    n(a);
  }, []), r = ae(() => ({ playerState: e, init: i }), [e, i]);
  return _e(() => {
    if (!s)
      return () => {
      };
    const a = (d) => {
      const l = pr(s);
      o(l);
    };
    s.addEventListener(a);
    const c = pr(s);
    return o(c), () => {
      s.removeEventListener(a);
    };
  }, [s]), /* @__PURE__ */ f.createElement(mc.Provider, { value: r }, t);
}, $e = () => Fa(mc);
function Jv(t, e, o) {
  var s, n, i;
  e === void 0 && (e = 50), o === void 0 && (o = {});
  var r = (s = o.isImmediate) != null && s, a = (n = o.callback) != null && n, c = o.maxWait, d = Date.now(), l = [];
  function h() {
    if (c !== void 0) {
      var p = Date.now() - d;
      if (p + e >= c)
        return c - p;
    }
    return e;
  }
  var u = function() {
    var p = [].slice.call(arguments), v = this;
    return new Promise(function(g, y) {
      var b = r && i === void 0;
      if (i !== void 0 && clearTimeout(i), i = setTimeout(function() {
        if (i = void 0, d = Date.now(), !r) {
          var E = t.apply(v, p);
          a && a(E), l.forEach(function(m) {
            return (0, m.resolve)(E);
          }), l = [];
        }
      }, h()), b) {
        var _ = t.apply(v, p);
        return a && a(_), g(_);
      }
      l.push({ resolve: g, reject: y });
    });
  };
  return u.cancel = function(p) {
    i !== void 0 && clearTimeout(i), l.forEach(function(v) {
      return (0, v.reject)(p);
    }), l = [];
  }, u;
}
const Qv = de.getLogger("useAudioCoreApi");
function e0(t, e) {
  const o = ae(() => {
    const s = Zc;
    return (i) => {
      if (s.includes(i.type)) {
        const r = t.current ?? [];
        for (const a of r)
          try {
            a(i);
          } catch (c) {
            Qv.error("error invoking public event listener", c);
          }
      }
    };
  }, [t]);
  _e(() => {
    e && e.addEventListener(o);
  }, [e, o]);
}
function t0(t) {
  const e = Y(t);
  e.current = t;
  const o = Y([]);
  return e0(o, t), ae(() => ({
    async play() {
      var n;
      return (n = e.current) == null ? void 0 : n.play();
    },
    pause() {
      var n;
      (n = e.current) == null || n.pause();
    },
    seek(n) {
      var i;
      (i = e.current) == null || i.seek(n);
    },
    getStatus() {
      var n;
      return ((n = e.current) == null ? void 0 : n.getPlayerStatus()) ?? "IDLE";
    },
    getCurrentTime() {
      var n, i;
      return ((i = (n = e.current) == null ? void 0 : n.getPlayerData()) == null ? void 0 : i.getCurrentTimeInSec()) ?? 0;
    },
    getDuration() {
      var n;
      return ((n = e.current) == null ? void 0 : n.getDurationInSec()) ?? 0;
    },
    setMuted(n) {
      var i;
      (i = e.current) == null || i.setMuted(n);
    },
    isMuted() {
      var n;
      return ((n = e.current) == null ? void 0 : n.isMuted()) ?? !1;
    },
    setVolume(n) {
      var i;
      (i = e.current) == null || i.setVolume(n);
    },
    getVolume() {
      var n;
      return ((n = e.current) == null ? void 0 : n.getVolume()) ?? 100;
    },
    addEventListener(n) {
      o.current.push(n);
    },
    removeEventListener(n) {
      const i = o.current.findIndex((r) => r === n);
      i !== -1 && o.current.splice(i, 1);
    }
  }), [e, o]);
}
const o0 = `@font-face{font-family:Bull Text;font-style:normal;font-weight:400;font-display:swap;src:url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/BullText-Regular.woff2) format("woff2"),url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/BullText-Regular.woff) format("woff")}@font-face{font-family:Bull Text;font-style:normal;font-weight:500;font-display:swap;src:url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/BullText-Medium.woff2) format("woff2"),url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/BullText-Medium.woff) format("woff")}@font-face{font-family:Bull Text;font-style:normal;font-weight:700;font-display:swap;src:url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/BullText-Bold.woff2) format("woff2"),url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/BullText-Bold.woff) format("woff")}@font-face{font-family:Bull;font-style:normal;font-weight:700;font-display:swap;src:url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/Bull-Bold.woff2) format("woff2"),url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/Bull-Bold.woff) format("woff")}@font-face{font-family:Bull;font-style:normal;font-weight:800;font-display:swap;src:url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/Bull-Heavy1.woff2) format("woff2"),url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/Bull-Heavy1.woff) format("woff")}@font-face{font-family:Bull VF;font-style:normal;font-weight:300 800;font-display:swap;src:url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/BullVAR.woff2) format("woff2-variations"),url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/BullVAR.woff2) format("woff2")}
`;
function s0(t, e) {
  if (t.length === 0)
    return 0;
  for (let o = 0; o < t.length; o++) {
    const s = t.start(o), n = t.end(o);
    if (s <= e && e <= n)
      return n;
  }
  return e;
}
function n0(t, e) {
  if (e === 0)
    return 0;
  const o = an(t / e);
  return isNaN(o) ? 0 : o * 100;
}
function i0(t, e) {
  return {
    ...t,
    type: "play",
    playbackPosition: e.getCurrentTimeInSec()
  };
}
function r0(t, e) {
  return {
    ...t,
    type: "playing",
    playbackPosition: e.getCurrentTimeInSec()
  };
}
function a0(t, e) {
  return e.getPlayerStatus() === "ENDED" ? {
    type: "playbackFinished",
    playerId: t.playerId,
    playbackPosition: e.getCurrentTimeInSec()
  } : { type: "paused", playerId: t.playerId, playbackPosition: e.getCurrentTimeInSec() };
}
function c0(t, e) {
  return {
    ...t,
    type: "seeking",
    targetPosition: e.currentSeekTarget,
    playbackPosition: e.getSeekStartTimeInSec(),
    issuer: e.currentSeekIssuer ?? "USER"
  };
}
function l0(t, e) {
  return {
    ...t,
    type: "seekingDone",
    issuer: e.currentSeekIssuer ?? "USER"
  };
}
function d0(t, e) {
  return {
    ...t,
    type: "timeChanged",
    duration: e.getDurationInSec()
  };
}
function u0(t, e, o) {
  var s;
  return {
    ...t,
    type: "error",
    code: String(((s = o.target.error) == null ? void 0 : s.code) ?? 0)
  };
}
const Yt = {
  play: i0,
  playing: r0,
  pause: a0,
  seeking: c0,
  seeked: l0,
  timeupdate: d0,
  error: u0
};
function m0(t, e, o) {
  var n;
  const s = {
    type: t.type,
    playerId: e,
    playbackPosition: o.getCurrentTimeInSec()
  };
  return (n = Yt == null ? void 0 : Yt[t.type]) == null ? void 0 : n.call(Yt, s, o, t);
}
const pc = [];
function hc(t) {
  return pc.find((o) => o.id === t);
}
function f0(t) {
  const e = hc(t);
  e && (e.audioElement.src = "");
}
function p0(t, e) {
  const o = hc(t);
  if (o)
    return o;
  const s = document.createElement("audio");
  s.id = t, s.preload = "none", s.controls = !1;
  const n = { audioElement: s, id: t };
  return pc.push(n), e.appendChild(s), n;
}
const Ne = de.getLogger("Html5AudioPlayerAdapter"), h0 = ["IDLE", "ENDED", "ERROR", "PAUSED"];
class v0 {
  constructor(e) {
    C(this, "audioElement");
    C(this, "playerId");
    C(this, "hasError", !1);
    C(this, "hasStarted", !1);
    C(this, "hasLoaded", !1);
    C(this, "isStalled", !1);
    C(this, "isPlaying", !1);
    C(this, "_isSeeking", !1);
    C(this, "seekStartTimeInSec", 0);
    C(this, "currentSeekTarget", 0);
    C(this, "currentSeekIssuer");
    C(this, "eventEmitter");
    // For `_handlePlayerEvent` we are using arrow style functions to be able to use it as event handler and still have `this` bound to the instance.
    // This enables us to easily remove the event handlers.
    C(this, "_handlePlayerEvent", (e) => {
      Ne.debug("html5 player event", e);
      const o = this.playerId, s = e.type;
      switch (this.setInternalStateForEvent(s), s) {
        case "playing":
        case "timeupdate":
          if (!this.hasStarted || this.isSeeking)
            return;
          break;
        case "error":
          this.mapEventAndEmit(e, o);
          return;
      }
      this.hasError || this.mapEventAndEmit(e, o), this.resetAdapterStateAfterEmittingEvent(s);
    });
    const o = e.playerId;
    this.playerId = o;
    const s = e.element;
    this.eventEmitter = e.eventEmitter;
    const n = p0(o, s);
    this.audioElement = n.audioElement;
  }
  get isSeeking() {
    return this._isSeeking;
  }
  set isSeeking(e) {
    this._isSeeking = e;
  }
  addEventListeners(e) {
    e.addEventListener("play", this._handlePlayerEvent), e.addEventListener("playing", this._handlePlayerEvent), e.addEventListener("ratechange", this._handlePlayerEvent), e.addEventListener("seeked", this._handlePlayerEvent), e.addEventListener("seeking", this._handlePlayerEvent), e.addEventListener("stalled", this._handlePlayerEvent), e.addEventListener("timeupdate", this._handlePlayerEvent), e.addEventListener("pause", this._handlePlayerEvent), e.addEventListener("error", this._handlePlayerEvent), e.addEventListener("ended", this._handlePlayerEvent), e.addEventListener("abort", this._handlePlayerEvent), e.addEventListener("waiting", this._handlePlayerEvent);
  }
  setInternalStateForEvent(e) {
    switch (e) {
      case "play":
        this.hasStarted = !0;
        break;
      case "playing":
        this.isPlaying = !0, this.isStalled = !1;
        break;
      case "timeupdate":
        this.isStalled = !1;
        break;
      case "pause":
        this.isPlaying = !1;
        break;
      case "stalled":
      case "waiting":
        this.isStalled = !0;
        break;
      case "error":
        this.hasError = !0, this.isPlaying = !1;
        break;
    }
  }
  resetAdapterStateAfterEmittingEvent(e) {
    switch (e) {
      case "seeked":
        this.currentSeekIssuer = void 0, this.currentSeekTarget = 0, this.isSeeking = !1;
        break;
      case "seeking":
        this.isSeeking = !0, this.seekStartTimeInSec = 0;
        break;
    }
  }
  mapEventAndEmit(e, o) {
    const s = m0(e, o, this);
    Ne.debug(o, "received html5 event", e, "mapped to", s), s && this.eventEmitter.fireEvent(s);
  }
  canSeekBackward() {
    return this.getCurrentTimeInSec() > 5;
  }
  canSeekForward() {
    return this.getCurrentTimeInSec() < this.getDurationInSec() - 5;
  }
  getPlayerType() {
    return "AUDIO";
  }
  mute() {
    this.audioElement.muted = !0;
  }
  pause() {
    Ne.info("pause"), this.audioElement.pause();
  }
  async play() {
    Ne.info("play"), await this.audioElement.play();
  }
  seek(e, o) {
    const s = this.getCurrentTimeInSec(), n = this.audioElement.duration, i = isNaN(n) ? e : Math.min(n - 3, e), r = this.getPlayerStatus();
    return Ne.debug("html5 seek to", i, "issuer", o, "status", r), this.audioElement.fastSeek && !h0.includes(r) ? this.audioElement.fastSeek(i) : this.audioElement.currentTime = i, this.seekStartTimeInSec = s, this.currentSeekTarget = i, this.currentSeekIssuer = o, !0;
  }
  unmute() {
    this.audioElement.muted = !1;
  }
  async load(e) {
    Ne.debug("loading audio source", e), await this.reset();
    const o = e.source.audioUrl, s = e.source.mediaType;
    if (!o)
      throw Ne.error("dont have audio url to load", e), new Error("dont have audio url to load");
    if (this.audioElement.canPlayType(s))
      this.addEventListeners(this.audioElement), this.audioElement.src = o, this.hasLoaded = !0;
    else
      throw Ne.error(`cannot play media type ${s}`), new Error(`cannot play media type ${s}`);
  }
  async destroy() {
    await this.reset();
  }
  async reset() {
    Ne.debug("Reset player", this.playerId), this.hasStarted = !1, this.hasError = !1, this.isStalled = !1, this.isPlaying = !1, this.isSeeking = !1, this.currentSeekTarget = 0, this.currentSeekIssuer = void 0, this.seekStartTimeInSec = 0, this.removeListeners(this.audioElement), f0(this.playerId);
  }
  removeListeners(e) {
    e.removeEventListener("play", this._handlePlayerEvent), e.removeEventListener("playing", this._handlePlayerEvent), e.removeEventListener("ratechange", this._handlePlayerEvent), e.removeEventListener("seeked", this._handlePlayerEvent), e.removeEventListener("seeking", this._handlePlayerEvent), e.removeEventListener("stalled", this._handlePlayerEvent), e.removeEventListener("timeupdate", this._handlePlayerEvent), e.removeEventListener("pause", this._handlePlayerEvent), e.removeEventListener("error", this._handlePlayerEvent), e.removeEventListener("ended", this._handlePlayerEvent), e.removeEventListener("abort", this._handlePlayerEvent), e.removeEventListener("waiting", this._handlePlayerEvent);
  }
  getPlaybackMode() {
    return "VOD";
  }
  getPlayerStatus() {
    return this.hasError || this.audioElement.error ? "ERROR" : this.audioElement.ended ? "ENDED" : this.isStalled ? "BUFFERING" : this.isPlaying ? "PLAYING" : !this.hasLoaded || !this.hasStarted ? "IDLE" : "PAUSED";
  }
  getCurrentTimeInSec() {
    return this.audioElement.currentTime;
  }
  getDurationInSec() {
    return this.audioElement.duration;
  }
  getSeekStartTimeInSec() {
    return this.seekStartTimeInSec;
  }
  getVolume() {
    return this.audioElement.volume;
  }
  setVolume(e) {
    this.audioElement.volume = e;
  }
  setHasError(e) {
    this.hasError = e;
  }
  getBufferLengthInSec() {
    const e = this.audioElement.buffered, o = this.getCurrentTimeInSec();
    return s0(e, o);
  }
  isPlayerLoaded() {
    return this.hasLoaded;
  }
  setPlaybackSpeed(e) {
    this.audioElement.playbackRate = e;
  }
  getPlaybackSpeed() {
    return this.audioElement.playbackRate;
  }
  getAudioLanguage() {
    return this.audioElement.lang;
  }
  getAudioLanguageId() {
    return "";
  }
  getMainMediaDurationInSec() {
    return this.getDurationInSec();
  }
  getLastMainMediaPositionInSec() {
    return this.getCurrentTimeInSec();
  }
  getTechVersion() {
    return "1.0.0";
  }
}
const Tt = class Tt {
  static setPlayerStatus(e) {
    this.staticPlayerStatus = e;
  }
  constructor(e) {
    Tt.staticOptions = e;
  }
  canSeekBackward() {
    return !1;
  }
  canSeekForward() {
    return !1;
  }
  getPlayerType() {
    return "AUDIO";
  }
  mute() {
  }
  pause() {
  }
  async play() {
  }
  seek(e, o) {
    return !1;
  }
  unmute() {
  }
  async load(e) {
  }
  async destroy() {
  }
  async reset() {
  }
  getPlaybackMode() {
    return "VOD";
  }
  getPlayerStatus() {
    return Tt.staticPlayerStatus;
  }
  getCurrentTimeInSec() {
    return 0;
  }
  getDurationInSec() {
    return 100;
  }
  getSeekStartTimeInSec() {
    return 0;
  }
  getVolume() {
    return 1;
  }
  setVolume(e) {
  }
  setHasError(e) {
  }
  getBufferLengthInSec() {
    return 0;
  }
  isPlayerLoaded() {
    return !1;
  }
  setPlaybackSpeed(e) {
  }
  getPlaybackSpeed() {
    return 1;
  }
  getAudioLanguage() {
    return "de";
  }
  getAudioLanguageId() {
    return "";
  }
  getMainMediaDurationInSec() {
    return 100;
  }
  getLastMainMediaPositionInSec() {
    return 0;
  }
  getTechVersion() {
    return "1.0.0";
  }
};
C(Tt, "staticPlayerStatus", "IDLE"), C(Tt, "staticOptions");
let Qs = Tt;
function g0(t) {
  switch (t.adapterType) {
    case "HTML5":
      return new v0(t);
    case "SIMULATION":
      return new Qs(t);
    default:
      throw new Error(`unknown player adapter type ${t.adapterType}`);
  }
}
function b0(t, e) {
  return e || t;
}
function hr(t, e) {
  return t === void 0 ? e : t;
}
function y0(t) {
  return {
    ...t,
    defaultPlayerMode: t.defaultPlayerMode ?? "standard",
    customInitAttributes: t.customInitAttributes ?? {},
    dataLayer: t.dataLayer ?? window.dataLayer
  };
}
function x0(t, e) {
  var r;
  const o = t.configs, s = t.services;
  if ((s == null ? void 0 : s.dataZoom) === "ACTIVE") {
    if (!((r = o.dataZoom) != null && r.configId))
      throw new Error("cannot enable dataZoom without a configuration id");
    if (!o.dataZoom.assetId)
      throw new Error("cannot enable dataZoom without an assetId");
  }
  const n = {
    googleAnalytics: hr(s == null ? void 0 : s.googleAnalytics, "ACTIVE"),
    dataZoom: e ? hr(s == null ? void 0 : s.dataZoom, "INACTIVE") : "INACTIVE"
  }, i = { ...o, googleAnalytics: y0(o.googleAnalytics) };
  return {
    ...t,
    configs: i,
    services: n
  };
}
function _0(t) {
  var r;
  const e = t.cookieConsent ?? !1, o = t.sharingEnabled ?? !0, s = t.environment ?? "PRODUCTION", n = ((r = t._debug) == null ? void 0 : r.playerAdapterType) ?? "HTML5", i = t.uiMode ?? "dark";
  return {
    ...t,
    configurationType: "AUDIO",
    cookieConsent: e,
    environment: s,
    hooks: t.hooks ?? [],
    sharingEnabled: o,
    tracking: x0(t.tracking, e),
    uiMode: i,
    _debug: {
      playerAdapterType: n
    }
  };
}
const ve = de.getLogger("AudioPlayerCoordinator"), Xt = {};
function vr() {
  ve.debug("Creation Stats", Xt);
}
const w0 = [Bo, Ts];
class k0 {
  constructor(e) {
    C(this, "playerId");
    C(this, "urlSharingStrategy");
    C(this, "dataLoader");
    C(this, "eventEmitter");
    C(this, "player");
    C(this, "trackingService");
    C(this, "mediaSessionService");
    C(this, "hookService");
    C(this, "dispatchElement");
    C(this, "playerConfig");
    C(this, "currentErrorDetails");
    C(this, "lastPlaybackPosition", 0);
    C(this, "cumulatedPlayTimeInSec", 0);
    C(this, "mediaMetaData");
    /** If a seek attempt happens during an ad is playing back the position will be stored and used to execute seek after the ad has finished. */
    C(this, "storedSeekOrTimeShift");
    C(this, "loaded", !1);
    C(this, "destroyed", !1);
    // noinspection JSUnusedGlobalSymbols
    C(this, "instanceId", ds());
    C(this, "lastRequestedVolume", 100);
    C(this, "genericListener", (e) => {
      switch (e.type) {
        case "loaded":
          this.handleLoadedEvent(e), this.dispatchDomEvent(e, document);
          break;
        case "timeChanged":
          this.handleTimeChangedEvent(e);
          break;
        case "seekingDone":
          this.handleSeekingEvent(e);
          break;
        case "play":
          this.dispatchDomEvent(e, document);
          break;
        case "error":
          this.handlePlayerOrDataError(e);
          break;
      }
      this.dispatchDomEvent(e);
    });
    C(this, "domEventListener", (e) => {
      if (!w0.includes(e.type))
        return;
      const s = e.detail;
      if (s.playerId === this.playerId)
        return;
      const n = this.getPlayerStatus();
      s.type === "play" && !["IDLE", "PAUSED"].includes(n) && (ve.debug("received play event from player", s.playerId, "pausing"), this.pause());
    });
    this.playerId = e.playerId;
    const o = Xt[this.playerId] ?? { createCount: 0, destroyCount: 0 };
    o.createCount += 1, Xt[this.playerId] = o, vr(), this.eventEmitter = e.eventEmitter ?? new jc(), this.dataLoader = e.dataLoader, this.dispatchElement = e.dispatchElement, this.urlSharingStrategy = e.urlSharingStrategy;
    const s = e.adapterType ?? "HTML5";
    ve.debug("created coordinator", this.playerId, o), this.player = g0({
      adapterType: s,
      playerId: e.playerId,
      element: e.divElement,
      eventEmitter: this.eventEmitter
    }), this.addEventListener(this.genericListener), this.mediaSessionService = new lv(this), document.addEventListener(Bo, this.domEventListener), document.addEventListener(Ts, this.domEventListener);
  }
  get isAudioLoaded() {
    return this.loaded;
  }
  addEventListener(e) {
    this.eventEmitter.addEventListener(e);
  }
  async destroy() {
    var e, o;
    if (ve.debug("destroying audio player coordinator", this.playerId), this.destroyed)
      ve.warn("calling destroy of an already destroyed audio player coordinator", this.playerId);
    else {
      this.loaded = !1, this.destroyed = !0;
      const s = Xt[this.playerId] ?? { createCount: 0, destroyCount: 0 };
      s.destroyCount += 1, Xt[this.playerId] = s, vr(), document.removeEventListener(Bo, this.domEventListener), document.removeEventListener(Ts, this.domEventListener);
      try {
        (e = this.trackingService) == null || e.destroy(), await ((o = this.hookService) == null ? void 0 : o.beforeDestroy(this.playerConfig, this.mediaMetaData, this)), await this.player.destroy(), ve.debug("done destroying coordinator", this.playerId);
      } catch (n) {
        const i = cn(n);
        ve.warn("error destroying player adapter for player", this.playerId, i);
      }
      this.trackingService = void 0, this.hookService = void 0, ve.debug("audio player coordinator destroyed", this.playerId);
    }
  }
  canSeekBackward() {
    return this.player.canSeekBackward();
  }
  canSeekForward() {
    return this.player.canSeekForward();
  }
  getCumulatedPlayTimeInSec() {
    return this.cumulatedPlayTimeInSec;
  }
  getCurrentErrorDetails() {
    return this.currentErrorDetails;
  }
  getDurationInSec() {
    var o;
    const e = this.player.getDurationInSec();
    return isNaN(e) ? ((o = this.mediaMetaData) == null ? void 0 : o.duration) ?? 0 : e;
  }
  getMediaMetaData() {
    return this.mediaMetaData;
  }
  getPlaybackSpeed() {
    return this.player.getPlaybackSpeed();
  }
  getPlayerConfiguration() {
    return this.playerConfig;
  }
  getPlayerStatus() {
    return this.player.getPlayerStatus();
  }
  /**
   * Returns the buffer length of the currently playing audio.
   */
  getBufferLengthInSec() {
    return this.player.getBufferLengthInSec();
  }
  getPlayerData() {
    return this.player;
  }
  getUIMode() {
    var e;
    return ((e = this.getPlayerConfiguration()) == null ? void 0 : e.uiMode) ?? "dark";
  }
  getVolume() {
    return this.player.getVolume();
  }
  /**
   * Returns the current player mode in which we are in. This has far-reaching consequences on `seek` vs. `timeshift`.
   * Note that in the case of Phasing (specifically in those phases where we don't have a videoUrl yet, such as PRE)
   * we won't know for certain what the playback mode will be.
   */
  getPlaybackMode() {
    return this.player.getPlaybackMode();
  }
  async load(e) {
    if (!e)
      throw new Error("no player config provided yet, cannot load");
    this.reset(), this.trackingService && (this.trackingService.destroy(), this.trackingService = void 0), this.hookService && (await this.hookService.beforeDestroy(void 0, void 0, this), this.hookService = void 0), this.loaded = !1, $v(e.overrideTranslationLanguage);
    const o = _0(e);
    this.playerConfig = o, this.hookService = new dv(
      this.playerConfig.hooks
    );
    try {
      const s = await this.dataLoader.loadData(o);
      this.playerConfig.assetId = b0(this.playerConfig.assetId, s.assetId), this.playerConfig.tracking.services.googleAnalytics === "ACTIVE" && (this.trackingService = av(
        this,
        this.playerConfig.tracking.configs.googleAnalytics.dataLayer
      )), this.mediaMetaData = s;
      try {
        this.playerConfig = await this.hookService.beforeLoad(this.playerConfig, s, this);
      } catch (r) {
        ve.warn("preloadHook failed, carrying on without it, error", r);
      }
      const n = await this.doLoad(s), i = e.initialSeekTimeInSec;
      return i && this.performInitialSeekOrTimeshift(i), await this.hookService.afterLoad(o, n, this), n;
    } catch (s) {
      ve.error("error during load", s);
      const n = s.message.includes("403") ? "NOT_AUTHORIZED" : "DATA_NOT_LOADED";
      this.handlePlayerOrDataError({ type: "error", playerId: this.playerId, code: n });
      return;
    }
  }
  async doLoad(e) {
    return await this.player.load({
      source: e.mediaSrc
    }), this.loaded = !0, this.eventEmitter.fireEvent({ type: "loaded", playerId: this.playerId, data: e }), e;
  }
  performInitialSeekOrTimeshift(e) {
    this.seek(e, "INITIAL");
  }
  pause() {
    return ve.info("pause"), this.player.pause();
  }
  async play() {
    if (!this.loaded)
      throw new Error("player not yet loaded");
    return this.eventEmitter.fireEvent({ type: "beforePlay", playerId: this.playerId }), this.player.play();
  }
  removeEventListener(e) {
    this.eventEmitter.removeEventListener(e);
  }
  reset() {
    var e;
    this.cumulatedPlayTimeInSec = 0, this.lastRequestedVolume = 100, this.lastPlaybackPosition = 0, this.storedSeekOrTimeShift = void 0, (e = this.trackingService) == null || e.reset();
  }
  seek(e, o = "USER") {
    return this.player.seek(e, o);
  }
  seekRelative(e) {
    const o = this.player;
    if (this.getPlaybackMode() === "LIVE")
      throw new Error("not supported");
    const s = o.getCurrentTimeInSec(), n = o.getDurationInSec(), i = Math.min(s + e, n), r = Math.max(0, i);
    return o.seek(r, "USER");
  }
  setPlaybackSpeed(e) {
    this.player.setPlaybackSpeed(e);
  }
  setVolume(e) {
    e > 0 && (this.lastRequestedVolume = e), this.player.setVolume(e);
  }
  setMuted(e) {
    this.player.setVolume(e ? 0 : this.lastRequestedVolume);
  }
  isMuted() {
    return this.getVolume() === 0;
  }
  dispatchDomEvent(e, o = this.dispatchElement.parentElement ?? void 0) {
    const s = new CustomEvent(Bo, { detail: e });
    ve.debug("dispatching DOM event", s), o == null || o.dispatchEvent(s);
  }
  dispatchPlayerEvent(e) {
    this.eventEmitter.fireEvent(e);
  }
  handleLoadedEvent(e) {
    this.lastPlaybackPosition = 0, this.cumulatedPlayTimeInSec = 0;
  }
  handleTimeChangedEvent(e) {
    this.cumulatedPlayTimeInSec += e.playbackPosition - this.lastPlaybackPosition, this.lastPlaybackPosition = e.playbackPosition;
  }
  handleSeekingEvent(e) {
    this.lastPlaybackPosition = e.playbackPosition;
  }
  handlePlayerOrDataError(e) {
    const o = e.code;
    o ? this.currentErrorDetails = { playerErrorCode: o } : this.currentErrorDetails = { serverErrorDetails: e }, this.player.getPlayerStatus() === "PLAYING" && this.player.pause(), this.player.setHasError(!0);
  }
  getCoverArt() {
    var e, o;
    if (this.isMediaDataLoadedOrError())
      return ((e = this.playerConfig) == null ? void 0 : e.coverArt) ?? ((o = this.mediaMetaData) == null ? void 0 : o.coverArt);
  }
  isMediaDataLoadedOrError() {
    return !!this.mediaMetaData || !!this.currentErrorDetails;
  }
  getTechVersion() {
    return this.player.getTechVersion();
  }
  restartPlaybackFromBeginning() {
    this.reset(), this.player.seek(0, "RESTART");
  }
  getMaxTimeShiftInSec() {
    throw new Error("Not supported");
  }
  timeShift(e) {
    throw new Error("Not supported");
  }
  seekOrTimeshiftRelative(e) {
    throw new Error("Not supported");
  }
}
function z0({
  urlSharingStrategy: t,
  dataLoader: e,
  dispatchElement: o,
  divElement: s,
  playerId: n,
  adapterType: i
}) {
  return new k0({
    urlSharingStrategy: t,
    dataLoader: e,
    dispatchElement: o,
    divElement: s,
    playerId: n,
    adapterType: i
  });
}
async function gr(t, e, o, s) {
  var r, a;
  const n = e.current;
  n && !n.destroyed && await n.destroy();
  const i = o ? z0(o) : void 0;
  t.skipCosmosFontInjection || pl(o0);
  try {
    return ns.debug("loading audio coordinator config", t), await (i == null ? void 0 : i.load(t)), (r = s.current) == null || r.call(s, i), i;
  } catch (c) {
    const d = c instanceof Error ? c : new Error(`Error loading the audio player ${c}`);
    throw ns.error("error loading the audio player", c), (a = s.current) == null || a.call(s, void 0, d), c;
  }
}
const ns = de.getLogger("rbup-audio-core");
function E0(t, e, o, s) {
  if (t && !e.current) {
    e.current = !0;
    const n = t.getCurrentErrorDetails();
    n ? o == null || o.reject(n) : t.isAudioLoaded && (o == null || o.resolve(s));
  }
}
const $0 = ({ config: t, dataLoader: e, onCoordinatorAvailable: o, urlSharingStrategy: s, internalOnApiAvailable: n }, i) => {
  var b;
  const [r] = J(ds()), a = Y(null), c = Y(), [d, l] = J(null);
  _e(() => {
    l(a.current);
  }, [a]);
  const h = ae(() => {
    var _;
    if (d)
      return {
        urlSharingStrategy: s ?? new tc(),
        dataLoader: e ?? new Gc(),
        dispatchElement: d,
        divElement: d,
        playerId: r,
        adapterType: (_ = t._debug) == null ? void 0 : _.playerAdapterType
      };
  }, [d, s, e, r, (b = t._debug) == null ? void 0 : b.playerAdapterType]), u = t0(c.current), p = B(Jv(gr, 100), [
    gr
  ]), v = Y(!1), g = B(
    (_, E) => {
      _ && E0(_, v, n, u), E && (n == null || n.reject(E));
    },
    [u, n]
  ), y = Y(g);
  return y.current = g, _e(() => {
    let _;
    return t.assetId && (async () => (_ = await p(
      t,
      c,
      h,
      y
    ), c.current = _, o == null || o(_)))(), () => {
      _ && !_.destroyed && _.destroy();
    };
  }, [t, c, h, p, o]), Cn(i, () => u, [u]), pv(a, t.environment), /* @__PURE__ */ f.createElement("div", { class: "audio-player", ref: a, "data-rbup-audio-core": !0 });
}, vc = nt($0);
async function S0(t, e, o) {
  ns.info("calling initRbupAudio with args", o), await customElements.whenDefined(e);
  const s = document.querySelector(`#${t}`);
  if (!s)
    throw new Error(`html element with id ${t} not found`);
  const n = ml(), i = {
    ...o,
    "internal-on-api-available": n
  };
  return bl(i), Object.assign(s, i), gl(s, i, ns), n;
}
function P0(t, e) {
  if (e === 0)
    return 0;
  const o = an(t / e);
  return isNaN(o) ? 0 : o * 100;
}
const C0 = ({ playbackPositionInPercent: t, show: e }) => {
  const o = `scrub-bar-handle ${e ? "scrub-bar-handle-visible" : ""}`, s = { left: `${t}%` };
  return /* @__PURE__ */ f.createElement("div", { "data-rbup-scrub-bar-handle": !0, class: o, style: s });
};
function T0(t, e, o, s, n, i) {
  return e > t ? s : o > t ? n : i;
}
function I0(t, e, o) {
  const s = Math.ceil(e / t), n = o.length / s, i = [];
  for (let r = 0; r < s; r++) {
    const a = Math.round(r * n);
    i.push(o[a]);
  }
  return i;
}
const Fo = typeof window < "u" && window.devicePixelRatio || 1, L0 = ({
  bufferColor: t,
  bufferPosition: e,
  notPlayedColor: o,
  playbackPosition: s,
  playedColor: n,
  points: i
}) => {
  const r = Y(null), a = B(
    (d) => {
      d.scale(Fo, Fo);
      const l = d.canvas.offsetHeight, h = d.canvas.offsetWidth, u = l, p = 1, v = 2, g = v + p;
      I0(g, h, i).forEach((b, _) => {
        const E = _ * g, m = Math.floor(b * u), P = E / h * 100;
        d.fillStyle = T0(
          P,
          s,
          e,
          n,
          t,
          o
        ), d.fillRect(E, l - m, v, m);
      });
    },
    [t, e, o, s, n, i]
  ), c = B(() => {
    const d = r.current;
    if (d) {
      const l = Math.floor(d.offsetWidth * Fo), h = Math.floor(d.offsetHeight * Fo);
      d.width = l, d.height = h;
      const u = d.getContext("2d");
      u && a(u);
    }
  }, [a]);
  return _e(() => {
    c();
  }, [c]), dc(c, r), /* @__PURE__ */ f.createElement("canvas", { "data-rbup-waveform": !0, class: "waveform-canvas", ref: r });
};
function A0(t, e, o) {
  return {
    background: "top left no-repeat",
    backgroundImage: [
      `linear-gradient(to right, ${o.playedColor}, ${o.playedColor})`,
      `linear-gradient(to right, ${o.bufferColor}, ${o.bufferColor})`,
      `linear-gradient(to right, ${o.notPlayedColor}, ${o.notPlayedColor})`
    ].join(","),
    backgroundSize: `${e}% 100%, ${t}% 100%, 100%`
  };
}
function O0(t, e) {
  return {
    bufferColor: t === "dark" ? "rgb(133,146,160)" : "rgb(204,207,210)",
    notPlayedColor: t === "dark" ? "rgb(51,73,97)" : "rgb(153,159,165)",
    playedColor: e
  };
}
const gc = ({ uiMode: t, primaryColor: e }) => {
  var q, ue;
  const {
    playerState: { durationInSec: o, playerCoordinator: s, playerConfiguration: n, playerStatus: i }
  } = $e(), r = Y(null), a = i === "ERROR", [c, d] = J(0), [l, h] = J(0), [u, p] = J(!1), [v, g] = J(
    ((q = s == null ? void 0 : s.getPlayerData()) == null ? void 0 : q.getCurrentTimeInSec()) ?? 0
  ), [y, b] = J(!1), _ = (ue = s == null ? void 0 : s.getMediaMetaData()) == null ? void 0 : ue.waveformPoints, E = ae(() => o > 0 ? Is(o * (l / 100)) : Is(0), [l, o]), m = ae(() => O0(t, e), [t, e]), P = B((N) => sl(N, r) ?? 0, []), k = B((N) => {
    h(N * 100);
  }, []), A = B(
    (N) => {
      g(N), s == null || s.seek(N);
    },
    [s]
  ), T = B(
    (N) => {
      k(P(N));
    },
    [P, k]
  ), z = B(
    (N) => {
      const se = P(N);
      se && o && (k(se), A(dl(se * o))), p(!1), document.removeEventListener("pointermove", T), document.removeEventListener("pointerup", z), Br() && b(!1), (s == null ? void 0 : s.getPlayerStatus()) === "IDLE" && s.play();
    },
    [
      o,
      P,
      T,
      s,
      A,
      k
    ]
  ), L = B(() => {
    u || b(!1);
  }, [u]), D = B(() => {
    b(!0);
  }, []), R = B(
    (N) => {
      document.addEventListener("pointermove", T), document.addEventListener("pointerup", z), p(!0), T(N);
    },
    [T, z]
  ), M = B(
    (N) => {
      u && N.preventDefault(), k(P(N));
    },
    [P, u, k]
  );
  _e(() => {
    const N = (se) => {
      var ne;
      switch (se.type) {
        case "timeChanged": {
          g(se.playbackPosition);
          break;
        }
        case "loaded":
        case "play":
        case "seeking": {
          g(((ne = s == null ? void 0 : s.getPlayerData()) == null ? void 0 : ne.getCurrentTimeInSec()) ?? 0);
          break;
        }
      }
      d((s == null ? void 0 : s.getBufferLengthInSec()) ?? 0);
    };
    return s == null || s.addEventListener(N), () => {
      const se = (n == null ? void 0 : n.initialSeekTimeInSec) ?? 0, ne = (s == null ? void 0 : s.getBufferLengthInSec()) ?? 0;
      g(se), d(ne), s == null || s.removeEventListener(N);
    };
  }, [n == null ? void 0 : n.initialSeekTimeInSec, s]);
  const W = P0(v, o), oe = n0(c, o), K = a ? void 0 : A0(oe, W, m), X = u ? l : W;
  return /* @__PURE__ */ f.createElement("div", { class: "scrub-bar" }, /* @__PURE__ */ f.createElement(Pn, { content: E, follow: !0, unreachable: !0 }, /* @__PURE__ */ f.createElement(
    "section",
    {
      class: "scrub-bar-section",
      onPointerDown: R,
      onPointerLeave: L,
      onPointerMove: M,
      onPointerOver: D,
      onPointerUp: z,
      onTouchMove: M,
      ref: r
    },
    _ && /* @__PURE__ */ f.createElement("div", { class: "scrub-bar__waveform" }, /* @__PURE__ */ f.createElement(
      L0,
      {
        bufferColor: m.bufferColor,
        bufferPosition: oe,
        notPlayedColor: m.notPlayedColor,
        playbackPosition: W,
        playedColor: m.playedColor,
        points: _
      }
    )),
    /* @__PURE__ */ f.createElement("div", { class: "scrub-bar__rail-container" }, /* @__PURE__ */ f.createElement("div", { "data-rbup-scrub-bar-rail": !0, class: "scrub-bar__rail", style: K }), /* @__PURE__ */ f.createElement(C0, { playbackPositionInPercent: X, show: y }))
  )));
}, R0 = `.scrub-bar{width:100%}.scrub-bar__rail-container{position:relative}.scrub-bar__rail{grid-row:2;height:2px;transition:transform .3s cubic-bezier(0,.32,.32,1);width:100%}.scrub-bar__waveform{grid-row:1;height:20px}.scrub-bar-section{align-items:center;cursor:pointer;display:grid;height:22px;-webkit-user-select:none;user-select:none;font:initial}.default-theme--error-light .scrub-bar__rail{background-color:#000f1e0d}.default-theme--error-dark .scrub-bar__rail{background-color:#ffffff1a}.scrub-bar-section:hover .scrub-bar__rail{transform:scaleY(2)}.default-theme--error-light .scrub-bar,.default-theme--error-dark .scrub-bar{pointer-events:none}.scrub-bar-handle{background:#FFFFFF;border-radius:9999px;box-shadow:0 2px 8px #000f1e;color:#fff;cursor:pointer;height:16px;left:0;opacity:0;position:absolute;top:-8px;transform:translate(-8px);transition:opacity .25s;width:16px}.scrub-bar-handle-visible{opacity:1}.waveform-canvas{height:20px;width:100%}.minimal-audio-player{--rbup-primary-color: #DB0A40}
`;
function D0(t, e, o) {
  const s = `minimal-audio-player ${o}`, n = t === "light" ? "light" : "dark";
  return e ? `${s} default-theme--error-${n}` : s;
}
const M0 = nt((t, e) => {
  const { config: o, dataLoader: s, id: n, internalOnApiAvailable: i, styles: r } = t, {
    init: a,
    playerState: { playerCoordinator: c, uiMode: d, playerStatus: l }
  } = $e(), h = Y(null), u = o, p = lc(h, Kc), g = D0(d, l === "ERROR", p), y = B(
    (E) => {
      E && a(E);
    },
    [a]
  ), b = h.current, _ = b ? getComputedStyle(b).getPropertyValue("--rbup-primary-color") : "#fff";
  return /* @__PURE__ */ f.createElement(f.Fragment, null, /* @__PURE__ */ f.createElement("style", null, r), /* @__PURE__ */ f.createElement("div", { id: n, class: g, ref: h }, u && /* @__PURE__ */ f.createElement(f.Fragment, null, /* @__PURE__ */ f.createElement(
    vc,
    {
      ref: e,
      config: u,
      dataLoader: s,
      onCoordinatorAvailable: y,
      internalOnApiAvailable: i
    }
  ), c && /* @__PURE__ */ f.createElement(gc, { primaryColor: _, uiMode: d }))));
});
nt((t, e) => /* @__PURE__ */ f.createElement(fc, null, /* @__PURE__ */ f.createElement(M0, { ref: e, styles: R0, ...t })));
function bc(t, e) {
  const o = "default-theme";
  return e ? `${o} default-theme--error-${t}` : `${o} default-theme--${t}`;
}
const yc = [
  { placeholder: "/im/", transformation: (t) => `/im:i:${t}/` },
  { placeholder: "/{op}/", transformation: (t) => `/${t}/` }
], br = 240;
function xc(t) {
  return t ? yc.some(({ placeholder: o }) => t.includes(o)) ? {
    defaultRes: yr(t, br * window.devicePixelRatio),
    lowRes: yr(t, Math.floor(br / 4) * devicePixelRatio)
  } : {
    defaultRes: t
  } : void 0;
}
function yr(t, e) {
  return yc.reduce((o, { placeholder: s, transformation: n }) => o.replace(s, n(`c_fill,w_${e},h_${e},q_auto,g_auto,f_auto`)), t);
}
const N0 = () => {
  const {
    playerState: { coverArt: t }
  } = $e(), e = xc(t);
  return /* @__PURE__ */ f.createElement(f.Fragment, null, e && /* @__PURE__ */ f.createElement("section", { "data-rbup-cover-art": !0 }, /* @__PURE__ */ f.createElement(
    Da,
    {
      class: "cover-art",
      image: e.defaultRes,
      imagePreview: e.lowRes,
      imageAlt: ""
    }
  )));
}, Es = "error-cover-art", F0 = ({ uiMode: t }) => {
  const e = `${Es} ${Es}--${t}`;
  return /* @__PURE__ */ f.createElement(f.Fragment, null, /* @__PURE__ */ f.createElement("section", { "data-rbup-cover-art": !0 }, /* @__PURE__ */ f.createElement("div", { class: e }, /* @__PURE__ */ f.createElement(Op, { class: `${Es}__icon` }))));
};
function B0() {
  const t = Z("audio-error-default-title"), e = Z("audio-error-default-description");
  return { title: t, description: e };
}
const U0 = () => {
  const { title: t, description: e } = B0();
  return /* @__PURE__ */ f.createElement("div", { className: "media-info__title" }, /* @__PURE__ */ f.createElement("section", { className: "media-info media-info--center" }, /* @__PURE__ */ f.createElement(Up, { "data-rbup-error-title": !0, size: "x-small" }, t), /* @__PURE__ */ f.createElement(Q, { "data-rbup-error-description": !0, size: "x-small", kind: "subtle" }, e)), /* @__PURE__ */ f.createElement("div", { class: "error-decoration" }, /* @__PURE__ */ f.createElement(Q, { appearance: "light", size: "medium", tag: "span" }, /* @__PURE__ */ f.createElement(cs, { "data-rbup-icon-headphones": !0, class: "error-decoration__headphone-icon" }))));
};
function Rn(t) {
  return t === "light" ? "dark" : "light";
}
const H0 = `.distribution-icons__tooltip{display:flex}.distribution-icons__tooltip-wrapper{width:100%}.distribution-icons__tooltip-wrapper [data-rbup-button]{margin:0 4px}
`, _c = ({ distributions: t, buttonType: e, uiMode: o }) => {
  const [s, n] = J(""), i = B((r) => {
    n(r);
  }, []);
  return /* @__PURE__ */ f.createElement(f.Fragment, null, t.length > 0 && /* @__PURE__ */ f.createElement(f.Fragment, null, /* @__PURE__ */ f.createElement("style", null, H0), /* @__PURE__ */ f.createElement(
    Pn,
    {
      "rbup-distribution-icons-bar": !0,
      class: "distribution-icons__tooltip",
      content: s,
      placement: "above",
      spacing: "tight",
      unreachable: !0,
      follow: !0
    },
    /* @__PURE__ */ f.createElement("div", { class: "distribution-icons__tooltip-wrapper" }, j0(t, i, e, o))
  )));
}, V0 = {
  spotify: "Spotify",
  deezer: "Deezer",
  amazon: "Amazon Music",
  "google-podcasts": "Google Podcasts",
  itunes: "Apple Podcasts"
};
function j0(t, e, o, s) {
  const n = s && Rn(s);
  return t.map((i, r) => /* @__PURE__ */ f.createElement(
    Sn,
    {
      "data-rbup-button": !0,
      href: i.url,
      kind: o,
      shape: "circle",
      size: "small",
      target: "_blank",
      ariaLabel: i.platform,
      appearance: n,
      onPointerEnter: () => {
        e(V0[i.platform] ?? Z("audio-podcast-listenOn"));
      },
      key: r
    },
    W0(i.platform)
  ));
}
function W0(t) {
  const e = "distribution-icons__icons";
  switch (t) {
    case "spotify":
      return /* @__PURE__ */ f.createElement(Mp, { "data-rbup-icon-spotify": !0, class: e, slot: "icon" });
    case "google-podcasts":
      return /* @__PURE__ */ f.createElement(Ap, { "data-rbup-icon-google-podcasts": !0, class: e, slot: "icon" });
    case "deezer":
      return /* @__PURE__ */ f.createElement(Ip, { "data-rbup-icon-deezer": !0, class: e, slot: "icon" });
    case "amazon":
      return /* @__PURE__ */ f.createElement(Sp, { "data-rbup-icon-amazon-music": !0, class: e, slot: "icon" });
    case "itunes":
      return /* @__PURE__ */ f.createElement(Pp, { "data-rbup-icon-apple-podcasts": !0, class: e, slot: "icon" });
  }
  return null;
}
const wc = ["spotify", "google-podcasts", "deezer", "amazon", "itunes"], kc = ({ isPlayerSizeLarge: t }) => {
  const {
    playerState: { mediaMetaData: e }
  } = $e(), o = ae(
    () => {
      var n;
      return ((n = e == null ? void 0 : e.distributions) == null ? void 0 : n.filter(
        (i) => wc.includes(i.platform)
      )) ?? [];
    },
    [e]
  ), s = t ? "bare" : "tertiary";
  return /* @__PURE__ */ f.createElement("div", { class: "listen-on", "data-rbup-listen-on": !0 }, /* @__PURE__ */ f.createElement(Q, { "data-rbup-listen-on-label": !0, class: "listen-on__label", size: "x-small", kind: "subtle" }, Z("audio-podcast-listenOn")), o.length > 0 && /* @__PURE__ */ f.createElement(_c, { distributions: o, buttonType: s }), o.length === 0 && /* @__PURE__ */ f.createElement(Sn, { "data-rbup-button": !0, kind: s, shape: "circle", size: "small" }, /* @__PURE__ */ f.createElement(cs, { "data-rbup-icon-headphones": !0, slot: "icon" })));
};
function zc(t) {
  const e = Math.floor(t / 3600), o = Math.floor(t / 60) - e * 60, s = Math.floor(t) % 60;
  return e < 1 ? `${Ke(o)}:${Ke(s)} ${Z("audio-duration-minute")}` : `${e} ${Z("audio-duration-hour")} ${Ke(o)} ${Z(
    "audio-duration-minute"
  )}`;
}
const Jt = ({ classesString: t = "" }) => /* @__PURE__ */ f.createElement("li", { class: `media-info__separator ${t}`, "aria-hidden": !0 }, /* @__PURE__ */ f.createElement(Q, { kind: "subtle", size: "x-small", tag: "span" }, "·")), Dn = ({
  dataAttribute: t,
  title: e,
  url: o,
  cosmosTextProps: s,
  clickCallback: n
}) => /* @__PURE__ */ f.createElement(Q, { ...s }, o ? /* @__PURE__ */ f.createElement(Np, { [t]: !0, href: o, target: "_blank", onClick: n }, e) : e), q0 = ({
  onClickCallback: t,
  podcastTitle: e,
  podcastShowPageUrl: o
}) => /* @__PURE__ */ f.createElement("div", { class: "media-info__podcast-title" }, /* @__PURE__ */ f.createElement(
  Dn,
  {
    dataAttribute: "data-rbup-podcast-title",
    title: e,
    url: o,
    cosmosTextProps: { clamp: 2, kind: "subtle", size: "x-small", tag: "h2" },
    clickCallback: () => t("Show", e)
  }
)), G0 = ({
  onClickCallback: t,
  podcastEpisodeTitle: e,
  episodePageUrl: o
}) => /* @__PURE__ */ f.createElement(f.Fragment, null, e && /* @__PURE__ */ f.createElement("div", { class: "media-info__title" }, /* @__PURE__ */ f.createElement(
  Dn,
  {
    dataAttribute: "data-rbup-media-info-title",
    title: e,
    url: o,
    cosmosTextProps: { clamp: 2, size: "x-large", tag: "h1", weight: "bold" },
    clickCallback: () => t("Episode", e)
  }
))), Z0 = ({
  onClickCallback: t,
  podcastShowTitle: e,
  podcastShowPageUrl: o,
  seasonText: s,
  episodeText: n,
  publishedAt: i,
  showHeadphoneIcon: r
}) => {
  const a = !!(s ?? n ?? i);
  return /* @__PURE__ */ f.createElement("ul", { "data-rbup-podcast-data": !0, class: "media-info__data-list" }, e && /* @__PURE__ */ f.createElement(f.Fragment, null, /* @__PURE__ */ f.createElement("li", { class: "media-info__data-list-title" }, /* @__PURE__ */ f.createElement(
    Dn,
    {
      dataAttribute: "data-rbup-podcast-list-title",
      title: e,
      url: o,
      cosmosTextProps: { clamp: 2, kind: "subtle", size: "x-small", tag: "h2" },
      clickCallback: () => t("Show", e)
    }
  )), a && /* @__PURE__ */ f.createElement(Jt, { classesString: "media-info__data-list-title" })), s && /* @__PURE__ */ f.createElement(f.Fragment, null, /* @__PURE__ */ f.createElement("li", { class: "media-info__data-list-item", "data-rbup-podcast-season": !0 }, /* @__PURE__ */ f.createElement(Q, { kind: "subtle", size: "x-small", tag: "span" }, s)), /* @__PURE__ */ f.createElement(Jt, null)), n && /* @__PURE__ */ f.createElement(f.Fragment, null, /* @__PURE__ */ f.createElement("li", { class: "media-info__data-list-item", "data-rbup-podcast-episode": !0 }, /* @__PURE__ */ f.createElement(Q, { kind: "subtle", size: "x-small", tag: "span" }, n)), /* @__PURE__ */ f.createElement(Jt, null)), i && /* @__PURE__ */ f.createElement(f.Fragment, null, /* @__PURE__ */ f.createElement("li", { class: "media-info__data-list-item", "data-rbup-podcast-published-date": !0 }, /* @__PURE__ */ f.createElement(Q, { kind: "subtle", size: "x-small", tag: "span" }, r && /* @__PURE__ */ f.createElement(cs, { "data-rbup-icon-headphones": !0, class: "media-info__headphone-icon" }), i)), /* @__PURE__ */ f.createElement(Jt, null)));
}, Y0 = ({ duration: t }) => /* @__PURE__ */ f.createElement("ul", { "data-rbup-podcast-data": !0, class: "media-info__data-list" }, /* @__PURE__ */ f.createElement("li", { className: "media-info__data-list-item", "data-rbup-audio-headphones": !0 }, /* @__PURE__ */ f.createElement(Q, { kind: "subtle", size: "x-small", tag: "span" }, /* @__PURE__ */ f.createElement(cs, { "data-rbup-icon-headphones": !0, class: "media-info__headphone-icon" }))), /* @__PURE__ */ f.createElement("li", { className: "media-info__data-list-item", "data-rbup-audio-audioclip-header": !0 }, /* @__PURE__ */ f.createElement(Q, { kind: "subtle", size: "x-small", tag: "span" }, "Audioclip")), /* @__PURE__ */ f.createElement(Jt, null), t && /* @__PURE__ */ f.createElement("li", { className: "media-info__data-list-item", "data-rbup-audio-duration": !0 }, /* @__PURE__ */ f.createElement(Q, { kind: "subtle", size: "x-small", tag: "span" }, t)));
function K0(t) {
  const e = t == null ? void 0 : t.coverArt, o = t == null ? void 0 : t.podcastTitle, s = t == null ? void 0 : t.podcastShowPageUrl, n = t == null ? void 0 : t.title, i = t == null ? void 0 : t.episodePageUrl, r = t == null ? void 0 : t.episodeNumber, a = t == null ? void 0 : t.seasonNumber, c = t != null && t.publishedAt ? new Intl.DateTimeFormat("default", { day: "numeric", month: "short", year: "numeric" }).format(
    new Date(t.publishedAt)
  ) : void 0, d = t == null ? void 0 : t.duration, l = d ? zc(d) : void 0, h = t == null ? void 0 : t.description;
  return {
    coverArt: e,
    podcastTitle: o,
    podcastShowPageUrl: s,
    publishedAt: c,
    seasonNumber: a,
    episodeNumber: r,
    episodeTitle: n,
    episodePageUrl: i,
    duration: l,
    description: h,
    hasPodcastData: !!(o ?? a ?? r ?? c)
  };
}
const X0 = (t, e, o) => !(!o || !t || e), J0 = ({ showAudioClipMediaInfo: t = !1 }) => {
  const {
    playerState: { mediaMetaData: e, playerCoordinator: o }
  } = $e(), {
    coverArt: s,
    podcastTitle: n,
    podcastShowPageUrl: i,
    publishedAt: r,
    seasonNumber: a,
    episodeNumber: c,
    episodeTitle: d,
    episodePageUrl: l,
    duration: h,
    description: u,
    hasPodcastData: p
  } = K0(e), v = c ? Z("audio-mediaInfo-episodeText", { episodeNumber: `${c}` }) : void 0, g = a ? Z("audio-mediaInfo-seasonText", { seasonNumber: `${a}` }) : void 0, b = X0(t, u, s) ? "media-info media-info--center" : "media-info", _ = B(
    (E, m) => {
      o == null || o.dispatchPlayerEvent({
        type: "podcastTitleClick",
        titleType: E,
        titleText: m,
        playerId: o.playerId
      });
    },
    [o]
  );
  return /* @__PURE__ */ f.createElement("section", { class: b }, /* @__PURE__ */ f.createElement("div", { class: "media-info__podcast-data" }, n && /* @__PURE__ */ f.createElement(
    q0,
    {
      podcastTitle: n,
      podcastShowPageUrl: i,
      onClickCallback: _
    }
  ), p && /* @__PURE__ */ f.createElement(
    Z0,
    {
      podcastShowTitle: n,
      podcastShowPageUrl: i,
      episodeText: v,
      seasonText: g,
      publishedAt: r,
      showHeadphoneIcon: t,
      onClickCallback: _
    }
  ), t && /* @__PURE__ */ f.createElement(Y0, { duration: h })), /* @__PURE__ */ f.createElement(
    G0,
    {
      podcastEpisodeTitle: d,
      episodePageUrl: l,
      onClickCallback: _
    }
  ), u && /* @__PURE__ */ f.createElement(Q0, { description: u }));
}, Q0 = ({ description: t }) => {
  const [e, o] = J(!0), [s, n] = J(), i = Y(null);
  dc(() => {
    var d, l, h;
    const c = (h = (l = (d = i.current) == null ? void 0 : d.querySelector(".media-info__description--text")) == null ? void 0 : l.shadowRoot) == null ? void 0 : h.querySelector("p");
    c && (n(c.scrollHeight), c.scrollHeight === c.clientHeight && o(!1));
  }, i);
  const a = (c) => {
    o(!1), c.stopPropagation();
  };
  return /* @__PURE__ */ f.createElement(
    "div",
    {
      ref: i,
      onpointerup: Br() ? a : (c) => c.stopPropagation(),
      style: { "--media-info-description-max-height": `${s}px` },
      class: e ? "media-info__description" : "media-info__description media-info__description--expanded"
    },
    /* @__PURE__ */ f.createElement(
      Q,
      {
        class: "media-info__description--text",
        kind: "subtle",
        size: "x-small",
        tag: "p",
        clamp: e && 2
      },
      t
    ),
    e && /* @__PURE__ */ f.createElement(
      Q,
      {
        class: "media-info__description--expand-icon",
        kind: "normal",
        size: "x-small",
        tag: "span",
        onPointerup: a
      },
      /* @__PURE__ */ f.createElement(Tp, null)
    )
  );
}, eg = ({ cssClass: t, onTooltipUpdate: e }) => {
  const {
    playerState: { playerStatus: o, playerCoordinator: s }
  } = $e(), n = o === "PLAYING", i = o === "ENDED", r = n ? "data-rbup-pause" : "data-rbup-play", a = tg(t, n, i), c = og(n, i), d = B(() => {
    s && o === "ENDED" ? (s.restartPlaybackFromBeginning(), s.play()) : il(o, s);
  }, [o, s]), l = n ? "--rbup-play-button-background-hover-color: initial" : "";
  return /* @__PURE__ */ f.createElement(
    Ys,
    {
      style: l,
      dataAttribute: r,
      Icon: a,
      label: c,
      onPointerUp: d,
      tooltipText: c,
      onTooltipUpdate: e,
      kind: n ? "bare" : "primary"
    }
  );
};
function tg(t, e, o) {
  return e ? /* @__PURE__ */ f.createElement(Rp, { "data-rbup-icon-pause": !0, class: `${t}`, slot: "icon" }) : o ? /* @__PURE__ */ f.createElement(Dp, { "data-rbup-icon-replay": !0, class: `${t}`, slot: "icon" }) : /* @__PURE__ */ f.createElement(Ra, { "data-rbup-icon-play": !0, class: `${t}`, slot: "icon" });
}
function og(t, e) {
  return Z(t ? "tooltip-pause" : e ? "tooltip-replay" : "tooltip-play");
}
const sg = () => {
  const {
    playerState: { playerStatus: t, playerCoordinator: e }
  } = $e(), o = t === "BUFFERING", s = !!(e != null && e.canSeekBackward()), n = !!(e != null && e.canSeekForward()), [i, r] = J(""), a = B(() => {
    e == null || e.seekRelative(jn);
  }, [e]), c = B(() => {
    e == null || e.seekRelative(-jn);
  }, [e]), d = B((l) => {
    r(l);
  }, []);
  return /* @__PURE__ */ f.createElement("section", { "data-rbup-play-controls": !0 }, /* @__PURE__ */ f.createElement(
    Pn,
    {
      class: "cosmos-tooltip",
      content: i,
      placement: "above",
      spacing: "tight",
      unreachable: !0,
      follow: !0,
      offset: 30
    },
    /* @__PURE__ */ f.createElement("div", { class: "play-seek-controls__play-seek-pause-container", "data-rbup-seek-pause-container": !0 }, /* @__PURE__ */ f.createElement(
      Ys,
      {
        dataAttribute: "data-rbup-seek-back",
        disabled: !s,
        Icon: /* @__PURE__ */ f.createElement(Cp, { "data-rbup-icon-back-10": !0, class: "play-seek-controls__icon", slot: "icon" }),
        label: Z("tooltip-rewind"),
        onPointerUp: c,
        tooltipText: Z("tooltip-rewind"),
        onTooltipUpdate: d,
        kind: "bare"
      }
    ), o && /* @__PURE__ */ f.createElement(Bp, { "data-rbup-buffer": !0, class: "play-seek-controls__spinner", label: "Buffering" }), !o && /* @__PURE__ */ f.createElement(eg, { cssClass: "play-seek-controls__icon", onTooltipUpdate: d }), /* @__PURE__ */ f.createElement(
      Ys,
      {
        dataAttribute: "data-rbup-seek-forward",
        disabled: !n,
        Icon: /* @__PURE__ */ f.createElement(
          Lp,
          {
            "data-rbup-icon-forward-10": !0,
            class: "play-seek-controls__icon",
            slot: "icon"
          }
        ),
        label: Z("tooltip-forward"),
        onPointerUp: a,
        tooltipText: Z("tooltip-forward"),
        onTooltipUpdate: d,
        kind: "bare"
      }
    ))
  ));
}, xr = () => {
  const {
    playerState: { durationInSec: t, playbackPosInSec: e }
  } = $e(), o = isNaN(e) || e > t ? 0 : t - e, s = `-${Is(o)}`;
  return /* @__PURE__ */ f.createElement("section", { "data-rbup-remaining-time-display": !0, class: "remaining-time" }, /* @__PURE__ */ f.createElement(Q, { "data-rbup-text": !0, size: "xx-small" }, s));
}, ng = `:host,:root{all:initial}@font-face{font-family:Bull Text;font-style:normal;font-weight:400;font-display:swap;src:url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/BullText-Regular.woff2) format("woff2"),url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/BullText-Regular.woff) format("woff")}@font-face{font-family:Bull Text;font-style:normal;font-weight:500;font-display:swap;src:url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/BullText-Medium.woff2) format("woff2"),url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/BullText-Medium.woff) format("woff")}@font-face{font-family:Bull Text;font-style:normal;font-weight:700;font-display:swap;src:url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/BullText-Bold.woff2) format("woff2"),url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/BullText-Bold.woff) format("woff")}@font-face{font-family:Bull;font-style:normal;font-weight:700;font-display:swap;src:url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/Bull-Bold.woff2) format("woff2"),url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/Bull-Bold.woff) format("woff")}@font-face{font-family:Bull;font-style:normal;font-weight:800;font-display:swap;src:url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/Bull-Heavy1.woff2) format("woff2"),url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/Bull-Heavy1.woff) format("woff")}@font-face{font-family:Bull VF;font-style:normal;font-weight:300 800;font-display:swap;src:url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/BullVAR.woff2) format("woff2-variations"),url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/BullVAR.woff2) format("woff2")}.cover-art{border-radius:8px}.error-cover-art{display:flex;justify-content:center;align-items:center;height:100%;border-radius:8px}.error-cover-art__icon{width:32px;height:32px;flex-shrink:0}.error-cover-art--light{background-color:#000f1e0d}.error-cover-art--light .error-cover-art__icon{color:#000f1e33}.error-cover-art--dark{background-color:#ffffff0d}.error-cover-art--dark .error-cover-art__icon{color:#fff3}.error-decoration{align-items:center;justify-content:flex-end;flex-grow:1;padding-right:4px;display:none}.default-theme--error-light .media-info--center,.default-theme--error-dark .media-info--center{gap:4px}.default-theme--error-light .media-info__title,.default-theme--error-dark .media-info__title{height:auto}.default-theme--error-light .error-decoration__headphone-icon{color:#000f1e1a}.default-theme--error-dark .error-decoration__headphone-icon{color:#ffffff1a}.cq-650 .error-decoration{display:flex}.listen-on{align-items:center;display:flex;flex-direction:column;justify-content:center}.listen-on__label{margin:0 0 12px}.listen-on__platforms{height:100%}.listen-on .distribution-icons__icons{width:20px;height:20px;color:#fff9}.cq-900 .listen-on{flex-direction:row;justify-content:flex-start}.cq-900 .listen-on__label{margin:0 4px 0 0}.default-theme--light .listen-on .distribution-icons__icons{color:#000f1e99}.play-seek-controls__play-seek-pause-container{align-items:center;display:flex;gap:12px}.play-seek-controls__play-seek-pause-container .play-seek-controls__icon{height:28px;width:28px}.play-seek-controls__play-seek-pause-container [data-rbup-pause]::part(base),.play-seek-controls__play-seek-pause-container [data-rbup-play]::part(base){height:56px;max-width:56px;min-width:56px;width:56px}.play-seek-controls__play-seek-pause-container [data-rbup-pause]{--cosmos-button-background-hover: var(--rbup-play-button-background-hover-color)}.play-seek-controls__play-seek-pause-container [data-rbup-play]{--cosmos-button-background: var(--rbup-primary-color);--cosmos-button-background-hover: var(--rbup-play-button-background-hover-color)}.play-seek-controls__play-seek-pause-container .play-seek-controls__spinner{width:56px;height:56px}.default-theme--error-light .play-seek-controls__play-seek-pause-container,.default-theme--error-dark .play-seek-controls__play-seek-pause-container{pointer-events:none}.default-theme--error-light .play-seek-controls__play-seek-pause-container [data-rbup-play]{--cosmos-button-background: rgba(0, 15, 30, .05)}.default-theme--error-light .play-seek-controls__play-seek-pause-container [data-rbup-seek-back],.default-theme--error-light .play-seek-controls__play-seek-pause-container [data-rbup-seek-forward]{--cosmos-button-color: rgba(0, 15, 30, .05)}.default-theme--error-dark .play-seek-controls__play-seek-pause-container [data-rbup-play]{--cosmos-button-background: rgba(255, 255, 255, .1);--cosmos-button-color: #000F1E}.default-theme--error-dark .play-seek-controls__play-seek-pause-container [data-rbup-seek-back],.default-theme--error-dark .play-seek-controls__play-seek-pause-container [data-rbup-seek-forward]{--cosmos-button-color: rgba(255, 255, 255, .1)}.scrub-bar{width:100%}.scrub-bar__rail-container{position:relative}.scrub-bar__rail{grid-row:2;height:2px;transition:transform .3s cubic-bezier(0,.32,.32,1);width:100%}.scrub-bar__waveform{grid-row:1;height:20px}.scrub-bar-section{align-items:center;cursor:pointer;display:grid;height:22px;-webkit-user-select:none;user-select:none;font:initial}.default-theme--error-light .scrub-bar__rail{background-color:#000f1e0d}.default-theme--error-dark .scrub-bar__rail{background-color:#ffffff1a}.scrub-bar-section:hover .scrub-bar__rail{transform:scaleY(2)}.default-theme--error-light .scrub-bar,.default-theme--error-dark .scrub-bar{pointer-events:none}.scrub-bar-handle{background:#FFFFFF;border-radius:9999px;box-shadow:0 2px 8px #000f1e;color:#fff;cursor:pointer;height:16px;left:0;opacity:0;position:absolute;top:-8px;transform:translate(-8px);transition:opacity .25s;width:16px}.scrub-bar-handle-visible{opacity:1}.media-info{align-items:center;display:flex;flex-direction:column;gap:10px}.media-info__podcast-data{align-items:center;display:flex;flex-direction:column;gap:4px}.media-info__data-list{align-items:baseline;display:flex;list-style:none;margin:0;padding:0}.media-info__data-list>*:not(:first-child){margin-left:4px}.media-info__data-list>*:not(:last-child){margin-right:4px}.media-info__separator:last-child{display:none}.media-info__data-list-title{display:none}.media-info__title{height:60px;text-align:center;align-content:center}.media-info__description{display:flex;max-height:2.5rem;overflow:hidden;transition:max-height 333ms cubic-bezier(.4,0,.22,1)}.media-info__description--expanded{max-height:var(--media-info-description-max-height, 10rem)}.media-info__description--text{text-align:center}.media-info__description--expand-icon{align-self:flex-end;margin-bottom:-4px;padding:2px}.cq-650 .media-info{align-items:start}.cq-650 .media-info__data-list-title{display:flex}.cq-650 .media-info__podcast-data{align-items:flex-start;flex-direction:row}.cq-650 .media-info__podcast-title{display:none}.cq-650 .media-info__title{text-align:start;height:auto}.cq-650 .media-info--center{position:absolute;bottom:50%;transform:translateY(calc(50% - 14px));margin-right:20px}.cq-650 .media-info__description--text{text-align:start}.waveform-canvas{height:20px;width:100%}.remaining-time{word-break:normal}.default-theme--error-light .remaining-time,.default-theme--error-dark .remaining-time{display:none}.themed-audio-player{--rbup-primary-color: #DB0A40}.themed-audio-player__grid{display:grid;gap:24px}.themed-audio-player__grid.cq-1150{grid-template-areas:". . playlist"}.default-theme{background-color:#001c39;border-radius:8px;box-shadow:0 0 30px #000f1e99}.default-theme *{box-sizing:border-box}.default-theme__grid{display:grid;position:relative;grid-template-areas:". . ." ". cover-image ." ". media-info ." ". controls ." ". scrub-bar ." "listen-on listen-on listen-on";gap:16px}.default-theme__grid--no-cover{grid-template-areas:". . ." "media-info media-info media-info" ". controls ." "scrub-bar scrub-bar scrub-bar" "listen-on listen-on listen-on";padding:16px}.default-theme__controls{align-items:center;display:flex;flex-direction:column;gap:16px;grid-area:controls;margin-top:-16px;margin-bottom:-16px}.default-theme__cover-image{grid-area:cover-image;justify-self:center;margin:16px}.default-theme__cover-image>section{height:135px;width:135px}.default-theme__media-info{grid-area:media-info}.default-theme__scrub-bar{align-self:center;grid-area:scrub-bar;justify-self:stretch}.default-theme__listen-on{grid-area:listen-on;background-color:#ffffff0d;border-radius:0 0 8px 8px;padding:16px}.default-theme__listen-on-with-media-info{display:none;margin-top:8px}.default-theme__scrub-bar-time{align-items:center;display:none;height:22px}.default-theme__scrub-bar--with-waveform .default-theme__scrub-bar-time{align-items:flex-end}.cq-650 .default-theme__grid{grid-template-areas:". . . . ." ". cover-image media-info media-info ." ". cover-image scrub-bar controls ." "listen-on listen-on listen-on listen-on listen-on";grid-template-columns:0 200px auto 176px 0}.cq-650 .default-theme__grid--no-cover{grid-template-areas:". . . ." ". media-info media-info ." ". scrub-bar controls ." "listen-on listen-on listen-on listen-on";grid-template-columns:0 auto 176px 0;min-height:175px;gap:16px 24px;padding:16px 0}.cq-650 .default-theme__controls{align-self:end;justify-self:end;margin-bottom:0}.cq-650 .default-theme__controls-time{display:none}.cq-650 .default-theme__cover-image{justify-self:start;margin:0 8px 0 0}.cq-650 .default-theme__cover-image>section{height:200px;width:200px}.cq-650 .default-theme__scrub-bar{align-items:end;align-self:end;display:flex;gap:16px;margin:0 0 8px}.cq-650 .default-theme__listen-on{padding:12px 16px 24px}.cq-650 .default-theme__scrub-bar-time{display:flex}.cq-900 .default-theme__grid{grid-template-columns:0 240px auto 176px 0}.cq-900 .default-theme__grid--no-cover{grid-template-columns:0 auto 176px 0}.cq-900 .default-theme__cover-image>section{height:240px;width:240px}.cq-900 .default-theme__listen-on{display:none}.cq-900 .default-theme__listen-on-with-media-info{display:block}.default-theme--light{background-color:#fff;box-shadow:0 0 30px #000f1e33}.default-theme--light .default-theme__listen-on{background-color:#000f1e0d}.default-theme--error-light{background-color:#efefef}.default-theme--error-dark{background-color:#001c39}
`, Qt = {
  small: 540,
  medium: 650,
  large: 900,
  "x-large": 1150
}, ig = [
  Qt.small,
  Qt.medium,
  Qt.large,
  Qt["x-large"]
];
function rg(t, e) {
  const o = t.findIndex((s) => s.megaphoneEpisodeId === e);
  if (o !== t.length - 1)
    return t[o + 1];
}
const ag = async (t, e) => {
  if (!t || !e)
    return;
  const o = t.getMediaMetaData(), s = o == null ? void 0 : o.playlist, n = o == null ? void 0 : o.megaphoneEpisodeId;
  if (!s || !n)
    return;
  const i = rg(s, n);
  if (!i)
    return;
  jr("NEXT_EPISODE_TRIGGERED_AUTOMATICALLY", t);
  const r = { ...e, assetId: i.megaphoneEpisodeId };
  await t.load(r);
}, cg = async (t) => {
  await (t == null ? void 0 : t.play());
}, $s = {
  playbackFinished: ag,
  loaded: cg
}, lg = (t, e) => {
  _e(() => {
    if (t) {
      const o = (s) => {
        var n;
        (n = $s[s.type]) == null || n.call($s, t, e);
      };
      return t.addEventListener(o), () => {
        t.removeEventListener(o);
      };
    }
  }, [e, t]);
}, dg = `@charset "UTF-8";.playlist-item{display:grid;grid-template-areas:"cover-art description";grid-template-columns:auto 1fr;height:108px;padding:16px;gap:16px;cursor:pointer}.playlist-item:hover{background-color:#ffffff1a}.playlist-item__data-list{display:grid;grid-template-columns:repeat(3,max-content);gap:0}.playlist-item__data-list--episode:after,.playlist-item__data-list--publishing-date:after{content:"•";margin:0 8px}.playlist-item__description{grid-area:description;display:flex;flex-direction:column;gap:4px;justify-content:center}.playlist-item__description--currently-playing{--cosmos-text-color: #E06600}.playlist-item__cover-art{grid-area:cover-art;width:76px;height:76px}.playlist-item__title{display:grid}.default-theme .playlist-item__data-list{color:#fff9}.default-theme--light .playlist-item:hover{background-color:#000f1e1a}.default-theme--light .playlist-item__data-list{color:#000f1e99}.themed-audio-player__playlist{position:relative;border-radius:8px;width:100%;-webkit-user-select:none;user-select:none;overflow:hidden}.themed-audio-player__playlist-elements::-webkit-scrollbar{width:4px}.themed-audio-player__playlist-elements::-webkit-scrollbar-track{background-color:transparent}.themed-audio-player__playlist-elements::-webkit-scrollbar-thumb{background-color:#fff9;border-radius:8px}.default-theme{background-color:#001c39}.default-theme--light{background-color:#fff}.default-theme--light .themed-audio-player__playlist-elements::-webkit-scrollbar-thumb{background-color:#000f1e99}.cq-1150 .themed-audio-player__playlist{width:448px;height:272px}.cq-1150 .themed-audio-player__playlist-elements{height:100%;overflow-x:hidden;overflow-y:scroll}
`, ug = `.themed-audio-player__playlist-elements-footer{display:flex;align-items:center;flex-direction:column;padding:24px 16px;background-color:#000f1e0d;gap:8px;border-top:1px solid rgba(0,15,30,.1)}.themed-audio-player__playlist-elements-footer .distribution-icons__tooltip-wrapper{display:flex;gap:4px}.themed-audio-player__playlist-elements-footer .distribution-icons__tooltip-wrapper>*{background:#F8F8F8;border-radius:50%}.themed-audio-player__playlist-elements-footer .distribution-icons__tooltip-wrapper .distribution-icons__icons{width:18px;height:18px;color:#000f1e}.default-theme--dark .themed-audio-player__playlist-elements-footer{background-color:#ffffff0d;border-color:#ffffff1a}.default-theme--dark .themed-audio-player__playlist-elements-footer .distribution-icons__tooltip-wrapper>*{background:rgba(0,15,30,.45)}.default-theme--dark .themed-audio-player__playlist-elements-footer .distribution-icons__tooltip-wrapper>* .distribution-icons__icons{color:#fff}
`, mg = ({
  remainingEpisodeCount: t,
  distributions: e,
  uiMode: o
}) => {
  const s = fg(t);
  return e != null && e.length ? /* @__PURE__ */ f.createElement(f.Fragment, null, /* @__PURE__ */ f.createElement("style", null, ug), /* @__PURE__ */ f.createElement("div", { class: "themed-audio-player__playlist-elements-footer" }, /* @__PURE__ */ f.createElement(
    Q,
    {
      size: "x-small",
      kind: "normal",
      weight: "bold",
      appearance: Rn(o)
    },
    s
  ), /* @__PURE__ */ f.createElement(_c, { distributions: e, buttonType: "tertiary", uiMode: o }))) : null;
};
function fg(t) {
  return t === 0 || t === void 0 ? Z("audio-podcast-playlist-all-episodes-on") : t === 1 ? Z("audio-podcast-playlist-additional-episodes-on", {
    additionalEpisodes: `${t}`
  }) : Z("audio-podcast-playlist-additional-episodes-on_plural", {
    additionalEpisodes: `${t}`
  });
}
function pg(t) {
  try {
    return new Intl.DateTimeFormat(navigator.language, {
      day: "numeric",
      month: "long",
      year: "numeric"
    }).format(new Date(t));
  } catch {
    return "Invalid Date";
  }
}
const hg = () => /* @__PURE__ */ f.createElement(
  Q,
  {
    "data-rbup-audio-playlist-item-currently-playing": !0,
    class: "playlist-item__description--currently-playing",
    size: "x-small",
    tag: "span",
    weight: "medium"
  },
  /* @__PURE__ */ f.createElement(Ra, null),
  " ",
  Z("audio-podcast-currently-playing")
), Ss = ({
  classNamePostfix: t,
  text: e,
  appearance: o
}) => {
  const s = `playlist-item__data-list--${t}`, n = { [`data-rbup-audio-playlist-item-${t}`]: !0 };
  return /* @__PURE__ */ f.createElement(
    Q,
    {
      ...n,
      class: s,
      size: "x-small",
      tag: "span",
      kind: "subtle",
      weight: "medium",
      appearance: o
    },
    e
  );
}, vg = ({
  currentlyPlaying: t,
  data: e,
  episodeIndex: o,
  onPointerUp: s,
  uiMode: n
}) => {
  const { coverArt: i, title: r, publishedAt: a, duration: c, megaphoneEpisodeId: d } = e, l = xc(i), h = Rn(n), u = zc(c), p = pg(a);
  return /* @__PURE__ */ f.createElement(
    "div",
    {
      "data-rbup-audio-playlist-item-currently-playing": t,
      "data-rbup-audio-playlist-item": !0,
      class: "playlist-item",
      role: "button",
      onPointerUp: () => s(d)
    },
    l && /* @__PURE__ */ f.createElement(
      Da,
      {
        "data-rbup-audio-playlist-item-cover-art": !0,
        class: "playlist-item__cover-art",
        image: l.defaultRes,
        imagePreview: l.lowRes,
        imageAlt: r
      }
    ),
    /* @__PURE__ */ f.createElement("div", { class: "playlist-item__description" }, t && /* @__PURE__ */ f.createElement(hg, null), /* @__PURE__ */ f.createElement("div", { class: "playlist-item__data-list" }, o && /* @__PURE__ */ f.createElement(Ss, { classNamePostfix: "episode", text: o, appearance: h }), /* @__PURE__ */ f.createElement(
      Ss,
      {
        classNamePostfix: "publishing-date",
        text: p,
        appearance: h
      }
    ), /* @__PURE__ */ f.createElement(Ss, { classNamePostfix: "duration", text: `${u}`, appearance: h })), /* @__PURE__ */ f.createElement(
      Q,
      {
        "data-rbup-audio-playlist-item-title": !0,
        class: "playlist-item__title",
        size: "x-small",
        weight: "bold",
        appearance: h,
        clamp: 2
      },
      r
    ))
  );
};
function gg(t) {
  return t === void 0 || t < 0 ? void 0 : `E${t < 10 ? "0" : ""}${t}`;
}
function bg(t) {
  const o = ["themed-audio-player__playlist"], s = bc(t, !1);
  return [...o, s].join(" ");
}
const yg = ({ config: t }) => {
  const e = Y(null), {
    playerState: { uiMode: o, mediaMetaData: s, playerCoordinator: n }
  } = $e(), {
    totalNumberOfEpisodes: i,
    distributions: r,
    playlist: a,
    megaphoneEpisodeId: c
  } = s ?? {}, d = Fr(t.theme), l = bg(o), h = a && i ? i - a.length : void 0, u = ae(
    () => (r == null ? void 0 : r.filter((v) => wc.includes(v.platform))) ?? [],
    [r]
  ), p = B(
    (v) => {
      if (n) {
        jr("NEXT_EPISODE_TRIGGERED_BY_USER_INTERACTION", n);
        const g = { ...t, assetId: v };
        n.load(g);
      }
    },
    [t, n]
  );
  return _e(() => {
    const v = e.current;
    if (!v)
      return;
    const g = v.querySelector(
      '[data-rbup-audio-playlist-item-currently-playing="true"]'
    );
    if (g) {
      const y = v.getBoundingClientRect().top, _ = g.getBoundingClientRect().top - y + v.scrollTop;
      v.scrollTo({ top: _, behavior: "smooth" });
    }
  }, [c]), lg(n, t), /* @__PURE__ */ f.createElement(f.Fragment, null, /* @__PURE__ */ f.createElement("style", null, dg), /* @__PURE__ */ f.createElement("div", { "data-rbup-audio-playlist": !0, class: l }, /* @__PURE__ */ f.createElement(
    "div",
    {
      "data-rbup-audio-playlist-elements": !0,
      class: "themed-audio-player__playlist-elements",
      style: d,
      ref: e
    },
    a == null ? void 0 : a.map((v, g) => /* @__PURE__ */ f.createElement(
      vg,
      {
        currentlyPlaying: v.megaphoneEpisodeId === c,
        data: v,
        episodeIndex: gg(v.episodeNumber),
        key: g,
        uiMode: o,
        onPointerUp: p
      }
    )),
    u.length > 0 && /* @__PURE__ */ f.createElement(
      mg,
      {
        remainingEpisodeCount: h,
        distributions: u,
        uiMode: o
      }
    )
  )));
};
function xg(t) {
  return !!t && t.length > 0;
}
const _g = nt((t, e) => {
  const { config: o, dataLoader: s, id: n, internalOnApiAvailable: i, styles: r, ThemeComponent: a } = t, {
    init: c,
    playerState: { playerCoordinator: d, mediaMetaData: l }
  } = $e(), h = Y(null), [u, p] = J(Pv());
  Sv(() => p(!0));
  const v = o, g = lc(h, ig), y = Kv(g, `${Qt.large}`), b = Fr(v == null ? void 0 : v.theme), _ = xg(l == null ? void 0 : l.playlist), E = _ ? " themed-audio-player__grid" : "", m = B(
    (P) => {
      P && c(P);
    },
    [c]
  );
  return /* @__PURE__ */ f.createElement(f.Fragment, null, /* @__PURE__ */ f.createElement("style", null, r), /* @__PURE__ */ f.createElement(
    "div",
    {
      "data-rbup-themed-audio-player": !0,
      id: n,
      class: `themed-audio-player ${g}${E}`,
      ref: h,
      style: b
    },
    v && /* @__PURE__ */ f.createElement(f.Fragment, null, /* @__PURE__ */ f.createElement(
      vc,
      {
        ref: e,
        config: v,
        dataLoader: s,
        onCoordinatorAvailable: m,
        internalOnApiAvailable: i
      }
    ), d && /* @__PURE__ */ f.createElement(a, { isPlayerSizeLarge: y }), _ && /* @__PURE__ */ f.createElement(yg, { config: v }))
  ));
}), wg = nt((t, e) => /* @__PURE__ */ f.createElement(fc, null, /* @__PURE__ */ f.createElement(_g, { ref: e, ...t })));
function kg(t) {
  const { hasError: e, showAudioClipMediaInfo: o, showListenOn: s, isPlayerSizeLarge: n } = t;
  return /* @__PURE__ */ f.createElement("div", { class: "default-theme__media-info" }, e ? /* @__PURE__ */ f.createElement(U0, null) : /* @__PURE__ */ f.createElement(f.Fragment, null, /* @__PURE__ */ f.createElement(J0, { showAudioClipMediaInfo: o }), /* @__PURE__ */ f.createElement("div", { class: "default-theme__listen-on-with-media-info" }, s && /* @__PURE__ */ f.createElement(kc, { isPlayerSizeLarge: n }))));
}
const zg = ({ isPlayerSizeLarge: t }) => {
  const {
    playerState: { coverArt: e, mediaMetaData: o, uiMode: s, playerStatus: n }
  } = $e(), i = Y(null), r = i.current, a = r ? getComputedStyle(r).getPropertyValue("--rbup-primary-color") : "#fff", c = !!(o != null && o.waveformPoints), d = !!(o != null && o.distributions), l = d, h = !d, u = n === "ERROR", p = bc(s, u), v = ["default-theme__grid", !e && !u && "default-theme__grid--no-cover"].filter(Boolean).join(" ");
  return /* @__PURE__ */ f.createElement("div", { class: p }, /* @__PURE__ */ f.createElement(Fp, { mode: s }, /* @__PURE__ */ f.createElement("div", { class: v, ref: i }, /* @__PURE__ */ f.createElement("div", { class: "default-theme__cover-image" }, u ? /* @__PURE__ */ f.createElement(F0, { uiMode: s }) : e && /* @__PURE__ */ f.createElement(N0, null)), kg({
    hasError: u,
    showAudioClipMediaInfo: h,
    showListenOn: l,
    isPlayerSizeLarge: t
  }), /* @__PURE__ */ f.createElement("div", { class: "default-theme__controls" }, /* @__PURE__ */ f.createElement(sg, null), /* @__PURE__ */ f.createElement("div", { class: "default-theme__controls-time" }, /* @__PURE__ */ f.createElement(xr, null))), /* @__PURE__ */ f.createElement(
    "div",
    {
      class: `default-theme__scrub-bar ${c ? "default-theme__scrub-bar--with-waveform" : ""}`
    },
    /* @__PURE__ */ f.createElement(gc, { uiMode: s, primaryColor: a }),
    /* @__PURE__ */ f.createElement("div", { class: "default-theme__scrub-bar-time" }, /* @__PURE__ */ f.createElement(xr, null))
  ), l && /* @__PURE__ */ f.createElement("div", { class: "default-theme__listen-on" }, /* @__PURE__ */ f.createElement(kc, { isPlayerSizeLarge: t })))));
}, Eg = nt((t, e) => /* @__PURE__ */ f.createElement(wg, { ref: e, styles: ng, ThemeComponent: zg, ...t }));
if (typeof window > "u")
  throw new Error("SSR is not supported");
const $g = {
  customInitAttributes: { content_type: "podcast" }
}, bo = (t, e) => ({
  ...$g,
  playerId: `RBUP_${t}_AUDIO`,
  accountName: `${t}_AUDIO`,
  brand: e
}), Sg = {
  ...bo("Bergwelten", "servus"),
  propertyName: "bergwelten"
}, Pg = {
  ...bo("Servus.com", "servus"),
  propertyName: "servus.com"
}, Cg = {
  ...bo("ServusTV", "servus"),
  propertyName: void 0
}, Tg = {
  ...bo("CarpeDiem", "non-red-bull-branded-sites"),
  propertyName: "carpediem.life"
}, Ig = {
  ...bo("Backend"),
  propertyName: "backend"
};
function Lg(t) {
  switch (t) {
    case "bergwelten":
      return Sg;
    case "carpediem":
      return Tg;
    case "servuscom":
      return Pg;
    case "servustv":
      return Cg;
    case "backend":
      return Ig;
    default:
      throw new Error(`unsupported projectId ${t}`);
  }
}
function Ag(t) {
  switch (t) {
    case "carpediem":
      return {
        primaryColor: "#fbceb4",
        primaryColorHover: "#f8b38b"
      };
    case "servustv":
      return {
        fontFamily: '"Noto Sans", "Bull Text", Helvetica, sans-serif',
        primaryColor: "#C30F24",
        primaryColorHover: "#DE1129"
      };
    case "backend":
    case "bergwelten":
    case "servuscom":
      return;
    default:
      throw new Error(`unsupported projectId ${t}`);
  }
}
function Ec(t) {
  return {
    coverArt: t.coverArt,
    distributions: t.distributions,
    duration: t.duration,
    episodeNumber: t.episodeNumber,
    episodePageUrl: t.episodePageUrl,
    mediaSrc: {
      audioUrl: t.audioUrl,
      mediaType: t.audioMediaType
    },
    podcastTitle: t.podcastTitle,
    podcastShowPageUrl: t.podcastShowPageUrl,
    publishedAt: t.publishedAt,
    seasonNumber: t.seasonNumber,
    title: t.title,
    waveformPoints: t.waveformPoints
  };
}
const Og = "megaphone";
async function Rg(t, e, o) {
  const s = rn(e, o), n = Dg(t), i = Mg(t), r = await fetch(`${s}/${Og}/${n}?${i}`);
  if (r.ok)
    return await r.json();
  throw new Error(`error loading from server ${r.status}`);
}
function Dg(t) {
  const { podcastId: e, episodeId: o } = t;
  return o && e ? "episode" : "latest-episode";
}
function Mg(t) {
  const { episodeId: e, podcastId: o, networkId: s, enablePlaylist: n } = t, i = [];
  return i.push(`fetchPlaylist=${n}`), e && i.push(`episodeId=${e}`), o && i.push(`podcastId=${o}`), s && i.push(`networkId=${s}`), i.join("&");
}
class Ng {
  constructor(e, o) {
    C(this, "initiallyLoaded", !1);
    C(this, "playlist");
    this.requestIds = e, this.prNumber = o;
  }
  async loadData(e) {
    const o = this.resolveRequestIds(e.assetId), s = await Rg(
      o,
      e.environment,
      this.prNumber
    );
    this.playlist = this.resolvePlaylist(s.playlist);
    const n = Ec(s);
    return this.initiallyLoaded = !0, {
      ...n,
      assetId: s.megaphoneEpisodeId,
      megaphoneShowId: s.megaphoneShowId,
      megaphoneNetworkId: s.megaphoneNetworkId,
      megaphoneEpisodeId: s.megaphoneEpisodeId,
      playlist: this.playlist,
      totalNumberOfEpisodes: s.totalNumberOfEpisodes
    };
  }
  resolveRequestIds(e) {
    if (!this.initiallyLoaded)
      return this.requestIds;
    const o = this.resolveEnablePlaylist();
    return {
      ...{ ...this.requestIds, enablePlaylist: o },
      episodeId: e
    };
  }
  resolveEnablePlaylist() {
    return this.initiallyLoaded ? !1 : this.requestIds.enablePlaylist;
  }
  resolvePlaylist(e) {
    return this.playlist ? this.playlist : (this.playlist = e, this.playlist);
  }
}
async function Fg(t, e, o, s = !1) {
  const i = {
    [s ? "showId" : "audioId"]: t
  }, r = rn(e, o), a = await fetch(`${r}/spreaker?${new URLSearchParams(i)}`);
  if (a.ok)
    return await a.json();
  throw new Error(`error loading from server ${a.status}`);
}
class Bg {
  constructor(e, o = !1) {
    this.prNumber = e, this.isPodcastShow = o;
  }
  async loadData(e) {
    const o = await Fg(
      e.assetId,
      e.environment,
      this.prNumber,
      this.isPodcastShow
    );
    return {
      ...Ec(o),
      assetId: o.spreakerId,
      spreakerId: o.spreakerId
    };
  }
}
const Ug = ({
  _debug: t,
  assetId: e,
  megaphonePodcastId: o,
  megaphoneEpisodeId: s,
  megaphoneNetworkId: n,
  cookieConsent: i,
  coverArt: r,
  customDataLayer: a,
  environment: c,
  internalOnApiAvailable: d,
  isPodcastShowId: l,
  overrideTranslationLanguage: h,
  uiMode: u,
  projectId: p,
  skipCosmosFontInjection: v = !1,
  prNumber: g,
  enablePlaylist: y = !1
}) => {
  const b = ae(
    () => jg(
      { spreakerId: e, isPodcastShow: fs(l) },
      {
        podcastId: o,
        episodeId: s,
        networkId: n,
        enablePlaylist: y
      },
      g
    ),
    [e, y, l, s, n, o, g]
  ), [_] = J(new tc()), E = p, m = Wg(e, o), P = ae(
    () => E ? {
      _debug: {
        playerAdapterType: t == null ? void 0 : t.playerAdapterType
      },
      assetId: m,
      cookieConsent: fs(i),
      coverArt: r,
      environment: c,
      overrideTranslationLanguage: h,
      skipCosmosFontInjection: fs(v),
      initialSeekTimeInSec: _.determineInitialSeek(m),
      theme: Ag(E),
      tracking: {
        configs: {
          googleAnalytics: {
            ...Lg(E),
            dataLayer: a
          }
        }
      },
      uiMode: u,
      mediaSessionArtist: "Red Bull"
    } : void 0,
    [
      E,
      t == null ? void 0 : t.playerAdapterType,
      m,
      i,
      r,
      c,
      h,
      v,
      _,
      a,
      u
    ]
  );
  return P ? /* @__PURE__ */ f.createElement(
    Eg,
    {
      config: P,
      dataLoader: b,
      internalOnApiAvailable: d,
      urlSharingStrategy: _
    }
  ) : /* @__PURE__ */ f.createElement(f.Fragment, null);
};
function Hg(t, e) {
  return S0(
    t,
    "rbup-audio-podcast",
    e
  );
}
const Vg = [
  "asset-id",
  "cookie-consent",
  "cover-art",
  "custom-data-layer",
  "enable-playlist",
  "environment",
  "internal-on-api-available",
  "is-podcast-show-id",
  "megaphone-episode-id",
  "megaphone-network-id",
  "megaphone-podcast-id",
  "override-translation-language",
  "pr-number",
  "project-id",
  "skip-cosmos-font-injection",
  "ui-mode"
];
function jg(t, e, o) {
  const { spreakerId: s, isPodcastShow: n } = t;
  return s ? new Bg(o, n) : new Ng(e, o);
}
function Wg(t, e) {
  return t ?? e;
}
Hc(Ug, "rbup-audio-podcast", Vg, {
  shadow: !0
});
window.initRbupAudioPodcast = Hg;
export {
  Hg as initRbupAudioPodcast
};
